export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: string; output: string };
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: Record<string, string>; output: Record<string, string> };
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any };
  /** The `SafeInt` scalar type represents non-fractional signed whole numeric values that are considered safe as defined by the ECMAScript specification. */
  SafeInt: { input: number; output: number };
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: File; output: File };
}

/**
 * sl-hle4.6: AI Crawler bot metadata exposed for UI rendering. Matches
 * KNOWN_AI_CRAWLER_BOTS in src/services/seo/llm-crawler-policy.ts.
 */
export interface AiCrawlerBotType {
  __typename?: 'AICrawlerBotType';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  userAgent: Scalars['String']['output'];
}

export interface AiProfitabilityAlertType {
  __typename?: 'AIProfitabilityAlertType';
  cacheMode: Maybe<Scalars['String']['output']>;
  cacheScope: Maybe<Scalars['String']['output']>;
  cacheWindowSeconds: Maybe<Scalars['Int']['output']>;
  cause: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  marginMicroCredits: Scalars['String']['output'];
  model: Maybe<Scalars['String']['output']>;
  provider: Maybe<Scalars['String']['output']>;
  scope: Scalars['String']['output'];
  severity: Scalars['String']['output'];
  tenantId: Maybe<Scalars['String']['output']>;
  workspaceId: Maybe<Scalars['String']['output']>;
}

export interface AiProfitabilityDimensionRowType {
  __typename?: 'AIProfitabilityDimensionRowType';
  cacheMode: Maybe<Scalars['String']['output']>;
  cacheScope: Maybe<Scalars['String']['output']>;
  cacheWindowSeconds: Maybe<Scalars['Int']['output']>;
  managedBackendId: Maybe<Scalars['String']['output']>;
  model: Maybe<Scalars['String']['output']>;
  provider: Maybe<Scalars['String']['output']>;
  tenantId: Maybe<Scalars['String']['output']>;
  totals: AiProfitabilityMoneyType;
  workspaceId: Maybe<Scalars['String']['output']>;
}

export interface AiProfitabilityMoneyType {
  __typename?: 'AIProfitabilityMoneyType';
  /** Customer charged amount in micro-credits. */
  customerChargedMicroCredits: Scalars['String']['output'];
  /** Customer pre-markup cost basis in micro-credits. */
  customerCostBasisMicroCredits: Scalars['String']['output'];
  eurComplete: Scalars['Boolean']['output'];
  lineCount: Scalars['Int']['output'];
  /** Customer charged micro-credits minus provider cost micro-credits. */
  marginMicroCredits: Scalars['String']['output'];
  /** Provider cost converted to micro-credits. */
  providerCostMicroCredits: Scalars['String']['output'];
  /** Provider cost in micro-EUR for lines with EUR snapshots; trust only when eurComplete=true. */
  providerCostMicroEur: Scalars['String']['output'];
  /** Provider cost in canonical micro-USD. */
  providerCostMicroUsd: Scalars['String']['output'];
}

export interface AiProfitabilityQueryInput {
  /** Optional feature_bucket filter (e.g. ai_chat, workflows). Omitted = all AI cost lines. */
  featureBucket?: InputMaybe<Scalars['String']['input']>;
  from: Scalars['DateTime']['input'];
  model?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['DateTime']['input'];
  traceFirst?: InputMaybe<Scalars['Int']['input']>;
  traceOffset?: InputMaybe<Scalars['Int']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}

export interface AiProfitabilityReportType {
  __typename?: 'AIProfitabilityReportType';
  alerts: Array<AiProfitabilityAlertType>;
  cacheWindowRows: Array<AiProfitabilityDimensionRowType>;
  managedBackendRows: Array<AiProfitabilityDimensionRowType>;
  overview: AiProfitabilityMoneyType;
  providerModelRows: Array<AiProfitabilityDimensionRowType>;
  requestTrace: AiProfitabilityTracePageType;
  tenantRows: Array<AiProfitabilityDimensionRowType>;
  workspaceRows: Array<AiProfitabilityDimensionRowType>;
}

export interface AiProfitabilityTracePageType {
  __typename?: 'AIProfitabilityTracePageType';
  nextOffset: Maybe<Scalars['Int']['output']>;
  rows: Array<AiProfitabilityTraceRowType>;
}

export interface AiProfitabilityTraceRowType {
  __typename?: 'AIProfitabilityTraceRowType';
  aiUsageLogId: Scalars['String']['output'];
  cacheKey: Maybe<Scalars['String']['output']>;
  cacheMode: Maybe<Scalars['String']['output']>;
  cacheScope: Maybe<Scalars['String']['output']>;
  cacheWindowSeconds: Maybe<Scalars['Int']['output']>;
  capability: Scalars['String']['output'];
  costKind: Scalars['String']['output'];
  costSource: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  creditTransactionId: Maybe<Scalars['String']['output']>;
  customerChargedMicroCredits: Scalars['String']['output'];
  customerCostBasisMicroCredits: Scalars['String']['output'];
  id: Scalars['String']['output'];
  managedBackendId: Maybe<Scalars['String']['output']>;
  model: Scalars['String']['output'];
  modelUsed: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  providerCostMicroCredits: Scalars['String']['output'];
  providerCostMicroEur: Maybe<Scalars['String']['output']>;
  providerCostMicroUsd: Scalars['String']['output'];
  providerUsed: Maybe<Scalars['String']['output']>;
  routingPolicy: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  triggerId: Maybe<Scalars['String']['output']>;
  userId: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
}

export interface AccessToken {
  __typename?: 'AccessToken';
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

/** sl-zvjz: First reason that prevents account-deletion. UI renders inline guidance per reason. */
export enum AccountDeletionBlockReason {
  OWNER_OF_ACTIVE_WORKSPACE = 'OWNER_OF_ACTIVE_WORKSPACE',
}

/** sl-zvjz: Aggregated read-only view powering the Multi-Step Deletion Modal. */
export interface AccountDeletionPreview {
  __typename?: 'AccountDeletionPreview';
  activeSubscriptions: Array<SubscriptionPreview>;
  blockedReason: Maybe<AccountDeletionBlockReason>;
  gracePeriodDays: Scalars['Int']['output'];
  ownedWorkspaces: Array<WorkspacePreview>;
  pendingInvoices: Array<InvoicePreview>;
  scheduledFinalizeDate: Scalars['DateTime']['output'];
}

/** sl-zvjz: Account-Deletion lifecycle status. Returned by scheduleAccountDeletion / cancelAccountDeletion / accountDeletionStatus. */
export interface AccountDeletionStatus {
  __typename?: 'AccountDeletionStatus';
  /** When the cron-finalizer will anonymize the row, null if not scheduled. */
  finalizesAt: Maybe<Scalars['DateTime']['output']>;
  /** Configured grace period in days (default 30, env-overridable). */
  gracePeriodDays: Scalars['Int']['output'];
  /** True if the grace window is still open and reactivation is possible. */
  reactivatable: Scalars['Boolean']['output'];
  /** True while the user is in the grace window. */
  scheduled: Scalars['Boolean']['output'];
  /** When deletion was scheduled, null if not scheduled. */
  scheduledAt: Maybe<Scalars['DateTime']['output']>;
}

export interface AddContextBlobInput {
  blobId: Scalars['String']['input'];
  contextId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface AddContextCategoryInput {
  categoryId: Scalars['String']['input'];
  contextId: Scalars['String']['input'];
  docs?: InputMaybe<Array<Scalars['String']['input']>>;
  type: ContextCategories;
  workspaceId: Scalars['String']['input'];
}

export interface AddContextDocInput {
  contextId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface AddContextFileInput {
  blobId?: InputMaybe<Scalars['String']['input']>;
  contextId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface AdminActivityAppCost {
  __typename?: 'AdminActivityAppCost';
  appBaseId: Scalars['String']['output'];
  costKind: Scalars['String']['output'];
  creditsMicro: Scalars['String']['output'];
  deleted: Scalars['Boolean']['output'];
  quantity: Scalars['String']['output'];
  title: Maybe<Scalars['String']['output']>;
  unit: Scalars['String']['output'];
}

export interface AdminActivityCounterPoint {
  __typename?: 'AdminActivityCounterPoint';
  amount: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  periodStart: Scalars['DateTime']['output'];
  unit: Scalars['String']['output'];
}

export interface AdminActivityCounterTotal {
  __typename?: 'AdminActivityCounterTotal';
  amount: Scalars['String']['output'];
  appBaseId: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  queue: Maybe<Scalars['String']['output']>;
  route: Maybe<Scalars['String']['output']>;
  unit: Scalars['String']['output'];
}

export interface AdminActivityKindRank {
  __typename?: 'AdminActivityKindRank';
  amount: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  unit: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
}

export interface AdminActivityMeasurement {
  __typename?: 'AdminActivityMeasurement';
  dimension: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  unit: Scalars['String']['output'];
  value: Scalars['String']['output'];
}

export interface AdminActivitySource {
  __typename?: 'AdminActivitySource';
  costs: Maybe<Array<AdminActivityMeasurement>>;
  incomplete: Scalars['Boolean']['output'];
  observedAt: Maybe<Scalars['DateTime']['output']>;
  quantities: Array<AdminActivityMeasurement>;
  retentionDays: Maybe<Scalars['Int']['output']>;
  retentionPolicy: Scalars['String']['output'];
  source: Scalars['String']['output'];
}

/** sl-kbz8.2: Admin who performed an audit action */
export interface AdminAuditLogAdminType {
  __typename?: 'AdminAuditLogAdminType';
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
}

/** sl-kbz8.2: Single audit log entry */
export interface AdminAuditLogEntryType {
  __typename?: 'AdminAuditLogEntryType';
  action: Scalars['String']['output'];
  admin: AdminAuditLogAdminType;
  adminId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  details: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  targetId: Maybe<Scalars['String']['output']>;
  targetType: Maybe<Scalars['String']['output']>;
}

/** Distinct filter values present in the admin audit log */
export interface AdminAuditLogFacetsType {
  __typename?: 'AdminAuditLogFacetsType';
  actions: Array<Scalars['String']['output']>;
  admins: Array<AdminAuditLogAdminType>;
  targetTypes: Array<Scalars['String']['output']>;
}

/** sl-ddz8.6.3: Result of admin backfill embeddings operation */
export interface AdminBackfillResult {
  __typename?: 'AdminBackfillResult';
  alreadyEmbedded: Scalars['Int']['output'];
  queued: Scalars['Int']['output'];
  totalDocs: Scalars['Int']['output'];
}

/** sl-sdk6.6.1: Knowledge graph statistics for a workspace */
export interface AdminGraphStats {
  __typename?: 'AdminGraphStats';
  edgeCount: Scalars['Int']['output'];
  nodeCount: Scalars['Int']['output'];
  nodeTypeDistribution: Scalars['JSON']['output'];
}

/** sl-sdk6.6.1: A single memory entry visible in the admin panel */
export interface AdminMemory {
  __typename?: 'AdminMemory';
  category: Scalars['String']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  importance: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Maybe<Scalars['String']['output']>;
  visibility: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
}

/** sl-sdk6.6.1: Filter input for admin memory browser */
export interface AdminMemoryFilters {
  category?: InputMaybe<Scalars['String']['input']>;
  minImportance?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sourceDocId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
}

/** sl-sdk6.6.1: Paginated list of admin memories */
export interface AdminMemoryPage {
  __typename?: 'AdminMemoryPage';
  items: Array<AdminMemory>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
}

export interface AdminPlanCountType {
  __typename?: 'AdminPlanCountType';
  count: Scalars['Int']['output'];
  percentage: Scalars['Float']['output'];
  plan: Scalars['String']['output'];
}

export interface AdminSignupTrendEntryType {
  __typename?: 'AdminSignupTrendEntryType';
  count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
}

/** sl-dkgt.1: Admin workspace list entry */
export interface AdminStorageBreakdownType {
  __typename?: 'AdminStorageBreakdownType';
  blobBytes: Scalars['Float']['output'];
  databaseBytes: Scalars['Float']['output'];
  derivedBytes: Scalars['Float']['output'];
  documentHistoryBytes: Scalars['Float']['output'];
  documentSnapshotBytes: Scalars['Float']['output'];
  mailSearchIndexBytes: Scalars['Float']['output'];
  searchIndexBytes: Scalars['Float']['output'];
}

export interface AdminStripePriceType {
  __typename?: 'AdminStripePriceType';
  active: Scalars['Boolean']['output'];
  billingScheme: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  priceId: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  recurring: Scalars['String']['output'];
  tiers: Maybe<Array<AdminStripeTierType>>;
  unitAmount: Scalars['Int']['output'];
}

export interface AdminStripeTierType {
  __typename?: 'AdminStripeTierType';
  flatAmount: Scalars['Int']['output'];
  unitAmount: Scalars['Int']['output'];
  upTo: Maybe<Scalars['Int']['output']>;
}

export interface AdminSubscriptionType {
  __typename?: 'AdminSubscriptionType';
  canceledAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  end: Maybe<Scalars['DateTime']['output']>;
  plan: Scalars['String']['output'];
  provider: Maybe<Scalars['String']['output']>;
  recurring: SubscriptionRecurring;
  start: Scalars['DateTime']['output'];
  status: SubscriptionStatus;
  userEmail: Scalars['String']['output'];
  userName: Maybe<Scalars['String']['output']>;
}

/** sl-kaqr.4.1: Admin tenant detail with members and workspaces */
export interface AdminTenantDetailType {
  __typename?: 'AdminTenantDetailType';
  billingEmail: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Tenant credit pool balance */
  creditBalance: Scalars['Float']['output'];
  creditEnabled: Scalars['Boolean']['output'];
  creditSuspended: Scalars['Boolean']['output'];
  /** sl-c6nw: Database name from the shard catalog */
  databaseName: Maybe<Scalars['String']['output']>;
  /** sl-c6nw: Database type - shard foundation exposes 'sharded' */
  databaseType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  memberCount: Scalars['Int']['output'];
  members: Array<AdminTenantMemberType>;
  name: Scalars['String']['output'];
  ownerEmail: Scalars['String']['output'];
  ownerName: Scalars['String']['output'];
  /** Effective plan (override > stripe > Free) */
  plan: Scalars['String']['output'];
  /** Member limit that applies to the current plan (-1 = unlimited, null = no plan config seeded) */
  planMemberLimit: Maybe<Scalars['Int']['output']>;
  planMonthlyCreditGrant: Maybe<Scalars['Int']['output']>;
  /** Admin override plan */
  planOverride: Maybe<Scalars['String']['output']>;
  /** Override expiry (null = permanent) */
  planOverrideExpiresAt: Maybe<Scalars['DateTime']['output']>;
  /** Admin who set the override */
  planOverrideSetBy: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  /** Stripe subscription plan */
  stripePlan: Maybe<Scalars['String']['output']>;
  totalStorageBytes: Scalars['Float']['output'];
  workspaceCount: Scalars['Int']['output'];
  workspaces: Array<AdminTenantWorkspaceType>;
}

/** sl-kaqr.4.1: Tenant member in admin detail view */
export interface AdminTenantMemberType {
  __typename?: 'AdminTenantMemberType';
  accepted: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  joinedAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  role: TenantRoleEnum;
  userId: Scalars['String']['output'];
}

/** sl-kaqr.4.1: Admin tenant list entry */
export interface AdminTenantType {
  __typename?: 'AdminTenantType';
  billingEmail: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** sl-c6nw: Database name from the shard catalog */
  databaseName: Maybe<Scalars['String']['output']>;
  /** sl-c6nw: Database type - shard foundation exposes 'sharded' */
  databaseType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  memberCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  ownerEmail: Scalars['String']['output'];
  ownerName: Scalars['String']['output'];
  /** Effective plan (override > stripe > Free) */
  plan: Scalars['String']['output'];
  /** Admin override plan */
  planOverride: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  storageBreakdown: AdminStorageBreakdownType;
  /** Stripe subscription plan */
  stripePlan: Maybe<Scalars['String']['output']>;
  totalStorageBytes: Scalars['Float']['output'];
  workspaceCount: Scalars['Int']['output'];
}

/** sl-kaqr.4.1: Tenant workspace in admin detail view */
export interface AdminTenantWorkspaceType {
  __typename?: 'AdminTenantWorkspaceType';
  createdAt: Scalars['DateTime']['output'];
  docCount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  memberCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** Seat add-on is billed through Stripe */
  seatAddonBilled: Scalars['Boolean']['output'];
  seatAddonQuantity: Scalars['Int']['output'];
  storageBreakdown: AdminStorageBreakdownType;
  totalStorageBytes: Scalars['Float']['output'];
}

export interface AdminUserStatsType {
  __typename?: 'AdminUserStatsType';
  activeLastSevenDays: Scalars['Int']['output'];
  activeLastThirtyDays: Scalars['Int']['output'];
  planCounts: Array<AdminPlanCountType>;
  signupsThisMonth: Scalars['Int']['output'];
  signupsThisWeek: Scalars['Int']['output'];
  totalUsers: Scalars['Int']['output'];
}

export interface AdminWorkerJobPlaces {
  __typename?: 'AdminWorkerJobPlaces';
  held: Scalars['Int']['output'];
  placesPerPod: Scalars['Int']['output'];
  pods: Scalars['Int']['output'];
  /** Workspaces holding or waiting; the list shows the first ones. */
  workspaceCount: Scalars['Int']['output'];
  workspaces: Array<AdminWorkerJobWorkspaceStanding>;
}

export interface AdminWorkerJobTierStanding {
  __typename?: 'AdminWorkerJobTierStanding';
  /** Longest known wait of the waiting jobs in ms, 0 when unknown */
  oldestWaitMs: Scalars['Int']['output'];
  /** Priority tier: live, derived, assistant, programmatic or background */
  tier: Scalars['String']['output'];
  /** Waiting jobs a free place of the workspace claim could start */
  underClaim: Scalars['Int']['output'];
  waiting: Scalars['Int']['output'];
}

export interface AdminWorkerJobWorkspaceStanding {
  __typename?: 'AdminWorkerJobWorkspaceStanding';
  /** Places held above the claim, lent by the fleet */
  borrowed: Scalars['Int']['output'];
  claim: Scalars['Int']['output'];
  held: Scalars['Int']['output'];
  /** Highest holding of the workspace; null without workspace stage */
  limit: Maybe<Scalars['Int']['output']>;
  tiers: Array<AdminWorkerJobTierStanding>;
  workspaceId: Scalars['String']['output'];
}

/** sl-dkgt.2.2: Workspace AI key status */
export interface AdminWorkspaceAiKeyStatusType {
  __typename?: 'AdminWorkspaceAIKeyStatusType';
  hasServerKey: Scalars['Boolean']['output'];
  hasWorkspaceKey: Scalars['Boolean']['output'];
  userKeysCount: Scalars['Int']['output'];
}

export interface AdminWorkspaceActivity {
  __typename?: 'AdminWorkspaceActivity';
  apps: Array<AdminActivityAppCost>;
  creditsMicro: Scalars['String']['output'];
  from: Scalars['DateTime']['output'];
  sources: Array<AdminActivitySource>;
  to: Scalars['DateTime']['output'];
  workspaceId: Scalars['String']['output'];
}

export interface AdminWorkspaceActivityCounters {
  __typename?: 'AdminWorkspaceActivityCounters';
  /** HOUR or DAY (UTC) granularity of series */
  bucket: Scalars['String']['output'];
  from: Scalars['DateTime']['output'];
  incomplete: Scalars['Boolean']['output'];
  queues: Array<AdminActivityCounterTotal>;
  retentionDays: Scalars['Int']['output'];
  routes: Array<AdminActivityCounterTotal>;
  series: Array<AdminActivityCounterPoint>;
  to: Scalars['DateTime']['output'];
  workspaceId: Scalars['String']['output'];
}

/** sl-dkgt.2.2: Admin workspace detail with members and quota */
export interface AdminWorkspaceDetailType {
  __typename?: 'AdminWorkspaceDetailType';
  aiKeyStatus: AdminWorkspaceAiKeyStatusType;
  aiUsageThisMonth: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletionScheduledAt: Maybe<Scalars['DateTime']['output']>;
  docCount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  memberCount: Scalars['Int']['output'];
  members: Array<AdminWorkspaceMemberType>;
  name: Scalars['String']['output'];
  ownerEmail: Scalars['String']['output'];
  ownerId: Scalars['String']['output'];
  ownerName: Scalars['String']['output'];
  plan: Scalars['String']['output'];
  quotaUsage: AdminWorkspaceQuotaUsageType;
  totalStorageBytes: Scalars['Float']['output'];
}

/** sl-dkgt.2.2: Workspace member in admin detail view */
export interface AdminWorkspaceMemberType {
  __typename?: 'AdminWorkspaceMemberType';
  accepted: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  joinedAt: Scalars['DateTime']['output'];
  membershipKind: WorkspaceMembershipKind;
  name: Scalars['String']['output'];
  role: Permission;
  userId: Scalars['String']['output'];
}

/** sl-dkgt.2.2: Workspace quota usage */
export interface AdminWorkspaceQuotaUsageType {
  __typename?: 'AdminWorkspaceQuotaUsageType';
  aiActions: Scalars['Int']['output'];
  aiActionsLimit: Scalars['Int']['output'];
  members: Scalars['Int']['output'];
  membersLimit: Scalars['Int']['output'];
  storageBreakdown: AdminStorageBreakdownType;
  storageBytes: Scalars['Float']['output'];
  storageBytesLimit: Scalars['Float']['output'];
}

/** sl-dkgt.4: Aggregated workspace stats for admin dashboard */
export interface AdminWorkspaceStatsType {
  __typename?: 'AdminWorkspaceStatsType';
  avgMembersPerWorkspace: Scalars['Float']['output'];
  avgStoragePerWorkspace: Scalars['Float']['output'];
  storageBreakdown: AdminStorageBreakdownType;
  top10ByAIUsage: Array<AdminWorkspaceType>;
  top10ByMembers: Array<AdminWorkspaceType>;
  top10ByStorage: Array<AdminWorkspaceType>;
  totalStorageUsed: Scalars['Float']['output'];
  totalWorkspaces: Scalars['Int']['output'];
}

/** sl-dkgt.1: Admin workspace list entry */
export interface AdminWorkspaceType {
  __typename?: 'AdminWorkspaceType';
  aiUsageThisMonth: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletionScheduledAt: Maybe<Scalars['DateTime']['output']>;
  docCount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  memberCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  ownerEmail: Scalars['String']['output'];
  ownerId: Scalars['String']['output'];
  ownerName: Scalars['String']['output'];
  plan: Scalars['String']['output'];
  storageBreakdown: AdminStorageBreakdownType;
  totalStorageBytes: Scalars['Float']['output'];
}

export interface AggregateBucketHitsObjectType {
  __typename?: 'AggregateBucketHitsObjectType';
  nodes: Array<SearchNodeObjectType>;
}

export interface AggregateBucketObjectType {
  __typename?: 'AggregateBucketObjectType';
  count: Scalars['Int']['output'];
  /** The hits object */
  hits: AggregateBucketHitsObjectType;
  key: Scalars['String']['output'];
}

export interface AggregateHitsOptions {
  fields: Array<Scalars['String']['input']>;
  highlights?: InputMaybe<Array<SearchHighlight>>;
  pagination?: InputMaybe<AggregateHitsPagination>;
}

export interface AggregateHitsPagination {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}

export interface AggregateInput {
  field: Scalars['String']['input'];
  options: AggregateOptions;
  query: SearchQuery;
  similar?: InputMaybe<Scalars['Boolean']['input']>;
  table: SearchTable;
}

export interface AggregateOptions {
  /** Search partitions the client answers from its own current index; their pages are left out. At most 64 partition indexes, never page ids. */
  excludedPartitions?: InputMaybe<Array<Scalars['Int']['input']>>;
  hits: AggregateHitsOptions;
  includeTechnicalSources?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<SearchPagination>;
}

export interface AggregateResultObjectType {
  __typename?: 'AggregateResultObjectType';
  buckets: Array<AggregateBucketObjectType>;
  pagination: SearchResultPagination;
}

export enum AiJobStatus {
  claimed = 'claimed',
  failed = 'failed',
  finished = 'finished',
  pending = 'pending',
  running = 'running',
}

export interface AlreadyInSpaceDataType {
  __typename?: 'AlreadyInSpaceDataType';
  spaceId: Scalars['String']['output'];
}

/**
 * sl-hle4.6: AI/LLM provenance + crawler policy settings for an AppBase. Mirrors the shape persisted at AppBase.config.settings.ai
 * (sl-y0sj.4 AIEO Pack). Per-app-base crawler policy overrides the workspace
 * default; null fields fall back to the workspace policy.
 */
export interface AppBaseAieoSettingsType {
  __typename?: 'AppBaseAIEOSettingsType';
  appBaseId: Scalars['ID']['output'];
  /** Author/source attribution URL for AI-rendered citations. */
  attributionUrl: Maybe<Scalars['String']['output']>;
  /**
   * Policy enum: ALLOW_ALL | BLOCK_ALL | PER_BOT. Null inherits the
   * workspace default policy.
   */
  crawlerPolicy: Maybe<Scalars['String']['output']>;
  /**
   * Per-bot ALLOW / DISALLOW map keyed by bot id (only meaningful when
   * crawlerPolicy = PER_BOT).
   */
  crawlerPolicyDetails: Maybe<Scalars['JSONObject']['output']>;
  /**
   * EU AI Act Art. 50 provenance label: human-authored | ai-generated |
   * ai-assisted | mixed | undeclared.
   */
  declaration: Maybe<Scalars['String']['output']>;
  /**
   * Per-app-base llms.txt body override. Max 10 KB. Null => generated from
   * workspace default.
   */
  llmsTextOverride: Maybe<Scalars['String']['output']>;
  /**
   * Explicit consent to use the page for AI training-data collection.
   * Independent from crawler policy — a page may BLOCK_ALL crawlers and
   * still grant trainingDataConsent for a permissioned partner.
   */
  trainingDataConsent: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  workspaceId: Scalars['ID']['output'];
}

/**
 * sl-hle4.2 REWORK: Opt-in monthly bandwidth budget per AppBase/site. The budget caps
 * how many credits one public site may consume
 * within a UTC calendar month — a soft layer on top of the workspace's
 * generic credit balance (the credit balance remains the hard floor).
 */
export interface AppBaseBandwidthBudgetType {
  __typename?: 'AppBaseBandwidthBudgetType';
  /** Percentages (0..100] at which to fire `budget_threshold:bandwidth` notifications. Sorted ascending, deduped. */
  alertThresholds: Array<Scalars['Int']['output']>;
  appBaseId: Scalars['String']['output'];
  /** `block` halts CDN serving via hard-cap when the budget is hit; `warn` only triggers notifications. */
  behavior: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** sl-hle4 Phase-4b cluster L: Stable row id (cuid). UI uses it as the React list-key + audit-log correlation handle. */
  id: Scalars['String']['output'];
  /** sl-hle4 Phase-4b cluster L: Sum of `app_bases_traffic` USAGE charges for the current UTC month, in micro-credits. Wire as string for BigInt parity. UI derives `usedPct = monthToDateUsedMicro / monthlyLimitMicro`. */
  monthToDateUsedMicro: Scalars['String']['output'];
  /** Monthly cap in micro-credits (1 credit = 10_000 micro-credits). Wire as string to preserve BigInt precision. */
  monthlyLimitMicro: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  workspaceId: Scalars['String']['output'];
}

/** A completed change the user made by hand in App Studio */
export interface AppBaseDraftChangeInput {
  /** What the user changed, shown in the version history */
  label: Scalars['String']['input'];
}

export interface AppBaseInvocationActionStatusType {
  __typename?: 'AppBaseInvocationActionStatusType';
  actionId: Scalars['String']['output'];
  allowed: Scalars['Boolean']['output'];
  concurrencyLimit: Scalars['Int']['output'];
  concurrencyUsed: Scalars['Int']['output'];
  effectiveRatePerHour: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  operation: Scalars['String']['output'];
  policyReason: Scalars['String']['output'];
  usedLastHour: Scalars['Int']['output'];
}

export interface AppBaseInvocationStatusType {
  __typename?: 'AppBaseInvocationStatusType';
  actions: Array<AppBaseInvocationActionStatusType>;
  exposure: Scalars['String']['output'];
  /** Bounded execution-history origin, for example app_base:internalLive. */
  origin: Scalars['String']['output'];
  planSlug: Scalars['String']['output'];
}

/** sl-bpu6.14.1: Member-facing read-only viewer state (published only, never draft) */
export interface AppBasePublicViewerStateType {
  __typename?: 'AppBasePublicViewerStateType';
  publishedVersion: Maybe<Scalars['Int']['output']>;
  viewConfig: Maybe<Scalars['JSONObject']['output']>;
}

/** A row owner reference. */
export interface AppBaseRowOwnerInput {
  /** Portal owners only; defaults to the managed App. */
  appBaseId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  /** workspaceMember or portal */
  type: Scalars['String']['input'];
}

export interface AppBaseRowOwnerReassignResultType {
  __typename?: 'AppBaseRowOwnerReassignResultType';
  reassignedRows: Scalars['Int']['output'];
  /** Live rows still matching the scope (0 for explicit rowIds). */
  remainingRows: Scalars['Int']['output'];
}

/** Owner of live App database rows: a workspace member or an App portal user. */
export interface AppBaseRowOwnerType {
  __typename?: 'AppBaseRowOwnerType';
  /** Portal owners only: the App whose portal the user belongs to. */
  appBaseId: Maybe<Scalars['String']['output']>;
  /** Name or email; null when the person no longer exists. */
  displayName: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  rowCount: Scalars['Int']['output'];
  /** workspaceMember or portal */
  type: Scalars['String']['output'];
}

/**
 * Ownership of the live rows of one database, read before switching an App
 * binding to own/group row visibility.
 */
export interface AppBaseRowOwnershipSummaryType {
  __typename?: 'AppBaseRowOwnershipSummaryType';
  /** True when more owners exist than listed. */
  moreOwners: Scalars['Boolean']['output'];
  /** Owners with the most rows first, at most 100. */
  owners: Array<AppBaseRowOwnerType>;
  /** Live rows without an owner; nobody sees them in own/group mode. */
  rowsWithoutOwner: Scalars['Int']['output'];
  /** Live (ACTIVE) rows of the database. */
  totalRows: Scalars['Int']['output'];
}

/**
 * sl-hle4.5: SEO + Open-Graph + JSON-LD settings for an AppBase.
 * Mirrors the i18n-aware shape persisted at AppBase.config.settings.seo
 * (sl-y0sj.3 SERP-SEO-Pack).
 */
export interface AppBaseSeoSettingsType {
  __typename?: 'AppBaseSEOSettingsType';
  appBaseId: Scalars['ID']['output'];
  /** Override for <link rel="canonical">. Defaults to current request URL when null. */
  canonicalUrlOverride: Maybe<Scalars['String']['output']>;
  /** BCP-47 → string. Per-locale meta description (≤ 160 chars per value). */
  descriptionsI18n: Maybe<Scalars['JSONObject']['output']>;
  indexing: Maybe<Scalars['Boolean']['output']>;
  /** schema.org JSON-LD type tag: auto | article | dataset | webpage. */
  jsonLdType: Maybe<Scalars['String']['output']>;
  /** BCP-47 → URL string. Per-locale Open-Graph image override. */
  ogImagesI18n: Maybe<Scalars['JSONObject']['output']>;
  /**
   * Robots directives whitelist: index/noindex/follow/nofollow/noai/
   * noimageai/notranslate/nosnippet plus max-snippet:N. Empty array means
   * default robots policy.
   */
  robotsDirectives: Array<Scalars['String']['output']>;
  /** BCP-47 → URL-safe path segment. Per-locale display slug. */
  slugsI18n: Maybe<Scalars['JSONObject']['output']>;
  /** JSON-LD object emitted as <script type="application/ld+json">. */
  structuredData: Maybe<Scalars['JSONObject']['output']>;
  /** BCP-47 → string. Per-locale SEO title (≤ 60 chars per value). */
  titlesI18n: Maybe<Scalars['JSONObject']['output']>;
  /** Twitter Card layout: summary | summary_large_image. */
  twitterCardType: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  workspaceId: Scalars['ID']['output'];
}

/** SEO check per App over the published snapshot of one App Container. */
export interface AppBaseSeoCheckType {
  __typename?: 'AppBaseSeoCheckType';
  apps: Array<AppSeoCheckAppType>;
  /** False until the App Container has a published snapshot. */
  published: Scalars['Boolean']['output'];
}

/** What deleting an App or App Container for good does with a table only it owns. */
export enum AppBaseTableAction {
  delete = 'delete',
  move = 'move',
}

/** One choice per table only the deleted App or App Container owns. */
export interface AppBaseTableDispositionInput {
  action: AppBaseTableAction;
  sourceKey: Scalars['String']['input'];
  /** Page outside every App folder the kept table moves onto (action move). */
  targetDocId?: InputMaybe<Scalars['String']['input']>;
}

/** sl-9qm.1.4: An AppBase configuration */
export interface AppBaseType {
  __typename?: 'AppBaseType';
  config: Scalars['JSONObject']['output'];
  createdAt: Scalars['DateTime']['output'];
  docId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isPublished: Scalars['Boolean']['output'];
  /** Offline access window in hours (1..672) of this App Container; null = the workspace's App window */
  offlineAccessTtlHours: Maybe<Scalars['Int']['output']>;
  /** Active card-cover/detail-gallery media. Null until preview cutover. */
  previewSet: Maybe<Scalars['JSONObject']['output']>;
  publishedAt: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  workspaceId: Scalars['String']['output'];
}

/** Channel through which the acting user (createdBy) made an AppBase version change: App Studio UI, AI chat/goal or MCP. */
export enum AppBaseVersionChangeSource {
  ai = 'ai',
  mcp = 'mcp',
  user = 'user',
}

/** Version history entry without the (large) config payload. Every applied change and every restore is its own version; undo/redo restores a version. */
export interface AppBaseVersionHistoryEntryType {
  __typename?: 'AppBaseVersionHistoryEntryType';
  active: Scalars['Boolean']['output'];
  baseVersion: Maybe<Scalars['Int']['output']>;
  changeLabel: Maybe<Scalars['String']['output']>;
  changeSource: Maybe<AppBaseVersionChangeSource>;
  createdAt: Scalars['DateTime']['output'];
  /** User the change is attributed to; null only for versions recorded before attribution. */
  createdBy: Maybe<Scalars['String']['output']>;
  /** True for the version the editor currently shows (draft, else active published). */
  current: Scalars['Boolean']['output'];
  publishedAt: Maybe<Scalars['DateTime']['output']>;
  /** Set when this version re-applied an older version (undo/redo/restore). */
  restoredFromVersion: Maybe<Scalars['Int']['output']>;
  role: AppBaseVersionRole;
  version: Scalars['Int']['output'];
}

/** One App Module of a saved version of an App Container. */
export interface AppBaseVersionModuleType {
  __typename?: 'AppBaseVersionModuleType';
  mountId: Scalars['String']['output'];
  title: Scalars['String']['output'];
}

/** sl-qhe4: Version lifecycle role — draft (unpublished edit), published (live), manual (pinned snapshot) */
export enum AppBaseVersionRole {
  draft = 'draft',
  manual = 'manual',
  published = 'published',
}

/** Linear undo/redo step over the AppBase version history. */
export enum AppBaseVersionStep {
  redo = 'redo',
  undo = 'undo',
}

/** sl-2q8e.1: Snapshot of an AppBase at a point in time */
export interface AppBaseVersionType {
  __typename?: 'AppBaseVersionType';
  active: Scalars['Boolean']['output'];
  appBaseId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  publishedAt: Maybe<Scalars['DateTime']['output']>;
  role: AppBaseVersionRole;
  version: Scalars['Int']['output'];
  viewConfig: Scalars['JSONObject']['output'];
  workspaceId: Scalars['String']['output'];
}

/** sl-2q8e.2: Viewer state bundle (draft > published prio, isDirty flag) */
export interface AppBaseViewerStateType {
  __typename?: 'AppBaseViewerStateType';
  draftVersion: Maybe<Scalars['Int']['output']>;
  isDirty: Scalars['Boolean']['output'];
  /** sl-bpu6.16.3: true iff there is an ACTIVE published version right now. */
  isLive: Scalars['Boolean']['output'];
  publishedVersion: Maybe<Scalars['Int']['output']>;
  selectedVersion: Maybe<Scalars['Int']['output']>;
  source: Scalars['String']['output'];
  viewConfig: Scalars['JSONObject']['output'];
}

export interface AppConfigValidateResult {
  __typename?: 'AppConfigValidateResult';
  error: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  module: Scalars['String']['output'];
  valid: Scalars['Boolean']['output'];
  value: Scalars['JSON']['output'];
}

export interface AppContainerDeletionSource {
  __typename?: 'AppContainerDeletionSource';
  appBaseId: Scalars['String']['output'];
  hasMountedApps: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
}

export interface AppContainerPublishResult {
  __typename?: 'AppContainerPublishResult';
  templateId: Scalars['String']['output'];
  versionNumber: Scalars['Int']['output'];
}

/** Work units of one App Container page in one hour and cost kind */
export interface AppLoadPoint {
  __typename?: 'AppLoadPoint';
  amount: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  periodStart: Scalars['DateTime']['output'];
  route: Scalars['String']['output'];
  unit: Scalars['String']['output'];
}

export interface AppSeoCheckAppType {
  __typename?: 'AppSeoCheckAppType';
  findings: Array<AppSeoCheckFindingType>;
  /** Mount id of the App, or "container" for the container's own addresses. */
  key: Scalars['String']['output'];
  status: AppSeoCheckStatus;
  title: Scalars['String']['output'];
}

/** Problem kinds of the App SEO check, ordered by weight. */
export enum AppSeoCheckCode {
  ai_crawlers_blocked = 'ai_crawlers_blocked',
  description_missing = 'description_missing',
  description_too_long = 'description_too_long',
  duplicate_description = 'duplicate_description',
  duplicate_title = 'duplicate_title',
  image_missing = 'image_missing',
  locale_missing = 'locale_missing',
  title_too_long = 'title_too_long',
}

export interface AppSeoCheckFindingType {
  __typename?: 'AppSeoCheckFindingType';
  code: AppSeoCheckCode;
  /** Affected addresses, affected locales, or 1 for AI access. */
  count: Scalars['Int']['output'];
  severity: AppSeoCheckSeverity;
}

/** Weight of a finding. A tip is shown but never changes the light. */
export enum AppSeoCheckSeverity {
  red = 'red',
  tip = 'tip',
  yellow = 'yellow',
}

/** Traffic light of one App in the App Studio SEO check. */
export enum AppSeoCheckStatus {
  green = 'green',
  off = 'off',
  red = 'red',
  yellow = 'yellow',
}

/** A table a permanent delete asks about or keeps; reason is exclusive-owned, shared or attached-existing. */
export interface AppTableChoiceType {
  __typename?: 'AppTableChoiceType';
  label: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  sourceKey: Scalars['String']['output'];
}

/** The tables deleting an App or App Container for good asks about (choices) and keeps (retained). */
export interface AppTableChoicesType {
  __typename?: 'AppTableChoicesType';
  choices: Array<AppTableChoiceType>;
  retained: Array<AppTableChoiceType>;
}

export interface AssignMailSignatureInput {
  accountId?: InputMaybe<Scalars['String']['input']>;
  scope: MailSignatureScope;
  signatureId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
}

/** Assistant output source item used by history source/context UI */
export interface AssistantSourceItemType {
  __typename?: 'AssistantSourceItemType';
  display: MessageContextDisplayType;
  id: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  label: Scalars['String']['output'];
  payload: Maybe<Scalars['JSONObject']['output']>;
  refs: Scalars['JSONObject']['output'];
}

/** Canonical assistant output sources attached to a chat message */
export interface AssistantSourceManifestType {
  __typename?: 'AssistantSourceManifestType';
  items: Array<AssistantSourceItemType>;
}

/** Attach an existing affine:database to an AppBase configuration. */
export interface AttachAppBaseDatabaseInput {
  blockId: Scalars['String']['input'];
  columnIds?: InputMaybe<Array<Scalars['String']['input']>>;
  confirmed: Scalars['Boolean']['input'];
  contentModel?: InputMaybe<Scalars['String']['input']>;
  databaseId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
  label: Scalars['String']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
  rowLimit?: InputMaybe<Scalars['Int']['input']>;
  sourceKey: Scalars['String']['input'];
}

/** sl-qhe4: Audit event domain category — coarse-grained grouping for filtering and alerting */
export enum AuditEventCategory {
  admin = 'admin',
  ai = 'ai',
  auth = 'auth',
  automation = 'automation',
  billing = 'billing',
  data = 'data',
  mail = 'mail',
  membership = 'membership',
  oauth = 'oauth',
  platform = 'platform',
  rbac = 'rbac',
  settings = 'settings',
  workflow = 'workflow',
}

/** sl-wmbt.4.1: Audit event connection (paginated) */
export interface AuditEventConnectionType {
  __typename?: 'AuditEventConnectionType';
  edges: Array<AuditEventEdgeType>;
  pageInfo: AuditEventPageInfoType;
}

/** sl-wmbt.4.1: Audit event edge for cursor pagination */
export interface AuditEventEdgeType {
  __typename?: 'AuditEventEdgeType';
  cursor: Scalars['String']['output'];
  node: WorkspaceAuditEventType;
}

/** sl-wmbt.4.1: Audit event filter input */
export interface AuditEventFilterInput {
  action?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** sl-97oo: Filter to all events from members of this user group. */
  groupId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
}

/** sl-wmbt.4.1: Audit event page info */
export interface AuditEventPageInfoType {
  __typename?: 'AuditEventPageInfoType';
  endCursor: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
}

/** sl-kbz8.2: Filter input for audit log queries */
export interface AuditLogFilterInput {
  action?: InputMaybe<Scalars['String']['input']>;
  adminId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  targetId?: InputMaybe<Scalars['String']['input']>;
  targetType?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
}

/**
 * Input for moving an automation to the trash of its host page, back, or
 * out for good. `operationId` is client-generated; a repeat with the same id
 * answers with the receipt of the first call.
 */
export interface AutomationLifecycleInput {
  blockId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
  operationId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

/** Receipt of a committed automation trash, restore or delete; `state` is `COMMITTED`. */
export interface AutomationLifecycleReceipt {
  __typename?: 'AutomationLifecycleReceipt';
  operationId: Scalars['String']['output'];
  state: Scalars['String']['output'];
}

/**
 * sl-y0sj.7.5 + sl-hle4.3.2: Current-month CDN bandwidth usage for AppBases. Data is sourced from Bunny Permanent Log Storage and may lag
 * real-time by up to ~24h — UI MUST surface `asOfDate` so owners do not
 * misread numbers as live. Plan-quota was removed in sl-hle4.1; bandwidth is
 * purely credit-billed (2 credits/GB) with an optional opt-in monthly site budget
 * cap (see `AppBaseBandwidthBudgetType`).
 */
export interface BandwidthUsageStatusType {
  __typename?: 'BandwidthUsageStatusType';
  appBaseId: Scalars['String']['output'];
  /** Latest ledger-row creation time. Reflects Bunny's ~24h log-flush lag. */
  asOfDate: Scalars['DateTime']['output'];
  /** 'block' caps remaining GB at budget-leftover, 'warn' only fires notifications. Null when unset. */
  budgetBehavior: Maybe<Scalars['String']['output']>;
  /** Budget cap in micro-credits (BigInt as String), null when unset. */
  budgetMonthlyLimitMicro: Maybe<Scalars['String']['output']>;
  /** True when this AppBase/site has an opt-in monthly bandwidth budget set. */
  budgetSet: Scalars['Boolean']['output'];
  /** 0..200 percent against the budget cap, null when unset. UI clamps to 100% for the progress bar. */
  budgetUsedPct: Maybe<Scalars['Float']['output']>;
  /** Workspace tenant credit balance at read time (micro-credits, BigInt as String). */
  creditBalanceMicro: Scalars['String']['output'];
  /** Pull-zone tier the workspace's traffic was routed through. Default `PV_BASIC`. */
  currentTier: Scalars['String']['output'];
  /**
   * GB this AppBase/site can still serve before either the credit balance OR
   * (when budgetBehavior='block') the budget remainder runs out — whichever
   * is smaller. Floor-rounded to whole GB.
   */
  remainingGB: Scalars['Float']['output'];
  /** UTC start of next month — the period rolls over here. */
  resetDate: Scalars['DateTime']['output'];
  /** GB of CDN traffic served so far this UTC month. */
  usedGB: Scalars['Float']['output'];
}

export interface BillingStatsType {
  __typename?: 'BillingStatsType';
  planDistribution: Array<PlanCountType>;
  totalActive: Scalars['Int']['output'];
  totalSubscriptions: Scalars['Int']['output'];
}

export interface BlobNotFoundDataType {
  __typename?: 'BlobNotFoundDataType';
  blobId: Scalars['String']['output'];
  spaceId: Scalars['String']['output'];
}

export interface BlockInviteEligibilityInput {
  docId: Scalars['String']['input'];
  groupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceId: Scalars['String']['input'];
}

export interface BlockInviteEligibleGroupType {
  __typename?: 'BlockInviteEligibleGroupType';
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  memberCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
}

export interface BlockInviteEligibleRecipientsType {
  __typename?: 'BlockInviteEligibleRecipientsType';
  groups: Array<BlockInviteEligibleGroupType>;
  ineligible: Array<BlockInviteIneligibleTargetType>;
  users: Array<BlockInviteEligibleUserType>;
}

export interface BlockInviteEligibleUserType {
  __typename?: 'BlockInviteEligibleUserType';
  avatarUrl: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
  role: DocRole;
}

export enum BlockInviteIneligibleReason {
  GROUP_EMPTY = 'GROUP_EMPTY',
  GROUP_INACTIVE = 'GROUP_INACTIVE',
  GROUP_MEMBER_WITHOUT_DOC_ACCESS = 'GROUP_MEMBER_WITHOUT_DOC_ACCESS',
  GROUP_NOT_FOUND = 'GROUP_NOT_FOUND',
  NOT_WORKSPACE_MEMBER = 'NOT_WORKSPACE_MEMBER',
  NO_DOC_ACCESS = 'NO_DOC_ACCESS',
  SELF = 'SELF',
}

export interface BlockInviteIneligibleTargetType {
  __typename?: 'BlockInviteIneligibleTargetType';
  detail: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  reason: BlockInviteIneligibleReason;
  type: BlockInviteTargetType;
}

export interface BlockInviteInput {
  assignment?: InputMaybe<Scalars['Boolean']['input']>;
  blockId?: InputMaybe<Scalars['String']['input']>;
  blockPreview?: InputMaybe<Scalars['String']['input']>;
  docId: Scalars['String']['input'];
  documentOnly?: InputMaybe<Scalars['Boolean']['input']>;
  elementId?: InputMaybe<Scalars['String']['input']>;
  groupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  mode?: InputMaybe<DocMode>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceId: Scalars['String']['input'];
}

export interface BlockInviteInviterType {
  __typename?: 'BlockInviteInviterType';
  avatarUrl: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
}

export interface BlockInviteNotificationBodyType {
  __typename?: 'BlockInviteNotificationBodyType';
  assignment: Scalars['Boolean']['output'];
  blockId: Maybe<Scalars['String']['output']>;
  blockPreview: Maybe<Scalars['String']['output']>;
  docId: Scalars['String']['output'];
  docTitle: Maybe<Scalars['String']['output']>;
  documentOnly: Maybe<Scalars['Boolean']['output']>;
  elementId: Maybe<Scalars['String']['output']>;
  inviter: BlockInviteInviterType;
  mode: DocMode;
  workspaceId: Scalars['String']['output'];
}

export enum BlockInviteTargetType {
  Group = 'Group',
  User = 'User',
}

/** sl-ya4v.14: Frontend gate for the rename action. Tells the settings UI whether the rate-limit window has elapsed and surfaces the next allowed timestamp. */
export interface BrandedSubdomainRenameAvailabilityType {
  __typename?: 'BrandedSubdomainRenameAvailabilityType';
  /** True when the workspace has a branded subdomain AND the 30-day rate-limit window has elapsed since the last rename. */
  canRename: Scalars['Boolean']['output'];
  /** The current branded label (without apex), or null when no branded subdomain is registered. */
  currentLabel: Maybe<Scalars['String']['output']>;
  /** Earliest UTC instant the next rename will be accepted. Null when the workspace has never renamed (or has no branded subdomain at all). */
  nextRenameAt: Maybe<Scalars['DateTime']['output']>;
}

/** sl-ya4v.14: Result of renameBrandedSubdomain / releaseBrandedSubdomain. The new effective host the frontend should use after the mutation succeeds (typed string so the UI never has to re-derive it). */
export interface BrandedSubdomainRenameResult {
  __typename?: 'BrandedSubdomainRenameResult';
  /** The workspace's new effective host. After release this is the default short-id host; after rename it is the new branded subdomain. */
  effectiveHost: Scalars['String']['output'];
}

/** sl-l8v6.4: Cache granularity for time-bucket aggregation in admin cache-performance dashboard. */
export enum CacheGranularity {
  DAY = 'DAY',
  HOUR = 'HOUR',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
}

/** sl-l8v6.4: Per-bucket cache-performance row. BigInt fields are decimal strings. */
export interface CachePerformanceBucketType {
  __typename?: 'CachePerformanceBucketType';
  /** Bucket start time, UTC */
  bucket: Scalars['DateTime']['output'];
  callCount: Scalars['Int']['output'];
  /** User-credits charged (BigInt string, absolute value). */
  chargedMicro: Scalars['String']['output'];
  /** hits / callCount, range 0..1 */
  hitRate: Scalars['Float']['output'];
  hits: Scalars['Int']['output'];
  misses: Scalars['Int']['output'];
  /** Customer cost basis in micro-credits from immutable cost lines. */
  paidMicro: Scalars['String']['output'];
  /** Net savings (BigInt string). Negative = write surcharge exceeded read benefit. */
  savedMicro: Scalars['String']['output'];
  /** CACHE_READ lines whose historical saving cannot be reconstructed from immutable cost lines alone. */
  uncomputableReadCount: Scalars['Int']['output'];
}

/** sl-l8v6.4: Input for cache-performance queries — date range + bucket size + optional feature_bucket filter. */
export interface CachePerformanceQueryInput {
  /** Optional feature_bucket filter (e.g. ai_chat, workflows). Defaults to "ai_chat" when omitted. */
  featureBucket?: InputMaybe<Scalars['String']['input']>;
  from: Scalars['DateTime']['input'];
  granularity: CacheGranularity;
  to: Scalars['DateTime']['input'];
}

/** sl-l8v6.4: Full cache-performance report — buckets time series + summary totals. */
export interface CachePerformanceReportType {
  __typename?: 'CachePerformanceReportType';
  buckets: Array<CachePerformanceBucketType>;
  totals: CachePerformanceTotalsType;
}

/** sl-l8v6.4: Cache-performance summary totals across the requested range. */
export interface CachePerformanceTotalsType {
  __typename?: 'CachePerformanceTotalsType';
  callCount: Scalars['Int']['output'];
  chargedMicro: Scalars['String']['output'];
  hitRateAvg: Scalars['Float']['output'];
  paidMicro: Scalars['String']['output'];
  savedMicro: Scalars['String']['output'];
  /** Customer cost basis without cache benefit (paidMicro + savedMicro), informational. */
  uncachedHypotheticalMicro: Scalars['String']['output'];
  /** Total CACHE_READ lines whose historical saving cannot be reconstructed. */
  uncomputableReadCount: Scalars['Int']['output'];
}

/** A goal turn's message: the goal and what the turn does */
export interface ChatGoalTurnMessage {
  __typename?: 'ChatGoalTurnMessage';
  goalId: Scalars['String']['output'];
  /** plan, step or verify */
  kind: Scalars['String']['output'];
  /** The step the turn works on */
  stepLabel: Maybe<Scalars['String']['output']>;
}

export enum ChatHistoryOrder {
  asc = 'asc',
  desc = 'desc',
}

export interface ChatMessage {
  __typename?: 'ChatMessage';
  attachments: Maybe<Array<Scalars['String']['output']>>;
  content: Scalars['String']['output'];
  context: Maybe<MessageContextType>;
  createdAt: Scalars['DateTime']['output'];
  id: Maybe<Scalars['ID']['output']>;
  /** sl-canvas2-8.31 Phase 6: Message type for Two-Call Pattern */
  messageType: Maybe<MessageType>;
  role: Scalars['String']['output'];
  sources: Maybe<AssistantSourceManifestType>;
  streamObjects: Maybe<Array<StreamObject>>;
  threadId: Maybe<Scalars['String']['output']>;
  /** sl-canvas2-8.31 Phase 6: Tool-related data for typed messages */
  toolData: Maybe<ToolMessageData>;
}

/** Comment change action */
export enum CommentChangeAction {
  create = 'create',
  delete = 'delete',
  update = 'update',
}

export interface CommentChangeObjectType {
  __typename?: 'CommentChangeObjectType';
  /** The action of the comment change */
  action: CommentChangeAction;
  commentId: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  /** The item of the comment or reply, different types have different fields, see UnionCommentObjectType */
  item: Scalars['JSONObject']['output'];
}

export interface CommentChangeObjectTypeEdge {
  __typename?: 'CommentChangeObjectTypeEdge';
  cursor: Scalars['String']['output'];
  node: CommentChangeObjectType;
}

export interface CommentCreateInput {
  content: Scalars['JSONObject']['input'];
  docId: Scalars['ID']['input'];
  docMode: DocMode;
  docTitle: Scalars['String']['input'];
  /** The mention user ids, if not provided, the comment will not be mentioned */
  mentions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Block IDs referenced by this comment, used for click-to-navigate */
  targetBlockIds?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceId: Scalars['ID']['input'];
}

export interface CommentObjectType {
  __typename?: 'CommentObjectType';
  /** The content of the comment */
  content: Scalars['JSONObject']['output'];
  /** The created at time of the comment */
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The replies of the comment */
  replies: Array<ReplyObjectType>;
  /** Whether the comment is resolved */
  resolved: Scalars['Boolean']['output'];
  /** Block IDs referenced by this comment, used for click-to-navigate */
  targetBlockIds: Array<Scalars['String']['output']>;
  /** The updated at time of the comment */
  updatedAt: Scalars['DateTime']['output'];
  /** The user who created the comment */
  user: PublicUserType;
}

export interface CommentObjectTypeEdge {
  __typename?: 'CommentObjectTypeEdge';
  cursor: Scalars['String']['output'];
  node: CommentObjectType;
}

export interface CommentResolveInput {
  id: Scalars['ID']['input'];
  /** Whether the comment is resolved */
  resolved: Scalars['Boolean']['input'];
  workspaceId: Scalars['ID']['input'];
}

export interface CommentUpdateInput {
  content: Scalars['JSONObject']['input'];
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
}

/** E029-COMPACT: Input for compacting a document */
export interface CompactDocInput {
  docId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

/** E029-COMPACT: Result of compacting a document */
export interface CompactResultType {
  __typename?: 'CompactResultType';
  error: Maybe<Scalars['String']['output']>;
  newSizeBytes: Scalars['Int']['output'];
  originalSizeBytes: Scalars['Int']['output'];
  reductionPercent: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
}

export interface ConnectMailAccountInput {
  areaRootFolderId?: InputMaybe<Scalars['String']['input']>;
  credentialId?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  emailAddress: Scalars['String']['input'];
  oauth2Credential?: InputMaybe<MailOAuth2CredentialInput>;
  passwordCredential?: InputMaybe<MailPasswordCredentialInput>;
  providerKind: MailProviderKind;
  providerProfileId: Scalars['String']['input'];
  syncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  testConnection?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['String']['input'];
}

/** An entry whose changes are open: its readers still see liveVersion. */
export interface ContentEntryOpenChangeType {
  __typename?: 'ContentEntryOpenChangeType';
  liveVersion: Scalars['Int']['output'];
  openedAt: Scalars['DateTime']['output'];
  /** User who opened the changes. */
  openedBy: Scalars['String']['output'];
  rowId: Scalars['String']['output'];
}

/** What a call did to one entry of an App Container source. */
export enum ContentEntryResultStatus {
  /** The call changed the state of the entry. */
  APPLIED = 'APPLIED',
  /** The row no longer exists. */
  NOT_FOUND = 'NOT_FOUND',
  /** The entry is not delivered: it has no versions and is written directly. */
  NOT_PUBLISHED = 'NOT_PUBLISHED',
  /** The entry was already in the state the call asks for. */
  UNCHANGED = 'UNCHANGED',
}

/** Result of a call on one entry of an App Container source. */
export interface ContentEntryResultType {
  __typename?: 'ContentEntryResultType';
  /** True while the row holds changes its readers do not see yet. */
  hasOpenChanges: Scalars['Boolean']['output'];
  /** Version its readers see; null for an entry that is not delivered. */
  liveVersion: Maybe<Scalars['Int']['output']>;
  rowId: Scalars['String']['output'];
  status: ContentEntryResultStatus;
}

/** One kept version of an entry, without what it holds. */
export interface ContentEntryVersionType {
  __typename?: 'ContentEntryVersionType';
  createdAt: Scalars['DateTime']['output'];
  /** User who made the version; null when that is no longer known. */
  createdBy: Maybe<Scalars['String']['output']>;
  /** True for the version the readers of the entry see. */
  live: Scalars['Boolean']['output'];
  publishedAt: Maybe<Scalars['DateTime']['output']>;
  version: Scalars['Int']['output'];
}

export enum ContextCategories {
  Collection = 'Collection',
  Tag = 'Tag',
}

export interface ContextMatchedDocChunk {
  __typename?: 'ContextMatchedDocChunk';
  chunk: Scalars['SafeInt']['output'];
  content: Scalars['String']['output'];
  distance: Maybe<Scalars['Float']['output']>;
  docId: Scalars['String']['output'];
}

export interface ContextMatchedFileChunk {
  __typename?: 'ContextMatchedFileChunk';
  blobId: Scalars['String']['output'];
  chunk: Scalars['SafeInt']['output'];
  content: Scalars['String']['output'];
  distance: Maybe<Scalars['Float']['output']>;
  fileId: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

/** Priority for context resolution */
export enum ContextPriority {
  HIGHEST = 'HIGHEST',
  LOWEST = 'LOWEST',
  MID = 'MID',
}

/** How the context was attached */
export enum ContextSource {
  CLIENT_ACTION = 'CLIENT_ACTION',
  FOCUS = 'FOCUS',
  FULLSCREEN = 'FULLSCREEN',
  LAST_ACTIVE = 'LAST_ACTIVE',
  PASTE = 'PASTE',
}

export interface ContextWorkspaceEmbeddingStatus {
  __typename?: 'ContextWorkspaceEmbeddingStatus';
  embedded: Scalars['SafeInt']['output'];
  total: Scalars['SafeInt']['output'];
}

export interface Copilot {
  __typename?: 'Copilot';
  audioTranscription: Maybe<TranscriptionResultType>;
  chats: PaginatedCopilotHistoriesType;
  /** Get the context list of a session */
  contexts: Array<CopilotContext>;
  /** @deprecated use `chats` instead */
  histories: Array<CopilotHistories>;
  /** List available models for a prompt, with human-readable names */
  models: CopilotModelsType;
  /** Get the quota of the user in the workspace */
  quota: CopilotQuota;
  /** Get the session by id */
  session: CopilotSessionType;
  /**
   * Get the session list in the workspace
   * @deprecated use `chats` instead
   */
  sessions: Array<CopilotSessionType>;
  workspaceId: Maybe<Scalars['ID']['output']>;
}

export interface CopilotAudioTranscriptionArgs {
  blobId?: InputMaybe<Scalars['String']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
}

export interface CopilotChatsArgs {
  docId?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<QueryChatHistoriesInput>;
  pagination: PaginationInput;
}

export interface CopilotContextsArgs {
  contextId?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
}

export interface CopilotHistoriesArgs {
  docId?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<QueryChatHistoriesInput>;
}

export interface CopilotModelsArgs {
  promptName: Scalars['String']['input'];
}

export interface CopilotSessionArgs {
  sessionId: Scalars['String']['input'];
}

export interface CopilotSessionsArgs {
  docId?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<QueryChatSessionsInput>;
}

/** What the agent of a chat session does now */
export enum CopilotAgentStatus {
  done = 'done',
  running = 'running',
  waiting = 'waiting',
}

export interface CopilotContext {
  __typename?: 'CopilotContext';
  /** list blobs in context */
  blobs: Array<CopilotContextBlob>;
  /** list collections in context */
  collections: Array<CopilotContextCategory>;
  /** list files in context */
  docs: Array<CopilotContextDoc>;
  /** list files in context */
  files: Array<CopilotContextFile>;
  id: Maybe<Scalars['ID']['output']>;
  /** match file in context */
  matchFiles: Array<ContextMatchedFileChunk>;
  /** match workspace docs */
  matchWorkspaceDocs: Array<ContextMatchedDocChunk>;
  /** list tags in context */
  tags: Array<CopilotContextCategory>;
  workspaceId: Scalars['String']['output'];
}

export interface CopilotContextMatchFilesArgs {
  content: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['SafeInt']['input']>;
  scopedThreshold?: InputMaybe<Scalars['Float']['input']>;
  threshold?: InputMaybe<Scalars['Float']['input']>;
}

export interface CopilotContextMatchWorkspaceDocsArgs {
  content: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['SafeInt']['input']>;
  scopedThreshold?: InputMaybe<Scalars['Float']['input']>;
  threshold?: InputMaybe<Scalars['Float']['input']>;
}

export interface CopilotContextBlob {
  __typename?: 'CopilotContextBlob';
  createdAt: Scalars['SafeInt']['output'];
  id: Scalars['ID']['output'];
}

export interface CopilotContextCategory {
  __typename?: 'CopilotContextCategory';
  createdAt: Scalars['SafeInt']['output'];
  docs: Array<CopilotContextDoc>;
  id: Scalars['ID']['output'];
  type: ContextCategories;
}

export interface CopilotContextDoc {
  __typename?: 'CopilotContextDoc';
  createdAt: Scalars['SafeInt']['output'];
  id: Scalars['ID']['output'];
}

export interface CopilotContextFile {
  __typename?: 'CopilotContextFile';
  blobId: Scalars['String']['output'];
  chunkSize: Scalars['SafeInt']['output'];
  createdAt: Scalars['SafeInt']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface CopilotContextFileNotSupportedDataType {
  __typename?: 'CopilotContextFileNotSupportedDataType';
  fileName: Scalars['String']['output'];
  message: Scalars['String']['output'];
}

export interface CopilotDocNotFoundDataType {
  __typename?: 'CopilotDocNotFoundDataType';
  docId: Scalars['String']['output'];
}

export interface CopilotFailedToAddWorkspaceFileEmbeddingDataType {
  __typename?: 'CopilotFailedToAddWorkspaceFileEmbeddingDataType';
  message: Scalars['String']['output'];
}

export interface CopilotFailedToGenerateEmbeddingDataType {
  __typename?: 'CopilotFailedToGenerateEmbeddingDataType';
  message: Scalars['String']['output'];
  provider: Scalars['String']['output'];
}

export interface CopilotFailedToMatchContextDataType {
  __typename?: 'CopilotFailedToMatchContextDataType';
  content: Scalars['String']['output'];
  contextId: Scalars['String']['output'];
  message: Scalars['String']['output'];
}

export interface CopilotFailedToMatchGlobalContextDataType {
  __typename?: 'CopilotFailedToMatchGlobalContextDataType';
  content: Scalars['String']['output'];
  message: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
}

export interface CopilotFailedToModifyContextDataType {
  __typename?: 'CopilotFailedToModifyContextDataType';
  contextId: Scalars['String']['output'];
  message: Scalars['String']['output'];
}

export interface CopilotHistories {
  __typename?: 'CopilotHistories';
  /** An mark identifying which view to use to display the session */
  action: Maybe<Scalars['String']['output']>;
  /** What the agent of the session does now */
  agentStatus: CopilotAgentStatus;
  createdAt: Scalars['DateTime']['output'];
  docId: Maybe<Scalars['String']['output']>;
  messages: Array<ChatMessage>;
  model: Scalars['String']['output'];
  optionalModels: Array<Scalars['String']['output']>;
  parentSessionId: Maybe<Scalars['String']['output']>;
  pinned: Scalars['Boolean']['output'];
  promptName: Scalars['String']['output'];
  /** Thinking depth the agent of this session answers with */
  reasoningMode: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  title: Maybe<Scalars['String']['output']>;
  /** The number of tokens used in the session */
  tokens: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  workspaceId: Scalars['String']['output'];
}

export interface CopilotHistoriesTypeEdge {
  __typename?: 'CopilotHistoriesTypeEdge';
  cursor: Scalars['String']['output'];
  node: CopilotHistories;
}

export interface CopilotInvalidContextDataType {
  __typename?: 'CopilotInvalidContextDataType';
  contextId: Scalars['String']['output'];
}

export interface CopilotMessageNotFoundDataType {
  __typename?: 'CopilotMessageNotFoundDataType';
  messageId: Scalars['String']['output'];
}

export interface CopilotModelType {
  __typename?: 'CopilotModelType';
  costMultiplier: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  tier: Scalars['String']['output'];
}

export interface CopilotModelsType {
  __typename?: 'CopilotModelsType';
  defaultModel: Scalars['String']['output'];
  optionalModels: Array<CopilotModelType>;
  proModels: Array<CopilotModelType>;
}

export interface CopilotPromptConfigInput {
  frequencyPenalty?: InputMaybe<Scalars['Float']['input']>;
  presencePenalty?: InputMaybe<Scalars['Float']['input']>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
  topP?: InputMaybe<Scalars['Float']['input']>;
}

export interface CopilotPromptConfigType {
  __typename?: 'CopilotPromptConfigType';
  frequencyPenalty: Maybe<Scalars['Float']['output']>;
  presencePenalty: Maybe<Scalars['Float']['output']>;
  temperature: Maybe<Scalars['Float']['output']>;
  topP: Maybe<Scalars['Float']['output']>;
}

export interface CopilotPromptMessageInput {
  content: Scalars['String']['input'];
  params?: InputMaybe<Scalars['JSON']['input']>;
  role: CopilotPromptMessageRole;
}

export enum CopilotPromptMessageRole {
  assistant = 'assistant',
  system = 'system',
  user = 'user',
}

export interface CopilotPromptMessageType {
  __typename?: 'CopilotPromptMessageType';
  content: Scalars['String']['output'];
  params: Maybe<Scalars['JSON']['output']>;
  role: CopilotPromptMessageRole;
}

export interface CopilotPromptNotFoundDataType {
  __typename?: 'CopilotPromptNotFoundDataType';
  name: Scalars['String']['output'];
}

export interface CopilotPromptType {
  __typename?: 'CopilotPromptType';
  action: Maybe<Scalars['String']['output']>;
  config: Maybe<CopilotPromptConfigType>;
  messages: Array<CopilotPromptMessageType>;
  model: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface CopilotProviderNotSupportedDataType {
  __typename?: 'CopilotProviderNotSupportedDataType';
  kind: Scalars['String']['output'];
  provider: Scalars['String']['output'];
}

export interface CopilotProviderSideErrorDataType {
  __typename?: 'CopilotProviderSideErrorDataType';
  kind: Scalars['String']['output'];
  message: Scalars['String']['output'];
  provider: Scalars['String']['output'];
}

export interface CopilotQuota {
  __typename?: 'CopilotQuota';
  limit: Maybe<Scalars['SafeInt']['output']>;
  used: Scalars['SafeInt']['output'];
}

export interface CopilotSessionType {
  __typename?: 'CopilotSessionType';
  docId: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  model: Scalars['String']['output'];
  optionalModels: Array<Scalars['String']['output']>;
  parentSessionId: Maybe<Scalars['ID']['output']>;
  pinned: Scalars['Boolean']['output'];
  promptName: Scalars['String']['output'];
  title: Maybe<Scalars['String']['output']>;
}

export interface CopilotWorkspaceConfig {
  __typename?: 'CopilotWorkspaceConfig';
  allIgnoredDocs: Array<CopilotWorkspaceIgnoredDoc>;
  ignoredDocs: PaginatedIgnoredDocsType;
  workspaceId: Scalars['String']['output'];
}

export interface CopilotWorkspaceConfigIgnoredDocsArgs {
  pagination: PaginationInput;
}

export interface CopilotWorkspaceIgnoredDoc {
  __typename?: 'CopilotWorkspaceIgnoredDoc';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Maybe<Scalars['String']['output']>;
  createdByAvatar: Maybe<Scalars['String']['output']>;
  docCreatedAt: Maybe<Scalars['DateTime']['output']>;
  docId: Scalars['String']['output'];
  docUpdatedAt: Maybe<Scalars['DateTime']['output']>;
  title: Maybe<Scalars['String']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
}

export interface CopilotWorkspaceIgnoredDocTypeEdge {
  __typename?: 'CopilotWorkspaceIgnoredDocTypeEdge';
  cursor: Scalars['String']['output'];
  node: CopilotWorkspaceIgnoredDoc;
}

export interface CorruptionReportForAiType {
  __typename?: 'CorruptionReportForAIType';
  appVersion: Maybe<Scalars['String']['output']>;
  browser: Maybe<Scalars['String']['output']>;
  clientTimestamp: Scalars['DateTime']['output'];
  clientTimezone: Scalars['String']['output'];
  corruptedDataPreviewHex: Maybe<Scalars['String']['output']>;
  corruptedDataSize: Scalars['Int']['output'];
  docId: Scalars['String']['output'];
  docTitle: Maybe<Scalars['String']['output']>;
  errorMessage: Scalars['String']['output'];
  errorType: Scalars['String']['output'];
  exportedAt: Scalars['DateTime']['output'];
  markdownPrompt: Scalars['String']['output'];
  operation: Scalars['String']['output'];
  os: Maybe<Scalars['String']['output']>;
  reportId: Scalars['String']['output'];
  serverTimestamp: Scalars['DateTime']['output'];
  status: CorruptionReportStatus;
  userId: Scalars['String']['output'];
  wasOnline: Scalars['Boolean']['output'];
  workspaceId: Scalars['String']['output'];
}

export interface CorruptionReportStatsType {
  __typename?: 'CorruptionReportStatsType';
  affectedDocs: Scalars['Int']['output'];
  affectedUsers: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  recovered: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  unrecoverable: Scalars['Int']['output'];
}

/** Status of a corruption report */
export enum CorruptionReportStatus {
  pending = 'pending',
  recovered = 'recovered',
  unrecoverable = 'unrecoverable',
}

export interface CorruptionReportType {
  __typename?: 'CorruptionReportType';
  appVersion: Maybe<Scalars['String']['output']>;
  binLength: Scalars['Int']['output'];
  binPreview: Maybe<Scalars['String']['output']>;
  browser: Maybe<Scalars['String']['output']>;
  clientTimestamp: Scalars['DateTime']['output'];
  clientTimezone: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  docId: Scalars['String']['output'];
  docTitleSnapshot: Maybe<Scalars['String']['output']>;
  errorMessage: Scalars['String']['output'];
  errorType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  operation: Scalars['String']['output'];
  os: Maybe<Scalars['String']['output']>;
  status: CorruptionReportStatus;
  userId: Scalars['String']['output'];
  wasOnline: Scalars['Boolean']['output'];
  workspaceId: Scalars['String']['output'];
}

/** sl-2q8e.2: Input for creating a draft snapshot */
export interface CreateAppBaseDraftInput {
  baseVersion?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Names a completed change: the current draft is kept as a version of its own
   * and this save starts the next one. Without it the draft is saved in place.
   */
  change?: InputMaybe<AppBaseDraftChangeInput>;
  viewConfig: Scalars['JSONObject']['input'];
}

/** sl-9qm.1.4: Input for creating an AppBase */
export interface CreateAppBaseInput {
  config?: InputMaybe<Scalars['JSONObject']['input']>;
  /** Optional explicit runtime mode. Only app-base is accepted. */
  productMode?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
}

export interface CreateChatMessageInput {
  attachments?: InputMaybe<Array<Scalars['String']['input']>>;
  blob?: InputMaybe<Scalars['Upload']['input']>;
  blobs?: InputMaybe<Array<Scalars['Upload']['input']>>;
  content?: InputMaybe<Scalars['String']['input']>;
  context?: InputMaybe<MessageContextInput>;
  sessionId: Scalars['String']['input'];
  threadId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface CreateChatSessionInput {
  docId?: InputMaybe<Scalars['String']['input']>;
  /** Model of the new agent; the prompt or workspace default when absent */
  model?: InputMaybe<Scalars['String']['input']>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  /** The prompt name to use for the session */
  promptName: Scalars['String']['input'];
  /** Thinking depth of the new agent; medium when absent */
  reasoningMode?: InputMaybe<Scalars['String']['input']>;
  /** true by default, compliant for old version */
  reuseLatestChat?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface CreateCheckoutSessionInput {
  cancelUrl?: InputMaybe<Scalars['String']['input']>;
  coupon?: InputMaybe<Scalars['String']['input']>;
  /** Start a free trial instead of paid checkout (sl-r9ix.1.1) */
  isTrial?: InputMaybe<Scalars['Boolean']['input']>;
  plan: Scalars['String']['input'];
  /** Direct payment provider Price ID (bypasses plan/recurring mapping) */
  providerPriceId?: InputMaybe<Scalars['String']['input']>;
  recurring?: InputMaybe<SubscriptionRecurring>;
  /** Deprecated alias for providerPriceId. Kept for Stripe-era API compatibility. */
  stripePriceId?: InputMaybe<Scalars['String']['input']>;
  successCallbackLink: Scalars['String']['input'];
  variant?: InputMaybe<SubscriptionVariant>;
  /** Withdrawal consent (§356 BGB) — user waives right of withdrawal */
  withdrawalConsent: Scalars['Boolean']['input'];
}

export interface CreateCopilotPromptInput {
  action?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CopilotPromptConfigInput>;
  messages: Array<CopilotPromptMessageInput>;
  model: Scalars['String']['input'];
  name: Scalars['String']['input'];
}

export interface CreateFolderInput {
  /** Optional explicit ID (e.g. from Y.js frontend folder) */
  id?: InputMaybe<Scalars['String']['input']>;
  inheritPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface CreateMailFolderInput {
  accountId: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  parentFolderId?: InputMaybe<Scalars['String']['input']>;
  parentPath?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface CreateSkillInput {
  description: Scalars['String']['input'];
  instructions: Scalars['String']['input'];
  name: Scalars['String']['input'];
  toolNames: Array<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface CreateUserInput {
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
}

export interface CreateWorkspaceMateInput {
  description: Scalars['String']['input'];
  /** Folders the new Mate is invited to as Editor; all are checked first, a refused one creates no Mate */
  folderIds?: InputMaybe<Array<Scalars['String']['input']>>;
  instructions: Scalars['String']['input'];
  name: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface CredentialsRequirementType {
  __typename?: 'CredentialsRequirementType';
  password: PasswordLimitsType;
}

/** sl-opil.6.1: Credit balance for a workspace */
export interface CreditBalanceType {
  __typename?: 'CreditBalanceType';
  /** sl-m82f.2.2: Micro-credits used with context='ai' in current billing period */
  aiUsedMicro: Scalars['String']['output'];
  /** Micro-credits remaining (string for BigInt serialization) */
  balanceMicro: Scalars['String']['output'];
  /** sl-m82f.2.2: AI-context used as display credits */
  displayAiUsed: Scalars['Float']['output'];
  /** Display credits (human-readable float) */
  displayBalance: Scalars['Float']['output'];
  /** Monthly grant remaining as display credits */
  displayMonthlyGrant: Scalars['Float']['output'];
  /** Monthly credits used as display credits */
  displayMonthlyUsed: Scalars['Float']['output'];
  /** sl-m82f.2.2: Other/legacy used as display credits */
  displayOtherUsed: Scalars['Float']['output'];
  /** sl-opil.13.3: Subscription remaining as display credits */
  displaySubscriptionRemaining: Scalars['Float']['output'];
  /** sl-m82f.2.2: Workflow-context used as display credits */
  displayWorkflowUsed: Scalars['Float']['output'];
  /** Whether the credits left count as low (one rule for chat, settings and warnings) */
  lowBalance: Scalars['Boolean']['output'];
  /** Below this share of the period's credits left, in whole percent, the balance counts as low */
  lowBalancePercent: Scalars['Int']['output'];
  /** Monthly grant remaining in micro-credits */
  monthlyGrantMicro: Scalars['String']['output'];
  /** Monthly credits used in micro-credits */
  monthlyUsedMicro: Scalars['String']['output'];
  /** sl-m82f.2.2: Micro-credits used with context=NULL (legacy/unclassified) */
  otherUsedMicro: Scalars['String']['output'];
  /** Current billing period end */
  periodEnd: Scalars['DateTime']['output'];
  /** Current billing period start */
  periodStart: Scalars['DateTime']['output'];
  /** Purchased credits remaining in micro-credits */
  purchasedRemainingMicro: Scalars['String']['output'];
  /** Share of the period's credits left in whole percent; null when nothing was granted */
  remainingPercent: Maybe<Scalars['Int']['output']>;
  /** sl-opil.13.3: Subscription grant in micro-credits (expires monthly) */
  subscriptionGrantMicro: Scalars['String']['output'];
  /** sl-opil.13.3: Subscription remaining in micro-credits */
  subscriptionRemainingMicro: Scalars['String']['output'];
  /** sl-opil.13.3: Subscription used in micro-credits */
  subscriptionUsedMicro: Scalars['String']['output'];
  /** sl-m82f.2.2: Micro-credits used with context='workflow' in current billing period */
  workflowUsedMicro: Scalars['String']['output'];
}

/** sl-k78j.1.2: Available credit pack for purchase. Pricing from provider catalog (SSOT). */
export interface CreditPackType {
  __typename?: 'CreditPackType';
  credits: Scalars['Int']['output'];
  /** ISO 4217 currency code (e.g. 'eur'). Null if no provider price found. */
  currency: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** Billing interval: 'month', 'year', or null for one-time. */
  interval: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  packType: Scalars['String']['output'];
  providerProductId: Maybe<Scalars['String']['output']>;
  stripeProductId: Maybe<Scalars['String']['output']>;
  /** Unit amount in smallest currency unit (e.g. cents). Null if no provider price found. */
  unitAmount: Maybe<Scalars['Int']['output']>;
}

/** sl-qhe4: Credit subscription billing lifecycle state */
export enum CreditSubscriptionStatus {
  active = 'active',
  canceled = 'canceled',
}

/** sl-opil.6.1: Paginated credit transaction list */
export interface CreditTransactionConnection {
  __typename?: 'CreditTransactionConnection';
  edges: Array<CreditTransactionEdge>;
  pageInfo: CreditTransactionPageInfo;
}

/** sl-opil.6.1: Credit transaction edge for pagination */
export interface CreditTransactionEdge {
  __typename?: 'CreditTransactionEdge';
  cursor: Scalars['String']['output'];
  node: CreditTransactionType;
}

/** sl-opil.6.1: Page info for credit transaction pagination */
export interface CreditTransactionPageInfo {
  __typename?: 'CreditTransactionPageInfo';
  endCursor: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
}

/** sl-opil.6.1: Credit transaction record */
export interface CreditTransactionType {
  __typename?: 'CreditTransactionType';
  /** Amount in micro-credits (string for BigInt, negative for deductions) */
  amountMicro: Scalars['String']['output'];
  /** Balance after this transaction in micro-credits */
  balanceAfterMicro: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Human-readable description */
  description: Scalars['String']['output'];
  /** Absolute amount as display credits */
  displayAmount: Scalars['Float']['output'];
  /** Balance after as display credits */
  displayBalanceAfter: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  /** Transaction type */
  type: CreditTransactionTypeEnum;
}

/** sl-opil.6.1: Credit transaction type enum */
export enum CreditTransactionTypeEnum {
  EXPIRY = 'EXPIRY',
  GRANT = 'GRANT',
  PURCHASE = 'PURCHASE',
  REFUND = 'REFUND',
  SUBSCRIPTION_EXPIRY = 'SUBSCRIPTION_EXPIRY',
  SUBSCRIPTION_GRANT = 'SUBSCRIPTION_GRANT',
  USAGE = 'USAGE',
}

/** sl-9qm.8.2: Kind of registered host (subdomain on streamlain.site, or own domain) */
export enum CustomDomainKind {
  custom = 'custom',
  subdomain = 'subdomain',
}

/** sl-9qm.8.2: SSL certificate provisioning lifecycle for a custom domain */
export enum CustomDomainSslStatus {
  active = 'active',
  failed = 'failed',
  pending = 'pending',
  provisioning = 'provisioning',
}

/** sl-9qm.8.2: DNS verification lifecycle for a custom domain */
export enum CustomDomainStatus {
  active = 'active',
  failed = 'failed',
  pending = 'pending',
  verifying = 'verifying',
}

/** sl-9qm.8.2: Custom domain for a workspace's AppBases */
export interface CustomDomainType {
  __typename?: 'CustomDomainType';
  /** sl-ya4v.4b-E: Routing target — the AppBase this domain serves. */
  appBaseId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  domain: Scalars['String']['output'];
  id: Scalars['String']['output'];
  sslStatus: CustomDomainSslStatus;
  status: CustomDomainStatus;
  type: CustomDomainKind;
  updatedAt: Scalars['DateTime']['output'];
  /** Full origin URL for this domain, with backend-owned dev/prod scheme. */
  url: Scalars['String']['output'];
  verificationToken: Maybe<Scalars['String']['output']>;
  verifiedAt: Maybe<Scalars['DateTime']['output']>;
  workspaceId: Scalars['String']['output'];
}

/** sl-nkka: Input for adding a property (column) to a sharded database. */
export interface DatabaseAddPropertyInput {
  blockId: Scalars['String']['input'];
  columnData?: InputMaybe<Scalars['JSON']['input']>;
  columnId: Scalars['String']['input'];
  columnName: Scalars['String']['input'];
  columnType: Scalars['String']['input'];
  docId: Scalars['String']['input'];
  insertIndex?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['String']['input'];
}

/** sl-nkka: Result for `databaseAddProperty`. */
export interface DatabaseAddPropertyResult {
  __typename?: 'DatabaseAddPropertyResult';
  columnId: Scalars['String']['output'];
}

/**
 * sl-d7zo.7: Input for adding a row to a sharded database.
 *
 * `values` keys are column IDs (the stable property identifiers) — names
 * are UI labels only and not accepted here.
 */
export interface DatabaseAddRowInput {
  blockId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
  /**
   * Optional client-generated stable row ID. Required by synchronous
   * DataSource consumers that need the row ID before backend confirmation.
   */
  rowId?: InputMaybe<Scalars['String']['input']>;
  /** Logical insert index in the row order. Omit to append. */
  targetIndex?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Initial cell values keyed by column ID. JSON-encoded; backend
   * decodes per property type.
   */
  values?: InputMaybe<Scalars['JSON']['input']>;
  workspaceId: Scalars['String']['input'];
}

/**
 * sl-d7zo.7: Result of `databaseAddRow`. `rowId` is the stable block ID
 * of the new row, usable in subsequent cell or row mutations.
 */
export interface DatabaseAddRowResult {
  __typename?: 'DatabaseAddRowResult';
  rowId: Scalars['String']['output'];
}

export interface DatabaseBulkCellInput {
  columnId: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['JSON']['input']>;
}

export interface DatabaseBulkFailure {
  __typename?: 'DatabaseBulkFailure';
  code: DatabaseBulkFailureCode;
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
}

export enum DatabaseBulkFailureCode {
  ACCESS_REVOKED = 'ACCESS_REVOKED',
  CANCELLED = 'CANCELLED',
  DATABASE_BULK_BUDGET_EXCEEDED = 'DATABASE_BULK_BUDGET_EXCEEDED',
  DEADLINE_EXCEEDED = 'DEADLINE_EXCEEDED',
  INVALID_INPUT = 'INVALID_INPUT',
  MUTATION_GROUP_PENDING = 'MUTATION_GROUP_PENDING',
  POST_ACK_FAILURE = 'POST_ACK_FAILURE',
  RUN_INTERRUPTED_AFTER_RECEIPT = 'RUN_INTERRUPTED_AFTER_RECEIPT',
  WRITE_FAILED = 'WRITE_FAILED',
}

/** Explicit progressive writes. Counts are confirmed source rows, never cells. */
export enum DatabaseBulkKind {
  delete = 'delete',
  update = 'update',
}

export interface DatabaseBulkMutateInput {
  databaseId: Scalars['ID']['input'];
  docId: Scalars['ID']['input'];
  kind: DatabaseBulkKind;
  operationId: Scalars['String']['input'];
  rows: Array<DatabaseBulkRowInput>;
  workspaceId: Scalars['ID']['input'];
}

export interface DatabaseBulkReceipt {
  __typename?: 'DatabaseBulkReceipt';
  deadlineAt: Scalars['String']['output'];
  groupId: Scalars['ID']['output'];
  mutationId: Scalars['String']['output'];
  operationId: Scalars['String']['output'];
  receiptDigest: Maybe<Scalars['String']['output']>;
  sourceRowIds: Array<Scalars['ID']['output']>;
  state: DatabaseBulkReceiptState;
  workspaceId: Scalars['ID']['output'];
}

export enum DatabaseBulkReceiptState {
  CANCELLED = 'CANCELLED',
  CLAIMED = 'CLAIMED',
  COMMITTED = 'COMMITTED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  QUARANTINED = 'QUARANTINED',
}

export interface DatabaseBulkReceiptStatus {
  __typename?: 'DatabaseBulkReceiptStatus';
  failureClass: Maybe<Scalars['String']['output']>;
  groupId: Scalars['String']['output'];
  operationId: Scalars['String']['output'];
  receiptDigest: Maybe<Scalars['String']['output']>;
  state: DatabaseBulkReceiptState;
  workspaceId: Scalars['ID']['output'];
}

export interface DatabaseBulkReceiptStatusInput {
  databaseId: Scalars['ID']['input'];
  docId: Scalars['ID']['input'];
  groupId: Scalars['String']['input'];
  operationId: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
}

export interface DatabaseBulkResult {
  __typename?: 'DatabaseBulkResult';
  acknowledgement: Scalars['String']['output'];
  confirmedCount: Scalars['SafeInt']['output'];
  databaseId: Scalars['ID']['output'];
  error: Maybe<DatabaseBulkFailure>;
  iteratorExhausted: Scalars['Boolean']['output'];
  kind: DatabaseBulkKind;
  operationId: Scalars['String']['output'];
  receipt: Maybe<DatabaseBulkReceipt>;
  skippedChanged: Scalars['SafeInt']['output'];
  skippedMissing: Scalars['SafeInt']['output'];
  status: DatabaseBulkStatus;
}

export interface DatabaseBulkRowInput {
  cells?: InputMaybe<Array<DatabaseBulkCellInput>>;
  expectedCells?: InputMaybe<Scalars['JSON']['input']>;
  rowId: Scalars['ID']['input'];
}

export enum DatabaseBulkStatus {
  cancelled = 'cancelled',
  completed = 'completed',
  partial = 'partial',
  pending = 'pending',
}

/** sl-d7zo.7: One cell update — single (rowId, columnId) write. */
export interface DatabaseCellUpdateInput {
  /** Column ID (the property ID in the database schema). */
  columnId: Scalars['String']['input'];
  /** Stable row block ID (the rowId in the shard subdoc rows map). */
  rowId: Scalars['String']['input'];
  /** Serializable cell value (JSON-encoded). Property type defines decode rules. */
  value?: InputMaybe<Scalars['JSON']['input']>;
}

export interface DatabaseDeleteDependency {
  __typename?: 'DatabaseDeleteDependency';
  columns: Array<DatabaseDeleteDependencyColumn>;
  databaseId: Scalars['String']['output'];
  databaseTitle: Scalars['String']['output'];
  docId: Scalars['String']['output'];
  docTitle: Scalars['String']['output'];
  writable: Scalars['Boolean']['output'];
}

export interface DatabaseDeleteDependencyColumn {
  __typename?: 'DatabaseDeleteDependencyColumn';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

/**
 * sl-d7zo.7: Input for deleting a property (column) from a sharded
 * database. `columnId` is the stable property identifier from the
 * database schema.
 */
export interface DatabaseDeletePropertyInput {
  blockId: Scalars['String']['input'];
  columnId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

/**
 * sl-d7zo.7: Result for `databaseDeleteProperty`. `success` is true if
 * the column existed and was removed; on failure `error` describes why.
 */
export interface DatabaseDeletePropertyResult {
  __typename?: 'DatabaseDeletePropertyResult';
  columnId: Maybe<Scalars['String']['output']>;
  error: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
}

/** sl-d7zo.7: Input for deleting a row from a sharded database. */
export interface DatabaseDeleteRowInput {
  blockId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
  rowId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

/** sl-d7zo.7: Input for duplicating a property (column) of a sharded database. */
export interface DatabaseDuplicatePropertyInput {
  blockId: Scalars['String']['input'];
  /**
   * Copy the values of the source column into the copy. Default false, like the
   * column menu: only the column is added and no row block is written.
   */
  copyValues?: InputMaybe<Scalars['Boolean']['input']>;
  docId: Scalars['String']['input'];
  /**
   * Name of the backlink a relation copy gets in its target database. Default:
   * the title of the source database, made unique.
   */
  inverseColumnName?: InputMaybe<Scalars['String']['input']>;
  newColumnId: Scalars['String']['input'];
  newName: Scalars['String']['input'];
  sourceColumnId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

/** sl-d7zo.7: Result for `databaseDuplicateProperty`. */
export interface DatabaseDuplicatePropertyResult {
  __typename?: 'DatabaseDuplicatePropertyResult';
  columnId: Scalars['String']['output'];
}

/**
 * Input for moving a sharded database to the trash of the page that hosts
 * it or back. The server finds the host; `operationId` is client-generated, and
 * a repeat with the same id answers with the receipt of the first call.
 */
export interface DatabaseLifecycleInput {
  databaseId: Scalars['String']['input'];
  operationId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

/** Receipt of a committed database trash or restore; `state` is `COMMITTED`. */
export interface DatabaseLifecycleReceipt {
  __typename?: 'DatabaseLifecycleReceipt';
  operationId: Scalars['String']['output'];
  state: Scalars['String']['output'];
}

export interface DatabaseMoveInput {
  databaseId: Scalars['String']['input'];
  operationId: Scalars['String']['input'];
  source: DatabaseMoveSourceInput;
  target: DatabaseMoveTargetInput;
  workspaceId: Scalars['String']['input'];
}

export interface DatabaseMoveKept {
  __typename?: 'DatabaseMoveKept';
  code: Scalars['String']['output'];
  databaseId: Scalars['String']['output'];
  message: Scalars['String']['output'];
}

export interface DatabaseMoveReceipt {
  __typename?: 'DatabaseMoveReceipt';
  blockId: Scalars['String']['output'];
  databaseId: Scalars['String']['output'];
  docId: Scalars['String']['output'];
  kept: Maybe<DatabaseMoveKept>;
  operationId: Scalars['String']['output'];
  status: DatabaseMoveStatus;
}

/** sl-d7zo.7: Input for moving a sharded database row in logical row order. */
export interface DatabaseMoveRowInput {
  blockId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
  rowId: Scalars['String']['input'];
  targetIndex: Scalars['Int']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface DatabaseMoveSourceInput {
  blockId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
}

export enum DatabaseMoveStatus {
  kept = 'kept',
  moved = 'moved',
  unchanged = 'unchanged',
}

export interface DatabaseMoveTargetInput {
  docId: Scalars['String']['input'];
  index: Scalars['Int']['input'];
  parentBlockId: Scalars['String']['input'];
  xywh?: InputMaybe<Scalars['String']['input']>;
}

/**
 * Input for permanently deleting a trashed sharded database. `blockId` is
 * the database id whose host block was already moved to the trashcan of
 * `docId`.
 */
export interface DatabasePermanentlyDeleteInput {
  blockId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

/**
 * Result for `databasePermanentlyDelete`. Lists the removed root and
 * row-shard system documents; an already deleted database yields an empty
 * list.
 */
export interface DatabasePermanentlyDeleteResult {
  __typename?: 'DatabasePermanentlyDeleteResult';
  deletedSystemDocCount: Scalars['Int']['output'];
  systemDocIds: Array<Scalars['String']['output']>;
}

/**
 * sl-d7zo.7: Input for renaming a property (column) of a sharded
 * database.
 */
export interface DatabaseRenamePropertyInput {
  blockId: Scalars['String']['input'];
  columnId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
  newName: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

/** sl-d7zo.7: Result for `databaseRenameProperty`. */
export interface DatabaseRenamePropertyResult {
  __typename?: 'DatabaseRenamePropertyResult';
  columnId: Scalars['String']['output'];
}

/** sl-nkka: Input for persisting property data changes such as select options. */
export interface DatabaseSetPropertyDataInput {
  blockId: Scalars['String']['input'];
  columnData?: InputMaybe<Scalars['JSON']['input']>;
  columnId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

/** sl-nkka: Result for `databaseSetPropertyData`. */
export interface DatabaseSetPropertyDataResult {
  __typename?: 'DatabaseSetPropertyDataResult';
  columnId: Scalars['String']['output'];
}

/** sl-d7zo.7: Input for changing a property type of a sharded database. */
export interface DatabaseSetPropertyTypeInput {
  blockId: Scalars['String']['input'];
  columnData?: InputMaybe<Scalars['JSON']['input']>;
  columnId: Scalars['String']['input'];
  columnType: Scalars['String']['input'];
  docId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

/** sl-d7zo.7: Result for `databaseSetPropertyType`. */
export interface DatabaseSetPropertyTypeResult {
  __typename?: 'DatabaseSetPropertyTypeResult';
  columnId: Scalars['String']['output'];
}

/**
 * sl-d7zo.7: Update one or more cells across one row of a sharded database.
 *
 * Routes through DatabaseCrudService.updateCells / updateCellsBatch, which
 * commit atomically via DatabaseRowShardStorageService inside a single
 * `$transactionWithRLS`. The owning document's `databaseShardManifest` and
 * each touched shard subdoc are written in one Yjs transact.
 */
export interface DatabaseUpdateCellsInput {
  /** Database block ID inside the owning doc (the affine:database blockId). */
  blockId: Scalars['String']['input'];
  /** Owning document ID (the doc that hosts the database block). */
  docId: Scalars['String']['input'];
  /** One or more cell writes. May span multiple rows (cross-row batch). */
  updates: Array<DatabaseCellUpdateInput>;
  workspaceId: Scalars['String']['input'];
}

/**
 * sl-d7zo.7: Result for `databaseUpdateCells`. `affectedRowIds` is the
 * distinct set of rows that received at least one cell write.
 */
export interface DatabaseUpdateCellsResult {
  __typename?: 'DatabaseUpdateCellsResult';
  affectedRowIds: Array<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
}

export interface DeleteAccount {
  __typename?: 'DeleteAccount';
  success: Scalars['Boolean']['output'];
}

export interface DeleteSessionInput {
  docId?: InputMaybe<Scalars['String']['input']>;
  sessionIds: Array<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
}

/** Detach an AppBase data-source binding without deleting the source database. */
export interface DetachAppBaseDatabaseInput {
  confirmed: Scalars['Boolean']['input'];
  sourceKey: Scalars['String']['input'];
}

/** sl-qsjm.3: Device trust entry */
export interface DeviceTrustType {
  __typename?: 'DeviceTrustType';
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  label: Maybe<Scalars['String']['output']>;
}

export interface DocActionDeniedDataType {
  __typename?: 'DocActionDeniedDataType';
  action: Scalars['String']['output'];
  docId: Scalars['String']['output'];
  spaceId: Scalars['String']['output'];
}

export interface DocCreatePreflightInput {
  docId: Scalars['String']['input'];
  targetFolderId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
}

export enum DocCreatePreflightReason {
  ALLOWED = 'ALLOWED',
  GUEST_EXPIRED = 'GUEST_EXPIRED',
  MEMBERSHIP_DENIED = 'MEMBERSHIP_DENIED',
  SYSTEM_DOC_DENIED = 'SYSTEM_DOC_DENIED',
  TARGET_FOLDER_DENIED = 'TARGET_FOLDER_DENIED',
  TARGET_FOLDER_REQUIRED = 'TARGET_FOLDER_REQUIRED',
  WORKSPACE_CREATE_DENIED = 'WORKSPACE_CREATE_DENIED',
}

export interface DocCreatePreflightResult {
  __typename?: 'DocCreatePreflightResult';
  allowed: Scalars['Boolean']['output'];
  reason: DocCreatePreflightReason;
  targetFolderId: Maybe<Scalars['String']['output']>;
}

export interface DocEffectiveAccessEntryType {
  __typename?: 'DocEffectiveAccessEntryType';
  areaBoundaryKind: Maybe<Scalars['String']['output']>;
  areaBoundaryRootFolderId: Maybe<Scalars['String']['output']>;
  areaBoundaryRootName: Maybe<Scalars['String']['output']>;
  avatarUrl: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  effectiveRole: DocRole;
  email: Maybe<Scalars['String']['output']>;
  isAreaBlocked: Scalars['Boolean']['output'];
  isDirectOverride: Scalars['Boolean']['output'];
  isInheritanceBlocked: Scalars['Boolean']['output'];
  isInherited: Scalars['Boolean']['output'];
  memberCount: Maybe<Scalars['Int']['output']>;
  permissionGraphVersion: Scalars['Int']['output'];
  principalId: Scalars['String']['output'];
  principalType: Scalars['String']['output'];
  sourceId: Maybe<Scalars['String']['output']>;
  sourceName: Maybe<Scalars['String']['output']>;
  sourceType: Scalars['String']['output'];
}

/** sl-jsx3.11.5: Group role assignment on a doc */
export interface DocGroupRoleType {
  __typename?: 'DocGroupRoleType';
  areaBoundaryKind: Maybe<Scalars['String']['output']>;
  areaBoundaryRootFolderId: Maybe<Scalars['String']['output']>;
  areaBoundaryRootName: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  docId: Scalars['String']['output'];
  groupId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isAreaBlocked: Scalars['Boolean']['output'];
  role: DocRole;
}

/** A single entry in the doc history timeline */
export interface DocHistoryEntryType {
  __typename?: 'DocHistoryEntryType';
  /** Cumulative size of all history entries up to this point */
  cumulativeSize: Scalars['Int']['output'];
  /** Fingerprint for grouping identical entries */
  dataFingerprint: Scalars['String']['output'];
  editorId: Maybe<Scalars['String']['output']>;
  /** Entry type: 'content' (has structs) or 'delete' (only DeleteSet) */
  entryType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isValid: Scalars['Boolean']['output'];
  size: Scalars['Int']['output'];
  timestamp: Scalars['DateTime']['output'];
  validationError: Maybe<Scalars['String']['output']>;
}

export interface DocHistoryNotFoundDataType {
  __typename?: 'DocHistoryNotFoundDataType';
  docId: Scalars['String']['output'];
  spaceId: Scalars['String']['output'];
  timestamp: Scalars['Int']['output'];
}

/** Doc history timeline with validation status */
export interface DocHistoryTimelineType {
  __typename?: 'DocHistoryTimelineType';
  corruptEntries: Scalars['Int']['output'];
  docId: Scalars['String']['output'];
  entries: Array<DocHistoryEntryType>;
  suggestedRestorePoint: Maybe<Scalars['DateTime']['output']>;
  totalEntries: Scalars['Int']['output'];
  validEntries: Scalars['Int']['output'];
}

export interface DocHistoryType {
  __typename?: 'DocHistoryType';
  editor: Maybe<EditorType>;
  id: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  workspaceId: Scalars['String']['output'];
}

export interface DocInheritedAccessEdge {
  __typename?: 'DocInheritedAccessEdge';
  cursor: Scalars['String']['output'];
  node: DocEffectiveAccessEntryType;
}

/** The direct role of a workspace Mate on a doc */
export interface DocMateRoleType {
  __typename?: 'DocMateRoleType';
  mateId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  role: DocRole;
}

/** Doc mode */
export enum DocMode {
  edgeless = 'edgeless',
  page = 'page',
}

export interface DocNotFoundDataType {
  __typename?: 'DocNotFoundDataType';
  docId: Scalars['String']['output'];
  spaceId: Scalars['String']['output'];
}

export interface DocPermissions {
  __typename?: 'DocPermissions';
  Doc_Comments_Create: Scalars['Boolean']['output'];
  Doc_Comments_Delete: Scalars['Boolean']['output'];
  Doc_Comments_Read: Scalars['Boolean']['output'];
  Doc_Comments_Resolve: Scalars['Boolean']['output'];
  Doc_Copy: Scalars['Boolean']['output'];
  Doc_Delete: Scalars['Boolean']['output'];
  Doc_Duplicate: Scalars['Boolean']['output'];
  Doc_Properties_Read: Scalars['Boolean']['output'];
  Doc_Properties_Update: Scalars['Boolean']['output'];
  Doc_Publish: Scalars['Boolean']['output'];
  Doc_Read: Scalars['Boolean']['output'];
  Doc_Restore: Scalars['Boolean']['output'];
  Doc_TransferOwner: Scalars['Boolean']['output'];
  Doc_Trash: Scalars['Boolean']['output'];
  Doc_Update: Scalars['Boolean']['output'];
  Doc_Users_Manage: Scalars['Boolean']['output'];
  Doc_Users_Read: Scalars['Boolean']['output'];
}

export interface DocPublicSharingType {
  __typename?: 'DocPublicSharingType';
  canEnable: Scalars['Boolean']['output'];
  canRevoke: Scalars['Boolean']['output'];
  manual: Scalars['Boolean']['output'];
  otherSourcesCount: Scalars['Int']['output'];
  public: Scalars['Boolean']['output'];
}

/** User permission in doc */
export enum DocRole {
  Commenter = 'Commenter',
  Editor = 'Editor',
  Manager = 'Manager',
  None = 'None',
  Owner = 'Owner',
  Reader = 'Reader',
}

/** E040: Server-side size info for a single document */
export interface DocSizeEntryType {
  __typename?: 'DocSizeEntryType';
  createdAt: Scalars['DateTime']['output'];
  docId: Scalars['String']['output'];
  historyCount: Scalars['Int']['output'];
  historySize: Scalars['Int']['output'];
  snapshotSize: Scalars['Int']['output'];
  title: Maybe<Scalars['String']['output']>;
  totalSize: Scalars['Int']['output'];
}

/** E029-COMPACT: Document size info for monitoring */
export interface DocSizeInfoType {
  __typename?: 'DocSizeInfoType';
  docId: Scalars['String']['output'];
  exceedsAutoThreshold: Scalars['Boolean']['output'];
  exceedsDocAlertThreshold: Scalars['Boolean']['output'];
  exceedsWsAlertThreshold: Scalars['Boolean']['output'];
  historyCount: Scalars['Int']['output'];
  lastModified: Maybe<Scalars['DateTime']['output']>;
  snapshotSizeBytes: Scalars['Int']['output'];
  snapshotSizeMB: Scalars['Float']['output'];
}

/** sl-xbxb: Doc-tag mapping (which tags are assigned to which doc) */
export interface DocTagIdsType {
  __typename?: 'DocTagIdsType';
  docId: Scalars['String']['output'];
  tagIds: Array<Scalars['String']['output']>;
}

export interface DocType {
  __typename?: 'DocType';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Doc create user */
  createdBy: Maybe<PublicUserType>;
  creatorId: Maybe<Scalars['String']['output']>;
  defaultRole: DocRole;
  defaultRoleDirect: Scalars['Boolean']['output'];
  /** paginated doc granted users list */
  grantedUsersList: PaginatedGrantedDocUserType;
  id: Scalars['String']['output'];
  inheritedAccess: PaginatedDocInheritedAccessType;
  /** Doc last updated user */
  lastUpdatedBy: Maybe<PublicUserType>;
  lastUpdaterId: Maybe<Scalars['String']['output']>;
  /** Doc metadata */
  meta: WorkspaceDocMeta;
  mode: PublicDocMode;
  permissionGraphVersion: Scalars['Int']['output'];
  permissions: DocPermissions;
  public: Scalars['Boolean']['output'];
  publicSharing: Maybe<DocPublicSharingType>;
  summary: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  /** Whether the doc is in trash */
  trashed: Scalars['Boolean']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  workspaceId: Scalars['String']['output'];
}

export interface DocTypeGrantedUsersListArgs {
  guestsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  includeCandidates?: InputMaybe<Scalars['Boolean']['input']>;
  pagination: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
}

export interface DocTypeInheritedAccessArgs {
  pagination: PaginationInput;
}

export interface DocTypeEdge {
  __typename?: 'DocTypeEdge';
  cursor: Scalars['String']['output'];
  node: DocType;
}

export interface DocUpdateBlockedDataType {
  __typename?: 'DocUpdateBlockedDataType';
  docId: Scalars['String']['output'];
  spaceId: Scalars['String']['output'];
}

export interface EditorType {
  __typename?: 'EditorType';
  avatarUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
}

/** Server-owned app-base data-source request. */
export interface EnsureAppBaseDataSourceRequestInput {
  contentModel: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  role: Scalars['String']['input'];
  sourceKey: Scalars['String']['input'];
}

/** Input for ensuring AppBase data sources before client use. */
export interface EnsureAppBaseDataSourcesInput {
  requests: Array<EnsureAppBaseDataSourceRequestInput>;
}

export type ErrorDataUnion =
  | AlreadyInSpaceDataType
  | BlobNotFoundDataType
  | CopilotContextFileNotSupportedDataType
  | CopilotDocNotFoundDataType
  | CopilotFailedToAddWorkspaceFileEmbeddingDataType
  | CopilotFailedToGenerateEmbeddingDataType
  | CopilotFailedToMatchContextDataType
  | CopilotFailedToMatchGlobalContextDataType
  | CopilotFailedToModifyContextDataType
  | CopilotInvalidContextDataType
  | CopilotMessageNotFoundDataType
  | CopilotPromptNotFoundDataType
  | CopilotProviderNotSupportedDataType
  | CopilotProviderSideErrorDataType
  | DocActionDeniedDataType
  | DocHistoryNotFoundDataType
  | DocNotFoundDataType
  | DocUpdateBlockedDataType
  | ExpectToGrantDocUserRolesDataType
  | ExpectToRevokeDocUserRolesDataType
  | ExpectToUpdateDocUserRoleDataType
  | GraphqlBadRequestDataType
  | HttpRequestErrorDataType
  | InvalidAppConfigDataType
  | InvalidAppConfigInputDataType
  | InvalidEmailDataType
  | InvalidHistoryTimestampDataType
  | InvalidIndexerInputDataType
  | InvalidOauthCallbackCodeDataType
  | InvalidOauthResponseDataType
  | InvalidPasswordLengthDataType
  | InvalidRuntimeConfigTypeDataType
  | InvalidSearchProviderRequestDataType
  | MemberNotFoundInSpaceDataType
  | MentionUserDocAccessDeniedDataType
  | MissingOauthQueryParameterDataType
  | NoCopilotProviderAvailableDataType
  | NoMoreSeatDataType
  | NotInSpaceDataType
  | QueryTooLongDataType
  | RuntimeConfigNotFoundDataType
  | SameSubscriptionRecurringDataType
  | SpaceAccessDeniedDataType
  | SpaceNotFoundDataType
  | SpaceOwnerNotFoundDataType
  | SpaceShouldHaveOnlyOneOwnerDataType
  | SubscriptionAlreadyExistsDataType
  | SubscriptionNotExistsDataType
  | SubscriptionPlanNotFoundDataType
  | UnknownOauthProviderDataType
  | UnsupportedClientVersionDataType
  | UnsupportedSubscriptionPlanDataType
  | ValidationErrorDataType
  | VersionRejectedDataType
  | WorkspacePermissionNotFoundDataType
  | WrongSignInCredentialsDataType;

export enum ErrorNames {
  ACCESS_DENIED = 'ACCESS_DENIED',
  ACTION_FORBIDDEN = 'ACTION_FORBIDDEN',
  ACTION_FORBIDDEN_ON_NON_TEAM_WORKSPACE = 'ACTION_FORBIDDEN_ON_NON_TEAM_WORKSPACE',
  ALREADY_IN_SPACE = 'ALREADY_IN_SPACE',
  AUTHENTICATION_REQUIRED = 'AUTHENTICATION_REQUIRED',
  BAD_REQUEST = 'BAD_REQUEST',
  BLOB_NOT_FOUND = 'BLOB_NOT_FOUND',
  BLOB_QUOTA_EXCEEDED = 'BLOB_QUOTA_EXCEEDED',
  CANNOT_DELETE_ACCOUNT_WITH_OWNED_TEAM_WORKSPACE = 'CANNOT_DELETE_ACCOUNT_WITH_OWNED_TEAM_WORKSPACE',
  CANNOT_DELETE_ALL_ADMIN_ACCOUNT = 'CANNOT_DELETE_ALL_ADMIN_ACCOUNT',
  CANNOT_DELETE_OWN_ACCOUNT = 'CANNOT_DELETE_OWN_ACCOUNT',
  CANT_UPDATE_ONETIME_PAYMENT_SUBSCRIPTION = 'CANT_UPDATE_ONETIME_PAYMENT_SUBSCRIPTION',
  CAN_NOT_BATCH_GRANT_DOC_OWNER_PERMISSIONS = 'CAN_NOT_BATCH_GRANT_DOC_OWNER_PERMISSIONS',
  CAN_NOT_REVOKE_YOURSELF = 'CAN_NOT_REVOKE_YOURSELF',
  CAPTCHA_VERIFICATION_FAILED = 'CAPTCHA_VERIFICATION_FAILED',
  COMMENT_ATTACHMENT_NOT_FOUND = 'COMMENT_ATTACHMENT_NOT_FOUND',
  COMMENT_ATTACHMENT_QUOTA_EXCEEDED = 'COMMENT_ATTACHMENT_QUOTA_EXCEEDED',
  COMMENT_NOT_FOUND = 'COMMENT_NOT_FOUND',
  COPILOT_ACTION_TAKEN = 'COPILOT_ACTION_TAKEN',
  COPILOT_CONTEXT_FILE_NOT_SUPPORTED = 'COPILOT_CONTEXT_FILE_NOT_SUPPORTED',
  COPILOT_DOCS_NOT_FOUND = 'COPILOT_DOCS_NOT_FOUND',
  COPILOT_DOC_NOT_FOUND = 'COPILOT_DOC_NOT_FOUND',
  COPILOT_EMBEDDING_DISABLED = 'COPILOT_EMBEDDING_DISABLED',
  COPILOT_EMBEDDING_UNAVAILABLE = 'COPILOT_EMBEDDING_UNAVAILABLE',
  COPILOT_FAILED_TO_ADD_WORKSPACE_FILE_EMBEDDING = 'COPILOT_FAILED_TO_ADD_WORKSPACE_FILE_EMBEDDING',
  COPILOT_FAILED_TO_CREATE_MESSAGE = 'COPILOT_FAILED_TO_CREATE_MESSAGE',
  COPILOT_FAILED_TO_GENERATE_EMBEDDING = 'COPILOT_FAILED_TO_GENERATE_EMBEDDING',
  COPILOT_FAILED_TO_GENERATE_TEXT = 'COPILOT_FAILED_TO_GENERATE_TEXT',
  COPILOT_FAILED_TO_MATCH_CONTEXT = 'COPILOT_FAILED_TO_MATCH_CONTEXT',
  COPILOT_FAILED_TO_MATCH_GLOBAL_CONTEXT = 'COPILOT_FAILED_TO_MATCH_GLOBAL_CONTEXT',
  COPILOT_FAILED_TO_MODIFY_CONTEXT = 'COPILOT_FAILED_TO_MODIFY_CONTEXT',
  COPILOT_INVALID_CONTEXT = 'COPILOT_INVALID_CONTEXT',
  COPILOT_MESSAGE_NOT_FOUND = 'COPILOT_MESSAGE_NOT_FOUND',
  COPILOT_PROMPT_INVALID = 'COPILOT_PROMPT_INVALID',
  COPILOT_PROMPT_NOT_FOUND = 'COPILOT_PROMPT_NOT_FOUND',
  COPILOT_PROVIDER_NOT_SUPPORTED = 'COPILOT_PROVIDER_NOT_SUPPORTED',
  COPILOT_PROVIDER_SIDE_ERROR = 'COPILOT_PROVIDER_SIDE_ERROR',
  COPILOT_QUOTA_EXCEEDED = 'COPILOT_QUOTA_EXCEEDED',
  COPILOT_SESSION_DELETED = 'COPILOT_SESSION_DELETED',
  COPILOT_SESSION_INVALID_INPUT = 'COPILOT_SESSION_INVALID_INPUT',
  COPILOT_SESSION_NOT_FOUND = 'COPILOT_SESSION_NOT_FOUND',
  COPILOT_TRANSCRIPTION_AUDIO_NOT_PROVIDED = 'COPILOT_TRANSCRIPTION_AUDIO_NOT_PROVIDED',
  COPILOT_TRANSCRIPTION_JOB_EXISTS = 'COPILOT_TRANSCRIPTION_JOB_EXISTS',
  COPILOT_TRANSCRIPTION_JOB_NOT_FOUND = 'COPILOT_TRANSCRIPTION_JOB_NOT_FOUND',
  CUSTOMER_PORTAL_CREATE_FAILED = 'CUSTOMER_PORTAL_CREATE_FAILED',
  DATABASE_LIMIT_EXCEEDED = 'DATABASE_LIMIT_EXCEEDED',
  DOC_ACTION_DENIED = 'DOC_ACTION_DENIED',
  DOC_DEFAULT_ROLE_CAN_NOT_BE_OWNER = 'DOC_DEFAULT_ROLE_CAN_NOT_BE_OWNER',
  DOC_HISTORY_NOT_FOUND = 'DOC_HISTORY_NOT_FOUND',
  DOC_IS_NOT_PUBLIC = 'DOC_IS_NOT_PUBLIC',
  DOC_NOT_FOUND = 'DOC_NOT_FOUND',
  DOC_UPDATE_BLOCKED = 'DOC_UPDATE_BLOCKED',
  EARLY_ACCESS_REQUIRED = 'EARLY_ACCESS_REQUIRED',
  EMAIL_ALREADY_USED = 'EMAIL_ALREADY_USED',
  EMAIL_SERVICE_NOT_CONFIGURED = 'EMAIL_SERVICE_NOT_CONFIGURED',
  EMAIL_TOKEN_NOT_FOUND = 'EMAIL_TOKEN_NOT_FOUND',
  EMAIL_VERIFICATION_REQUIRED = 'EMAIL_VERIFICATION_REQUIRED',
  EXPECT_TO_GRANT_DOC_USER_ROLES = 'EXPECT_TO_GRANT_DOC_USER_ROLES',
  EXPECT_TO_PUBLISH_DOC = 'EXPECT_TO_PUBLISH_DOC',
  EXPECT_TO_REVOKE_DOC_USER_ROLES = 'EXPECT_TO_REVOKE_DOC_USER_ROLES',
  EXPECT_TO_REVOKE_PUBLIC_DOC = 'EXPECT_TO_REVOKE_PUBLIC_DOC',
  EXPECT_TO_UPDATE_DOC_USER_ROLE = 'EXPECT_TO_UPDATE_DOC_USER_ROLE',
  FAILED_TO_CHECKOUT = 'FAILED_TO_CHECKOUT',
  FAILED_TO_SAVE_UPDATES = 'FAILED_TO_SAVE_UPDATES',
  FAILED_TO_UPSERT_SNAPSHOT = 'FAILED_TO_UPSERT_SNAPSHOT',
  GRAPHQL_BAD_REQUEST = 'GRAPHQL_BAD_REQUEST',
  HTTP_REQUEST_ERROR = 'HTTP_REQUEST_ERROR',
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  INVALID_APP_CONFIG = 'INVALID_APP_CONFIG',
  INVALID_APP_CONFIG_INPUT = 'INVALID_APP_CONFIG_INPUT',
  INVALID_AUTH_STATE = 'INVALID_AUTH_STATE',
  INVALID_CHECKOUT_PARAMETERS = 'INVALID_CHECKOUT_PARAMETERS',
  INVALID_EMAIL = 'INVALID_EMAIL',
  INVALID_EMAIL_TOKEN = 'INVALID_EMAIL_TOKEN',
  INVALID_HISTORY_TIMESTAMP = 'INVALID_HISTORY_TIMESTAMP',
  INVALID_INDEXER_INPUT = 'INVALID_INDEXER_INPUT',
  INVALID_INVITATION = 'INVALID_INVITATION',
  INVALID_OAUTH_CALLBACK_CODE = 'INVALID_OAUTH_CALLBACK_CODE',
  INVALID_OAUTH_CALLBACK_STATE = 'INVALID_OAUTH_CALLBACK_STATE',
  INVALID_OAUTH_RESPONSE = 'INVALID_OAUTH_RESPONSE',
  INVALID_PASSWORD_LENGTH = 'INVALID_PASSWORD_LENGTH',
  INVALID_RUNTIME_CONFIG_TYPE = 'INVALID_RUNTIME_CONFIG_TYPE',
  INVALID_SEARCH_PROVIDER_REQUEST = 'INVALID_SEARCH_PROVIDER_REQUEST',
  INVALID_SUBSCRIPTION_PARAMETERS = 'INVALID_SUBSCRIPTION_PARAMETERS',
  LINK_EXPIRED = 'LINK_EXPIRED',
  MAILER_SERVICE_IS_NOT_CONFIGURED = 'MAILER_SERVICE_IS_NOT_CONFIGURED',
  MANAGED_BY_APP_STORE_OR_PLAY = 'MANAGED_BY_APP_STORE_OR_PLAY',
  MEMBER_NOT_FOUND_IN_SPACE = 'MEMBER_NOT_FOUND_IN_SPACE',
  MEMBER_QUOTA_EXCEEDED = 'MEMBER_QUOTA_EXCEEDED',
  MENTION_USER_DOC_ACCESS_DENIED = 'MENTION_USER_DOC_ACCESS_DENIED',
  MENTION_USER_ONESELF_DENIED = 'MENTION_USER_ONESELF_DENIED',
  MISSING_OAUTH_QUERY_PARAMETER = 'MISSING_OAUTH_QUERY_PARAMETER',
  NETWORK_ERROR = 'NETWORK_ERROR',
  NEW_OWNER_IS_NOT_ACTIVE_MEMBER = 'NEW_OWNER_IS_NOT_ACTIVE_MEMBER',
  NOTIFICATION_NOT_FOUND = 'NOTIFICATION_NOT_FOUND',
  NOT_FOUND = 'NOT_FOUND',
  NOT_IN_SPACE = 'NOT_IN_SPACE',
  NO_COPILOT_PROVIDER_AVAILABLE = 'NO_COPILOT_PROVIDER_AVAILABLE',
  NO_MORE_SEAT = 'NO_MORE_SEAT',
  OAUTH_ACCOUNT_ALREADY_CONNECTED = 'OAUTH_ACCOUNT_ALREADY_CONNECTED',
  OAUTH_STATE_EXPIRED = 'OAUTH_STATE_EXPIRED',
  OWNER_CAN_NOT_LEAVE_WORKSPACE = 'OWNER_CAN_NOT_LEAVE_WORKSPACE',
  PASSWORD_REQUIRED = 'PASSWORD_REQUIRED',
  QUERY_TOO_LONG = 'QUERY_TOO_LONG',
  REPLY_NOT_FOUND = 'REPLY_NOT_FOUND',
  RUNTIME_CONFIG_NOT_FOUND = 'RUNTIME_CONFIG_NOT_FOUND',
  SAME_EMAIL_PROVIDED = 'SAME_EMAIL_PROVIDED',
  SAME_SUBSCRIPTION_RECURRING = 'SAME_SUBSCRIPTION_RECURRING',
  SEARCH_PROVIDER_NOT_FOUND = 'SEARCH_PROVIDER_NOT_FOUND',
  SIGN_UP_FORBIDDEN = 'SIGN_UP_FORBIDDEN',
  SPACE_ACCESS_DENIED = 'SPACE_ACCESS_DENIED',
  SPACE_NOT_FOUND = 'SPACE_NOT_FOUND',
  SPACE_OWNER_NOT_FOUND = 'SPACE_OWNER_NOT_FOUND',
  SPACE_SHOULD_HAVE_ONLY_ONE_OWNER = 'SPACE_SHOULD_HAVE_ONLY_ONE_OWNER',
  STORAGE_QUOTA_EXCEEDED = 'STORAGE_QUOTA_EXCEEDED',
  SUBSCRIPTION_ALREADY_EXISTS = 'SUBSCRIPTION_ALREADY_EXISTS',
  SUBSCRIPTION_EXPIRED = 'SUBSCRIPTION_EXPIRED',
  SUBSCRIPTION_HAS_BEEN_CANCELED = 'SUBSCRIPTION_HAS_BEEN_CANCELED',
  SUBSCRIPTION_HAS_NOT_BEEN_CANCELED = 'SUBSCRIPTION_HAS_NOT_BEEN_CANCELED',
  SUBSCRIPTION_NOT_EXISTS = 'SUBSCRIPTION_NOT_EXISTS',
  SUBSCRIPTION_PLAN_NOT_FOUND = 'SUBSCRIPTION_PLAN_NOT_FOUND',
  TOO_MANY_REQUEST = 'TOO_MANY_REQUEST',
  UNKNOWN_OAUTH_PROVIDER = 'UNKNOWN_OAUTH_PROVIDER',
  UNSPLASH_IS_NOT_CONFIGURED = 'UNSPLASH_IS_NOT_CONFIGURED',
  UNSUPPORTED_CLIENT_VERSION = 'UNSUPPORTED_CLIENT_VERSION',
  UNSUPPORTED_SUBSCRIPTION_PLAN = 'UNSUPPORTED_SUBSCRIPTION_PLAN',
  USER_AVATAR_NOT_FOUND = 'USER_AVATAR_NOT_FOUND',
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  VERSION_REJECTED = 'VERSION_REJECTED',
  WORKSPACE_ID_REQUIRED_FOR_TEAM_SUBSCRIPTION = 'WORKSPACE_ID_REQUIRED_FOR_TEAM_SUBSCRIPTION',
  WORKSPACE_ID_REQUIRED_TO_UPDATE_TEAM_SUBSCRIPTION = 'WORKSPACE_ID_REQUIRED_TO_UPDATE_TEAM_SUBSCRIPTION',
  WORKSPACE_PERMISSION_NOT_FOUND = 'WORKSPACE_PERMISSION_NOT_FOUND',
  WRONG_SIGN_IN_CREDENTIALS = 'WRONG_SIGN_IN_CREDENTIALS',
  WRONG_SIGN_IN_METHOD = 'WRONG_SIGN_IN_METHOD',
}

export interface ExpectToGrantDocUserRolesDataType {
  __typename?: 'ExpectToGrantDocUserRolesDataType';
  docId: Scalars['String']['output'];
  spaceId: Scalars['String']['output'];
}

export interface ExpectToRevokeDocUserRolesDataType {
  __typename?: 'ExpectToRevokeDocUserRolesDataType';
  docId: Scalars['String']['output'];
  spaceId: Scalars['String']['output'];
}

export interface ExpectToUpdateDocUserRoleDataType {
  __typename?: 'ExpectToUpdateDocUserRoleDataType';
  docId: Scalars['String']['output'];
  spaceId: Scalars['String']['output'];
}

export enum FeatureType {
  Admin = 'Admin',
}

export interface FolderEffectiveAccessEntryType {
  __typename?: 'FolderEffectiveAccessEntryType';
  areaBoundaryKind: Maybe<Scalars['String']['output']>;
  areaBoundaryRootFolderId: Maybe<Scalars['String']['output']>;
  areaBoundaryRootName: Maybe<Scalars['String']['output']>;
  avatarUrl: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  effectiveRole: FolderRole;
  email: Maybe<Scalars['String']['output']>;
  isAreaBlocked: Scalars['Boolean']['output'];
  isDirectOverride: Scalars['Boolean']['output'];
  isInheritanceBlocked: Scalars['Boolean']['output'];
  isInherited: Scalars['Boolean']['output'];
  membershipKind: Maybe<WorkspaceMembershipKind>;
  permissionGraphVersion: Scalars['Int']['output'];
  principalId: Scalars['String']['output'];
  principalType: Scalars['String']['output'];
  sourceId: Maybe<Scalars['String']['output']>;
  sourceName: Maybe<Scalars['String']['output']>;
  sourceType: Scalars['String']['output'];
  workspaceRole: Maybe<Permission>;
}

/** sl-jsx3.11.5: Group role assignment on a folder */
export interface FolderGroupRoleType {
  __typename?: 'FolderGroupRoleType';
  areaBoundaryKind: Maybe<Scalars['String']['output']>;
  areaBoundaryRootFolderId: Maybe<Scalars['String']['output']>;
  areaBoundaryRootName: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  folderId: Scalars['String']['output'];
  groupId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isAreaBlocked: Scalars['Boolean']['output'];
  role: FolderRole;
}

/** The direct role of a workspace Mate on a folder */
export interface FolderMateRoleType {
  __typename?: 'FolderMateRoleType';
  mateId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  role: FolderRole;
}

/** Folder owner information */
export interface FolderOwnerType {
  __typename?: 'FolderOwnerType';
  avatarUrl: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

/** Folder permissions for current user */
export interface FolderPermissions {
  __typename?: 'FolderPermissions';
  Folder_AddDoc: Scalars['Boolean']['output'];
  Folder_CreateSubfolder: Scalars['Boolean']['output'];
  Folder_Delete: Scalars['Boolean']['output'];
  Folder_Move: Scalars['Boolean']['output'];
  Folder_Read: Scalars['Boolean']['output'];
  Folder_RemoveDoc: Scalars['Boolean']['output'];
  Folder_Restore: Scalars['Boolean']['output'];
  Folder_Trash: Scalars['Boolean']['output'];
  Folder_Update: Scalars['Boolean']['output'];
  Folder_Users_Manage: Scalars['Boolean']['output'];
  Folder_Users_Read: Scalars['Boolean']['output'];
}

/** Folder role hierarchy: Owner > Admin > Editor > Reader */
export enum FolderRole {
  Admin = 'Admin',
  Editor = 'Editor',
  None = 'None',
  Owner = 'Owner',
  Reader = 'Reader',
}

/** Hierarchical folder for organizing documents */
export interface FolderType {
  __typename?: 'FolderType';
  children: Array<FolderType>;
  createdAt: Scalars['DateTime']['output'];
  docCount: Scalars['Int']['output'];
  /** IDs of documents linked to this folder */
  docIds: Array<Scalars['String']['output']>;
  effectiveAccess: Array<FolderEffectiveAccessEntryType>;
  grantedUsers: PaginatedGrantedFolderUserType;
  id: Scalars['String']['output'];
  immutable: Scalars['Boolean']['output'];
  inheritPermissions: Scalars['Boolean']['output'];
  isWorkspaceRoot: Scalars['Boolean']['output'];
  /** True when user sees only metadata (public folder, no role) */
  metadataOnly: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** The folder owner (user with Owner role) */
  owner: Maybe<FolderOwnerType>;
  ownerUserId: Maybe<Scalars['String']['output']>;
  parentId: Maybe<Scalars['String']['output']>;
  permissionGraphVersion: Scalars['Int']['output'];
  permissions: FolderPermissions;
  storageLimitBytes: Maybe<Scalars['Float']['output']>;
  storageUsedBytes: Maybe<Scalars['Float']['output']>;
  systemKind: Maybe<Scalars['String']['output']>;
  /** Whether this folder is in the trash */
  trashed: Scalars['Boolean']['output'];
  /** When the folder was trashed (null if not trashed) */
  trashedAt: Maybe<Scalars['DateTime']['output']>;
  /** User ID who trashed the folder */
  trashedBy: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  visibility: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
}

/** Hierarchical folder for organizing documents */
export interface FolderTypeGrantedUsersArgs {
  pagination: PaginationInput;
}

export interface ForkChatSessionInput {
  docId: Scalars['String']['input'];
  /** Identify a message in the array and keep it with all previous messages into a forked session. */
  latestMessageId?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface GenerateAccessTokenInput {
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
}

/** sl-xk37: Input for generating workspace MCP token */
export interface GenerateWorkspaceMcpTokenInput {
  /** Expiration in days (7, 30, 90) or null for unlimited */
  expirationDays?: InputMaybe<Scalars['Int']['input']>;
  /** Set true to revoke and replace an existing token for this member */
  replaceExisting?: InputMaybe<Scalars['Boolean']['input']>;
  targetUserId: Scalars['String']['input'];
  /** Deny-only tool restrictions for this grant. Missing means unrestricted. */
  toolPolicy?: InputMaybe<WorkspaceMcpToolPolicyInput>;
  workspaceId: Scalars['String']['input'];
}

export interface GetCorruptionReportsInput {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<CorruptionReportStatus>;
  workspaceId: Scalars['String']['input'];
}

/** Input for doc history timeline query */
export interface GetDocHistoryTimelineInput {
  before?: InputMaybe<Scalars['DateTime']['input']>;
  docId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface GrantDocUserRolesInput {
  docId: Scalars['String']['input'];
  role: DocRole;
  userIds: Array<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface GrantFolderRoleInput {
  folderId: Scalars['String']['input'];
  role: FolderRole;
  userId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

/** Input for granting MCP access to the current members of a workspace group */
export interface GrantWorkspaceMcpGroupInput {
  /** Expiration in days (7, 30, 90) or null for unlimited */
  expirationDays?: InputMaybe<Scalars['Int']['input']>;
  groupId: Scalars['String']['input'];
  /** Deny-only tool restrictions for every grant. Missing means unrestricted. */
  toolPolicy?: InputMaybe<WorkspaceMcpToolPolicyInput>;
  workspaceId: Scalars['String']['input'];
}

export interface GrantedDocUserType {
  __typename?: 'GrantedDocUserType';
  areaBoundaryKind: Maybe<Scalars['String']['output']>;
  areaBoundaryRootFolderId: Maybe<Scalars['String']['output']>;
  areaBoundaryRootName: Maybe<Scalars['String']['output']>;
  hasDirectGrant: Maybe<Scalars['Boolean']['output']>;
  houseGuestExpiresAt: Maybe<Scalars['DateTime']['output']>;
  isAreaBlocked: Scalars['Boolean']['output'];
  membershipKind: Maybe<WorkspaceMembershipKind>;
  role: DocRole;
  user: WorkspaceUserType;
  workspaceRole: Permission;
}

export interface GrantedDocUserTypeEdge {
  __typename?: 'GrantedDocUserTypeEdge';
  cursor: Scalars['String']['output'];
  node: GrantedDocUserType;
}

/** User with folder role */
export interface GrantedFolderUserType {
  __typename?: 'GrantedFolderUserType';
  areaBoundaryKind: Maybe<Scalars['String']['output']>;
  areaBoundaryRootFolderId: Maybe<Scalars['String']['output']>;
  areaBoundaryRootName: Maybe<Scalars['String']['output']>;
  isAreaBlocked: Scalars['Boolean']['output'];
  membershipKind: Maybe<WorkspaceMembershipKind>;
  role: FolderRole;
  user: UserType;
  workspaceRole: Permission;
}

/** sl-sdk6.6.3: An edge in the knowledge graph for visualization */
export interface GraphEdgeGql {
  __typename?: 'GraphEdgeGql';
  /** sl-f1sz.4.1: When this relation was created */
  createdAt: Maybe<Scalars['DateTime']['output']>;
  properties: Maybe<Scalars['JSON']['output']>;
  source: Scalars['String']['output'];
  target: Scalars['String']['output'];
  type: Scalars['String']['output'];
}

/** sl-sdk6.6.3: A node in the knowledge graph for visualization */
export interface GraphNodeGql {
  __typename?: 'GraphNodeGql';
  description: Maybe<Scalars['String']['output']>;
  /** sl-f1sz.4.1: Real-world event timestamp (if known) */
  eventTime: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** sl-f1sz.4.1: When this entity was ingested into the graph */
  ingestionTime: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  properties: Maybe<Scalars['JSON']['output']>;
  /** sl-iw27.4.2: Snapshot ID this node belongs to */
  snapshotId: Maybe<Scalars['String']['output']>;
  /** sl-iw27.4.2: Snapshot status (null = live, pending/stale = review overlay) */
  snapshotStatus: Maybe<Scalars['String']['output']>;
  /** Source document IDs for provenance and source filtering */
  sourceDocIds: Array<Scalars['String']['output']>;
  type: Scalars['String']['output'];
}

export interface GraphqlBadRequestDataType {
  __typename?: 'GraphqlBadRequestDataType';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
}

export interface HttpRequestErrorDataType {
  __typename?: 'HttpRequestErrorDataType';
  message: Scalars['String']['output'];
}

export interface ImportUsersInput {
  users: Array<CreateUserInput>;
}

export interface InvalidAppConfigDataType {
  __typename?: 'InvalidAppConfigDataType';
  hint: Scalars['String']['output'];
  key: Scalars['String']['output'];
  module: Scalars['String']['output'];
}

export interface InvalidAppConfigInputDataType {
  __typename?: 'InvalidAppConfigInputDataType';
  message: Scalars['String']['output'];
}

export interface InvalidEmailDataType {
  __typename?: 'InvalidEmailDataType';
  email: Scalars['String']['output'];
}

export interface InvalidHistoryTimestampDataType {
  __typename?: 'InvalidHistoryTimestampDataType';
  timestamp: Scalars['String']['output'];
}

export interface InvalidIndexerInputDataType {
  __typename?: 'InvalidIndexerInputDataType';
  reason: Scalars['String']['output'];
}

export interface InvalidOauthCallbackCodeDataType {
  __typename?: 'InvalidOauthCallbackCodeDataType';
  body: Scalars['String']['output'];
  status: Scalars['Int']['output'];
}

export interface InvalidOauthResponseDataType {
  __typename?: 'InvalidOauthResponseDataType';
  reason: Scalars['String']['output'];
}

export interface InvalidPasswordLengthDataType {
  __typename?: 'InvalidPasswordLengthDataType';
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
}

export interface InvalidRuntimeConfigTypeDataType {
  __typename?: 'InvalidRuntimeConfigTypeDataType';
  get: Scalars['String']['output'];
  key: Scalars['String']['output'];
  want: Scalars['String']['output'];
}

export interface InvalidSearchProviderRequestDataType {
  __typename?: 'InvalidSearchProviderRequestDataType';
  reason: Scalars['String']['output'];
  type: Scalars['String']['output'];
}

export interface InvitationAcceptedNotificationBodyType {
  __typename?: 'InvitationAcceptedNotificationBodyType';
  /** The user who created the notification, maybe null when user is deleted or sent by system */
  createdByUser: Maybe<PublicUserType>;
  inviteId: Scalars['ID']['output'];
  /** The type of the notification */
  type: NotificationType;
  workspace: Maybe<NotificationWorkspaceType>;
}

export interface InvitationBlockedNotificationBodyType {
  __typename?: 'InvitationBlockedNotificationBodyType';
  /** The user who created the notification, maybe null when user is deleted or sent by system */
  createdByUser: Maybe<PublicUserType>;
  inviteId: Scalars['ID']['output'];
  /** The type of the notification */
  type: NotificationType;
  workspace: Maybe<NotificationWorkspaceType>;
}

export interface InvitationNotificationBodyType {
  __typename?: 'InvitationNotificationBodyType';
  /** The user who created the notification, maybe null when user is deleted or sent by system */
  createdByUser: Maybe<PublicUserType>;
  inviteId: Scalars['ID']['output'];
  /** The type of the notification */
  type: NotificationType;
  workspace: Maybe<NotificationWorkspaceType>;
}

export interface InvitationReviewApprovedNotificationBodyType {
  __typename?: 'InvitationReviewApprovedNotificationBodyType';
  /** The user who created the notification, maybe null when user is deleted or sent by system */
  createdByUser: Maybe<PublicUserType>;
  inviteId: Scalars['ID']['output'];
  /** The type of the notification */
  type: NotificationType;
  workspace: Maybe<NotificationWorkspaceType>;
}

export interface InvitationReviewDeclinedNotificationBodyType {
  __typename?: 'InvitationReviewDeclinedNotificationBodyType';
  /** The user who created the notification, maybe null when user is deleted or sent by system */
  createdByUser: Maybe<PublicUserType>;
  /** The type of the notification */
  type: NotificationType;
  workspace: Maybe<NotificationWorkspaceType>;
}

export interface InvitationReviewRequestNotificationBodyType {
  __typename?: 'InvitationReviewRequestNotificationBodyType';
  /** The user who created the notification, maybe null when user is deleted or sent by system */
  createdByUser: Maybe<PublicUserType>;
  inviteId: Scalars['ID']['output'];
  /** The type of the notification */
  type: NotificationType;
  workspace: Maybe<NotificationWorkspaceType>;
}

export interface InvitationType {
  __typename?: 'InvitationType';
  /** Invitee information */
  invitee: WorkspaceUserType;
  /** Invitation status in workspace */
  status: Maybe<WorkspaceMemberStatus>;
  /** User information */
  user: WorkspaceUserType;
  /** Workspace information */
  workspace: InvitationWorkspaceType;
}

export interface InvitationWorkspaceType {
  __typename?: 'InvitationWorkspaceType';
  /** Base64 encoded avatar */
  avatar: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Workspace name */
  name: Scalars['String']['output'];
}

export interface InviteLink {
  __typename?: 'InviteLink';
  /** Invite link expire time */
  expireTime: Scalars['DateTime']['output'];
  /** Invite link */
  link: Scalars['String']['output'];
}

export interface InviteResult {
  __typename?: 'InviteResult';
  email: Scalars['String']['output'];
  /** Invite error */
  error: Maybe<Scalars['JSONObject']['output']>;
  /** Invite id, null if invite record create failed */
  inviteId: Maybe<Scalars['String']['output']>;
  /**
   * Invite email sent success
   * @deprecated Notification will be sent asynchronously
   */
  sentSuccess: Scalars['Boolean']['output'];
}

export interface InviteUserType {
  __typename?: 'InviteUserType';
  /** User avatar url */
  avatarUrl: Maybe<Scalars['String']['output']>;
  /**
   * User email verified
   * @deprecated useless
   */
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** User is disabled */
  disabled: Maybe<Scalars['Boolean']['output']>;
  /** User email */
  email: Maybe<Scalars['String']['output']>;
  /** User email verified */
  emailVerified: Maybe<Scalars['Boolean']['output']>;
  /** User password has been set */
  hasPassword: Maybe<Scalars['Boolean']['output']>;
  /** House guest expiry timestamp; null for other membership kinds */
  houseGuestExpiresAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** Invite id */
  inviteId: Scalars['String']['output'];
  /** Membership kind within this workspace */
  membershipKind: WorkspaceMembershipKind;
  /** User name */
  name: Maybe<Scalars['String']['output']>;
  /**
   * User permission in workspace
   * @deprecated Use role instead
   */
  permission: Permission;
  /** User role in workspace */
  role: Permission;
  /** Member invite status in workspace */
  status: WorkspaceMemberStatus;
}

/** sl-zvjz: Pending invoice summary (status open or uncollectible). */
export interface InvoicePreview {
  __typename?: 'InvoicePreview';
  amount: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  dueDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
}

export enum InvoiceStatus {
  Draft = 'Draft',
  Open = 'Open',
  Paid = 'Paid',
  Uncollectible = 'Uncollectible',
  Void = 'Void',
}

export interface InvoiceType {
  __typename?: 'InvoiceType';
  amount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastPaymentError: Maybe<Scalars['String']['output']>;
  link: Maybe<Scalars['String']['output']>;
  /** sl-7ikc.3.1: Stripe-hosted invoice PDF URL */
  pdfUrl: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  status: InvoiceStatus;
  updatedAt: Scalars['DateTime']['output'];
}

/** sl-iw27.4.2: KG Changelog entry (tracks node additions/removals on accept) */
export interface KgChangelogType {
  __typename?: 'KgChangelogType';
  after: Maybe<Scalars['JSONObject']['output']>;
  before: Maybe<Scalars['JSONObject']['output']>;
  changeType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  snapshotId: Scalars['String']['output'];
  targetEdgeId: Maybe<Scalars['String']['output']>;
  targetNodeId: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
}

/** sl-8g8i.5: KG Config Snapshot */
export interface KgConfigSnapshotType {
  __typename?: 'KgConfigSnapshotType';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
}

/** sl-8g8i.5: KG Config Key-Value */
export interface KgConfigValueType {
  __typename?: 'KgConfigValueType';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
  valueType: Scalars['String']['output'];
}

/** sl-iw27.4.2: Entity duplicate found during snapshot revalidation */
export interface KgDuplicateEntityType {
  __typename?: 'KgDuplicateEntityType';
  liveNodeId: Scalars['String']['output'];
  liveNodeName: Scalars['String']['output'];
  snapshotNodeId: Scalars['String']['output'];
  snapshotNodeName: Scalars['String']['output'];
}

/** sl-8g8i.5: KG Entity Type Configuration */
export interface KgEntityTypeType {
  __typename?: 'KgEntityTypeType';
  color: Scalars['String']['output'];
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  synonyms: Array<Scalars['String']['output']>;
}

/** sl-8g8i.5: KG Pipeline Step Configuration */
export interface KgPipelineStepType {
  __typename?: 'KgPipelineStepType';
  config: Scalars['JSON']['output'];
  dependencies: Array<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  stepType: Scalars['String']['output'];
}

/** sl-8g8i.5: KG Relation Type Configuration */
export interface KgRelationTypeType {
  __typename?: 'KgRelationTypeType';
  banned: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  semanticDescription: Scalars['String']['output'];
  synonyms: Array<Scalars['String']['output']>;
}

/** sl-iw27.4.2: Result of revalidating a stale snapshot */
export interface KgRevalidationResultType {
  __typename?: 'KgRevalidationResultType';
  duplicateEntities: Array<KgDuplicateEntityType>;
  isValid: Scalars['Boolean']['output'];
  orphanNodes: Array<Scalars['String']['output']>;
  snapshotId: Scalars['String']['output'];
}

/** sl-iw27.4.2: Snapshot with changelog details */
export interface KgSnapshotDetailsType {
  __typename?: 'KgSnapshotDetailsType';
  changelog: Array<KgChangelogType>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  parentSnapshotId: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  projectedBaseline: Maybe<Scalars['String']['output']>;
  staleSince: Maybe<Scalars['DateTime']['output']>;
  stats: Scalars['JSONObject']['output'];
  status: Scalars['String']['output'];
  trigger: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
}

/** sl-iw27.4.2: Timeline view with history + pending */
export interface KgSnapshotTimelineType {
  __typename?: 'KgSnapshotTimelineType';
  history: Array<KgSnapshotType>;
  pending: Array<KgSnapshotType>;
}

/** sl-iw27.4.2: KG Snapshot for pipeline review */
export interface KgSnapshotType {
  __typename?: 'KgSnapshotType';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  parentSnapshotId: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  projectedBaseline: Maybe<Scalars['String']['output']>;
  staleSince: Maybe<Scalars['DateTime']['output']>;
  stats: Scalars['JSONObject']['output'];
  status: Scalars['String']['output'];
  trigger: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
}

export interface LimitedUserType {
  __typename?: 'LimitedUserType';
  /** User email */
  email: Scalars['String']['output'];
  /** User password has been set */
  hasPassword: Maybe<Scalars['Boolean']['output']>;
}

/** sl-kaqr.4.1: Filter input for tenant listing */
export interface ListTenantInput {
  first?: InputMaybe<Scalars['Int']['input']>;
  nameFilter?: InputMaybe<Scalars['String']['input']>;
  planFilter?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}

export interface ListUserInput {
  activeInDays?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  planFilter?: InputMaybe<Scalars['String']['input']>;
  /** Case-insensitive match on e-mail or name */
  search?: InputMaybe<Scalars['String']['input']>;
  signupFrom?: InputMaybe<Scalars['DateTime']['input']>;
  signupTo?: InputMaybe<Scalars['DateTime']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  statusFilter?: InputMaybe<Scalars['String']['input']>;
}

/** sl-dkgt.1: Filter input for workspace listing */
export interface ListWorkspaceInput {
  createdFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  memberCountMax?: InputMaybe<Scalars['Int']['input']>;
  memberCountMin?: InputMaybe<Scalars['Int']['input']>;
  nameFilter?: InputMaybe<Scalars['String']['input']>;
  ownerFilter?: InputMaybe<Scalars['String']['input']>;
  planFilter?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  storageMax?: InputMaybe<Scalars['Float']['input']>;
  storageMin?: InputMaybe<Scalars['Float']['input']>;
}

export interface ListedBlob {
  __typename?: 'ListedBlob';
  createdAt: Scalars['String']['output'];
  key: Scalars['String']['output'];
  mime: Scalars['String']['output'];
  size: Scalars['Int']['output'];
}

/** sl-k94y.5.1: Deployment-wide locale settings sourced from `application_settings`. */
export interface LocaleSettingsType {
  __typename?: 'LocaleSettingsType';
  /** BCP-47 tags the deployment will accept on inbound writes (e.g. publish boundaries). */
  availableLocales: Array<Scalars['String']['output']>;
  /** Tag used as the i18n-fallback baseline for WORKSPACE/TENANT-visible content. */
  defaultLocale: Scalars['String']['output'];
}

export interface MailAccount {
  __typename?: 'MailAccount';
  accessDocId: Scalars['String']['output'];
  activationStatus: Scalars['String']['output'];
  area: Scalars['JSONObject']['output'];
  capabilities: Scalars['JSONObject']['output'];
  createdAt: Scalars['DateTime']['output'];
  credentialId: Scalars['String']['output'];
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  displayName: Maybe<Scalars['String']['output']>;
  effectiveDocRole: Maybe<DocRole>;
  emailAddress: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastError: Maybe<Scalars['String']['output']>;
  lastErrorAt: Maybe<Scalars['DateTime']['output']>;
  lastSyncedAt: Maybe<Scalars['DateTime']['output']>;
  lifecycleState: Scalars['String']['output'];
  mailboxGroupId: Maybe<Scalars['String']['output']>;
  mailboxRootId: Maybe<Scalars['String']['output']>;
  providerKind: MailProviderKind;
  providerProfileId: Scalars['String']['output'];
  resourceId: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  showInWorkspace: Scalars['Boolean']['output'];
  status: MailAccountStatus;
  syncAuthorityUserId: Scalars['String']['output'];
  syncEnabled: Scalars['Boolean']['output'];
  syncMode: Scalars['String']['output'];
  trashedAt: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
}

export interface MailAccountQuotaUsage {
  __typename?: 'MailAccountQuotaUsage';
  accountId: Scalars['String']['output'];
  emailAddress: Scalars['String']['output'];
  factors: Array<MailQuotaFactor>;
  providerKind: MailProviderKind;
  providerProfileId: Scalars['String']['output'];
  worstFactorKind: MailQuotaFactorKind;
  worstPercent: Scalars['Float']['output'];
}

export enum MailAccountStatus {
  active = 'active',
  auth_error = 'auth_error',
  disabled = 'disabled',
  paused = 'paused',
  sync_error = 'sync_error',
}

export interface MailAdminAccountMetadata {
  __typename?: 'MailAdminAccountMetadata';
  activationStatus: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  emailAddress: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastError: Maybe<Scalars['String']['output']>;
  lastErrorAt: Maybe<Scalars['DateTime']['output']>;
  lastSyncedAt: Maybe<Scalars['DateTime']['output']>;
  mailboxGroupId: Maybe<Scalars['String']['output']>;
  providerKind: MailProviderKind;
  providerProfileId: Scalars['String']['output'];
  status: MailAccountStatus;
  syncAuthorityUserId: Scalars['String']['output'];
  syncEnabled: Scalars['Boolean']['output'];
  syncMode: Scalars['String']['output'];
  userEmail: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  userName: Maybe<Scalars['String']['output']>;
}

export interface MailAdminOverview {
  __typename?: 'MailAdminOverview';
  accounts: Array<MailAdminAccountMetadata>;
  auditEvents: Array<MailAuditEvent>;
  policy: MailPolicy;
  quotaUsers: Array<MailUserQuotaUsage>;
  searchIndexStatus: MailSearchIndexAdminStatus;
  usage: MailUsageStats;
  workspaceId: Scalars['String']['output'];
}

export interface MailAttachment {
  __typename?: 'MailAttachment';
  accountId: Scalars['String']['output'];
  blobKey: Scalars['String']['output'];
  contentId: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  disposition: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
  id: Scalars['String']['output'];
  messageId: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  sizeBytes: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
}

export interface MailAuditEvent {
  __typename?: 'MailAuditEvent';
  accountId: Maybe<Scalars['String']['output']>;
  action: Scalars['String']['output'];
  actorUserId: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  metadata: Maybe<Scalars['JSONObject']['output']>;
  targetUserId: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
}

export interface MailAutoresponder {
  __typename?: 'MailAutoresponder';
  accountId: Maybe<Scalars['String']['output']>;
  bodyHtml: Maybe<Scalars['String']['output']>;
  bodyText: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  endsAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  signatureId: Maybe<Scalars['String']['output']>;
  startsAt: Maybe<Scalars['DateTime']['output']>;
  subject: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
}

export enum MailComposeKind {
  forward = 'forward',
  new = 'new',
  reply = 'reply',
  reply_all = 'reply_all',
}

export interface MailCredentialShareProposal {
  __typename?: 'MailCredentialShareProposal';
  credentialId: Scalars['String']['output'];
  currentRole: Maybe<Scalars['String']['output']>;
  managedRole: Maybe<Scalars['String']['output']>;
  proposedRole: Scalars['String']['output'];
  targetId: Scalars['String']['output'];
  targetType: Scalars['String']['output'];
}

export interface MailCredentialShareProposalInput {
  accessDocId?: InputMaybe<Scalars['String']['input']>;
  accountId: Scalars['String']['input'];
  docRole?: InputMaybe<DocRole>;
  proposedRole?: InputMaybe<Scalars['String']['input']>;
  targets: Array<MailCredentialShareTargetInput>;
  workspaceId: Scalars['String']['input'];
}

export interface MailCredentialShareTargetInput {
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
}

export enum MailDirection {
  draft = 'draft',
  inbound = 'inbound',
  outbound = 'outbound',
}

export enum MailFolder {
  archive = 'archive',
  custom = 'custom',
  drafts = 'drafts',
  inbox = 'inbox',
  junk = 'junk',
  sent = 'sent',
  trash = 'trash',
}

export interface MailMailboxFolder {
  __typename?: 'MailMailboxFolder';
  accountId: Scalars['String']['output'];
  canCreateChild: Scalars['Boolean']['output'];
  canDelete: Scalars['Boolean']['output'];
  canMoveMessages: Scalars['Boolean']['output'];
  canRename: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  delimiter: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isSystem: Scalars['Boolean']['output'];
  messageCount: Scalars['Int']['output'];
  path: Scalars['String']['output'];
  providerFolderId: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  rowId: Maybe<Scalars['String']['output']>;
  selectable: Scalars['Boolean']['output'];
  sortOrder: Scalars['Int']['output'];
  unreadCount: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
}

export interface MailMailboxRoot {
  __typename?: 'MailMailboxRoot';
  accountStatusDatabaseId: Maybe<Scalars['String']['output']>;
  archiveDatabaseId: Scalars['String']['output'];
  attachmentsDatabaseId: Scalars['String']['output'];
  compositionsDatabaseId: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  docId: Scalars['String']['output'];
  draftsDatabaseId: Scalars['String']['output'];
  foldersDatabaseId: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  inboxDatabaseId: Scalars['String']['output'];
  messagesDatabaseId: Scalars['String']['output'];
  rulesDatabaseId: Maybe<Scalars['String']['output']>;
  sentDatabaseId: Scalars['String']['output'];
  trashDatabaseId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
}

export interface MailMessage {
  __typename?: 'MailMessage';
  accountId: Scalars['String']['output'];
  bccAddresses: Array<Scalars['String']['output']>;
  bodyHydratedAt: Maybe<Scalars['DateTime']['output']>;
  bodyLastAccessedAt: Maybe<Scalars['DateTime']['output']>;
  bodyStatus: Scalars['String']['output'];
  cachePinned: Scalars['Boolean']['output'];
  ccAddresses: Array<Scalars['String']['output']>;
  compositionKind: Maybe<MailComposeKind>;
  createdAt: Scalars['DateTime']['output'];
  direction: MailDirection;
  folder: MailFolder;
  folderId: Maybe<Scalars['String']['output']>;
  fromAddress: Maybe<Scalars['String']['output']>;
  fromName: Maybe<Scalars['String']['output']>;
  hasAttachments: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  inReplyToHeader: Maybe<Scalars['String']['output']>;
  internalDate: Maybe<Scalars['DateTime']['output']>;
  isFlagged: Scalars['Boolean']['output'];
  isRead: Scalars['Boolean']['output'];
  isStarred: Scalars['Boolean']['output'];
  mailboxRootId: Maybe<Scalars['String']['output']>;
  messageId: Maybe<Scalars['String']['output']>;
  providerUid: Maybe<Scalars['String']['output']>;
  receivedAt: Maybe<Scalars['DateTime']['output']>;
  referencesHeader: Maybe<Scalars['String']['output']>;
  rowId: Maybe<Scalars['String']['output']>;
  sentAt: Maybe<Scalars['DateTime']['output']>;
  sizeBytes: Scalars['String']['output'];
  snippet: Maybe<Scalars['String']['output']>;
  sourceMessageId: Maybe<Scalars['String']['output']>;
  subject: Maybe<Scalars['String']['output']>;
  threadId: Maybe<Scalars['String']['output']>;
  toAddresses: Array<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
}

export interface MailMessageBody {
  __typename?: 'MailMessageBody';
  accountId: Scalars['String']['output'];
  attachments: Array<MailAttachment>;
  bodyEvictedAt: Maybe<Scalars['DateTime']['output']>;
  bodyHtml: Maybe<Scalars['String']['output']>;
  bodyHydratedAt: Maybe<Scalars['DateTime']['output']>;
  bodyLastAccessedAt: Maybe<Scalars['DateTime']['output']>;
  bodyStatus: Scalars['String']['output'];
  bodyText: Maybe<Scalars['String']['output']>;
  cachePinned: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  sizeBytes: Scalars['String']['output'];
  subject: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
}

export interface MailOAuth2CredentialInput {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  emailAddress: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['String']['input']>;
  imapHost?: InputMaybe<Scalars['String']['input']>;
  imapPort?: InputMaybe<Scalars['Int']['input']>;
  provider: MailProviderKind;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  scopes?: InputMaybe<Array<Scalars['String']['input']>>;
  smtpHost?: InputMaybe<Scalars['String']['input']>;
  smtpPort?: InputMaybe<Scalars['Int']['input']>;
  tokenUrl: Scalars['String']['input'];
}

export interface MailPasswordCredentialInput {
  emailAddress: Scalars['String']['input'];
  imapHost: Scalars['String']['input'];
  imapPort: Scalars['Int']['input'];
  imapTls: Scalars['Boolean']['input'];
  password: Scalars['String']['input'];
  smtpHost: Scalars['String']['input'];
  smtpPort: Scalars['Int']['input'];
  smtpTls: Scalars['Boolean']['input'];
  username: Scalars['String']['input'];
}

export interface MailPolicy {
  __typename?: 'MailPolicy';
  /** Periods the workspace plan allows */
  availableMailWindowDays: Array<Scalars['Int']['output']>;
  /** Stored period capped by the plan history, in days */
  effectiveMailWindowDays: Scalars['Int']['output'];
  /** Stored period for mail on devices and in search, in days */
  mailWindowDays: Scalars['Int']['output'];
  retentionDays: Maybe<Scalars['Int']['output']>;
  retentionMode: MailRetentionMode;
  searchIndexAttachmentsEnabled: Scalars['Boolean']['output'];
  searchIndexEnabled: Scalars['Boolean']['output'];
  workspaceId: Scalars['String']['output'];
}

export enum MailProviderKind {
  custom_oauth2 = 'custom_oauth2',
  generic_imap_smtp = 'generic_imap_smtp',
  gmail_oauth = 'gmail_oauth',
  microsoft_oauth = 'microsoft_oauth',
}

export interface MailQuotaFactor {
  __typename?: 'MailQuotaFactor';
  action: Maybe<Scalars['String']['output']>;
  detail: Scalars['String']['output'];
  kind: MailQuotaFactorKind;
  label: Scalars['String']['output'];
  limitBytes: Maybe<Scalars['String']['output']>;
  limitCount: Maybe<Scalars['Int']['output']>;
  limitSources: Array<MailQuotaLimitSource>;
  percent: Scalars['Float']['output'];
  status: MailQuotaStatus;
  usedBytes: Maybe<Scalars['String']['output']>;
  usedCount: Maybe<Scalars['Int']['output']>;
}

export enum MailQuotaFactorKind {
  attachment_cache = 'attachment_cache',
  body_cache = 'body_cache',
  search_window_coverage = 'search_window_coverage',
}

export interface MailQuotaLimitSource {
  __typename?: 'MailQuotaLimitSource';
  kind: MailQuotaLimitSourceKind;
  label: Scalars['String']['output'];
  limitBytes: Maybe<Scalars['String']['output']>;
  limitCount: Maybe<Scalars['Int']['output']>;
}

export enum MailQuotaLimitSourceKind {
  policy = 'policy',
  private_folder = 'private_folder',
}

export enum MailQuotaStatus {
  danger = 'danger',
  exceeded = 'exceeded',
  ok = 'ok',
  unknown = 'unknown',
  warn = 'warn',
}

export enum MailRetentionMode {
  days = 'days',
  none = 'none',
}

export interface MailRule {
  __typename?: 'MailRule';
  accountId: Maybe<Scalars['String']['output']>;
  actions: Scalars['JSONObject']['output'];
  conditions: Scalars['JSONObject']['output'];
  createdAt: Scalars['DateTime']['output'];
  effectiveEnabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lastRunAt: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  requestedEnabled: Scalars['Boolean']['output'];
  rowId: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
  validationError: Maybe<Scalars['String']['output']>;
  validationStatus: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
}

export interface MailSearchDiagnostics {
  __typename?: 'MailSearchDiagnostics';
  messages: Array<MailSearchMessageDiagnostic>;
  messagesMissingBody: Scalars['Int']['output'];
  missingPermissionTargets: Scalars['Int']['output'];
  pdfAttachmentsFailed: Scalars['Int']['output'];
  pdfAttachmentsIndexed: Scalars['Int']['output'];
  pdfAttachmentsMissingOcr: Scalars['Int']['output'];
  pdfAttachmentsRepairable: Scalars['Int']['output'];
  pdfAttachmentsStale: Scalars['Int']['output'];
  scopeStatus: MailSearchIndexStatus;
  totalAttachments: Scalars['Int']['output'];
  totalMessages: Scalars['Int']['output'];
  totalPdfAttachments: Scalars['Int']['output'];
}

export interface MailSearchDiagnosticsInput {
  accountId?: InputMaybe<Scalars['String']['input']>;
  folderId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}

export interface MailSearchIndexAdminStatus {
  __typename?: 'MailSearchIndexAdminStatus';
  avgIndexedBytesPerMessage: Scalars['String']['output'];
  backfillCancelledAt: Maybe<Scalars['DateTime']['output']>;
  backfillCompletedAt: Maybe<Scalars['DateTime']['output']>;
  backfillCursorDate: Maybe<Scalars['DateTime']['output']>;
  backfillFailedCount: Scalars['Int']['output'];
  backfillIndexedCount: Scalars['Int']['output'];
  backfillJobId: Maybe<Scalars['String']['output']>;
  backfillLastError: Maybe<Scalars['String']['output']>;
  backfillPageCount: Scalars['Int']['output'];
  backfillPageSize: Maybe<Scalars['Int']['output']>;
  backfillPausedAt: Maybe<Scalars['DateTime']['output']>;
  backfillPurgedCount: Scalars['Int']['output'];
  backfillQueuedCount: Scalars['Int']['output'];
  backfillRunId: Maybe<Scalars['String']['output']>;
  backfillScannedCount: Scalars['Int']['output'];
  backfillSkippedCount: Scalars['Int']['output'];
  backfillStartedAt: Maybe<Scalars['DateTime']['output']>;
  backfillStatus: Scalars['String']['output'];
  coveragePercent: Scalars['Float']['output'];
  degradedReasons: Array<Scalars['String']['output']>;
  eligibleMessageCount: Scalars['Int']['output'];
  newestEligibleMessageAt: Maybe<Scalars['DateTime']['output']>;
  newestUnindexedMessageAt: Maybe<Scalars['DateTime']['output']>;
  oldestEligibleMessageAt: Maybe<Scalars['DateTime']['output']>;
  oldestUnindexedMessageAt: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  unindexedMessageCount: Scalars['Int']['output'];
}

export enum MailSearchIndexStatus {
  failed = 'failed',
  indexed = 'indexed',
  missing = 'missing',
  missing_permission = 'missing_permission',
  none = 'none',
  stale = 'stale',
  unknown = 'unknown',
}

export interface MailSearchMessageDiagnostic {
  __typename?: 'MailSearchMessageDiagnostic';
  accountId: Scalars['String']['output'];
  attachmentCount: Scalars['Int']['output'];
  attachmentStatus: MailSearchIndexStatus;
  bodyStatus: MailSearchIndexStatus;
  failedPdfAttachmentCount: Scalars['Int']['output'];
  folder: Maybe<Scalars['String']['output']>;
  folderId: Maybe<Scalars['String']['output']>;
  indexedPdfPageCount: Scalars['Int']['output'];
  messageId: Scalars['String']['output'];
  missingOcrAttachmentCount: Scalars['Int']['output'];
  ocrStatus: MailSearchIndexStatus;
  pdfAttachmentCount: Scalars['Int']['output'];
  receivedAt: Maybe<Scalars['DateTime']['output']>;
  stalePdfAttachmentCount: Scalars['Int']['output'];
}

export interface MailSearchReindexError {
  __typename?: 'MailSearchReindexError';
  attachmentId: Maybe<Scalars['String']['output']>;
  blobKey: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  messageId: Maybe<Scalars['String']['output']>;
  status: MailSearchIndexStatus;
}

export interface MailSearchReindexInput {
  accountId?: InputMaybe<Scalars['String']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  folderId?: InputMaybe<Scalars['String']['input']>;
  forceOcr?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface MailSearchReindexResult {
  __typename?: 'MailSearchReindexResult';
  errors: Array<MailSearchReindexError>;
  failedTargets: Scalars['Int']['output'];
  fallbackDocReindexCount: Scalars['Int']['output'];
  indexedPages: Scalars['Int']['output'];
  missingPermissionTargets: Scalars['Int']['output'];
  processedAttachments: Scalars['Int']['output'];
  processedMessages: Scalars['Int']['output'];
  processedTargets: Scalars['Int']['output'];
}

export interface MailSignature {
  __typename?: 'MailSignature';
  bodyHtml: Maybe<Scalars['String']['output']>;
  bodyText: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
}

export interface MailSignatureAssignment {
  __typename?: 'MailSignatureAssignment';
  accountId: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  scope: MailSignatureScope;
  signatureId: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
}

export enum MailSignatureScope {
  forward = 'forward',
  new = 'new',
  reply = 'reply',
}

export interface MailSyncState {
  __typename?: 'MailSyncState';
  accountId: Scalars['String']['output'];
  currentFolderIndex: Scalars['Int']['output'];
  currentFolderPath: Maybe<Scalars['String']['output']>;
  duplicateCount: Scalars['Int']['output'];
  fetchedCount: Scalars['Int']['output'];
  finishedAt: Maybe<Scalars['DateTime']['output']>;
  folderTotal: Scalars['Int']['output'];
  lastError: Maybe<Scalars['String']['output']>;
  lastErrorAt: Maybe<Scalars['DateTime']['output']>;
  lastModSeq: Maybe<Scalars['String']['output']>;
  lastSuccessfulSyncAt: Maybe<Scalars['DateTime']['output']>;
  lastUid: Maybe<Scalars['String']['output']>;
  lockedAt: Maybe<Scalars['DateTime']['output']>;
  lockedBy: Maybe<Scalars['String']['output']>;
  persistedCount: Scalars['Int']['output'];
  phase: Maybe<Scalars['String']['output']>;
  startedAt: Maybe<Scalars['DateTime']['output']>;
  syncReason: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
}

export interface MailTrustedSender {
  __typename?: 'MailTrustedSender';
  createdAt: Scalars['DateTime']['output'];
  senderAddress: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
}

export interface MailUsageStats {
  __typename?: 'MailUsageStats';
  accountCount: Scalars['Int']['output'];
  attachmentCacheBytes: Scalars['String']['output'];
  attachmentCount: Scalars['Int']['output'];
  bodyCacheBytes: Scalars['String']['output'];
  calculatedAt: Scalars['DateTime']['output'];
  messageCount: Scalars['Int']['output'];
  searchFailedMessageCount: Scalars['Int']['output'];
  searchIndexBytes: Scalars['String']['output'];
  searchIndexedMessageCount: Scalars['Int']['output'];
  searchPendingMessageCount: Scalars['Int']['output'];
  searchSkippedMessageCount: Scalars['Int']['output'];
}

export interface MailUserQuotaUsage {
  __typename?: 'MailUserQuotaUsage';
  accounts: Array<MailAccountQuotaUsage>;
  factors: Array<MailQuotaFactor>;
  mailWindowDays: Scalars['Int']['output'];
  userEmail: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  userName: Maybe<Scalars['String']['output']>;
  worstFactorKind: MailQuotaFactorKind;
  worstPercent: Scalars['Float']['output'];
}

export enum MailVirtualFolder {
  flagged = 'flagged',
  starred = 'starred',
}

export interface MailVirtualFolderSummary {
  __typename?: 'MailVirtualFolderSummary';
  accountId: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: MailVirtualFolder;
  messageCount: Scalars['Int']['output'];
  unreadCount: Scalars['Int']['output'];
}

export enum MailWatchInterest {
  active = 'active',
  cold = 'cold',
  manual = 'manual',
  push = 'push',
}

export interface ManageUserInput {
  /** User email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** User name */
  name?: InputMaybe<Scalars['String']['input']>;
}

/** sl-opil.6.1: Managed AI allocation status */
export interface ManagedAiStatusType {
  __typename?: 'ManagedAIStatusType';
  consentAt: Maybe<Scalars['DateTime']['output']>;
  consentGiven: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  maxRequestsPerMinute: Scalars['Int']['output'];
  suspendReason: Maybe<Scalars['String']['output']>;
  suspended: Scalars['Boolean']['output'];
}

/** sl-amfa: Marketplace category with template count */
export interface MarketplaceCategoryGql {
  __typename?: 'MarketplaceCategoryGql';
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
}

/** Workspace artifacts produced by a marketplace install. */
export interface MarketplaceInstallArtifactSummaryGql {
  __typename?: 'MarketplaceInstallArtifactSummaryGql';
  artifactKinds: Array<Scalars['String']['output']>;
  docCount: Scalars['Int']['output'];
  primaryDocId: Maybe<Scalars['String']['output']>;
  workflowId: Maybe<Scalars['String']['output']>;
}

/** sl-amfa: Installed marketplace template in a workspace */
export interface MarketplaceInstallGql {
  __typename?: 'MarketplaceInstallGql';
  artifactSummary: MarketplaceInstallArtifactSummaryGql;
  installId: Scalars['String']['output'];
  installedAt: Scalars['DateTime']['output'];
  installedDocIds: Array<Scalars['String']['output']>;
  isLegacyInstall: Scalars['Boolean']['output'];
  latestSemanticVersion: Maybe<Scalars['String']['output']>;
  latestVersion: Scalars['Int']['output'];
  managementActions: MarketplaceInstallManagementActionsGql;
  semanticVersion: Maybe<Scalars['String']['output']>;
  stepInsertType: Maybe<Scalars['String']['output']>;
  templateId: Scalars['String']['output'];
  templateTitle: Scalars['String']['output'];
  templateType: Scalars['String']['output'];
  versionNumber: Scalars['Int']['output'];
  workflowId: Maybe<Scalars['String']['output']>;
}

/** Safe UI actions available for an installed marketplace template. */
export interface MarketplaceInstallManagementActionsGql {
  __typename?: 'MarketplaceInstallManagementActionsGql';
  canOpenDoc: Scalars['Boolean']['output'];
  canOpenWorkflow: Scalars['Boolean']['output'];
  canRemove: Scalars['Boolean']['output'];
  canUseStep: Scalars['Boolean']['output'];
  primaryAction: Scalars['String']['output'];
  removeMode: Scalars['String']['output'];
}

/** sl-amfa: Template rating result */
export interface MarketplaceRatingGql {
  __typename?: 'MarketplaceRatingGql';
  comment: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  rating: Scalars['Int']['output'];
  templateId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
}

/** sl-amfa: Template report result */
export interface MarketplaceReportGql {
  __typename?: 'MarketplaceReportGql';
  createdAt: Scalars['DateTime']['output'];
  details: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
  status: Scalars['String']['output'];
  templateId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
}

/** sl-amfa: Marketplace template for browsing */
export interface MarketplaceTemplateGql {
  __typename?: 'MarketplaceTemplateGql';
  averageRating: Maybe<Scalars['Float']['output']>;
  category: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  credentialRequirements: Scalars['JSON']['output'];
  /**
   * sl-eglf.1.2: Multi-language description map keyed by BCP-47 locale.
   * Always present (NOT NULL DEFAULT '{}') but may be empty for legacy rows;
   * clients pick a locale via custom-app-viewer's locale-chain helper.
   */
  descriptionsI18n: Scalars['JSONObject']['output'];
  downloadCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  previewImageBlobId: Maybe<Scalars['String']['output']>;
  publishedByUserId: Scalars['String']['output'];
  /** sl-kypm: SWR step type when installed — only for step templates */
  stepInsertType: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  /** sl-kypm: Template type discriminator ('doc', 'app', 'step', 'workflow', or 'automation') */
  templateType: MarketplaceTemplateType;
  /**
   * sl-k94y.1.1: Multi-language title map keyed by BCP-47 locale (always
   * present, en baseline enforced at every write boundary). Replaces the
   * former scalar `title: String!` — clients resolve via the same locale-
   * chain helper used for `descriptionsI18n`.
   */
  titlesI18n: Scalars['JSONObject']['output'];
}

/** sl-qhe4: Marketplace template kind — doc, app, step (single node), workflow (multi-step), automation (full config), app_container (one App Container with its Apps) */
export enum MarketplaceTemplateType {
  app = 'app',
  app_container = 'app_container',
  automation = 'automation',
  doc = 'doc',
  step = 'step',
  workflow = 'workflow',
}

/** sl-amfa: Paginated marketplace templates result */
export interface MarketplaceTemplatesPage {
  __typename?: 'MarketplaceTemplatesPage';
  items: Array<MarketplaceTemplateGql>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
}

/** Which pages a share lets a person change or delete through the Mate: none, only the person's own, or all the person may read through it */
export enum MateChangeScope {
  likeRead = 'likeRead',
  off = 'off',
  own = 'own',
}

/** What keeps a right of a share from the full right in a folder: the Mate's role there, the share, a workspace rule, or the person's own role for creating */
export enum MateEffectLimit {
  member = 'member',
  role = 'role',
  rule = 'rule',
  share = 'share',
}

/** sl-sdk6.5: Expert Bot */
export interface MateGql {
  __typename?: 'MateGql';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  instructions: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  /** personal or workspace */
  kind: Scalars['String']['output'];
  /** own, mint, lavender, sky, amber or rose */
  markColor: Scalars['String']['output'];
  memoryEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
}

/** A folder a Mate was invited to, directly or through a group */
export interface MateInvitedFolderGql {
  __typename?: 'MateInvitedFolderGql';
  folderId: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

/** What a share lets a person read through the Mate: only what the person reads too, only the pages the Mate created for the person, or everything the Mate reads */
export enum MateReadScope {
  all = 'all',
  intersection = 'intersection',
  own = 'own',
}

/** One right of a share in one folder, as a turn gets it */
export interface MateRightEffectGql {
  __typename?: 'MateRightEffectGql';
  allowed: Scalars['Boolean']['output'];
  /** Whether a workspace rule of the AI actions makes the turn ask first */
  ask: Scalars['Boolean']['output'];
  /** Null when nothing narrows the right */
  limitedBy: Maybe<MateEffectLimit>;
}

/** How a Mate's turn combines rights: all it holds, or only what the member holds too */
export enum MateRuleMode {
  all = 'all',
  intersection = 'intersection',
}

/** What one share lets a turn do in one folder the Mate was invited to */
export interface MateShareFolderEffectGql {
  __typename?: 'MateShareFolderEffectGql';
  create: MateRightEffectGql;
  delete: MateRightEffectGql;
  folderId: Scalars['String']['output'];
  mateRole: FolderRole;
  name: Scalars['String']['output'];
  read: MateRightEffectGql;
  /** The share's rights, before the workspace rule */
  rights: MateShareRightsGql;
  update: MateRightEffectGql;
}

/** A share of a Mate with a member or a group */
export interface MateShareGql {
  __typename?: 'MateShareGql';
  mateId: Scalars['String']['output'];
  mode: MateShareMode;
  principalId: Scalars['String']['output'];
  principalKind: MateSharePrincipalKind;
  /** Name of the member or group */
  principalName: Scalars['String']['output'];
  shareMemory: Scalars['Boolean']['output'];
}

/** What a share lets a person do through the Mate: only their own rights, submit, manage their own pages, or edit everything the Mate reads */
export enum MateShareMode {
  editAll = 'editAll',
  intersection = 'intersection',
  manageOwn = 'manageOwn',
  submit = 'submit',
}

/** Whom a Mate is shared with */
export enum MateSharePrincipalKind {
  group = 'group',
  user = 'user',
}

/** What a share lets a person do through the Mate (3x3x3) */
export interface MateShareRightsGql {
  __typename?: 'MateShareRightsGql';
  create: Scalars['Boolean']['output'];
  delete: MateChangeScope;
  read: MateReadScope;
  update: MateChangeScope;
}

export interface MemberNotFoundInSpaceDataType {
  __typename?: 'MemberNotFoundInSpaceDataType';
  spaceId: Scalars['String']['output'];
}

/** sl-apue: Member quota info with seat addon details */
export interface MemberQuotaInfoType {
  __typename?: 'MemberQuotaInfoType';
  /** Base member limit from the plan */
  baseLimit: Scalars['Int']['output'];
  /** Whether more members can be invited */
  canInvite: Scalars['Boolean']['output'];
  /** Current number of workspace members */
  currentUsage: Scalars['Int']['output'];
  /** Effective limit (baseLimit + extraSeats, -1 = unlimited) */
  effectiveLimit: Scalars['Int']['output'];
  /** Number of purchased extra seats */
  extraSeats: Scalars['Int']['output'];
  /** Maximum purchasable extra seats for the active plan (-1 = unlimited) */
  maxExtraSeats: Scalars['Int']['output'];
  /** sl-7vu4: Graduated tiered seat pricing as JSON string (null = not available) */
  seatTiers: Maybe<Scalars['String']['output']>;
  /** Bytes of storage each extra seat adds ("0" = no fixed amount) */
  storagePerSeat: Scalars['String']['output'];
}

/** sl-qsjm.5: Member 2FA compliance status */
export interface MemberTwoFactorStatusType {
  __typename?: 'MemberTwoFactorStatusType';
  avatarUrl: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  hasEmailOTP: Scalars['Boolean']['output'];
  hasTOTP: Scalars['Boolean']['output'];
  name: Maybe<Scalars['String']['output']>;
  role: Permission;
  userId: Scalars['String']['output'];
}

/** sl-pmcz: User memory usage stats */
export interface MemoryUsage {
  __typename?: 'MemoryUsage';
  count: Scalars['Int']['output'];
  limit: Scalars['Int']['output'];
}

export interface MentionDocInput {
  /** The block id in the doc */
  blockId?: InputMaybe<Scalars['String']['input']>;
  /** The element id in the doc */
  elementId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  mode: DocMode;
  title: Scalars['String']['input'];
}

export interface MentionDocType {
  __typename?: 'MentionDocType';
  blockId: Maybe<Scalars['String']['output']>;
  elementId: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  mode: DocMode;
  title: Scalars['String']['output'];
}

export interface MentionInput {
  doc: MentionDocInput;
  userId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MentionNotificationBodyType {
  __typename?: 'MentionNotificationBodyType';
  /** The user who created the notification, maybe null when user is deleted or sent by system */
  createdByUser: Maybe<PublicUserType>;
  doc: MentionDocType;
  /** The type of the notification */
  type: NotificationType;
  workspace: Maybe<NotificationWorkspaceType>;
}

export interface MentionUserDocAccessDeniedDataType {
  __typename?: 'MentionUserDocAccessDeniedDataType';
  docId: Scalars['String']['output'];
}

/** Shared display data passed to context and source UI rows */
export interface MessageContextDisplayInput {
  icon?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  unavailable?: InputMaybe<Scalars['Boolean']['input']>;
  unavailableReason?: InputMaybe<Scalars['String']['input']>;
}

/** Shared display data for context and source UI rows */
export interface MessageContextDisplayType {
  __typename?: 'MessageContextDisplayType';
  icon: Maybe<Scalars['String']['output']>;
  preview: Maybe<Scalars['String']['output']>;
  subtitle: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  unavailable: Maybe<Scalars['Boolean']['output']>;
  unavailableReason: Maybe<Scalars['String']['output']>;
}

/** Structured context for copilot messages (replaces legacy params) */
export interface MessageContextInput {
  /** Active document when this message is sent */
  docId?: InputMaybe<Scalars['String']['input']>;
  items: Array<MessageContextItemInput>;
  searchMode?: InputMaybe<SearchMode>;
}

/** Canonical context item passed to copilot */
export interface MessageContextItemInput {
  display: MessageContextDisplayInput;
  id: Scalars['String']['input'];
  kind: MessageContextItemKind;
  label: Scalars['String']['input'];
  payload?: InputMaybe<Scalars['JSONObject']['input']>;
  priority: ContextPriority;
  refs: Scalars['JSONObject']['input'];
  source: ContextSource;
  subtitle?: InputMaybe<Scalars['String']['input']>;
}

/** Canonical context item kind */
export enum MessageContextItemKind {
  ASSISTANT_CHANNEL = 'ASSISTANT_CHANNEL',
  ATTACHMENT = 'ATTACHMENT',
  AUTOMATION = 'AUTOMATION',
  CANVAS_SELECTION = 'CANVAS_SELECTION',
  CODE_SELECTION = 'CODE_SELECTION',
  COLLECTION = 'COLLECTION',
  DATABASE = 'DATABASE',
  DOC = 'DOC',
  FILE = 'FILE',
  IMAGE = 'IMAGE',
  MAIL = 'MAIL',
  PDF_BLOCK = 'PDF_BLOCK',
  PDF_FILE = 'PDF_FILE',
  TAG = 'TAG',
  WORKFLOW = 'WORKFLOW',
  WORKSPACE_VIEW = 'WORKSPACE_VIEW',
}

/** Canonical context item attached to a chat message */
export interface MessageContextItemType {
  __typename?: 'MessageContextItemType';
  display: MessageContextDisplayType;
  id: Scalars['String']['output'];
  kind: MessageContextItemKind;
  label: Scalars['String']['output'];
  payload: Maybe<Scalars['JSONObject']['output']>;
  priority: ContextPriority;
  refs: Scalars['JSONObject']['output'];
  source: ContextSource;
  subtitle: Maybe<Scalars['String']['output']>;
}

/** Structured context for copilot messages (output type) */
export interface MessageContextType {
  __typename?: 'MessageContextType';
  /** Active document when this message was sent */
  docId: Maybe<Scalars['String']['output']>;
  items: Array<MessageContextItemType>;
  searchMode: Maybe<SearchMode>;
}

/** sl-canvas2-8.31: Message types for Two-Call Pattern */
export enum MessageType {
  goal_turn = 'goal_turn',
  text = 'text',
  tool_approval_request = 'tool_approval_request',
  tool_approval_response = 'tool_approval_response',
  tool_call = 'tool_call',
  tool_result = 'tool_result',
}

/** The workspace's own Marketplace listing of a source, newest version. */
export interface MineCopy {
  __typename?: 'MineCopy';
  templateId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  versionNumber: Scalars['Int']['output'];
}

/** Answer of the copy question before deleting an automation or workflow. */
export interface MineCopyLookup {
  __typename?: 'MineCopyLookup';
  copy: Maybe<MineCopy>;
  /** False when the server holds no config or workflow, so nothing can be copied. */
  sourceExists: Scalars['Boolean']['output'];
}

/** Source kinds whose private copy in Mine the copy question looks up. */
export enum MineCopySourceKind {
  AUTOMATION = 'AUTOMATION',
  WORKFLOW = 'WORKFLOW',
}

export interface MissingOauthQueryParameterDataType {
  __typename?: 'MissingOauthQueryParameterDataType';
  name: Scalars['String']['output'];
}

/** Move an attached AppBase database reference to another document. */
export interface MoveAppBaseDatabaseInput {
  confirmed: Scalars['Boolean']['input'];
  sourceKey: Scalars['String']['input'];
  targetDocId: Scalars['String']['input'];
}

export interface MoveMailMessageInput {
  folderId: Scalars['String']['input'];
  messageId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface Mutation {
  __typename?: 'Mutation';
  acceptInviteById: Scalars['Boolean']['output'];
  /** sl-iw27.4.2: Accept a pending KG snapshot */
  acceptKgSnapshot: KgSnapshotType;
  /** sl-kaqr.3.2: Accept a tenant invitation */
  acceptTenantInvite: TenantMemberType;
  /** add a blob to context */
  addContextBlob: CopilotContextBlob;
  /** add a category to context */
  addContextCategory: CopilotContextCategory;
  /** add a doc to context */
  addContextDoc: CopilotContextDoc;
  /** add a file to context */
  addContextFile: CopilotContextFile;
  /** Add a document to a folder */
  addDocToFolder: Scalars['Boolean']['output'];
  /** Add a workspace Mate to a group: it holds the group's roles */
  addGroupMate: Scalars['Boolean']['output'];
  /** sl-jsx3.11.5: Add a member to a group (Admin only) */
  addGroupMember: UserGroupMemberType;
  /** sl-kaqr.2.2: Add a member to a tenant (Owner/Admin only) */
  addTenantMember: TenantMemberType;
  /** Assign a plan to a user (admin only, no Stripe) */
  adminAssignPlan: SubscriptionType;
  /** sl-ddz8.6.3: Backfill embeddings for unembedded docs in a workspace (admin only) */
  adminBackfillEmbeddings: AdminBackfillResult;
  /** sl-sdk6.6.1: Delete a single memory entry (admin only) */
  adminDeleteMemory: Scalars['Boolean']['output'];
  /** sl-qsjm: Admin-only: disable TOTP for a user (with audit log) */
  adminDisableTOTP: Scalars['Boolean']['output'];
  /** sl-sdk6.6.1: Pseudonymize all memories for a user in a workspace (admin only, DSGVO) */
  adminPseudonymizeUserMemories: Scalars['Boolean']['output'];
  /**
   * Apply a confirmed AppBase Development Plan recipe. With `change` the version
   * history shows that label for the run instead of the list of applied steps.
   */
  applyAppBaseDevelopment: Scalars['JSONObject']['output'];
  approveMember: Scalars['Boolean']['output'];
  /** sl-ckdp: Assign a default signature to an account and compose scope. */
  assignMailSignature: MailSignatureAssignment;
  /** Attach an existing affine:database to an AppBase configuration (Editor+). */
  attachExistingAppBaseDatabase: Scalars['JSONObject']['output'];
  /** Delete a trashed automation for good: its trash entry, config and managed grants in one commit. Idempotent per operationId. */
  automationDelete: AutomationLifecycleReceipt;
  /** Bring an automation back from the trash of its host page; its config is active again in the same commit. Idempotent per operationId. */
  automationRestore: AutomationLifecycleReceipt;
  /** Move an automation to the trash of its host page; its config is trashed in the same commit. Idempotent per operationId. */
  automationTrash: AutomationLifecycleReceipt;
  /** Ban an user */
  banUser: UserType;
  /** Opens changes of one delivered entry: what it holds now stays what its readers see until the changes are published. An entry with open changes answers UNCHANGED. */
  beginContentEntryChange: ContentEntryResultType;
  /** sl-zvjz: Cancel a pending deletion (reactivation) while the grace window is still open. */
  cancelAccountDeletion: AccountDeletionStatus;
  /** Cancel a recurring credit subscription at period end (§314 BGB) */
  cancelCreditSubscription: Scalars['Boolean']['output'];
  /** sl-dl66: Cancel a pending interval change (§356 BGB Widerrufsrecht) */
  cancelPendingIntervalChange: Scalars['Boolean']['output'];
  cancelSubscription: SubscriptionType;
  changeEmail: UserType;
  changePassword: Scalars['Boolean']['output'];
  claimAudioTranscription: Maybe<TranscriptionResultType>;
  /** Cleanup sessions */
  cleanupCopilotSession: Array<Scalars['String']['output']>;
  /** sl-hle4.2 REWORK: Clear one AppBase/site's optional monthly credit budget (Owner only). Returns true when a row was removed. */
  clearAppBaseBandwidthBudget: Scalars['Boolean']['output'];
  /** E029-COMPACT: Compact document (Y.js re-encode) - safe, no data loss */
  compactDoc: CompactResultType;
  /** sl-n1hp.3.1: Confirm a node split — create new nodes, transfer edges, delete original */
  confirmSplitGraphNode: Array<GraphNodeGql>;
  /** Create an edge (relation) between two graph nodes */
  connectGraphNodes: Scalars['Boolean']['output'];
  /** sl-obn0.4.1: Connect a mail account for the current workspace user. */
  connectMailAccount: MailAccount;
  /** sl-9qm.1.4: Create an AppBase (Editor+) */
  createAppBase: AppBaseType;
  /** sl-2q8e.2: Create or update a draft snapshot (Editor+) */
  createAppBaseDraft: AppBaseVersionType;
  /**
   * Create or replace a time-limited invitation for one external portal identity.
   * Returns the sign-in link; sendEmail also mails it to the invited address.
   */
  createAppBasePortalInvitation: Scalars['JSONObject']['output'];
  /** One-time password reset (or first password) link for a user (admin only) */
  createChangePasswordUrl: Scalars['String']['output'];
  /** Create a subscription checkout link of stripe */
  createCheckoutSession: Scalars['String']['output'];
  createComment: CommentObjectType;
  /** Create a context session */
  createCopilotContext: Scalars['String']['output'];
  /** Create a chat message */
  createCopilotMessage: Scalars['String']['output'];
  /** Create a copilot prompt */
  createCopilotPrompt: CopilotPromptType;
  /** Create a chat session */
  createCopilotSession: Scalars['String']['output'];
  /** sl-opil.6.2: Create a Stripe checkout URL for credit pack purchase */
  createCreditCheckout: Scalars['String']['output'];
  /** Create a stripe customer portal to manage payment methods */
  createCustomerPortal: Scalars['String']['output'];
  /** Create a new folder */
  createFolder: FolderType;
  /** sl-jsx3.11.5: Create a group (Admin only) */
  createGroup: UserGroupType;
  createInviteLink: InviteLink;
  /** sl-8g8i.5: Create a KG config snapshot for versioning (admin only) */
  createKgConfigSnapshot: Scalars['String']['output'];
  /** sl-obn0.7: Create a validated custom mail folder. */
  createMailFolder: MailMailboxFolder;
  /** A memory of a workspace Mate; only whoever manages the Mate saves one */
  createMateMemory: UserMemory;
  createReply: ReplyObjectType;
  createSelfhostWorkspaceCustomerPortal: Scalars['String']['output'];
  /** Add a skill to the workspace library (whoever manages the workspace Mates) */
  createSkill: SkillGql;
  /** sl-xbxb: Create a new tag definition in workspace */
  createTag: WorkspaceTagType;
  /** Create a new user */
  createUser: UserType;
  /** sl-pmcz.1.1: Manually create a user AI memory */
  createUserMemory: UserMemory;
  /** Create a new workspace */
  createWorkspace: WorkspaceType;
  /** Create a workspace Mate (Owners and Admins, plan with ai-expert-bots) */
  createWorkspaceMate: MateGql;
  /** sl-nkka: Add a sharded database property by stable client-generated ID. */
  databaseAddProperty: DatabaseAddPropertyResult;
  /** sl-d7zo.7: Add a row to a sharded database, returning the new row ID. */
  databaseAddRow: DatabaseAddRowResult;
  databaseBulkMutate: DatabaseBulkResult;
  /** sl-d7zo.7: Delete a property (column) from a sharded database. */
  databaseDeleteProperty: DatabaseDeletePropertyResult;
  /** sl-d7zo.7: Delete a row from a sharded database. */
  databaseDeleteRow: Scalars['Boolean']['output'];
  /** sl-d7zo.7: Duplicate a property (column) of a sharded database. */
  databaseDuplicateProperty: DatabaseDuplicatePropertyResult;
  databaseMove: DatabaseMoveReceipt;
  /** sl-d7zo.7: Move a row inside the sharded database row order. */
  databaseMoveRow: Scalars['Boolean']['output'];
  /** Permanently delete a trashed sharded database: removes its root and row-shard system documents and their access bindings. */
  databasePermanentlyDelete: DatabasePermanentlyDeleteResult;
  /** sl-d7zo.7: Rename a property (column) of a sharded database. */
  databaseRenameProperty: DatabaseRenamePropertyResult;
  /** Bring a sharded database back from the trash of its host page and unmark its root and rows. Idempotent per operationId. */
  databaseRestore: DatabaseLifecycleReceipt;
  /** sl-nkka: Persist sharded database property metadata/data changes. */
  databaseSetPropertyData: DatabaseSetPropertyDataResult;
  /** sl-d7zo.7: Change a property type of a sharded database. */
  databaseSetPropertyType: DatabaseSetPropertyTypeResult;
  /** Move a sharded database to the trash of its host page; root and rows stay. Idempotent per operationId. */
  databaseTrash: DatabaseLifecycleReceipt;
  /**
   * sl-d7zo.7: Write one or more cells across one or more rows of a
   * sharded database. Single backend write entry point for frontend cell
   * edits on row-sharded databases (Gate-C blocks local doc mutation).
   */
  databaseUpdateCells: DatabaseUpdateCellsResult;
  /** delete all notifications owned by the current user */
  deleteAllNotifications: Scalars['Boolean']['output'];
  /** sl-9qm.1.4: Delete an AppBase (Admin+) */
  deleteAppBase: Scalars['Boolean']['output'];
  deleteBlob: Scalars['Boolean']['output'];
  /** Delete a comment */
  deleteComment: Scalars['Boolean']['output'];
  /** sl-etat: Delete a knowledge graph edge */
  deleteGraphEdge: Scalars['Boolean']['output'];
  /** sl-etat: Delete a knowledge graph node and all its edges */
  deleteGraphNode: Scalars['Boolean']['output'];
  /** sl-jsx3.11.5: Delete a group (Admin only) */
  deleteGroup: Scalars['Boolean']['output'];
  /** sl-8g8i.5: Delete a KG config value (admin only) */
  deleteKgConfigValue: Scalars['Boolean']['output'];
  /** sl-8g8i.5: Delete a KG entity type (admin only) */
  deleteKgEntityType: Scalars['Boolean']['output'];
  /** sl-8g8i.5: Delete a KG relation type (admin only) */
  deleteKgRelationType: Scalars['Boolean']['output'];
  /** sl-iw27.4.2: Delete a node from a pending snapshot */
  deleteKgSnapshotNode: Scalars['Boolean']['output'];
  /** sl-obn0.4.1: Delete current user's mail account. */
  deleteMailAccount: Scalars['Boolean']['output'];
  /** sl-ckdp: Remove an autoresponder override so the account inherits the global default. */
  deleteMailAutoresponderOverride: Scalars['Boolean']['output'];
  /** sl-obn0.7: Delete an empty custom mail folder. */
  deleteMailFolder: Scalars['Boolean']['output'];
  /** sl-obn0.7: Delete a mail rule. */
  deleteMailRule: Scalars['Boolean']['output'];
  /** sl-ckdp: Delete a current user's mail signature. */
  deleteMailSignature: Scalars['Boolean']['output'];
  /** sl-ckdp: Remove a default signature override so the account inherits the global default. */
  deleteMailSignatureAssignment: Scalars['Boolean']['output'];
  /** Delete a workspace Mate; a personal Mate cannot be deleted */
  deleteMate: Scalars['Boolean']['output'];
  /** delete one notification owned by the current user */
  deleteNotification: Scalars['Boolean']['output'];
  /** Delete a reply */
  deleteReply: Scalars['Boolean']['output'];
  /** Delete a skill; the Mates that carried it lose it */
  deleteSkill: Scalars['Boolean']['output'];
  /** sl-xbxb: Delete a tag (cascades to all doc-tag assignments) */
  deleteTag: Scalars['Boolean']['output'];
  /** Delete a user account */
  deleteUser: DeleteAccount;
  /** sl-pmcz.1.1: Delete a user's AI memory */
  deleteUserMemory: Scalars['Boolean']['output'];
  deleteWorkspace: Scalars['Boolean']['output'];
  /** Detach an AppBase database binding without deleting attached-existing data. */
  detachAppBaseDatabase: Scalars['JSONObject']['output'];
  /** Compare two AppBase Development Plans and return impact-classified changes. */
  diffAppBaseDevelopment: Scalars['JSONObject']['output'];
  /** sl-opil.6.2: Disable managed AI for a workspace (Owner only) */
  disableManagedAI: Scalars['Boolean']['output'];
  /** sl-qsjm: Disable TOTP (requires password + valid code or backup code) */
  disableTOTP: Scalars['Boolean']['output'];
  /** sl-2q8e.2: Discard current draft (Editor+) */
  discardAppBaseDraft: Scalars['Boolean']['output'];
  /** Writes the live version back into the given rows and closes their open changes. 1 to 500 entries per call. A cell whose column was removed or changed its type since stays as it is. */
  discardContentEntryChanges: Array<ContentEntryResultType>;
  /** Delete all edges between two graph nodes (both directions) */
  disconnectGraphNodes: Scalars['Int']['output'];
  /** sl-iw27.4.2: Edit a node within a pending snapshot */
  editKgSnapshotNode: Scalars['Boolean']['output'];
  /** sl-opil.6.2: Enable managed AI for a workspace (Owner only) */
  enableManagedAI: ManagedAiStatusType;
  /** sl-qsjm: Start TOTP setup (password optional — AuthGuard suffices during onboarding) */
  enableTOTP: TotpSetupResponse;
  /** Reenable an banned user */
  enableUser: UserType;
  /** sl-bcrf.6.3: Enqueue an explicit, idempotent workspace-scoped projection rebuild. */
  enqueuePermissionGraphProjectionRebuild: PermissionGraphRebuildEnqueueResultType;
  /** Ensure AppBase data sources server-side before the client uses them. */
  ensureAppBaseDataSources: Scalars['JSONObject']['output'];
  /** Explain one AppBase Development Plan gap. */
  explainAppBaseDevelopmentGap: Scalars['JSONObject']['output'];
  finalizeCheckoutSession: Scalars['String']['output'];
  /** Create a chat session */
  forkCopilotSession: Scalars['String']['output'];
  generateUserAccessToken: RevealedAccessToken;
  /** sl-xk37: Generate workspace-scoped MCP token for a member (Admin/Owner only) */
  generateWorkspaceMcpToken: WorkspaceMcpTokenWithConfig;
  /** sl-jsx3.11.5: Grant a group role on a doc (Admin only) */
  grantDocGroupRole: DocGroupRoleType;
  /** Grant a doc role to a workspace Mate (any role below Owner) */
  grantDocMateRole: Scalars['Boolean']['output'];
  grantDocUserRoles: Scalars['Boolean']['output'];
  /** sl-jsx3.11.5: Grant a group role on a folder (Admin only) */
  grantFolderGroupRole: FolderGroupRoleType;
  /** Grant a folder role to a workspace Mate (any role below Owner) */
  grantFolderMateRole: Scalars['Boolean']['output'];
  /** Grant folder role to user */
  grantFolderRole: Scalars['Boolean']['output'];
  grantMember: Scalars['Boolean']['output'];
  /** Grant MCP access once to the current members of a workspace group (Admin/Owner only) */
  grantWorkspaceMcpAccessToGroup: WorkspaceMcpGroupGrantResult;
  /** import users */
  importUsers: Array<UserImportResultType>;
  /** @deprecated use [inviteMembers] instead */
  inviteBatch: Array<InviteResult>;
  inviteMembers: Array<InviteResult>;
  /** sl-kaqr.3.2: Invite a member by email (creates pending membership) */
  inviteTenantMember: TenantMemberType;
  leaveWorkspace: Scalars['Boolean']['output'];
  /** mention user in a doc */
  mentionUser: Scalars['ID']['output'];
  /** sl-etat: Merge two graph nodes (source → target) */
  mergeGraphNodes: GraphNodeGql;
  /** Move an AppBase database reference and canonical binding placement. */
  moveAppBaseDatabase: Scalars['JSONObject']['output'];
  /** Move one mounted App to another place: / or a path with exactly one segment such as /blog. Its pages move along. With swap the App mounted there takes the old place; without it a taken place fails with APP_BASE_MOUNT_POINT_TAKEN, a path that is no mount point with APP_BASE_MOUNT_POINT_INVALID. */
  moveAppBaseMount: Scalars['JSONObject']['output'];
  /** Move folder to new parent */
  moveFolder: FolderType;
  /** sl-obn0.7: Move a message through validated folder semantics. */
  moveMailMessage: MailMessage;
  /** Delete an App in the trash for good: definition, Agent Actions and the bindings of tables only it used. Each table only it owns is deleted or moved as chosen in tables. */
  permanentlyDeleteApp: Scalars['Boolean']['output'];
  /** Permanently delete a trashed AppBase aggregate. */
  permanentlyDeleteAppBase: Scalars['Boolean']['output'];
  /** Permanently delete a trashed document (irreversible) */
  permanentlyDeleteDoc: Scalars['Boolean']['output'];
  /** Permanently delete a trashed folder (irreversible) */
  permanentlyDeleteFolder: Scalars['Boolean']['output'];
  /** sl-pmcz: Pin/unpin a memory (pinned = immune to auto-cleanup) */
  pinUserMemory: UserMemory;
  /** Plan AppBase/App development through the shared AppBase Development Plan. */
  planAppBaseDevelopment: Scalars['JSONObject']['output'];
  /** sl-2q8e.2: Promote a version to published (Admin+) */
  publishAppBaseDraft: AppBaseVersionType;
  /** Publish an App container to the workspace's own templates. */
  publishAppContainerToMine: AppContainerPublishResult;
  /** Private copy of an automation to Mine; an existing copy gets a new version. */
  publishAutomationToMine: AppContainerPublishResult;
  /** Makes what the given entries hold now their live version and closes their open changes. 1 to 500 entries per call, all or none. An entry without open changes answers UNCHANGED and is not written. */
  publishContentEntries: Array<ContentEntryResultType>;
  publishDoc: DocType;
  /** @deprecated use publishDoc instead */
  publishPage: DocType;
  /** Copy an App in the trash to Mine without restoring its stored configuration. */
  publishTrashedAppToMine: AppContainerPublishResult;
  /** Private copy of a workflow to Mine; an existing copy gets a new version. */
  publishWorkflowToMine: AppContainerPublishResult;
  /** sl-apue + sl-fwcn: Purchase extra seats as item on plan subscription */
  purchaseExtraSeats: SeatAddonResultType;
  /** Push opaque current-user UI settings. Server stores and syncs payloads without interpreting them. */
  pushUiSettingsVault: PushUiSettingsVaultResult;
  /** queue workspace doc embedding */
  queueWorkspaceEmbedding: Scalars['Boolean']['output'];
  /** sl-amfa.4.2: Rate a marketplace template (1-5 stars, upsert) */
  rateTemplate: MarketplaceRatingGql;
  reactivateWorkspace: WorkspaceType;
  /** mark all notifications as read */
  readAllNotifications: Scalars['Boolean']['output'];
  /** mark notification as read */
  readNotification: Scalars['Boolean']['output'];
  /** Bulk-assign the owner of live App database rows (Workspace_AppBases_Edit + App Doc write + database Doc write). */
  reassignAppBaseRowOwners: AppBaseRowOwnerReassignResultType;
  /** Refresh a database binding's placement hints after a canonical database move. */
  rebindAppBaseDatabase: Scalars['JSONObject']['output'];
  /** Rebuild a doc from history by replaying valid entries until a timestamp */
  rebuildDocFromHistory: RecoveryResultType;
  /** Queue workspace mail body search-index rebuild candidates (Admin/Owner only). */
  rebuildMailSearchIndex: RebuildMailSearchIndexResult;
  recoverDoc: Scalars['DateTime']['output'];
  /** sl-etat: Force re-extraction of a document's KG entities */
  reextractDoc: Scalars['Boolean']['output'];
  refreshAppBasePublishedContent: Scalars['Boolean']['output'];
  /** Refresh current user subscriptions and return latest. */
  refreshUserSubscriptions: Array<SubscriptionType>;
  /** sl-qsjm: Regenerate backup codes (requires password) */
  regenerateBackupCodes: Array<Scalars['String']['output']>;
  /** sl-9qm.8.2 + sl-ya4v.4b-E: Register a custom domain (requires DNS verification). See registerSubdomain.appBaseId. */
  registerCustomDomain: CustomDomainType;
  /** sl-9qm.8.2 + sl-ya4v.4b-E: Register a managed subdomain (e.g. acme.streamlain.site). appBaseId binds the routing target — the domain serves exactly this AppBase; the service rejects cross-workspace AppBase ids. */
  registerSubdomain: CustomDomainType;
  /** Re-import the backend-seeded demo document into an existing workspace */
  reimportOnboardingDoc: Scalars['String']['output'];
  /** Repair current user's mail search/OCR index for a bounded mail scope. */
  reindexMailSearch: MailSearchReindexResult;
  /** Rebuild page-level PDF search provenance for a workspace, doc, or attachment */
  reindexPdfProvenance: PdfProvenanceReindexResult;
  /** Re-index all workspace embeddings: delete existing + queue all docs (sl-nagw.4.1) */
  reindexWorkspaceEmbeddings: ReindexWorkspaceEmbeddingsResult;
  /** sl-iw27.4.2: Reject a pending KG snapshot */
  rejectKgSnapshot: KgSnapshotType;
  /** sl-ya4v.14: Release the workspace's branded subdomain. Workspace falls back to its default short-id host. The released label enters the 30-day cooldown (re-registration ban) plus an up-to-90-day stale-slug 301 redirect lifetime (best-effort — the redirect ends early if any workspace reclaims the label after the 30-day cooldown). */
  releaseBrandedSubdomain: BrandedSubdomainRenameResult;
  releaseDeletedBlobs: Scalars['Boolean']['output'];
  /** Remind members without an accepted second factor to set one up (Owner/Admin, while 2FA is required). Returns the number of members reminded. */
  remindWorkspaceTwoFactorMembers: Scalars['Int']['output'];
  /** Remove user avatar */
  removeAvatar: RemoveAvatar;
  /** remove a blob from context */
  removeContextBlob: Scalars['Boolean']['output'];
  /** remove a category from context */
  removeContextCategory: Scalars['Boolean']['output'];
  /** remove a doc from context */
  removeContextDoc: Scalars['Boolean']['output'];
  /** remove a file from context */
  removeContextFile: Scalars['Boolean']['output'];
  /** sl-9qm.8.2: Remove a custom domain */
  removeCustomDomain: Scalars['Boolean']['output'];
  /** Remove a document from its folder */
  removeDocFromFolder: Scalars['Boolean']['output'];
  /** Remove a workspace Mate from a group */
  removeGroupMate: Scalars['Boolean']['output'];
  /** sl-jsx3.11.5: Remove a member from a group (Admin only) */
  removeGroupMember: Scalars['Boolean']['output'];
  /** sl-apue: Remove all extra seats from a workspace */
  removeSeatAddon: Scalars['Boolean']['output'];
  /** sl-kaqr.2.2: Remove a member from a tenant (Owner/Admin only) */
  removeTenantMember: Scalars['Boolean']['output'];
  /** sl-ya4v.14: Rename the workspace's branded subdomain. Validates plan-gate (Pro+), 30-day rate-limit, 30-day cooldown on the new label, and reserved-list membership. Atomic — slug-history + audit written in the same transaction. */
  renameBrandedSubdomain: BrandedSubdomainRenameResult;
  /** sl-etat: Rename a graph node */
  renameGraphNode: GraphNodeGql;
  /** Put the App mounts in the given order; every mount id exactly once. */
  reorderAppBaseMounts: Scalars['JSONObject']['output'];
  /** Report a data corruption event from the client */
  reportCorruption: CorruptionReportType;
  /** sl-amfa.4.2: Report a marketplace template for abuse/policy violation */
  reportTemplate: MarketplaceReportGql;
  /** sl-iw27.4.2: Re-promote a validated stale snapshot to pending */
  repromoteKgSnapshot: Scalars['Boolean']['output'];
  /** Ask the workspace admins to grant the current member MCP access */
  requestWorkspaceMcpAccess: Scalars['Boolean']['output'];
  /**
   * sl-hle4.6: Strip the entire AIEO settings block for an AppBase
   * (Admin+).
   */
  resetAppBaseAIEO: Scalars['Boolean']['output'];
  /**
   * sl-hle4.5: Strip the entire SEO settings block for an AppBase
   * (Admin+). Re-emits CDN purge for the AppBase + workspace SEO assets.
   */
  resetAppBaseSEO: Scalars['Boolean']['output'];
  /** sl-etat: Reset knowledge graph for a workspace (Owner only) */
  resetKnowledgeGraph: Scalars['Boolean']['output'];
  /** Reset all personal AI memories for the current user in a workspace (Owner/Admin only) */
  resetPersonalMemories: Scalars['Boolean']['output'];
  /** Reset all permission overrides for one workspace role (Admin/Owner only). */
  resetRolePermissions: Scalars['Boolean']['output'];
  /**
   * Clear workspace-level timeout overrides — effective limits fall
   * back to the plan defaults.
   */
  resetWorkflowLimits: WorkflowLimitsType;
  /** Resolve a comment or not */
  resolveComment: Scalars['Boolean']['output'];
  /** Resolve a pending decision by selecting a candidate */
  resolvePendingDecision: PendingDecisionType;
  /** Put an App from the trash back at its removed mount; a taken place refuses with APP_RESTORE_MOUNT_OCCUPIED. */
  restoreApp: Scalars['JSONObject']['output'];
  /** Restore a trashed AppBase aggregate. */
  restoreAppBase: Scalars['Boolean']['output'];
  /** Takes one App Module back to a saved version as new draft; the other App Modules and the tables stay (Admin+) */
  restoreAppBaseModule: AppBaseVersionType;
  /** sl-2q8e.2: Restore a historical version as new draft (Admin+) */
  restoreAppBaseVersion: AppBaseVersionType;
  /** Writes an old version of an entry into its row. For a delivered entry that is an open change, live only after publishContentEntries; changes already open are overwritten. Whether the entry is delivered (status, scheduled and published time) stays as the row has it. An entry that is not delivered is written directly and answers APPLIED without open changes. */
  restoreContentEntryVersion: ContentEntryResultType;
  /** Restore a doc from trash */
  restoreDoc: DocType;
  /** Restore a trashed folder and its contents */
  restoreFolder: FolderType;
  /** sl-8g8i.5: Restore a KG config snapshot (admin only, replaces current config) */
  restoreKgConfigSnapshot: Scalars['Boolean']['output'];
  /** sl-lkdb.4.1: Restore a workspace to a specific point in time (admin only) */
  restoreWorkspace: RecoveryLogType;
  resumeSubscription: SubscriptionType;
  retryAudioTranscription: Maybe<TranscriptionResultType>;
  /** Reveal one newly granted workspace MCP config exactly once for the target user */
  revealWorkspaceMcpGrant: WorkspaceMcpGrantReveal;
  /** @deprecated use [revokeMember] instead */
  revoke: Scalars['Boolean']['output'];
  /** sl-qsjm.3: Revoke all device trusts */
  revokeAllDeviceTrusts: Scalars['Int']['output'];
  /** Revoke one pending portal invitation. */
  revokeAppBasePortalInvitation: Scalars['Boolean']['output'];
  /** sl-qsjm.3: Revoke a specific device trust */
  revokeDeviceTrust: Scalars['Boolean']['output'];
  /** sl-jsx3.11.5: Revoke a group role from a doc (Admin only) */
  revokeDocGroupRole: Scalars['Boolean']['output'];
  /** Revoke the doc role of a workspace Mate */
  revokeDocMateRole: Scalars['Boolean']['output'];
  revokeDocUserRoles: Scalars['Boolean']['output'];
  /** sl-jsx3.11.5: Revoke a group role from a folder (Admin only) */
  revokeFolderGroupRole: Scalars['Boolean']['output'];
  /** Revoke the folder role of a workspace Mate */
  revokeFolderMateRole: Scalars['Boolean']['output'];
  /** Revoke folder role from user */
  revokeFolderRole: Scalars['Boolean']['output'];
  revokeInviteLink: Scalars['Boolean']['output'];
  revokeMember: Scalars['Boolean']['output'];
  revokePublicDoc: DocType;
  /** @deprecated use revokePublicDoc instead */
  revokePublicPage: DocType;
  revokeUserAccessToken: Scalars['Boolean']['output'];
  /** sl-xk37: Revoke a workspace MCP token (Admin/Owner only) */
  revokeWorkspaceMcpToken: Scalars['Boolean']['output'];
  /** Create or update a persisted mailbox draft for the current user. */
  saveMailDraft: SaveMailDraftResult;
  /** sl-zvjz: Schedule the current user's account for deletion after a grace period. Cancels Stripe subscriptions, invalidates sessions, emits audit event. Throws on Owner-of-Active-Workspace or already-scheduled state. */
  scheduleAccountDeletion: AccountDeletionStatus;
  /** Send a block-level attention invite to already-authorized doc users/groups. */
  sendBlockInvite: SendBlockInviteResultType;
  sendChangeEmail: Scalars['Boolean']['output'];
  sendChangePasswordEmail: Scalars['Boolean']['output'];
  /** sl-qsjm: Send email OTP code for 2FA verification */
  sendEmailOTP: Scalars['Boolean']['output'];
  /** sl-obn0.4.1: Send mail through current user's account and append Sent row. */
  sendMail: SendMailResult;
  /** Send an existing persisted mailbox draft. */
  sendSavedMailDraft: SendMailResult;
  sendSetPasswordEmail: Scalars['Boolean']['output'];
  sendTestEmail: Scalars['Boolean']['output'];
  sendVerifyChangeEmail: Scalars['Boolean']['output'];
  sendVerifyEmail: Scalars['Boolean']['output'];
  /** Change the page rights of an App Container: one access edit (defaults, set, inherit or groups) per call; an edit that breaks a rule is refused with its rule ids. */
  setAppBaseAccess: Scalars['JSONObject']['output'];
  /** sl-hle4.2 REWORK: Set one AppBase/site's optional monthly credit budget (Owner only). */
  setAppBaseBandwidthBudget: AppBaseBandwidthBudgetType;
  setAppBaseFrameMount: Scalars['JSONObject']['output'];
  /** Name one App mount in the navigation and place it there (primary, secondary, hidden); a null label shows the App under its own name. */
  setAppBaseMountNavigation: Scalars['JSONObject']['output'];
  setBlob: Scalars['String']['output'];
  /** sl-x1eb.2.1: Set initial password for authenticated user (onboarding wizard) */
  setInitialPassword: Scalars['Boolean']['output'];
  setMailWatchInterest: Scalars['Boolean']['output'];
  /** Set the skills a Mate carries, by whoever may change the Mate */
  setMateSkills: Array<Scalars['String']['output']>;
  /** sl-hle4.16: Set the calling user's notification preference for one trigger in one workspace. */
  setMyNotificationPreference: UserNotificationPreferenceType;
  /** sl-qsjm: Set preferred 2FA method (totp or email) */
  setPreferredTwoFactorMethod: Scalars['Boolean']['output'];
  /** Share a Mate with a member or a group, at most with the modes the workspace rule allows */
  shareMate: MateShareGql;
  /** Skip a pending decision (leave relation unlinked) */
  skipPendingDecision: PendingDecisionType;
  /** Run AppBase Development Plan smoke checks. */
  smokeTestAppBaseDevelopment: Scalars['JSONObject']['output'];
  /** Undo/redo: restore the version the linear history step points to (new version, history is never rewritten). */
  stepAppBaseVersion: AppBaseVersionType;
  /** E040: Strip doc history - merge + delete all histories. Destructive, cannot be undone. */
  stripDocHistory: StripDocHistoryResultType;
  submitAudioTranscription: Maybe<TranscriptionResultType>;
  /** sl-dl66: Switch billing interval for a plan subscription (Monthly/Yearly) */
  switchPlanInterval: SubscriptionType;
  /** sl-obn0.4.1: Queue a sync job for current user's mail account. */
  syncMailAccount: Scalars['String']['output'];
  /** sl-xbxb: Assign a tag to a document */
  tagDoc: Scalars['Boolean']['output'];
  transferMailSyncAuthority: MailAccount;
  transferWorkspaceOwnership: Scalars['Boolean']['output'];
  /**
   * sl-i7kr.5.3: AI-translate canonical database content into TranslationDB
   * rows (Owner, Pro+ plan). Idempotent — existing rows are skipped unless
   * `overrideExisting` is set. Uses the same managed-credit accounting,
   * durable source-hash cache and 100/hour workspace rate limit as metadata
   * translation.
   */
  translateAppBaseContent: TranslateAppBaseContentResult;
  /**
   * sl-hle4.7: AI-translate an AppBase's i18n title and/or
   * description maps from the source locale to one or more target locales
   * (Admin+, Pro+ plan). Idempotent — locales whose target value is already
   * filled are skipped unless `overrideExisting` is set. Each translated
   * string consumes managed AI credits; the source of truth for charged
   * spend is `ai_usage_log` joinable via the returned `jobId`. Hard rate
   * limit: 100 calls per hour per workspace.
   */
  translateAppBaseMetadata: TranslateAppBaseMetadataResult;
  /** Move a doc to trash */
  trashDoc: DocType;
  /** Move folder and its contents to trash (soft-delete) */
  trashFolder: FolderType;
  /** Trigger cleanup of trashed doc embeddings */
  triggerCleanupTrashedDocEmbeddings: Scalars['Boolean']['output'];
  /** Trigger generate missing titles cron job */
  triggerGenerateTitleCron: Scalars['Boolean']['output'];
  /** Trust one sender for automatic remote image loading by the current user. */
  trustMailSender: MailTrustedSender;
  /** sl-rwfq.4.2: Generic undo for graph mutations (delete, merge, split, rename, etc.) */
  undoGraphMutation: Scalars['Boolean']['output'];
  /** Move one App mount out; an App without another mount goes to the trash with its data. */
  unmountApp: Scalars['JSONObject']['output'];
  /** sl-2q8e.2: Deactivate current published version (Admin+) */
  unpublishAppBase: AppBaseVersionType;
  /** End the share of a Mate with a member or a group */
  unshareMate: Scalars['Boolean']['output'];
  /** sl-xbxb: Remove a tag from a document */
  untagDoc: Scalars['Boolean']['output'];
  /** sl-opil.6.2: Update AI consent for a workspace (Owner only) */
  updateAIConsent: ManagedAiStatusType;
  /** sl-9qm.1.4: Update an AppBase (Admin+) */
  updateAppBase: AppBaseType;
  /**
   * sl-hle4.6: Replace AIEO settings (LLM crawler policy + AI provenance
   * declaration + llms.txt override) for an AppBase (Admin+).
   * Triggers per-app-base CDN purge + always purges the workspace robots.txt /
   * llms.txt / sitemap.xml so the new policy takes effect.
   */
  updateAppBaseAIEO: AppBaseAieoSettingsType;
  /** Persist the AI-first app-base brief and lifecycle state. */
  updateAppBaseBrief: Scalars['JSONObject']['output'];
  /**
   * sl-hle4.5: Replace SEO settings for an AppBase (Admin+).
   * Validates per-locale title (≤60) / description (≤160) length, robots
   * whitelist, and JSON-LD type. Triggers per-app-base CDN purge; toggles to
   * `indexing` additionally purge sitemap.xml + robots.txt + llms.txt.
   */
  updateAppBaseSEO: AppBaseSeoSettingsType;
  /** update app configuration */
  updateAppConfig: Scalars['JSONObject']['output'];
  /** sl-tdgy.7: Update circuit breaker config for a workspace */
  updateCircuitBreakerConfig: Scalars['Boolean']['output'];
  /** Update a comment content */
  updateComment: Scalars['Boolean']['output'];
  /** Update a copilot prompt */
  updateCopilotPrompt: CopilotPromptType;
  /** Update a chat session */
  updateCopilotSession: Scalars['String']['output'];
  /** Update the status of a corruption report */
  updateCorruptionReportStatus: CorruptionReportType;
  updateDocDefaultRole: Scalars['Boolean']['output'];
  updateDocTitle: DocType;
  updateDocUserRole: Scalars['Boolean']['output'];
  /** Update folder name */
  updateFolder: FolderType;
  /** sl-ncr1.2.2: Change the entity type (label) of a graph node */
  updateGraphNodeType: GraphNodeGql;
  /** sl-jsx3.11.5: Update a group (Admin only) */
  updateGroup: UserGroupType;
  /** sl-8g8i.5: Update a KG pipeline step (admin only) */
  updateKgPipelineStep: Scalars['Boolean']['output'];
  /** sl-k94y.8.1: Update deployment locale settings (admin only). */
  updateLocaleSettings: LocaleSettingsType;
  /** sl-obn0.4.1: Update current user's mail account metadata/status. */
  updateMailAccount: MailAccount;
  /** sl-obn0.7: Rename a validated custom mail folder. */
  updateMailFolder: MailMailboxFolder;
  /** sl-obn0.7: Update safe message state fields. */
  updateMailMessageState: MailMessage;
  /** sl-obn0.4.2: Update workspace mail policy (Admin/Owner only). */
  updateMailPolicy: MailPolicy;
  /** Change a Mate: a personal one by its owner, a workspace one by its managers */
  updateMate: MateGql;
  updateProfile: UserType;
  /** Update a reply content */
  updateReply: Scalars['Boolean']['output'];
  /** sl-sdk6.7.2: Set or reset a role permission override (Admin/Owner only). granted=null resets to default. */
  updateRolePermission: Scalars['Boolean']['output'];
  /** sl-apue: Update the number of extra seats for a workspace */
  updateSeatCount: SeatAddonResultType;
  /** Update user settings */
  updateSettings: Scalars['Boolean']['output'];
  /** Change a skill of the workspace library (whoever manages the workspace Mates) */
  updateSkill: SkillGql;
  /** sl-b828.12: Update a system prompt template and append version history when body changes */
  updateSystemPromptTemplate: SystemPromptTemplateType;
  /** sl-xbxb: Update tag name and/or color */
  updateTag: WorkspaceTagType;
  /** sl-kaqr.2.2: Update tenant details (Owner/Admin only) */
  updateTenant: TenantType;
  /** sl-kaqr.2.2: Update a tenant member's role (Owner only) */
  updateTenantMemberRole: TenantMemberType;
  /** Update an user */
  updateUser: UserType;
  /** update user enabled feature */
  updateUserFeatures: Array<FeatureType>;
  /** sl-pmcz.1.1: Update a user's AI memory content */
  updateUserMemory: UserMemory;
  /**
   * Set workspace-level overrides for step/workflow timeouts. Values
   * above the plan cap are clamped down; workflow timeout is clamped up
   * to be at least the step timeout. Returns the post-update effective
   * limits so the client can refresh without a second query.
   */
  updateWorkflowLimits: WorkflowLimitsType;
  /** Update workspace */
  updateWorkspace: WorkspaceType;
  /** Update ignored docs */
  updateWorkspaceEmbeddingIgnoredDocs: Scalars['Int']['output'];
  /** sl-ddz8.7.2: Update workspace memory configuration (admin only, upsert) */
  updateWorkspaceMemoryConfig: WorkspaceMemoryConfigGql;
  /** sl-qsjm.5: Update workspace 2FA enforcement policy */
  updateWorkspacePolicy: WorkspacePolicyType;
  /** sl-sf9o: Update workspace model routing configuration (Owner/Admin only) */
  updateWorkspaceRoutingConfig: WorkspaceRoutingConfigType;
  /** Upload user avatar */
  uploadAvatar: UserType;
  /** Upload a comment attachment and return the access url */
  uploadCommentAttachment: Scalars['String']['output'];
  /** sl-8g8i.5: Upsert a KG config value (admin only) */
  upsertKgConfigValue: Scalars['Boolean']['output'];
  /** sl-8g8i.5: Upsert a KG entity type (admin only) */
  upsertKgEntityType: Scalars['Boolean']['output'];
  /** sl-8g8i.5: Upsert a KG relation type (admin only) */
  upsertKgRelationType: Scalars['Boolean']['output'];
  /** sl-ckdp: Create or update a current user's account autoresponder. */
  upsertMailAutoresponder: MailAutoresponder;
  /** sl-obn0.7: Create or update a validated mail rule. */
  upsertMailRule: MailRule;
  /** sl-ckdp: Create or update a current user's mail signature. */
  upsertMailSignature: MailSignature;
  /** Validate an AppBase Development Plan through the shared AppBase Development Plan. */
  validateAppBaseDevelopment: Scalars['JSONObject']['output'];
  /** validate app configuration */
  validateAppConfig: Array<AppConfigValidateResult>;
  /** sl-qsjm.3: Verify backup code during login (sets session as 2FA-verified) */
  verifyBackupCodeLogin: TwoFactorVerifyResult;
  verifyEmail: Scalars['Boolean']['output'];
  /** sl-qsjm.3: Verify Email OTP during login (sets session as 2FA-verified) */
  verifyEmailOTPLogin: TwoFactorVerifyResult;
  /** sl-qsjm.3: Verify TOTP code during login (sets session as 2FA-verified) */
  verifyTOTPLogin: TwoFactorVerifyResult;
  /** sl-qsjm: Verify TOTP code to complete setup (returns backup codes) */
  verifyTOTPSetup: Array<Scalars['String']['output']>;
}

export interface MutationAcceptInviteByIdArgs {
  inviteId: Scalars['String']['input'];
  sendAcceptMail?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}

export interface MutationAcceptKgSnapshotArgs {
  snapshotId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationAcceptTenantInviteArgs {
  tenantId: Scalars['ID']['input'];
}

export interface MutationAddContextBlobArgs {
  options: AddContextBlobInput;
}

export interface MutationAddContextCategoryArgs {
  options: AddContextCategoryInput;
}

export interface MutationAddContextDocArgs {
  options: AddContextDocInput;
}

export interface MutationAddContextFileArgs {
  content: Scalars['Upload']['input'];
  options: AddContextFileInput;
}

export interface MutationAddDocToFolderArgs {
  docId: Scalars['String']['input'];
  folderId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationAddGroupMateArgs {
  groupId: Scalars['String']['input'];
  mateId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationAddGroupMemberArgs {
  groupId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationAddTenantMemberArgs {
  role: TenantRoleEnum;
  tenantId: Scalars['ID']['input'];
  userId: Scalars['String']['input'];
}

export interface MutationAdminAssignPlanArgs {
  plan: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}

export interface MutationAdminBackfillEmbeddingsArgs {
  workspaceId: Scalars['String']['input'];
}

export interface MutationAdminDeleteMemoryArgs {
  memoryId: Scalars['String']['input'];
}

export interface MutationAdminDisableTotpArgs {
  userId: Scalars['String']['input'];
}

export interface MutationAdminPseudonymizeUserMemoriesArgs {
  userId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationApplyAppBaseDevelopmentArgs {
  change?: InputMaybe<AppBaseDraftChangeInput>;
  input: Scalars['JSONObject']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationApproveMemberArgs {
  userId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationAssignMailSignatureArgs {
  input: AssignMailSignatureInput;
}

export interface MutationAttachExistingAppBaseDatabaseArgs {
  id: Scalars['String']['input'];
  input: AttachAppBaseDatabaseInput;
  workspaceId: Scalars['String']['input'];
}

export interface MutationAutomationDeleteArgs {
  input: AutomationLifecycleInput;
}

export interface MutationAutomationRestoreArgs {
  input: AutomationLifecycleInput;
}

export interface MutationAutomationTrashArgs {
  input: AutomationLifecycleInput;
}

export interface MutationBanUserArgs {
  id: Scalars['String']['input'];
}

export interface MutationBeginContentEntryChangeArgs {
  appBaseId: Scalars['String']['input'];
  rowId: Scalars['String']['input'];
  sourceKey: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationCancelCreditSubscriptionArgs {
  creditPackId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationCancelPendingIntervalChangeArgs {
  creditPackId?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationCancelSubscriptionArgs {
  language?: InputMaybe<Scalars['String']['input']>;
  plan: Scalars['String']['input'];
  terminationReason?: InputMaybe<Scalars['String']['input']>;
  terminationType?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}

export interface MutationChangeEmailArgs {
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
}

export interface MutationChangePasswordArgs {
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
}

export interface MutationClaimAudioTranscriptionArgs {
  jobId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationCleanupCopilotSessionArgs {
  options: DeleteSessionInput;
}

export interface MutationClearAppBaseBandwidthBudgetArgs {
  appBaseId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationCompactDocArgs {
  input: CompactDocInput;
}

export interface MutationConfirmSplitGraphNodeArgs {
  edgeTargetNodeName?: InputMaybe<Scalars['String']['input']>;
  newNodes: Array<SplitEntityInput>;
  originalNodeId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationConnectGraphNodesArgs {
  relationType: Scalars['String']['input'];
  sourceNodeId: Scalars['String']['input'];
  targetNodeId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationConnectMailAccountArgs {
  input: ConnectMailAccountInput;
}

export interface MutationCreateAppBaseArgs {
  input: CreateAppBaseInput;
  workspaceId: Scalars['String']['input'];
}

export interface MutationCreateAppBaseDraftArgs {
  appBaseId: Scalars['String']['input'];
  input: CreateAppBaseDraftInput;
  workspaceId: Scalars['String']['input'];
}

export interface MutationCreateAppBasePortalInvitationArgs {
  appBaseId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface MutationCreateChangePasswordUrlArgs {
  userId: Scalars['String']['input'];
}

export interface MutationCreateCheckoutSessionArgs {
  input: CreateCheckoutSessionInput;
}

export interface MutationCreateCommentArgs {
  input: CommentCreateInput;
}

export interface MutationCreateCopilotContextArgs {
  sessionId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationCreateCopilotMessageArgs {
  options: CreateChatMessageInput;
}

export interface MutationCreateCopilotPromptArgs {
  input: CreateCopilotPromptInput;
}

export interface MutationCreateCopilotSessionArgs {
  options: CreateChatSessionInput;
}

export interface MutationCreateCreditCheckoutArgs {
  cancelUrl: Scalars['String']['input'];
  packId: Scalars['String']['input'];
  successUrl: Scalars['String']['input'];
  withdrawalConsent: Scalars['Boolean']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationCreateFolderArgs {
  input: CreateFolderInput;
}

export interface MutationCreateGroupArgs {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationCreateInviteLinkArgs {
  expireTime: WorkspaceInviteLinkExpireTime;
  workspaceId: Scalars['String']['input'];
}

export interface MutationCreateKgConfigSnapshotArgs {
  label?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}

export interface MutationCreateMailFolderArgs {
  input: CreateMailFolderInput;
}

export interface MutationCreateMateMemoryArgs {
  category: Scalars['String']['input'];
  content: Scalars['String']['input'];
  mateId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationCreateReplyArgs {
  input: ReplyCreateInput;
}

export interface MutationCreateSelfhostWorkspaceCustomerPortalArgs {
  workspaceId: Scalars['String']['input'];
}

export interface MutationCreateSkillArgs {
  input: CreateSkillInput;
}

export interface MutationCreateTagArgs {
  color: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationCreateUserArgs {
  input: CreateUserInput;
}

export interface MutationCreateUserMemoryArgs {
  category: Scalars['String']['input'];
  content: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationCreateWorkspaceArgs {
  idempotencyKey: Scalars['String']['input'];
  init?: InputMaybe<Scalars['Upload']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}

export interface MutationCreateWorkspaceMateArgs {
  input: CreateWorkspaceMateInput;
}

export interface MutationDatabaseAddPropertyArgs {
  input: DatabaseAddPropertyInput;
}

export interface MutationDatabaseAddRowArgs {
  input: DatabaseAddRowInput;
}

export interface MutationDatabaseBulkMutateArgs {
  input: DatabaseBulkMutateInput;
}

export interface MutationDatabaseDeletePropertyArgs {
  input: DatabaseDeletePropertyInput;
}

export interface MutationDatabaseDeleteRowArgs {
  input: DatabaseDeleteRowInput;
}

export interface MutationDatabaseDuplicatePropertyArgs {
  input: DatabaseDuplicatePropertyInput;
}

export interface MutationDatabaseMoveArgs {
  input: DatabaseMoveInput;
}

export interface MutationDatabaseMoveRowArgs {
  input: DatabaseMoveRowInput;
}

export interface MutationDatabasePermanentlyDeleteArgs {
  input: DatabasePermanentlyDeleteInput;
}

export interface MutationDatabaseRenamePropertyArgs {
  input: DatabaseRenamePropertyInput;
}

export interface MutationDatabaseRestoreArgs {
  input: DatabaseLifecycleInput;
}

export interface MutationDatabaseSetPropertyDataArgs {
  input: DatabaseSetPropertyDataInput;
}

export interface MutationDatabaseSetPropertyTypeArgs {
  input: DatabaseSetPropertyTypeInput;
}

export interface MutationDatabaseTrashArgs {
  input: DatabaseLifecycleInput;
}

export interface MutationDatabaseUpdateCellsArgs {
  input: DatabaseUpdateCellsInput;
}

export interface MutationDeleteAppBaseArgs {
  id: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationDeleteBlobArgs {
  hash?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  permanently?: Scalars['Boolean']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationDeleteCommentArgs {
  id: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationDeleteGraphEdgeArgs {
  edgeId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationDeleteGraphNodeArgs {
  nodeId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationDeleteGroupArgs {
  groupId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationDeleteKgConfigValueArgs {
  id: Scalars['String']['input'];
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}

export interface MutationDeleteKgEntityTypeArgs {
  id: Scalars['String']['input'];
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}

export interface MutationDeleteKgRelationTypeArgs {
  id: Scalars['String']['input'];
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}

export interface MutationDeleteKgSnapshotNodeArgs {
  nodeId: Scalars['String']['input'];
  snapshotId: Scalars['String']['input'];
}

export interface MutationDeleteMailAccountArgs {
  accountId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationDeleteMailAutoresponderOverrideArgs {
  accountId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationDeleteMailFolderArgs {
  folderId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationDeleteMailRuleArgs {
  ruleId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationDeleteMailSignatureArgs {
  signatureId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationDeleteMailSignatureAssignmentArgs {
  accountId: Scalars['String']['input'];
  scope: MailSignatureScope;
  workspaceId: Scalars['String']['input'];
}

export interface MutationDeleteMateArgs {
  mateId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationDeleteNotificationArgs {
  id: Scalars['String']['input'];
}

export interface MutationDeleteReplyArgs {
  id: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationDeleteSkillArgs {
  skillId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationDeleteTagArgs {
  tagId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationDeleteUserArgs {
  id: Scalars['String']['input'];
}

export interface MutationDeleteUserMemoryArgs {
  id: Scalars['String']['input'];
}

export interface MutationDeleteWorkspaceArgs {
  id: Scalars['String']['input'];
}

export interface MutationDetachAppBaseDatabaseArgs {
  id: Scalars['String']['input'];
  input: DetachAppBaseDatabaseInput;
  workspaceId: Scalars['String']['input'];
}

export interface MutationDiffAppBaseDevelopmentArgs {
  newTree: Scalars['JSONObject']['input'];
  oldTree: Scalars['JSONObject']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationDisableManagedAiArgs {
  workspaceId: Scalars['String']['input'];
}

export interface MutationDisableTotpArgs {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
}

export interface MutationDiscardAppBaseDraftArgs {
  appBaseId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationDiscardContentEntryChangesArgs {
  appBaseId: Scalars['String']['input'];
  rowIds: Array<Scalars['String']['input']>;
  sourceKey: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationDisconnectGraphNodesArgs {
  sourceNodeId: Scalars['String']['input'];
  targetNodeId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationEditKgSnapshotNodeArgs {
  name?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['String']['input'];
  snapshotId: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
}

export interface MutationEnableManagedAiArgs {
  workspaceId: Scalars['String']['input'];
}

export interface MutationEnableTotpArgs {
  password?: InputMaybe<Scalars['String']['input']>;
}

export interface MutationEnableUserArgs {
  id: Scalars['String']['input'];
}

export interface MutationEnqueuePermissionGraphProjectionRebuildArgs {
  workspaceId: Scalars['String']['input'];
}

export interface MutationEnsureAppBaseDataSourcesArgs {
  id: Scalars['String']['input'];
  input: EnsureAppBaseDataSourcesInput;
  workspaceId: Scalars['String']['input'];
}

export interface MutationExplainAppBaseDevelopmentGapArgs {
  gapId: Scalars['String']['input'];
  input: Scalars['JSONObject']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationFinalizeCheckoutSessionArgs {
  sessionId: Scalars['String']['input'];
}

export interface MutationForkCopilotSessionArgs {
  options: ForkChatSessionInput;
}

export interface MutationGenerateUserAccessTokenArgs {
  input: GenerateAccessTokenInput;
}

export interface MutationGenerateWorkspaceMcpTokenArgs {
  input: GenerateWorkspaceMcpTokenInput;
}

export interface MutationGrantDocGroupRoleArgs {
  docId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
  role: DocRole;
  workspaceId: Scalars['String']['input'];
}

export interface MutationGrantDocMateRoleArgs {
  docId: Scalars['String']['input'];
  mateId: Scalars['String']['input'];
  role: DocRole;
  workspaceId: Scalars['String']['input'];
}

export interface MutationGrantDocUserRolesArgs {
  input: GrantDocUserRolesInput;
}

export interface MutationGrantFolderGroupRoleArgs {
  folderId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
  role: FolderRole;
  workspaceId: Scalars['String']['input'];
}

export interface MutationGrantFolderMateRoleArgs {
  folderId: Scalars['String']['input'];
  mateId: Scalars['String']['input'];
  role: FolderRole;
  workspaceId: Scalars['String']['input'];
}

export interface MutationGrantFolderRoleArgs {
  input: GrantFolderRoleInput;
}

export interface MutationGrantMemberArgs {
  permission: Permission;
  userId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationGrantWorkspaceMcpAccessToGroupArgs {
  input: GrantWorkspaceMcpGroupInput;
}

export interface MutationImportUsersArgs {
  input: ImportUsersInput;
}

export interface MutationInviteBatchArgs {
  emails: Array<Scalars['String']['input']>;
  sendInviteMail?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface MutationInviteMembersArgs {
  emails: Array<Scalars['String']['input']>;
  permission?: InputMaybe<Permission>;
  workspaceId: Scalars['String']['input'];
}

export interface MutationInviteTenantMemberArgs {
  email: Scalars['String']['input'];
  role: TenantRoleEnum;
  tenantId: Scalars['ID']['input'];
}

export interface MutationLeaveWorkspaceArgs {
  sendLeaveMail?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['String']['input'];
  workspaceName?: InputMaybe<Scalars['String']['input']>;
}

export interface MutationMentionUserArgs {
  input: MentionInput;
}

export interface MutationMergeGraphNodesArgs {
  sourceNodeId: Scalars['String']['input'];
  targetNodeId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationMoveAppBaseDatabaseArgs {
  id: Scalars['String']['input'];
  input: MoveAppBaseDatabaseInput;
  workspaceId: Scalars['String']['input'];
}

export interface MutationMoveAppBaseMountArgs {
  change?: InputMaybe<AppBaseDraftChangeInput>;
  id: Scalars['String']['input'];
  mountId: Scalars['String']['input'];
  mountPoint: Scalars['String']['input'];
  swap?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface MutationMoveFolderArgs {
  folderId: Scalars['String']['input'];
  newParentId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface MutationMoveMailMessageArgs {
  input: MoveMailMessageInput;
}

export interface MutationPermanentlyDeleteAppArgs {
  appId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  tables: Array<AppBaseTableDispositionInput>;
  workspaceId: Scalars['String']['input'];
}

export interface MutationPermanentlyDeleteAppBaseArgs {
  id: Scalars['String']['input'];
  tables: Array<AppBaseTableDispositionInput>;
  workspaceId: Scalars['String']['input'];
}

export interface MutationPermanentlyDeleteDocArgs {
  docId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationPermanentlyDeleteFolderArgs {
  folderId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationPinUserMemoryArgs {
  id: Scalars['String']['input'];
  pinned: Scalars['Boolean']['input'];
}

export interface MutationPlanAppBaseDevelopmentArgs {
  input: Scalars['JSONObject']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationPublishAppBaseDraftArgs {
  appBaseId: Scalars['String']['input'];
  version: Scalars['Int']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationPublishAppContainerToMineArgs {
  appBaseId: Scalars['String']['input'];
  fromTrash?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface MutationPublishAutomationToMineArgs {
  automationBlockId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationPublishContentEntriesArgs {
  appBaseId: Scalars['String']['input'];
  rowIds: Array<Scalars['String']['input']>;
  sourceKey: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationPublishDocArgs {
  docId: Scalars['String']['input'];
  mode?: InputMaybe<PublicDocMode>;
  workspaceId: Scalars['String']['input'];
}

export interface MutationPublishPageArgs {
  mode?: InputMaybe<PublicDocMode>;
  pageId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationPublishTrashedAppToMineArgs {
  appId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationPublishWorkflowToMineArgs {
  workflowId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationPurchaseExtraSeatsArgs {
  quantity: Scalars['Int']['input'];
  withdrawalConsent: Scalars['Boolean']['input'];
  workspaceId: Scalars['ID']['input'];
}

export interface MutationPushUiSettingsVaultArgs {
  input: PushUiSettingsVaultInput;
}

export interface MutationQueueWorkspaceEmbeddingArgs {
  docId: Array<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface MutationRateTemplateArgs {
  comment?: InputMaybe<Scalars['String']['input']>;
  rating: Scalars['Int']['input'];
  templateId: Scalars['ID']['input'];
}

export interface MutationReactivateWorkspaceArgs {
  id: Scalars['String']['input'];
}

export interface MutationReadNotificationArgs {
  id: Scalars['String']['input'];
}

export interface MutationReassignAppBaseRowOwnersArgs {
  input: ReassignAppBaseRowOwnersInput;
}

export interface MutationRebindAppBaseDatabaseArgs {
  id: Scalars['String']['input'];
  input: RebindAppBaseDatabaseInput;
  workspaceId: Scalars['String']['input'];
}

export interface MutationRebuildDocFromHistoryArgs {
  input: RebuildDocFromHistoryInput;
}

export interface MutationRebuildMailSearchIndexArgs {
  input: RebuildMailSearchIndexInput;
}

export interface MutationRecoverDocArgs {
  guid: Scalars['String']['input'];
  timestamp: Scalars['DateTime']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationReextractDocArgs {
  docId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationRefreshAppBasePublishedContentArgs {
  appBaseId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationRegenerateBackupCodesArgs {
  password: Scalars['String']['input'];
}

export interface MutationRegisterCustomDomainArgs {
  appBaseId: Scalars['String']['input'];
  domain: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationRegisterSubdomainArgs {
  appBaseId: Scalars['String']['input'];
  subdomain: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationReimportOnboardingDocArgs {
  locale?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface MutationReindexMailSearchArgs {
  input: MailSearchReindexInput;
}

export interface MutationReindexPdfProvenanceArgs {
  input: PdfProvenanceReindexInput;
}

export interface MutationReindexWorkspaceEmbeddingsArgs {
  docIds?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceId: Scalars['String']['input'];
}

export interface MutationRejectKgSnapshotArgs {
  reason?: InputMaybe<Scalars['String']['input']>;
  snapshotId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationReleaseBrandedSubdomainArgs {
  workspaceId: Scalars['String']['input'];
}

export interface MutationReleaseDeletedBlobsArgs {
  workspaceId: Scalars['String']['input'];
}

export interface MutationRemindWorkspaceTwoFactorMembersArgs {
  workspaceId: Scalars['String']['input'];
}

export interface MutationRemoveContextBlobArgs {
  options: RemoveContextBlobInput;
}

export interface MutationRemoveContextCategoryArgs {
  options: RemoveContextCategoryInput;
}

export interface MutationRemoveContextDocArgs {
  options: RemoveContextDocInput;
}

export interface MutationRemoveContextFileArgs {
  options: RemoveContextFileInput;
}

export interface MutationRemoveCustomDomainArgs {
  domainId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationRemoveDocFromFolderArgs {
  docId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationRemoveGroupMateArgs {
  groupId: Scalars['String']['input'];
  mateId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationRemoveGroupMemberArgs {
  groupId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationRemoveSeatAddonArgs {
  workspaceId: Scalars['ID']['input'];
}

export interface MutationRemoveTenantMemberArgs {
  tenantId: Scalars['ID']['input'];
  userId: Scalars['String']['input'];
}

export interface MutationRenameBrandedSubdomainArgs {
  newLabel: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationRenameGraphNodeArgs {
  newName: Scalars['String']['input'];
  nodeId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationReorderAppBaseMountsArgs {
  change?: InputMaybe<AppBaseDraftChangeInput>;
  id: Scalars['String']['input'];
  mountIds: Array<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface MutationReportCorruptionArgs {
  input: ReportCorruptionInput;
}

export interface MutationReportTemplateArgs {
  details?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
  templateId: Scalars['ID']['input'];
}

export interface MutationRepromoteKgSnapshotArgs {
  snapshotId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationRequestWorkspaceMcpAccessArgs {
  workspaceId: Scalars['String']['input'];
}

export interface MutationResetAppBaseAieoArgs {
  appBaseId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
}

export interface MutationResetAppBaseSeoArgs {
  appBaseId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
}

export interface MutationResetKnowledgeGraphArgs {
  workspaceId: Scalars['String']['input'];
}

export interface MutationResetPersonalMemoriesArgs {
  workspaceId: Scalars['String']['input'];
}

export interface MutationResetRolePermissionsArgs {
  role: Permission;
  workspaceId: Scalars['String']['input'];
}

export interface MutationResetWorkflowLimitsArgs {
  workspaceId: Scalars['String']['input'];
}

export interface MutationResolveCommentArgs {
  input: CommentResolveInput;
}

export interface MutationResolvePendingDecisionArgs {
  id: Scalars['String']['input'];
  resolvedWith: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationRestoreAppArgs {
  appId: Scalars['String']['input'];
  change?: InputMaybe<AppBaseDraftChangeInput>;
  id: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationRestoreAppBaseArgs {
  id: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationRestoreAppBaseModuleArgs {
  appBaseId: Scalars['String']['input'];
  mountId: Scalars['String']['input'];
  version: Scalars['Int']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationRestoreAppBaseVersionArgs {
  appBaseId: Scalars['String']['input'];
  version: Scalars['Int']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationRestoreContentEntryVersionArgs {
  appBaseId: Scalars['String']['input'];
  rowId: Scalars['String']['input'];
  sourceKey: Scalars['String']['input'];
  version: Scalars['Int']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationRestoreDocArgs {
  docId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationRestoreFolderArgs {
  folderId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationRestoreKgConfigSnapshotArgs {
  id: Scalars['String']['input'];
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}

export interface MutationRestoreWorkspaceArgs {
  targetTimestamp: Scalars['DateTime']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationResumeSubscriptionArgs {
  plan: Scalars['String']['input'];
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}

export interface MutationRetryAudioTranscriptionArgs {
  jobId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationRevealWorkspaceMcpGrantArgs {
  input: RevealWorkspaceMcpGrantInput;
}

export interface MutationRevokeArgs {
  userId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationRevokeAppBasePortalInvitationArgs {
  appBaseId: Scalars['String']['input'];
  invitationId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationRevokeDeviceTrustArgs {
  trustId: Scalars['String']['input'];
}

export interface MutationRevokeDocGroupRoleArgs {
  docId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationRevokeDocMateRoleArgs {
  docId: Scalars['String']['input'];
  mateId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationRevokeDocUserRolesArgs {
  input: RevokeDocUserRoleInput;
}

export interface MutationRevokeFolderGroupRoleArgs {
  folderId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationRevokeFolderMateRoleArgs {
  folderId: Scalars['String']['input'];
  mateId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationRevokeFolderRoleArgs {
  folderId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationRevokeInviteLinkArgs {
  workspaceId: Scalars['String']['input'];
}

export interface MutationRevokeMemberArgs {
  userId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationRevokePublicDocArgs {
  docId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationRevokePublicPageArgs {
  docId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationRevokeUserAccessTokenArgs {
  id: Scalars['String']['input'];
}

export interface MutationRevokeWorkspaceMcpTokenArgs {
  tokenId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationSaveMailDraftArgs {
  input: SaveMailDraftInput;
}

export interface MutationScheduleAccountDeletionArgs {
  reason?: InputMaybe<Scalars['String']['input']>;
}

export interface MutationSendBlockInviteArgs {
  input: BlockInviteInput;
}

export interface MutationSendChangeEmailArgs {
  callbackUrl: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
}

export interface MutationSendChangePasswordEmailArgs {
  callbackUrl: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
}

export interface MutationSendMailArgs {
  input: SendMailInput;
}

export interface MutationSendSavedMailDraftArgs {
  files?: InputMaybe<Array<Scalars['Upload']['input']>>;
  input: SendSavedMailDraftInput;
}

export interface MutationSendSetPasswordEmailArgs {
  callbackUrl: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
}

export interface MutationSendTestEmailArgs {
  config: Scalars['JSONObject']['input'];
}

export interface MutationSendVerifyChangeEmailArgs {
  callbackUrl: Scalars['String']['input'];
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
}

export interface MutationSendVerifyEmailArgs {
  callbackUrl: Scalars['String']['input'];
}

export interface MutationSetAppBaseAccessArgs {
  change?: InputMaybe<AppBaseDraftChangeInput>;
  edit: Scalars['JSONObject']['input'];
  id: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationSetAppBaseBandwidthBudgetArgs {
  input: SetAppBaseBandwidthBudgetInput;
}

export interface MutationSetAppBaseFrameMountArgs {
  change?: InputMaybe<AppBaseDraftChangeInput>;
  id: Scalars['String']['input'];
  mountId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface MutationSetAppBaseMountNavigationArgs {
  change?: InputMaybe<AppBaseDraftChangeInput>;
  design?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  mountId: Scalars['String']['input'];
  placement: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationSetBlobArgs {
  blob: Scalars['Upload']['input'];
  docId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface MutationSetInitialPasswordArgs {
  password: Scalars['String']['input'];
}

export interface MutationSetMailWatchInterestArgs {
  accountId: Scalars['String']['input'];
  interest: MailWatchInterest;
  workspaceId: Scalars['String']['input'];
}

export interface MutationSetMateSkillsArgs {
  mateId: Scalars['String']['input'];
  skillIds: Array<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface MutationSetMyNotificationPreferenceArgs {
  input: SetMyNotificationPreferenceInput;
}

export interface MutationSetPreferredTwoFactorMethodArgs {
  method: Scalars['String']['input'];
}

export interface MutationShareMateArgs {
  input: ShareMateInput;
}

export interface MutationSkipPendingDecisionArgs {
  id: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationSmokeTestAppBaseDevelopmentArgs {
  input: Scalars['JSONObject']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationStepAppBaseVersionArgs {
  appBaseId: Scalars['String']['input'];
  step: AppBaseVersionStep;
  workspaceId: Scalars['String']['input'];
}

export interface MutationStripDocHistoryArgs {
  input: StripDocHistoryInput;
}

export interface MutationSubmitAudioTranscriptionArgs {
  blob?: InputMaybe<Scalars['Upload']['input']>;
  blobId: Scalars['String']['input'];
  blobs?: InputMaybe<Array<Scalars['Upload']['input']>>;
  workspaceId: Scalars['String']['input'];
}

export interface MutationSwitchPlanIntervalArgs {
  plan: Scalars['String']['input'];
  recurring: SubscriptionRecurring;
  targetPlan?: InputMaybe<Scalars['String']['input']>;
  withdrawalConsent?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface MutationSyncMailAccountArgs {
  accountId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationTagDocArgs {
  docId: Scalars['String']['input'];
  tagId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationTransferMailSyncAuthorityArgs {
  input: TransferMailSyncAuthorityInput;
}

export interface MutationTransferWorkspaceOwnershipArgs {
  userId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationTranslateAppBaseContentArgs {
  input: TranslateAppBaseContentInput;
}

export interface MutationTranslateAppBaseMetadataArgs {
  input: TranslateAppBaseMetadataInput;
}

export interface MutationTrashDocArgs {
  docId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationTrashFolderArgs {
  folderId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationTrustMailSenderArgs {
  input: TrustMailSenderInput;
}

export interface MutationUndoGraphMutationArgs {
  undoPayload: Scalars['JSON']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationUnmountAppArgs {
  change?: InputMaybe<AppBaseDraftChangeInput>;
  id: Scalars['String']['input'];
  mountId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationUnpublishAppBaseArgs {
  appBaseId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationUnshareMateArgs {
  mateId: Scalars['String']['input'];
  principalId: Scalars['String']['input'];
  principalKind: MateSharePrincipalKind;
  workspaceId: Scalars['String']['input'];
}

export interface MutationUntagDocArgs {
  docId: Scalars['String']['input'];
  tagId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationUpdateAiConsentArgs {
  consent: Scalars['Boolean']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationUpdateAppBaseArgs {
  id: Scalars['String']['input'];
  input: UpdateAppBaseInput;
  workspaceId: Scalars['String']['input'];
}

export interface MutationUpdateAppBaseAieoArgs {
  input: UpdateAppBaseAieoInput;
}

export interface MutationUpdateAppBaseBriefArgs {
  id: Scalars['String']['input'];
  input: UpdateAppBaseBriefInput;
  workspaceId: Scalars['String']['input'];
}

export interface MutationUpdateAppBaseSeoArgs {
  input: UpdateAppBaseSeoInput;
}

export interface MutationUpdateAppConfigArgs {
  updates: Array<UpdateAppConfigInput>;
}

export interface MutationUpdateCircuitBreakerConfigArgs {
  input: UpdateCircuitBreakerConfigInput;
}

export interface MutationUpdateCommentArgs {
  input: CommentUpdateInput;
}

export interface MutationUpdateCopilotPromptArgs {
  messages: Array<CopilotPromptMessageInput>;
  name: Scalars['String']['input'];
}

export interface MutationUpdateCopilotSessionArgs {
  options: UpdateChatSessionInput;
}

export interface MutationUpdateCorruptionReportStatusArgs {
  id: Scalars['String']['input'];
  status: CorruptionReportStatus;
}

export interface MutationUpdateDocDefaultRoleArgs {
  input: UpdateDocDefaultRoleInput;
}

export interface MutationUpdateDocTitleArgs {
  input: UpdateDocTitleInput;
}

export interface MutationUpdateDocUserRoleArgs {
  input: UpdateDocUserRoleInput;
}

export interface MutationUpdateFolderArgs {
  input: UpdateFolderInput;
}

export interface MutationUpdateGraphNodeTypeArgs {
  newType: Scalars['String']['input'];
  nodeId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationUpdateGroupArgs {
  description?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface MutationUpdateKgPipelineStepArgs {
  config?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}

export interface MutationUpdateLocaleSettingsArgs {
  input: UpdateLocaleSettingsInput;
}

export interface MutationUpdateMailAccountArgs {
  input: UpdateMailAccountInput;
}

export interface MutationUpdateMailFolderArgs {
  input: UpdateMailFolderInput;
}

export interface MutationUpdateMailMessageStateArgs {
  input: UpdateMailMessageStateInput;
}

export interface MutationUpdateMailPolicyArgs {
  input: UpdateMailPolicyInput;
  workspaceId: Scalars['String']['input'];
}

export interface MutationUpdateMateArgs {
  input: UpdateMateInput;
  mateId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationUpdateProfileArgs {
  input: UpdateUserInput;
}

export interface MutationUpdateReplyArgs {
  input: ReplyUpdateInput;
}

export interface MutationUpdateRolePermissionArgs {
  input: UpdateRolePermissionInput;
}

export interface MutationUpdateSeatCountArgs {
  quantity: Scalars['Int']['input'];
  withdrawalConsent: Scalars['Boolean']['input'];
  workspaceId: Scalars['ID']['input'];
}

export interface MutationUpdateSettingsArgs {
  input: UpdateUserSettingsInput;
}

export interface MutationUpdateSkillArgs {
  input: UpdateSkillInput;
}

export interface MutationUpdateSystemPromptTemplateArgs {
  body: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
}

export interface MutationUpdateTagArgs {
  color?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationUpdateTenantArgs {
  id: Scalars['ID']['input'];
  input: UpdateTenantInput;
}

export interface MutationUpdateTenantMemberRoleArgs {
  role: TenantRoleEnum;
  tenantId: Scalars['ID']['input'];
  userId: Scalars['String']['input'];
}

export interface MutationUpdateUserArgs {
  id: Scalars['String']['input'];
  input: ManageUserInput;
}

export interface MutationUpdateUserFeaturesArgs {
  features: Array<FeatureType>;
  id: Scalars['String']['input'];
}

export interface MutationUpdateUserMemoryArgs {
  category?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  id: Scalars['String']['input'];
}

export interface MutationUpdateWorkflowLimitsArgs {
  input: UpdateWorkflowLimitsInput;
}

export interface MutationUpdateWorkspaceArgs {
  input: UpdateWorkspaceInput;
}

export interface MutationUpdateWorkspaceEmbeddingIgnoredDocsArgs {
  add?: InputMaybe<Array<Scalars['String']['input']>>;
  remove?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceId: Scalars['String']['input'];
}

export interface MutationUpdateWorkspaceMemoryConfigArgs {
  input: UpdateWorkspaceMemoryConfigInput;
  workspaceId: Scalars['String']['input'];
}

export interface MutationUpdateWorkspacePolicyArgs {
  input: UpdateWorkspacePolicyInput;
  workspaceId: Scalars['String']['input'];
}

export interface MutationUpdateWorkspaceRoutingConfigArgs {
  input: UpdateWorkspaceRoutingConfigInput;
  workspaceId: Scalars['String']['input'];
}

export interface MutationUploadAvatarArgs {
  avatar: Scalars['Upload']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationUploadCommentAttachmentArgs {
  attachment: Scalars['Upload']['input'];
  docId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationUpsertKgConfigValueArgs {
  description?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
  valueType?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}

export interface MutationUpsertKgEntityTypeArgs {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  synonyms?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}

export interface MutationUpsertKgRelationTypeArgs {
  banned?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  semanticDescription?: InputMaybe<Scalars['String']['input']>;
  synonyms?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}

export interface MutationUpsertMailAutoresponderArgs {
  input: UpsertMailAutoresponderInput;
}

export interface MutationUpsertMailRuleArgs {
  input: UpsertMailRuleInput;
}

export interface MutationUpsertMailSignatureArgs {
  input: UpsertMailSignatureInput;
}

export interface MutationValidateAppBaseDevelopmentArgs {
  tree: Scalars['JSONObject']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface MutationValidateAppConfigArgs {
  updates: Array<UpdateAppConfigInput>;
}

export interface MutationVerifyBackupCodeLoginArgs {
  code: Scalars['String']['input'];
  trustDevice?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface MutationVerifyEmailArgs {
  token: Scalars['String']['input'];
}

export interface MutationVerifyEmailOtpLoginArgs {
  code: Scalars['String']['input'];
  trustDevice?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface MutationVerifyTotpLoginArgs {
  code: Scalars['String']['input'];
  trustDevice?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface MutationVerifyTotpSetupArgs {
  code: Scalars['String']['input'];
}

/** A workspace Mate by id and name */
export interface NamedMateType {
  __typename?: 'NamedMateType';
  mateId: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface NoCopilotProviderAvailableDataType {
  __typename?: 'NoCopilotProviderAvailableDataType';
  modelId: Scalars['String']['output'];
}

export interface NoMoreSeatDataType {
  __typename?: 'NoMoreSeatDataType';
  spaceId: Scalars['String']['output'];
}

export interface NotInSpaceDataType {
  __typename?: 'NotInSpaceDataType';
  spaceId: Scalars['String']['output'];
}

/** Notification level */
export enum NotificationLevel {
  Default = 'Default',
  High = 'High',
  Low = 'Low',
  Min = 'Min',
  None = 'None',
}

export interface NotificationObjectType {
  __typename?: 'NotificationObjectType';
  /** Just a placeholder to export UnionNotificationBodyType, don't use it */
  _placeholderForUnionNotificationBodyType: UnionNotificationBodyType;
  /** The body of the notification, different types have different fields, see UnionNotificationBodyType */
  body: Scalars['JSONObject']['output'];
  /** The created at time of the notification */
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The level of the notification */
  level: NotificationLevel;
  /** Whether the notification has been read */
  read: Scalars['Boolean']['output'];
  /** The type of the notification */
  type: NotificationType;
  /** The updated at time of the notification */
  updatedAt: Scalars['DateTime']['output'];
}

export interface NotificationObjectTypeEdge {
  __typename?: 'NotificationObjectTypeEdge';
  cursor: Scalars['String']['output'];
  node: NotificationObjectType;
}

/** Notification type */
export enum NotificationType {
  AIQuotaExhausted = 'AIQuotaExhausted',
  AppAttachApproved = 'AppAttachApproved',
  AppAttachDeclined = 'AppAttachDeclined',
  AppAttachRequested = 'AppAttachRequested',
  AppAttachUsageCreated = 'AppAttachUsageCreated',
  AutomationBindingAutoPaused = 'AutomationBindingAutoPaused',
  AutomationCycleBlocked = 'AutomationCycleBlocked',
  AutomationFailed = 'AutomationFailed',
  AutomationImportHeld = 'AutomationImportHeld',
  AutomationPlanLimitReached = 'AutomationPlanLimitReached',
  BlockInvite = 'BlockInvite',
  BudgetThresholdAi = 'BudgetThresholdAi',
  BudgetThresholdAutomations = 'BudgetThresholdAutomations',
  BudgetThresholdBandwidth = 'BudgetThresholdBandwidth',
  CalendarInvitation = 'CalendarInvitation',
  CalendarInvitationCancelled = 'CalendarInvitationCancelled',
  CalendarInvitationUpdated = 'CalendarInvitationUpdated',
  CalendarReminder = 'CalendarReminder',
  CalendarResponseChanged = 'CalendarResponseChanged',
  Comment = 'Comment',
  CommentMention = 'CommentMention',
  CredentialShareRequested = 'CredentialShareRequested',
  CreditBalanceLow = 'CreditBalanceLow',
  DatabaseMoveManagerRequired = 'DatabaseMoveManagerRequired',
  DatabaseSourceDeleted = 'DatabaseSourceDeleted',
  DatabaseSourceRestoreRequested = 'DatabaseSourceRestoreRequested',
  DocRoleRevoked = 'DocRoleRevoked',
  DocRoleUpdated = 'DocRoleUpdated',
  DocShared = 'DocShared',
  FolderRoleRevoked = 'FolderRoleRevoked',
  FolderShared = 'FolderShared',
  Invitation = 'Invitation',
  InvitationAccepted = 'InvitationAccepted',
  InvitationBlocked = 'InvitationBlocked',
  InvitationRejected = 'InvitationRejected',
  InvitationReviewApproved = 'InvitationReviewApproved',
  InvitationReviewDeclined = 'InvitationReviewDeclined',
  InvitationReviewRequest = 'InvitationReviewRequest',
  MailReceived = 'MailReceived',
  ManagedAIAccessChanged = 'ManagedAIAccessChanged',
  MarketplaceTemplateUpdateAvailable = 'MarketplaceTemplateUpdateAvailable',
  Mention = 'Mention',
  ObjectAccessApproved = 'ObjectAccessApproved',
  ObjectAccessDeclined = 'ObjectAccessDeclined',
  ObjectAccessRequested = 'ObjectAccessRequested',
  PendingDecision = 'PendingDecision',
  StorageFull = 'StorageFull',
  WebhookPayloadTooLarge = 'WebhookPayloadTooLarge',
  WebhookRateLimited = 'WebhookRateLimited',
  WorkflowConcurrencyRejected = 'WorkflowConcurrencyRejected',
  WorkflowCooldownExpired = 'WorkflowCooldownExpired',
  WorkflowCredentialAccessDenied = 'WorkflowCredentialAccessDenied',
  WorkflowPermissionDenied = 'WorkflowPermissionDenied',
  WorkflowRoleRevoked = 'WorkflowRoleRevoked',
  WorkflowRoleUpdated = 'WorkflowRoleUpdated',
  WorkflowScheduleAutoDisabled = 'WorkflowScheduleAutoDisabled',
  WorkflowShared = 'WorkflowShared',
  WorkspaceMcpGrant = 'WorkspaceMcpGrant',
  WorkspaceMcpRequested = 'WorkspaceMcpRequested',
  WorkspaceMcpRevoked = 'WorkspaceMcpRevoked',
  WorkspaceMembershipRevoked = 'WorkspaceMembershipRevoked',
  WorkspaceRoleUpdated = 'WorkspaceRoleUpdated',
}

export interface NotificationWorkspaceType {
  __typename?: 'NotificationWorkspaceType';
  /** Workspace avatar url */
  avatarUrl: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Workspace name */
  name: Scalars['String']['output'];
}

export enum OAuthProviderType {
  Apple = 'Apple',
  GitHub = 'GitHub',
  Google = 'Google',
  Microsoft = 'Microsoft',
  OIDC = 'OIDC',
}

/** sl-wtvw.2: Onboarding reason */
export enum OnboardingReason {
  has_workspace = 'has_workspace',
  invited = 'invited',
  new_tenant = 'new_tenant',
  workspace_access_revoked = 'workspace_access_revoked',
}

/** sl-wtvw.2: Onboarding status for current user */
export interface OnboardingStatusType {
  __typename?: 'OnboardingStatusType';
  /** sl-x1eb.1.2: Member ID for pending invitation (for /invite/:inviteId route) */
  inviteId: Maybe<Scalars['String']['output']>;
  invitedWorkspaceId: Maybe<Scalars['String']['output']>;
  needsOnboarding: Scalars['Boolean']['output'];
  reason: OnboardingReason;
  /** Notification to acknowledge after successful workspace creation. */
  revocationNotificationId: Maybe<Scalars['String']['output']>;
  /** Workspace name snapshot for an unacknowledged membership revocation. */
  revokedWorkspaceName: Maybe<Scalars['String']['output']>;
}

/** sl-tdgy.5: Per-operation rate limit + current usage */
export interface OperationLimitType {
  __typename?: 'OperationLimitType';
  /** Operation type (ai_call, code_execution, http_proxy) */
  operation: Scalars['String']['output'];
  /** Current requests in window */
  rateCurrent: Scalars['Int']['output'];
  /** Max requests per minute */
  rateLimit: Scalars['Int']['output'];
}

export interface PageInfo {
  __typename?: 'PageInfo';
  endCursor: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor: Maybe<Scalars['String']['output']>;
}

/** sl-kbz8.2: Paginated audit log results */
export interface PaginatedAuditLogsType {
  __typename?: 'PaginatedAuditLogsType';
  entries: Array<AdminAuditLogEntryType>;
  total: Scalars['Int']['output'];
}

export interface PaginatedCommentChangeObjectType {
  __typename?: 'PaginatedCommentChangeObjectType';
  edges: Array<CommentChangeObjectTypeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
}

export interface PaginatedCommentObjectType {
  __typename?: 'PaginatedCommentObjectType';
  edges: Array<CommentObjectTypeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
}

export interface PaginatedCopilotHistoriesType {
  __typename?: 'PaginatedCopilotHistoriesType';
  edges: Array<CopilotHistoriesTypeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
}

export interface PaginatedCorruptionReportsType {
  __typename?: 'PaginatedCorruptionReportsType';
  hasMore: Scalars['Boolean']['output'];
  items: Array<CorruptionReportType>;
  total: Scalars['Int']['output'];
}

export interface PaginatedDocInheritedAccessType {
  __typename?: 'PaginatedDocInheritedAccessType';
  edges: Array<DocInheritedAccessEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
}

export interface PaginatedDocType {
  __typename?: 'PaginatedDocType';
  edges: Array<DocTypeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
}

export interface PaginatedGrantedDocUserType {
  __typename?: 'PaginatedGrantedDocUserType';
  edges: Array<GrantedDocUserTypeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
}

/** Paginated folder users */
export interface PaginatedGrantedFolderUserType {
  __typename?: 'PaginatedGrantedFolderUserType';
  items: Array<GrantedFolderUserType>;
  totalCount: Scalars['Int']['output'];
}

export interface PaginatedIgnoredDocsType {
  __typename?: 'PaginatedIgnoredDocsType';
  edges: Array<CopilotWorkspaceIgnoredDocTypeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
}

export interface PaginatedNotificationObjectType {
  __typename?: 'PaginatedNotificationObjectType';
  edges: Array<NotificationObjectTypeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
}

export interface PaginationInput {
  /** returns the elements in the list that come after the specified cursor. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** returns the first n elements from the list. */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** ignore the first n elements from the list. */
  offset?: InputMaybe<Scalars['Int']['input']>;
}

export interface PasswordLimitsType {
  __typename?: 'PasswordLimitsType';
  maxLength: Scalars['Int']['output'];
  minLength: Scalars['Int']['output'];
}

export interface PdfPageSearchInput {
  /** Restrict PDF page hits to one attachment block before applying limit */
  attachmentBlockId?: InputMaybe<Scalars['String']['input']>;
  /** Include underlying technical storage docs/databases in addition to semantic results. */
  includeTechnicalSources?: InputMaybe<Scalars['Boolean']['input']>;
  keyword: Scalars['String']['input'];
  /** Limit the number of PDF page hits to return, default is 20 */
  limit?: InputMaybe<Scalars['Int']['input']>;
}

export interface PdfProvenanceReindexError {
  __typename?: 'PdfProvenanceReindexError';
  attachmentBlockId: Maybe<Scalars['String']['output']>;
  docId: Scalars['String']['output'];
  message: Scalars['String']['output'];
}

export interface PdfProvenanceReindexInput {
  attachmentBlockId?: InputMaybe<Scalars['String']['input']>;
  docId?: InputMaybe<Scalars['String']['input']>;
  forceOcr?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface PdfProvenanceReindexResult {
  __typename?: 'PdfProvenanceReindexResult';
  errors: Array<PdfProvenanceReindexError>;
  failedDocs: Scalars['Int']['output'];
  indexedPages: Scalars['Int']['output'];
  processedAttachments: Scalars['Int']['output'];
  processedDocs: Scalars['Int']['output'];
  totalDocs: Scalars['Int']['output'];
}

export interface PdfSearchHitObjectType {
  __typename?: 'PdfSearchHitObjectType';
  attachmentBlockId: Scalars['String']['output'];
  blobId: Scalars['String']['output'];
  coverageStatus: Maybe<Scalars['String']['output']>;
  docId: Scalars['String']['output'];
  pageIndex: Scalars['Int']['output'];
  rects: Array<PdfSearchRectObjectType>;
  score: Scalars['Float']['output'];
  snippet: Scalars['String']['output'];
  source: Maybe<Scalars['String']['output']>;
  technicalSourceKind: Maybe<WorkspaceSearchTechnicalSourceKind>;
  visibility: Maybe<WorkspaceSearchResultVisibility>;
}

export interface PdfSearchRectObjectType {
  __typename?: 'PdfSearchRectObjectType';
  height: Scalars['Float']['output'];
  width: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
}

/** Pending decision notification body — relation lookup needs manual resolution */
export interface PendingDecisionNotificationBodyType {
  __typename?: 'PendingDecisionNotificationBodyType';
  /** Human-readable automation name */
  automationName: Maybe<Scalars['String']['output']>;
  /** Automation block ID */
  blockId: Scalars['ID']['output'];
  /** Candidate rows with all cell values */
  candidates: Array<Scalars['JSONObject']['output']>;
  /** Document ID containing the automation */
  docId: Scalars['ID']['output'];
  /** Human-readable document title */
  docTitle: Maybe<Scalars['String']['output']>;
  /** Number of candidate matches found */
  matchCount: Scalars['Int']['output'];
  /** ID of the AutomationPendingDecision record */
  pendingDecisionId: Scalars['ID']['output'];
  /** The search value that was looked up */
  searchValue: Scalars['String']['output'];
  /** Target relation column name */
  targetColumnName: Maybe<Scalars['String']['output']>;
  /** The type of the notification */
  type: NotificationType;
  /** Workspace context */
  workspaceId: Scalars['ID']['output'];
}

/** sl-qhe4: Manual relation resolution lifecycle state */
export enum PendingDecisionStatus {
  pending = 'pending',
  resolved = 'resolved',
  skipped = 'skipped',
}

/** Pending decision for manual relation resolution */
export interface PendingDecisionType {
  __typename?: 'PendingDecisionType';
  candidates: Array<RelationCandidateType>;
  configId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  matchCount: Scalars['Int']['output'];
  searchValue: Scalars['String']['output'];
  sourceRowId: Scalars['String']['output'];
  status: PendingDecisionStatus;
  targetColumn: Scalars['String']['output'];
  targetColumnName: Maybe<Scalars['String']['output']>;
}

/** sl-dl66: Pending interval change for a subscription */
export interface PendingIntervalChangeType {
  __typename?: 'PendingIntervalChangeType';
  creditPackId: Maybe<Scalars['String']['output']>;
  effectiveDate: Scalars['DateTime']['output'];
  newInterval: Scalars['String']['output'];
  type: Scalars['String']['output'];
}

/** User permission in workspace */
export enum Permission {
  Admin = 'Admin',
  Editor = 'Editor',
  Owner = 'Owner',
  Reader = 'Reader',
}

export enum PermissionDenialReason {
  CIRCULAR_MOVE = 'CIRCULAR_MOVE',
  DOC_ROLE_DENIED = 'DOC_ROLE_DENIED',
  FOLDER_ROLE_DENIED = 'FOLDER_ROLE_DENIED',
  IMMUTABLE_OBJECT = 'IMMUTABLE_OBJECT',
  NOT_AUTHENTICATED = 'NOT_AUTHENTICATED',
  NOT_FOUND = 'NOT_FOUND',
  PARENT_TRASHED = 'PARENT_TRASHED',
  PRIVATE_BOUNDARY_OWNER_REQUIRED = 'PRIVATE_BOUNDARY_OWNER_REQUIRED',
  ROLE_ESCALATION_DENIED = 'ROLE_ESCALATION_DENIED',
  SOURCE_FOLDER_ROLE_DENIED = 'SOURCE_FOLDER_ROLE_DENIED',
  SYSTEM_OBJECT = 'SYSTEM_OBJECT',
  TARGET_DENIED = 'TARGET_DENIED',
  TARGET_FOLDER_ROLE_DENIED = 'TARGET_FOLDER_ROLE_DENIED',
  TRASHED_STATE_MISMATCH = 'TRASHED_STATE_MISMATCH',
  WORKSPACE_ROLE_DENIED = 'WORKSPACE_ROLE_DENIED',
}

/** sl-bcrf.6: Bounded permission graph connection. */
export interface PermissionGraphConnectionType {
  __typename?: 'PermissionGraphConnectionType';
  diagnostics: PermissionGraphDiagnosticsType;
  edges: Array<PermissionGraphEdgeType>;
  pageInfo: PermissionGraphPageInfoType;
  rightsEpoch: Scalars['Int']['output'];
}

/** sl-bcrf.6: Bounded-query and projection diagnostics without tenant internals. */
export interface PermissionGraphDiagnosticsType {
  __typename?: 'PermissionGraphDiagnosticsType';
  bounded: Scalars['Boolean']['output'];
  maxPageSize: Scalars['Int']['output'];
  maxSubtreeDepth: Scalars['Int']['output'];
  projectionStatus: Scalars['String']['output'];
  resetReason: Maybe<Scalars['String']['output']>;
}

/** sl-bcrf.6.3: Bounded tenant/workspace-scoped projection diagnostics. */
export interface PermissionGraphDriftDiagnosticsResultType {
  __typename?: 'PermissionGraphDriftDiagnosticsResultType';
  findings: Array<PermissionGraphDriftFindingType>;
  rightsEpoch: Scalars['Int']['output'];
  sampledDocs: Scalars['Int']['output'];
  sampledPrincipals: Scalars['Int']['output'];
  truncated: Scalars['Boolean']['output'];
  workspaceId: Scalars['String']['output'];
}

/** sl-bcrf.6.3: One typed projection drift finding. */
export interface PermissionGraphDriftFindingType {
  __typename?: 'PermissionGraphDriftFindingType';
  detail: Scalars['String']['output'];
  docId: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  sourceId: Maybe<Scalars['String']['output']>;
  userId: Maybe<Scalars['String']['output']>;
}

/** sl-bcrf.6: Permission graph cursor edge. */
export interface PermissionGraphEdgeType {
  __typename?: 'PermissionGraphEdgeType';
  cursor: Scalars['String']['output'];
  node: PermissionGraphElementType;
  sortKey: Scalars['String']['output'];
}

/** sl-bcrf.6: Mixed, deterministically sorted graph element stream. */
export type PermissionGraphElementType =
  | PermissionGraphNodeType
  | PermissionGraphRelationshipType;

/** sl-bcrf.6: Sparse permission graph filter. Filters apply to graph source/target, never a global user x doc matrix. */
export interface PermissionGraphFilterInput {
  permission?: InputMaybe<Scalars['String']['input']>;
  resourceId?: InputMaybe<Scalars['String']['input']>;
  resourceType?: InputMaybe<Scalars['String']['input']>;
  subjectId?: InputMaybe<Scalars['String']['input']>;
  subjectType?: InputMaybe<Scalars['String']['input']>;
}

/** sl-bcrf.6: One normal node in the bounded permission graph. */
export interface PermissionGraphNodeType {
  __typename?: 'PermissionGraphNodeType';
  id: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  label: Scalars['String']['output'];
  metadata: Maybe<Scalars['JSON']['output']>;
  workspaceId: Scalars['String']['output'];
}

/** sl-bcrf.6: Permission graph pagination info. */
export interface PermissionGraphPageInfoType {
  __typename?: 'PermissionGraphPageInfoType';
  endCursor: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  resetRequired: Maybe<Scalars['String']['output']>;
  token: Maybe<Scalars['String']['output']>;
}

/** sl-bcrf.6: Structured origin of a canonical or derived relationship. */
export interface PermissionGraphProvenanceType {
  __typename?: 'PermissionGraphProvenanceType';
  effective: Scalars['Boolean']['output'];
  inherited: Scalars['Boolean']['output'];
  sourceId: Scalars['String']['output'];
  sourceType: Scalars['String']['output'];
  viaFolderId: Maybe<Scalars['String']['output']>;
  viaGroupId: Maybe<Scalars['String']['output']>;
}

/** sl-bcrf.6.3: Idempotent rebuild enqueue acknowledgement. */
export interface PermissionGraphRebuildEnqueueResultType {
  __typename?: 'PermissionGraphRebuildEnqueueResultType';
  jobId: Scalars['String']['output'];
  rightsEpoch: Scalars['Int']['output'];
  workspaceId: Scalars['String']['output'];
}

/** sl-bcrf.6: One sparse permission domain relationship. */
export interface PermissionGraphRelationshipType {
  __typename?: 'PermissionGraphRelationshipType';
  id: Scalars['String']['output'];
  provenance: PermissionGraphProvenanceType;
  relationshipType: Scalars['String']['output'];
  role: Maybe<Scalars['String']['output']>;
  sourceId: Scalars['String']['output'];
  sourceType: Scalars['String']['output'];
  targetId: Scalars['String']['output'];
  targetType: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
}

export interface PermissionLifecycleAreaImpact {
  __typename?: 'PermissionLifecycleAreaImpact';
  fromAreaBlocked: Scalars['Boolean']['output'];
  fromAreaKind: Scalars['String']['output'];
  fromAreaRootFolderId: Scalars['String']['output'];
  fromAreaRootName: Scalars['String']['output'];
  impact: Scalars['String']['output'];
  principalId: Scalars['String']['output'];
  principalType: Scalars['String']['output'];
  role: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
  sourceName: Maybe<Scalars['String']['output']>;
  sourceType: Scalars['String']['output'];
  targetId: Scalars['String']['output'];
  targetKind: PermissionPreflightTargetKind;
  targetName: Maybe<Scalars['String']['output']>;
  toAreaBlocked: Scalars['Boolean']['output'];
  toAreaKind: Scalars['String']['output'];
  toAreaRootFolderId: Scalars['String']['output'];
  toAreaRootName: Scalars['String']['output'];
}

export enum PermissionLifecycleOperation {
  DOC_DELETE = 'DOC_DELETE',
  DOC_MOVE = 'DOC_MOVE',
  DOC_RESTORE = 'DOC_RESTORE',
  DOC_TRASH = 'DOC_TRASH',
  FOLDER_DELETE = 'FOLDER_DELETE',
  FOLDER_MOVE = 'FOLDER_MOVE',
  FOLDER_RESTORE = 'FOLDER_RESTORE',
  FOLDER_TRASH = 'FOLDER_TRASH',
}

export interface PermissionLifecyclePreflightInput {
  limit?: InputMaybe<Scalars['Int']['input']>;
  operation: PermissionLifecycleOperation;
  targets: Array<PermissionPreflightTargetInput>;
  workspaceId: Scalars['String']['input'];
}

export interface PermissionLifecyclePreflightResult {
  __typename?: 'PermissionLifecyclePreflightResult';
  affectedDocIds: Array<Scalars['String']['output']>;
  affectedFolderIds: Array<Scalars['String']['output']>;
  allowed: Scalars['Boolean']['output'];
  areaImpacts: Array<PermissionLifecycleAreaImpact>;
  blockedObjects: Array<PermissionPreflightBlockedObject>;
  blockedTargetIds: Array<Scalars['String']['output']>;
  operation: PermissionLifecycleOperation;
  reasonCounts: Array<PermissionPreflightReasonCount>;
  totalBlockedCount: Scalars['Int']['output'];
}

export interface PermissionPreflightBlockedObject {
  __typename?: 'PermissionPreflightBlockedObject';
  id: Scalars['String']['output'];
  kind: PermissionPreflightTargetKind;
  name: Maybe<Scalars['String']['output']>;
  reason: PermissionDenialReason;
  targetId: Maybe<Scalars['String']['output']>;
}

export interface PermissionPreflightReasonCount {
  __typename?: 'PermissionPreflightReasonCount';
  count: Scalars['Int']['output'];
  reason: PermissionDenialReason;
}

export interface PermissionPreflightTargetInput {
  id: Scalars['String']['input'];
  kind: PermissionPreflightTargetKind;
  targetFolderId?: InputMaybe<Scalars['String']['input']>;
}

export enum PermissionPreflightTargetKind {
  DOC = 'DOC',
  FOLDER = 'FOLDER',
}

/** Price a plan or interval change of the subscription bills. */
export interface PlanChangePriceType {
  __typename?: 'PlanChangePriceType';
  /** Amount per interval in the smallest currency unit */
  amount: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  /** monthly or yearly */
  interval: Scalars['String']['output'];
  /** regular (list price) or launch (launch offer price) */
  kind: Scalars['String']['output'];
  priceId: Scalars['String']['output'];
}

export interface PlanCountType {
  __typename?: 'PlanCountType';
  count: Scalars['Int']['output'];
  plan: Scalars['String']['output'];
}

export interface PlanFeatureType {
  __typename?: 'PlanFeatureType';
  displayName: Scalars['String']['output'];
  featureKey: Scalars['String']['output'];
  visibility: Scalars['String']['output'];
}

/** The plans the platform relies on by role */
export interface PlanRolesType {
  __typename?: 'PlanRolesType';
  /** The plan of a tenant without a plan subscription */
  basePlan: Scalars['String']['output'];
  /** The plan of the demo workspace; null without one */
  demoPlan: Maybe<Scalars['String']['output']>;
}

/** E040: Metadata for the strip warning dialog */
export interface PrepareDocStripResultType {
  __typename?: 'PrepareDocStripResultType';
  historyCount: Scalars['Int']['output'];
  historySizeBytes: Scalars['Int']['output'];
  mergedSizeBytes: Scalars['Int']['output'];
  reductionPercent: Scalars['Int']['output'];
  snapshotSizeBytes: Scalars['Int']['output'];
}

export interface PrepareMailCompositionInput {
  accountId?: InputMaybe<Scalars['String']['input']>;
  composeKind: MailComposeKind;
  sourceMessageId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface PreparedMailAttachment {
  __typename?: 'PreparedMailAttachment';
  blobKey: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  mimeType: Maybe<Scalars['String']['output']>;
}

export interface PreparedMailComposition {
  __typename?: 'PreparedMailComposition';
  accountId: Scalars['String']['output'];
  attachments: Array<PreparedMailAttachment>;
  bcc: Array<Scalars['String']['output']>;
  cc: Array<Scalars['String']['output']>;
  composeKind: MailComposeKind;
  inReplyToHeader: Maybe<Scalars['String']['output']>;
  quoteHtml: Maybe<Scalars['String']['output']>;
  quoteText: Scalars['String']['output'];
  referencesHeader: Maybe<Scalars['String']['output']>;
  sourceMessageId: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  to: Array<Scalars['String']['output']>;
}

/** sl-jmyl.3: Real-time presence entry — which users are viewing a doc */
export interface PresenceDocEntry {
  __typename?: 'PresenceDocEntry';
  docId: Scalars['String']['output'];
  userIds: Array<Scalars['String']['output']>;
}

/** Launch offer of a pricing plan while bookings still get it */
export interface PricingLaunchOfferType {
  __typename?: 'PricingLaunchOfferType';
  /** First instant (ISO 8601) without launch prices */
  endsAt: Scalars['String']['output'];
  /** Paid months a booking pays the launch prices */
  paidMonths: Scalars['Int']['output'];
  /** Launch seat tiers per interval as JSON string */
  seatTiers: Maybe<Scalars['String']['output']>;
}

/** Pricing plan price from Stripe (sl-jqld.1) */
export interface PricingPlanPriceType {
  __typename?: 'PricingPlanPriceType';
  amount: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  interval: Scalars['String']['output'];
  /** regular (list price) or launch (launch offer price) */
  kind: Scalars['String']['output'];
  priceId: Scalars['String']['output'];
}

/** Pricing plan quota limits (sl-jqld.1) */
export interface PricingPlanQuotasType {
  __typename?: 'PricingPlanQuotasType';
  /** Audit-trail retention in days (-1 = unlimited); null when the plan has no Audit Trail */
  auditTrailRetentionDays: Maybe<Scalars['Int']['output']>;
  blobLimit: Scalars['String']['output'];
  externalAccessPerDocLimit: Scalars['Int']['output'];
  guestLimit: Scalars['Int']['output'];
  historyDays: Scalars['Int']['output'];
  maxExtraSeats: Scalars['Int']['output'];
  memberLimit: Scalars['Int']['output'];
  monthlyCreditGrant: Maybe<Scalars['Int']['output']>;
  /** sl-7vu4: Graduated tiered seat pricing as JSON string (null = no seat addons) */
  seatTiers: Maybe<Scalars['String']['output']>;
  storage: Scalars['String']['output'];
  storagePerMember: Scalars['String']['output'];
  /** Bytes of storage each extra seat adds ("0" = no fixed amount) */
  storagePerSeat: Scalars['String']['output'];
}

/** Pricing plan with display data from DB + prices from Stripe (sl-jqld.1) */
export interface PricingPlanType {
  __typename?: 'PricingPlanType';
  badge: Maybe<Scalars['String']['output']>;
  ctaType: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  displayOrder: Scalars['Int']['output'];
  featured: Scalars['Boolean']['output'];
  features: Array<Scalars['String']['output']>;
  /** The plan of a tenant without a plan subscription (plan role base) */
  isBasePlan: Scalars['Boolean']['output'];
  isFreePlan: Scalars['Boolean']['output'];
  /** Launch offer while bookable and the plan has a launch price (tsk-plan-launch-offer-1019) */
  launchOffer: Maybe<PricingLaunchOfferType>;
  prices: Array<PricingPlanPriceType>;
  productName: Scalars['String']['output'];
  quotas: PricingPlanQuotasType;
  /** Days of the free trial at checkout (0 = no trial) */
  trialDays: Scalars['Int']['output'];
}

/** The mode which the public doc default in */
export enum PublicDocMode {
  Edgeless = 'Edgeless',
  Page = 'Page',
}

export interface PublicUserType {
  __typename?: 'PublicUserType';
  avatarUrl: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface PushUiSettingsVaultInput {
  entries: Array<UiSettingsVaultEntryInput>;
}

export interface PushUiSettingsVaultResult {
  __typename?: 'PushUiSettingsVaultResult';
  entries: Array<UiSettingsVaultEntry>;
}

export interface Query {
  __typename?: 'Query';
  accessTokens: Array<AccessToken>;
  /** sl-zvjz: Read-only aggregated preview for the Multi-Step Deletion Modal — Stripe subs, owned workspaces, pending invoices, block-reason. */
  accountDeletionPreview: AccountDeletionPreview;
  /** sl-zvjz: Read the current user's account-deletion lifecycle status — drives the reactivation banner + settings page. */
  accountDeletionStatus: AccountDeletionStatus;
  /** AI provider/customer profitability from immutable cost lines. Admin only. */
  adminAIProfitability: AiProfitabilityReportType;
  /** Distinct actions, target types and actors of the audit log */
  adminAuditLogFacets: AdminAuditLogFacetsType;
  /** sl-kbz8.2: List admin audit log entries with filtering and pagination */
  adminAuditLogs: PaginatedAuditLogsType;
  /** Get billing statistics (admin only) */
  adminBillingStats: BillingStatsType;
  /** Get subscriptions for a specific user (admin only) */
  adminGetUserSubscriptions: Array<SubscriptionType>;
  /** sl-sdk6.6.1: Get knowledge graph statistics for a workspace (admin only) */
  adminGraphStats: AdminGraphStats;
  /** List all subscriptions (admin only) */
  adminListSubscriptions: Array<AdminSubscriptionType>;
  /** sl-sdk6.6.1: List workspace memories with filtering and pagination (admin only) */
  adminMemories: AdminMemoryPage;
  /** Get plan distribution (admin only) */
  adminPlanDistribution: Array<AdminPlanCountType>;
  /** List payment provider products with prices (admin only) */
  adminProviderProducts: Array<AdminStripePriceType>;
  /** Get signup trend as time series (admin only) */
  adminSignupTrend: Array<AdminSignupTrendEntryType>;
  /** Deprecated alias for adminProviderProducts */
  adminStripeProducts: Array<AdminStripePriceType>;
  /** sl-l8v6.4: Cache performance across ALL tenants (system view). Admin only. */
  adminSystemCachePerformance: CachePerformanceReportType;
  /** sl-b828.12: Read a single system prompt template by key */
  adminSystemPromptTemplate: SystemPromptTemplateType;
  /** sl-b828.12: List admin-managed system prompt templates */
  adminSystemPromptTemplates: Array<SystemPromptTemplateType>;
  /** sl-l8v6.4: Cache performance for a single tenant (aggregated across its workspaces). Admin only. */
  adminTenantCachePerformance: CachePerformanceReportType;
  /** sl-kaqr.4.1: Get tenant detail with members and workspaces (admin only) */
  adminTenantDetail: AdminTenantDetailType;
  /** sl-kaqr.4.1: List tenants with aggregated data (admin only) */
  adminTenants: Array<AdminTenantType>;
  /** sl-kaqr.4.1: Count tenants matching filter (admin only) */
  adminTenantsCount: Scalars['Int']['output'];
  /** Top 20 workspaces by charged ledger credits in [from,to). Admin only. */
  adminTopWorkspaces: Array<AdminWorkspaceActivity>;
  /** Top 20 workspaces by booked activity of one kind in [from,to). Admin only. */
  adminTopWorkspacesByActivity: Array<AdminActivityKindRank>;
  /** Get aggregated user stats (admin only) */
  adminUserStats: AdminUserStatsType;
  /** Get webhook health status (admin only) */
  adminWebhookHealth: WebhookHealthType;
  /** Worker job places now: fleet, and per workspace its claim, held and borrowed places and waiting jobs per work class. Admin only. */
  adminWorkerJobPlaces: AdminWorkerJobPlaces;
  adminWorkspaceActivity: AdminWorkspaceActivity;
  /** Booked hourly activity of one workspace in [from,to): series per kind, queues and app routes. Admin only. */
  adminWorkspaceActivityCounters: AdminWorkspaceActivityCounters;
  /** sl-dkgt.2.2: Get workspace detail with members and quota (admin only) */
  adminWorkspaceDetail: AdminWorkspaceDetailType;
  /** sl-ddz8.7.2: Get workspace memory configuration (admin only) */
  adminWorkspaceMemoryConfig: WorkspaceMemoryConfigGql;
  /** sl-dkgt.4: Get aggregated workspace stats for dashboard (admin only) */
  adminWorkspaceStats: AdminWorkspaceStatsType;
  /** sl-dkgt.1: List workspaces with aggregated data (admin only) */
  adminWorkspaces: Array<AdminWorkspaceType>;
  agentTool: Scalars['JSONObject']['output'];
  agentToolDryRun: Scalars['JSONObject']['output'];
  agentToolVersionHistory: Scalars['JSONObject']['output'];
  /** Private Agent Tools visible to an authorized editor. */
  agentTools: Scalars['JSONObject']['output'];
  /** sl-9qm.1.4 (sl-ya4v.4): Get an AppBase by appBaseSlug — workspace resolved from request hostname (public, no auth) */
  appBase: Maybe<AppBaseType>;
  /** sl-hle4.6: Read AIEO settings for an AppBase (Admin+). */
  appBaseAIEO: Maybe<AppBaseAieoSettingsType>;
  /** Resolve one AppBase access projection for the current user. */
  appBaseAppAccess: Scalars['JSONObject']['output'];
  /** Admin matrix for AppBase routes, data-source docs, and grants. */
  appBaseAppPermissionMatrix: Scalars['JSONObject']['output'];
  /** List AppBases the current user can access through root-doc/route RBAC. */
  appBaseApps: Scalars['JSONObject']['output'];
  /** sl-hle4.2 REWORK: Optional monthly bandwidth budget for one AppBase/site (Owner/Admin only). Null when no budget is set. */
  appBaseBandwidthBudget: Maybe<AppBaseBandwidthBudgetType>;
  /** Check binding placement/revision health for attached databases. */
  appBaseDatabaseBindingHealth: Scalars['JSONObject']['output'];
  /** List AppBase database bindings for one AppBase (Editor+). */
  appBaseDatabaseBindings: Scalars['JSONObject']['output'];
  /** Inspect an AppBase/App target through the shared AppBase Development Plan. */
  appBaseDevelopmentInspect: Scalars['JSONObject']['output'];
  /** List next valid actions for an AppBase Development Plan. */
  appBaseDevelopmentNextSteps: Scalars['JSONObject']['output'];
  /** Read AppBase Development Plan progress, gaps and next steps. */
  appBaseDevelopmentStatus: Scalars['JSONObject']['output'];
  /** Owner-only effective AppBase invocation policy, usage and concurrency snapshot. */
  appBaseInvocationStatus: AppBaseInvocationStatusType;
  /** Row IDs of one database owned by the caller, for local-first `:me` App routes (App read + database Doc read). */
  appBaseOwnRowIds: Array<Scalars['String']['output']>;
  /** Pending time-limited invitations for one Web App portal. */
  appBasePortalInvitations: Array<Scalars['JSONObject']['output']>;
  /** Portal identities granted access to one Web App. */
  appBasePortalMembers: Array<Scalars['JSONObject']['output']>;
  /** Current workspace/app usage against the canonical AppBase plan limits. */
  appBaseProductQuota: Scalars['JSONObject']['output'];
  /** sl-bpu6.14.1: Member-facing published-only viewer state (never draft) */
  appBasePublicViewerState: AppBasePublicViewerStateType;
  /** Row ownership counts of one database for App administration (Workspace_AppBases_Edit + App Doc write + database Doc read). */
  appBaseRowOwnershipSummary: AppBaseRowOwnershipSummaryType;
  /** sl-hle4.5: Read SEO settings for an AppBase (Admin+). */
  appBaseSEO: Maybe<AppBaseSeoSettingsType>;
  /** SEO check per App over the published snapshot (App Container editors). */
  appBaseSeoCheck: Maybe<AppBaseSeoCheckType>;
  /** Read AppBase manifest and artifact summary without returning file bodies. */
  appBaseState: Scalars['JSONObject']['output'];
  /** Version history (newest first) for undo/redo and restore. */
  appBaseVersionHistory: Array<AppBaseVersionHistoryEntryType>;
  /** The App Modules a saved version holds, in their order, by their shown title: what the versions window offers to restore one by one. */
  appBaseVersionModules: Array<AppBaseVersionModuleType>;
  /** sl-2q8e.2: Viewer-state bundle (draft > published, isDirty flag) (Editor+) */
  appBaseViewerState: AppBaseViewerStateType;
  /** sl-9qm.1.4: List AppBases in a workspace (authenticated) */
  appBases: Array<AppBaseType>;
  /** sl-oemf.5: List AppBases bound to a doc (authenticated) */
  appBasesByDocId: Array<AppBaseType>;
  /** get the whole app configuration */
  appConfig: Scalars['JSONObject']['output'];
  /** Tables and Agent Actions of each App Container against the plan quota of the workspace. */
  appContainerPlanOverview: Scalars['JSONObject']['output'];
  /** Tables and Agent Actions of the live version of one App Container; null while nothing is live. */
  appContainerPublishedPlanUsage: Maybe<Scalars['JSONObject']['output']>;
  /** Authorized root identities and copy availability, including the trash. */
  appContainersForDeletion: Array<AppContainerDeletionSource>;
  /** Work units of one App Container per page and hour in [from,to), at most 90 days: booked hours plus the hours still buffered. Requires the right to edit App Containers. */
  appLoadSource: Array<AppLoadPoint>;
  /** The tables deleting an App in the trash (appId) or the App Container in the trash for good asks about. */
  appTableChoices: AppTableChoicesType;
  /** List users/groups that can receive a block invite for the current doc. */
  blockInviteEligibleRecipients: BlockInviteEligibleRecipientsType;
  /** sl-ya4v.14: Frontend rate-limit gate. Returns canRename=true once the 30-day window has elapsed since the last rename. Settings UI uses this to enable/disable the rename action and show the next-allowed timestamp without round-tripping a failed mutation. */
  brandedSubdomainRenameAvailability: BrandedSubdomainRenameAvailabilityType;
  /** Whether the member may manage the workspace's own Mates */
  canManageWorkspaceMates: Scalars['Boolean']['output'];
  /** @deprecated use `user.quotaUsage` instead */
  collectAllBlobSizes: WorkspaceBlobSizes;
  /** Entries of one App Container source whose changes are open, oldest first. Empty for a source without delivered entries. */
  contentEntryOpenChanges: Array<ContentEntryOpenChangeType>;
  /** Kept versions of one entry of an App Container source, newest first, without what they hold. Empty for a source without delivered entries. */
  contentEntryVersions: Array<ContentEntryVersionType>;
  /** Get a corruption report in AI-friendly format */
  corruptionReportForAI: Maybe<CorruptionReportForAiType>;
  /** sl-opil.6.1: Get credit balance for a workspace */
  creditBalance: CreditBalanceType;
  /** sl-opil.6.1: Get available credit packs for purchase */
  creditPacks: Array<CreditPackType>;
  /** sl-opil.6.1: Get credit transaction history for a workspace */
  creditTransactions: CreditTransactionConnection;
  /** sl-y0sj.7.5 REWORK: Current-month CDN bandwidth usage for one AppBase/site (Owner only). */
  currentBandwidthUsage: BandwidthUsageStatusType;
  /** Get current user */
  currentUser: Maybe<UserType>;
  /** sl-9qm.8.2: List custom domains for a workspace */
  customDomains: Array<CustomDomainType>;
  databaseBulkReceiptStatus: DatabaseBulkReceiptStatus;
  databaseDeleteDependencies: Array<DatabaseDeleteDependency>;
  /** Discover attachable affine:databases in the AppBase host doc or another readable doc. */
  discoverAppBaseDatabases: Scalars['JSONObject']['output'];
  /** sl-jsx3.11.5: Get all group roles on a doc */
  docGroupRoles: Array<DocGroupRoleType>;
  /** Get doc history timeline for admin recovery */
  docHistoryTimeline: DocHistoryTimelineType;
  /** The workspace Mates with a direct role on a doc */
  docMateRoles: Array<DocMateRoleType>;
  /** E029-COMPACT: Get document size info for monitoring */
  docSizeInfo: DocSizeInfoType;
  /** sl-xbxb: Get doc-tag mappings for a workspace (docId → tagIds) */
  docTagIds: Array<DocTagIdsType>;
  error: ErrorDataUnion;
  /** sl-ncr1.3.1: Find similar node pairs for quality tools */
  findSimilarNodes: Array<SimilarNodePair>;
  /** sl-jsx3.11.5: Get all group roles on a folder (for Share Modal) */
  folderGroupRoles: Array<FolderGroupRoleType>;
  /** The workspace Mates with a direct role on a folder */
  folderMateRoles: Array<FolderMateRoleType>;
  /** get workspace invitation info */
  getInviteInfo: InvitationType;
  /** sl-jsx3.11.5: Get a single group by ID */
  group: Maybe<UserGroupType>;
  /** sl-jsx3.11.5: Get all doc roles of a group (for 'By Group' view) */
  groupDocRoles: Array<DocGroupRoleType>;
  /** sl-jsx3.11.5: Get all folder roles of a group (for 'By Group' view) */
  groupFolderRoles: Array<FolderGroupRoleType>;
  /** The workspace Mates in a group */
  groupMates: Array<NamedMateType>;
  /** sl-jsx3.16.1: Get all members of a group */
  groupMembers: Array<UserGroupMemberType>;
  /** sl-jsx3.11.5: Get all groups in a workspace */
  groups: Array<UserGroupType>;
  /** sl-amfa.4.2: List installed marketplace templates in a workspace (auth required) */
  installedTemplates: Array<MarketplaceInstallGql>;
  /**
   * Get is admin of workspace
   * @deprecated use WorkspaceType[role] instead
   */
  isAdmin: Scalars['Boolean']['output'];
  /**
   * Get is owner of workspace
   * @deprecated use WorkspaceType[role] instead
   */
  isOwner: Scalars['Boolean']['output'];
  /** sl-qsjm.5: Check if current user meets workspace 2FA requirement */
  isWorkspaceTwoFactorCompliant: Scalars['Boolean']['output'];
  /** sl-8g8i.5: KG config snapshots (admin only) */
  kgConfigSnapshots: Array<KgConfigSnapshotType>;
  /** sl-8g8i.5: KG config values (admin only) */
  kgConfigValues: Array<KgConfigValueType>;
  /** sl-8g8i.5: KG entity types (admin only) */
  kgEntityTypes: Array<KgEntityTypeType>;
  /** sl-8g8i.5: KG pipeline steps (admin only) */
  kgPipelineSteps: Array<KgPipelineStepType>;
  /** sl-8g8i.5: KG relation types (admin only) */
  kgRelationTypes: Array<KgRelationTypeType>;
  /** sl-iw27.4.2: Get a single snapshot with changelog details */
  kgSnapshotDetails: Maybe<KgSnapshotDetailsType>;
  /** sl-iw27.4.2: KG snapshot timeline (history + pending) */
  kgSnapshotTimeline: KgSnapshotTimelineType;
  /** sl-iw27.4.2: KG snapshots for a workspace */
  kgSnapshots: Array<KgSnapshotType>;
  /**
   * sl-hle4.6: List the registry of known LLM crawler bots. Stable —
   * surface for the workspace-settings UI bot toggle matrix.
   */
  knownAICrawlerBots: Array<AiCrawlerBotType>;
  /** List all copilot prompts */
  listCopilotPrompts: Array<CopilotPromptType>;
  /** sl-k94y.5.1: Deployment locale settings (DB-driven availableLocales + defaultLocale) */
  localeSettings: LocaleSettingsType;
  /** sl-obn0.4.1: List connected mail accounts for current workspace user. */
  mailAccounts: Array<MailAccount>;
  /** sl-obn0.4.2: Admin metadata view without message contents. */
  mailAdminOverview: MailAdminOverview;
  /** sl-ckdp: List current user's account autoresponders. */
  mailAutoresponders: Array<MailAutoresponder>;
  mailComposeSignature: Maybe<MailSignature>;
  /** sl-appres.3: Credential shares missing for mailbox app access. */
  mailCredentialShareProposals: Array<MailCredentialShareProposal>;
  /** Current user's mail quota usage and per-account factors. */
  mailCurrentUserQuota: MailUserQuotaUsage;
  /** sl-obn0.7: List account folders for macOS-style mailbox tree. */
  mailFolders: Array<MailMailboxFolder>;
  /** sl-obn0.4.1: Read current user's server-side mail body and attachments. */
  mailMessageBody: MailMessageBody;
  /** sl-obn0.4.1: List current user's indexed mail messages for one account. */
  mailMessages: Array<MailMessage>;
  /** sl-obn0.7: List current user's validated mail rules. */
  mailRules: Array<MailRule>;
  /** sl-ckdp: List default signature assignments. */
  mailSignatureAssignments: Array<MailSignatureAssignment>;
  /** sl-ckdp: List current user's mail signatures. */
  mailSignatures: Array<MailSignature>;
  /** sl-obn0.9.1: List current user's mail sync progress states. */
  mailSyncStates: Array<MailSyncState>;
  /** List current user's trusted senders for automatic mail image loading. */
  mailTrustedSenders: Array<MailTrustedSender>;
  /** sl-ckdp: Dynamic starred/flagged mailbox summaries for an account. */
  mailVirtualFolders: Array<MailVirtualFolderSummary>;
  /** sl-appres.3: Current user's mailbox root access document. */
  mailboxRoot: MailMailboxRoot;
  /** Doc ids of the current user's existing mailbox roots. Read-only and plan-independent (technical docs hidden from search). */
  mailboxRootDocIds: Array<Scalars['String']['output']>;
  /** sl-opil.6.1: Get managed AI status for a workspace */
  managedAIStatus: ManagedAiStatusType;
  /** sl-amfa.4.2: List marketplace categories (public) */
  marketplaceCategories: Array<MarketplaceCategoryGql>;
  /** sl-amfa.4.2: Get a single marketplace template by ID (public) */
  marketplaceTemplate: Maybe<MarketplaceTemplateGql>;
  /** sl-amfa.4.2: Browse marketplace templates (public, paginated) */
  marketplaceTemplates: MarketplaceTemplatesPage;
  /** The active workspace Mates a member may name in a grant */
  mateGrantTargets: Array<NamedMateType>;
  /** The folders a new workspace Mate can be invited to by whoever manages them */
  mateInviteFolders: Array<MateInvitedFolderGql>;
  /** What a share of a Mate lets a turn do in each folder the Mate was invited to, for whoever manages the Mate */
  mateShareEffect: Array<MateShareFolderEffectGql>;
  /** The shares of a Mate, for whoever manages it */
  mateShares: Array<MateShareGql>;
  /** The skills a Mate carries, for whoever may change the Mate */
  mateSkills: Array<Scalars['String']['output']>;
  /** sl-apue: Get member quota info with seat addon details */
  memberQuotaInfo: MemberQuotaInfoType;
  /** sl-pmcz: Memory usage stats for the current user */
  memoryUsage: MemoryUsage;
  /** Whether an automation or workflow can be copied to Mine and its newest copy there. */
  mineCopy: MineCopyLookup;
  /** Get all doc IDs the current user can access in a workspace (sl-jsx3.4 Default-Deny) */
  myAccessibleDocIds: Array<Scalars['String']['output']>;
  /** sl-hle4.16: List the calling user's notification preferences in a workspace. Each entry is one registered trigger merged with the user's stored preference (or the trigger's defaults when no row exists). */
  myNotificationPreferencesInWorkspace: Array<UserNotificationPreferenceType>;
  /** sl-kaqr.2.2: Get all tenants the current user belongs to */
  myTenants: Array<TenantType>;
  /** List current user's MCP tokens for a workspace */
  myWorkspaceMcpTokens: Array<WorkspaceMcpToken>;
  /** sl-wtvw.2: Get onboarding status for current user */
  onboardingStatus: OnboardingStatusType;
  /** sl-dl66: Get all pending interval changes for the workspace (plan, seat addon, credit subs) */
  pendingIntervalChanges: Array<PendingIntervalChangeType>;
  /** sl-bcrf.6: Bounded folder/subtree permission graph drilldown. */
  permissionFolderSubtree: PermissionGraphConnectionType;
  /** sl-bcrf.6: Bounded permission graph changes since an opaque token. */
  permissionGraphChanges: PermissionGraphConnectionType;
  /** sl-bcrf.6: Bounded sparse permission graph edges for Admin diagnostics. */
  permissionGraphEdges: PermissionGraphConnectionType;
  /** sl-bcrf.6.3: Explicit bounded projection drift scan. Normal graph reads never run it. */
  permissionGraphProjectionDiagnostics: PermissionGraphDriftDiagnosticsResultType;
  /** sl-bcrf.6: Bounded permission relationships lookup. */
  permissionGraphRelationships: PermissionGraphConnectionType;
  /** sl-bcrf.6: Bounded permission graph roots for Admin diagnostics. */
  permissionGraphRoots: PermissionGraphConnectionType;
  /** sl-bcrf.6: Bounded resource -> subjects lookup. */
  permissionResourceSubjects: PermissionGraphConnectionType;
  /** sl-bcrf.6: Bounded subject -> resources lookup. */
  permissionSubjectResources: PermissionGraphConnectionType;
  /** Price a plan or interval change of the subscription bills, as switchPlanInterval resolves it */
  planChangePrice: PlanChangePriceType;
  /** The plans the platform relies on by role (plan_configs.plan_role) */
  planRoles: PlanRolesType;
  preflightDocCreate: DocCreatePreflightResult;
  preflightPermissionLifecycle: PermissionLifecyclePreflightResult;
  /** E040: Prepare doc history strip - compute metadata for warning dialog */
  prepareDocStrip: PrepareDocStripResultType;
  /** sl-ckdp: Prepare reply/reply-all/forward fields for a source message. */
  prepareMailComposition: PreparedMailComposition;
  prices: Array<SubscriptionPrice>;
  /** Get pricing plans with display data from DB + provider catalog prices */
  pricingPlans: Array<PricingPlanType>;
  /** Get dynamic pricing plans directly from active payment provider products/prices */
  providerPricingPlans: Array<StripePricingPlanType>;
  /** Get current user payment provider subscriptions */
  providerUserSubscriptions: Array<StripeUserSubscriptionType>;
  /** Get public user by id */
  publicUserById: Maybe<PublicUserType>;
  /** query workspace embedding status */
  queryWorkspaceEmbeddingStatus: ContextWorkspaceEmbeddingStatus;
  /** sl-lkdb.4.1: Get recovery history for a workspace (admin only) */
  recoveryHistory: Array<RecoveryLogType>;
  /** sl-lkdb: Get a single recovery log entry by ID (admin only) */
  recoveryLog: RecoveryLogType;
  /** sl-lkdb.4.1: Get available PITR time range for a workspace (admin only) */
  recoveryTimeRange: RecoveryTimeRangeType;
  /** sl-4cgk.3.1: Get research credit balance for a workspace (Owner/Admin only) */
  researchBalance: ResearchBalanceType;
  /** sl-iw27.4.2: Revalidate a stale snapshot against projected state */
  revalidateKgSnapshot: KgRevalidationResultType;
  revealedAccessTokens: Array<RevealedAccessToken>;
  scheduledWorkspaces: Array<WorkspaceType>;
  /** server config */
  serverConfig: ServerConfigType;
  /** The tools a skill may name, in groups, for whoever manages the workspace Mates */
  skillToolCatalog: Array<SkillToolGroupGql>;
  /** sl-n1hp.3.1: Get LLM-generated split preview for a node */
  splitGraphNodePreview: SplitNodePreviewGql;
  /** Deprecated alias for providerPricingPlans */
  stripePricingPlans: Array<StripePricingPlanType>;
  /** Deprecated alias for providerUserSubscriptions */
  stripeUserSubscriptions: Array<StripeUserSubscriptionType>;
  /** sl-kaqr.2.2: Get a specific tenant by ID (must be a member) */
  tenant: TenantType;
  /** sl-b828.12: Render a prompt template with explicit JSON variables (admin only) */
  testSystemPromptTemplate: Scalars['String']['output'];
  /** sl-qsjm: Get 2FA status for current user */
  totpStatus: TotpStatusResponse;
  /** Apps in the trash of the App Containers the caller may read. */
  trashedApps: Array<TrashedAppType>;
  /** Check if the current user is eligible for a free Pro trial (sl-r9ix.2.2) */
  trialEligible: Scalars['Boolean']['output'];
  /** sl-qsjm.3: List trusted devices for current user */
  trustedDevices: Array<DeviceTrustType>;
  /** List opaque current-user UI settings entries, optionally filtered by scope. */
  uiSettingsVaultEntries: Array<UiSettingsVaultEntry>;
  /** The Mates a member may pick: their own and those shared with them or their groups */
  usableMates: Array<UsableMateGql>;
  /** Get user by email */
  user: Maybe<UserOrLimitedUser>;
  /** Get user by email for admin */
  userByEmail: Maybe<UserType>;
  /** Get user by id */
  userById: UserType;
  /** sl-pmcz.1.1: List user's AI memories in a workspace */
  userMemories: Array<UserMemory>;
  /** List registered users */
  users: Array<UserType>;
  /** Count users matching the list filters (admin only) */
  usersCount: Scalars['Int']['output'];
  /** sl-7q0s.5.1: Get workflow usage summary for a workspace */
  workflowUsageSummary: WorkflowUsageSummaryType;
  /** Get workspace by id */
  workspace: WorkspaceType;
  /** sl-wmbt.4.1: Query unified workspace audit events (Team+, Admin only) */
  workspaceAuditEvents: AuditEventConnectionType;
  /** Get corruption reports for a workspace */
  workspaceCorruptionReports: PaginatedCorruptionReportsType;
  /** Get corruption statistics for a workspace */
  workspaceCorruptionStats: CorruptionReportStatsType;
  /** sl-t828.1: Check if user can create more workspaces (plan limit) */
  workspaceCreationQuota: WorkspaceCreationQuotaType;
  /** Get active credit subscriptions for a workspace */
  workspaceCreditSubscriptions: Array<WorkspaceCreditSubscriptionType>;
  workspaceDeletionGraceDays: Scalars['Int']['output'];
  /** E040: Get server-side doc sizes for all docs in a workspace */
  workspaceDocSizes: Array<DocSizeEntryType>;
  /** sl-sdk6.6.3: Get workspace knowledge graph data for the Graph Explorer (Enterprise only) */
  workspaceGraphData: WorkspaceGraphData;
  /** Every workspace Mate, for the Owners and Admins who manage them */
  workspaceMates: Array<MateGql>;
  /** sl-xk37: List all MCP tokens for a workspace (Admin/Owner only) */
  workspaceMcpTokens: Array<WorkspaceMcpToken>;
  /** sl-qsjm.5: Get member 2FA compliance status for workspace */
  workspaceMemberCompliance: Array<MemberTwoFactorStatusType>;
  /** sl-qsjm.5: Get workspace 2FA policy */
  workspacePolicy: WorkspacePolicyType;
  /** sl-ya4v.5 + sl-ya4v.12: Public-host snapshot for the workspace settings UI (default + branded + custom + effective). Returns null for Free-tier workspaces — Free has no publishing rights, so no URL identity. */
  workspacePublicHost: Maybe<WorkspacePublicHostType>;
  /** Source-of-truth matrix for configurable workspace role permissions. */
  workspaceRolePermissionMatrix: WorkspaceRolePermissionMatrix;
  /** sl-sdk6.7.2: Get role permission overrides for a workspace (Admin/Owner only) */
  workspaceRolePermissionOverrides: Array<WorkspaceRolePermissionOverride>;
  /**
   * Get workspace role permissions
   * @deprecated use WorkspaceType[permissions] instead
   */
  workspaceRolePermissions: WorkspaceRolePermissions;
  /** sl-sf9o: Get workspace model routing configuration */
  workspaceRoutingConfig: WorkspaceRoutingConfigType;
  /** sl-67kc.3.4: Workspace-wide chip data for parked long-running operations the user can access. */
  workspaceRunningOperations: Array<WorkspaceRunningOperationType>;
  /** sl-apue: Get current seat addon status for a workspace */
  workspaceSeatAddon: Maybe<WorkspaceSeatAddonType>;
  /** The skill library of the workspace, by name */
  workspaceSkills: Array<SkillGql>;
  /** sl-xbxb: Get all tag definitions for a workspace */
  workspaceTags: Array<WorkspaceTagType>;
  /** Get all accessible workspaces for current user */
  workspaces: Array<WorkspaceType>;
}

export interface QueryAdminAiProfitabilityArgs {
  input: AiProfitabilityQueryInput;
}

export interface QueryAdminAuditLogsArgs {
  filter: AuditLogFilterInput;
}

export interface QueryAdminGetUserSubscriptionsArgs {
  userId: Scalars['String']['input'];
}

export interface QueryAdminGraphStatsArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryAdminListSubscriptionsArgs {
  planFilter?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  statusFilter?: InputMaybe<SubscriptionStatus>;
  take?: InputMaybe<Scalars['Int']['input']>;
}

export interface QueryAdminMemoriesArgs {
  filters?: InputMaybe<AdminMemoryFilters>;
  workspaceId: Scalars['String']['input'];
}

export interface QueryAdminSignupTrendArgs {
  input: SignupTrendInput;
}

export interface QueryAdminSystemCachePerformanceArgs {
  input: CachePerformanceQueryInput;
}

export interface QueryAdminSystemPromptTemplateArgs {
  key: Scalars['String']['input'];
}

export interface QueryAdminTenantCachePerformanceArgs {
  input: CachePerformanceQueryInput;
  tenantId: Scalars['String']['input'];
}

export interface QueryAdminTenantDetailArgs {
  tenantId: Scalars['String']['input'];
}

export interface QueryAdminTenantsArgs {
  filter: ListTenantInput;
}

export interface QueryAdminTenantsCountArgs {
  filter: ListTenantInput;
}

export interface QueryAdminTopWorkspacesArgs {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
}

export interface QueryAdminTopWorkspacesByActivityArgs {
  from: Scalars['DateTime']['input'];
  kind: Scalars['String']['input'];
  to: Scalars['DateTime']['input'];
}

export interface QueryAdminWorkspaceActivityArgs {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryAdminWorkspaceActivityCountersArgs {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryAdminWorkspaceDetailArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryAdminWorkspaceMemoryConfigArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryAdminWorkspacesArgs {
  filter: ListWorkspaceInput;
}

export interface QueryAgentToolArgs {
  instanceId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryAgentToolDryRunArgs {
  input: Scalars['JSONObject']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryAgentToolVersionHistoryArgs {
  instanceId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryAgentToolsArgs {
  appBaseId?: InputMaybe<Scalars['String']['input']>;
  appId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface QueryAppBaseArgs {
  appBaseSlug: Scalars['String']['input'];
}

export interface QueryAppBaseAieoArgs {
  appBaseId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
}

export interface QueryAppBaseAppAccessArgs {
  id: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryAppBaseAppPermissionMatrixArgs {
  id: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryAppBaseAppsArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryAppBaseBandwidthBudgetArgs {
  appBaseId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryAppBaseDatabaseBindingHealthArgs {
  id: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryAppBaseDatabaseBindingsArgs {
  id: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryAppBaseDevelopmentInspectArgs {
  target: Scalars['JSONObject']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryAppBaseDevelopmentNextStepsArgs {
  input: Scalars['JSONObject']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryAppBaseDevelopmentStatusArgs {
  input: Scalars['JSONObject']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryAppBaseInvocationStatusArgs {
  appBaseId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryAppBaseOwnRowIdsArgs {
  appBaseId: Scalars['String']['input'];
  databaseId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryAppBasePortalInvitationsArgs {
  appBaseId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryAppBasePortalMembersArgs {
  appBaseId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryAppBaseProductQuotaArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryAppBasePublicViewerStateArgs {
  appBaseId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryAppBaseRowOwnershipSummaryArgs {
  appBaseId: Scalars['String']['input'];
  databaseId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryAppBaseSeoArgs {
  appBaseId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
}

export interface QueryAppBaseSeoCheckArgs {
  appBaseId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
}

export interface QueryAppBaseStateArgs {
  id: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryAppBaseVersionHistoryArgs {
  appBaseId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryAppBaseVersionModulesArgs {
  appBaseId: Scalars['String']['input'];
  version: Scalars['Int']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryAppBaseViewerStateArgs {
  appBaseId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryAppBasesArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryAppBasesByDocIdArgs {
  docId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryAppContainerPlanOverviewArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryAppContainerPublishedPlanUsageArgs {
  appBaseId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryAppContainersForDeletionArgs {
  appBaseIds?: Array<Scalars['String']['input']>;
  docIds?: Array<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface QueryAppLoadSourceArgs {
  appBaseId: Scalars['String']['input'];
  from: Scalars['DateTime']['input'];
  route?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['DateTime']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryAppTableChoicesArgs {
  appId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryBlockInviteEligibleRecipientsArgs {
  input: BlockInviteEligibilityInput;
}

export interface QueryBrandedSubdomainRenameAvailabilityArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryCanManageWorkspaceMatesArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryContentEntryOpenChangesArgs {
  appBaseId: Scalars['String']['input'];
  sourceKey: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryContentEntryVersionsArgs {
  appBaseId: Scalars['String']['input'];
  rowId: Scalars['String']['input'];
  sourceKey: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryCorruptionReportForAiArgs {
  id: Scalars['String']['input'];
}

export interface QueryCreditBalanceArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryCreditTransactionsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<CreditTransactionTypeEnum>;
  workspaceId: Scalars['String']['input'];
}

export interface QueryCurrentBandwidthUsageArgs {
  appBaseId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryCustomDomainsArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryDatabaseBulkReceiptStatusArgs {
  input: DatabaseBulkReceiptStatusInput;
}

export interface QueryDatabaseDeleteDependenciesArgs {
  input: DatabasePermanentlyDeleteInput;
}

export interface QueryDiscoverAppBaseDatabasesArgs {
  docId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryDocGroupRolesArgs {
  docId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryDocHistoryTimelineArgs {
  input: GetDocHistoryTimelineInput;
}

export interface QueryDocMateRolesArgs {
  docId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryDocSizeInfoArgs {
  docId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryDocTagIdsArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryErrorArgs {
  name: ErrorNames;
}

export interface QueryFindSimilarNodesArgs {
  cosineThreshold?: InputMaybe<Scalars['Float']['input']>;
  levenshteinThreshold?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface QueryFolderGroupRolesArgs {
  folderId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryFolderMateRolesArgs {
  folderId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryGetInviteInfoArgs {
  inviteId: Scalars['String']['input'];
}

export interface QueryGroupArgs {
  groupId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryGroupDocRolesArgs {
  groupId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryGroupFolderRolesArgs {
  groupId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryGroupMatesArgs {
  groupId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryGroupMembersArgs {
  groupId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryGroupsArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryInstalledTemplatesArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryIsAdminArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryIsOwnerArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryIsWorkspaceTwoFactorCompliantArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryKgConfigSnapshotsArgs {
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}

export interface QueryKgConfigValuesArgs {
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}

export interface QueryKgEntityTypesArgs {
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}

export interface QueryKgPipelineStepsArgs {
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}

export interface QueryKgRelationTypesArgs {
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}

export interface QueryKgSnapshotDetailsArgs {
  snapshotId: Scalars['String']['input'];
}

export interface QueryKgSnapshotTimelineArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryKgSnapshotsArgs {
  status?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface QueryMailAccountsArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryMailAdminOverviewArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryMailAutorespondersArgs {
  accountId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface QueryMailComposeSignatureArgs {
  accountId: Scalars['String']['input'];
  composeKind: MailComposeKind;
  workspaceId: Scalars['String']['input'];
}

export interface QueryMailCredentialShareProposalsArgs {
  input: MailCredentialShareProposalInput;
}

export interface QueryMailCurrentUserQuotaArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryMailFoldersArgs {
  accountId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface QueryMailMessageBodyArgs {
  messageId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryMailMessagesArgs {
  accountId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  folder?: InputMaybe<MailFolder>;
  folderId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  virtualFolder?: InputMaybe<MailVirtualFolder>;
  workspaceId: Scalars['String']['input'];
}

export interface QueryMailRulesArgs {
  accountId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface QueryMailSignatureAssignmentsArgs {
  accountId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface QueryMailSignaturesArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryMailSyncStatesArgs {
  accountId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface QueryMailTrustedSendersArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryMailVirtualFoldersArgs {
  accountId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryMailboxRootArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryMailboxRootDocIdsArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryManagedAiStatusArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryMarketplaceTemplateArgs {
  id: Scalars['ID']['input'];
}

export interface QueryMarketplaceTemplatesArgs {
  category?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  templateType?: InputMaybe<Scalars['String']['input']>;
}

export interface QueryMateGrantTargetsArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryMateInviteFoldersArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryMateShareEffectArgs {
  mateId: Scalars['String']['input'];
  principalId: Scalars['String']['input'];
  principalKind: MateSharePrincipalKind;
  workspaceId: Scalars['String']['input'];
}

export interface QueryMateSharesArgs {
  mateId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryMateSkillsArgs {
  mateId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryMemberQuotaInfoArgs {
  workspaceId: Scalars['ID']['input'];
}

export interface QueryMemoryUsageArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryMineCopyArgs {
  sourceId: Scalars['String']['input'];
  sourceKind: MineCopySourceKind;
  workspaceId: Scalars['String']['input'];
}

export interface QueryMyAccessibleDocIdsArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryMyNotificationPreferencesInWorkspaceArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryMyWorkspaceMcpTokensArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryPendingIntervalChangesArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryPermissionFolderSubtreeArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  depth?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  folderId: Scalars['String']['input'];
  permission?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface QueryPermissionGraphChangesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sinceToken?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface QueryPermissionGraphEdgesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PermissionGraphFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface QueryPermissionGraphProjectionDiagnosticsArgs {
  sampleDocs?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface QueryPermissionGraphRelationshipsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PermissionGraphFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface QueryPermissionGraphRootsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface QueryPermissionResourceSubjectsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  permission?: InputMaybe<Scalars['String']['input']>;
  resourceId: Scalars['String']['input'];
  resourceKind: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryPermissionSubjectResourcesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  permission?: InputMaybe<Scalars['String']['input']>;
  resourceKind?: InputMaybe<Scalars['String']['input']>;
  subjectId: Scalars['String']['input'];
  subjectKind: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryPlanChangePriceArgs {
  plan: Scalars['String']['input'];
  recurring: SubscriptionRecurring;
  targetPlan?: InputMaybe<Scalars['String']['input']>;
}

export interface QueryPreflightDocCreateArgs {
  input: DocCreatePreflightInput;
}

export interface QueryPreflightPermissionLifecycleArgs {
  input: PermissionLifecyclePreflightInput;
}

export interface QueryPrepareDocStripArgs {
  input: StripDocHistoryInput;
}

export interface QueryPrepareMailCompositionArgs {
  input: PrepareMailCompositionInput;
}

export interface QueryPricingPlansArgs {
  language?: InputMaybe<Scalars['String']['input']>;
}

export interface QueryPublicUserByIdArgs {
  id: Scalars['String']['input'];
}

export interface QueryQueryWorkspaceEmbeddingStatusArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryRecoveryHistoryArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryRecoveryLogArgs {
  logId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryRecoveryTimeRangeArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryResearchBalanceArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryRevalidateKgSnapshotArgs {
  snapshotId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QuerySkillToolCatalogArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QuerySplitGraphNodePreviewArgs {
  nodeId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface QueryTenantArgs {
  id: Scalars['ID']['input'];
}

export interface QueryTestSystemPromptTemplateArgs {
  body?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  variablesJson: Scalars['String']['input'];
}

export interface QueryTrashedAppsArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryUiSettingsVaultEntriesArgs {
  scopes?: InputMaybe<Array<Scalars['String']['input']>>;
}

export interface QueryUsableMatesArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryUserArgs {
  email: Scalars['String']['input'];
}

export interface QueryUserByEmailArgs {
  email: Scalars['String']['input'];
}

export interface QueryUserByIdArgs {
  id: Scalars['String']['input'];
}

export interface QueryUserMemoriesArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryUsersArgs {
  filter: ListUserInput;
}

export interface QueryUsersCountArgs {
  filter?: InputMaybe<ListUserInput>;
}

export interface QueryWorkflowUsageSummaryArgs {
  month?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface QueryWorkspaceArgs {
  id: Scalars['String']['input'];
}

export interface QueryWorkspaceAuditEventsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AuditEventFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface QueryWorkspaceCorruptionReportsArgs {
  input: GetCorruptionReportsInput;
}

export interface QueryWorkspaceCorruptionStatsArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryWorkspaceCreditSubscriptionsArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryWorkspaceDocSizesArgs {
  input: WorkspaceDocSizesInput;
}

export interface QueryWorkspaceGraphDataArgs {
  includeSnapshotNodes?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nodeTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceId: Scalars['String']['input'];
}

export interface QueryWorkspaceMatesArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryWorkspaceMcpTokensArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryWorkspaceMemberComplianceArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryWorkspacePolicyArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryWorkspacePublicHostArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryWorkspaceRolePermissionMatrixArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryWorkspaceRolePermissionOverridesArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryWorkspaceRolePermissionsArgs {
  id: Scalars['String']['input'];
}

export interface QueryWorkspaceRoutingConfigArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryWorkspaceRunningOperationsArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryWorkspaceSeatAddonArgs {
  workspaceId: Scalars['ID']['input'];
}

export interface QueryWorkspaceSkillsArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryWorkspaceTagsArgs {
  workspaceId: Scalars['String']['input'];
}

export interface QueryChatHistoriesInput {
  action?: InputMaybe<Scalars['Boolean']['input']>;
  excludePromptNames?: InputMaybe<Array<Scalars['String']['input']>>;
  fork?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  messageOrder?: InputMaybe<ChatHistoryOrder>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  sessionOrder?: InputMaybe<ChatHistoryOrder>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  withMessages?: InputMaybe<Scalars['Boolean']['input']>;
  withPrompt?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface QueryChatSessionsInput {
  action?: InputMaybe<Scalars['Boolean']['input']>;
  excludePromptNames?: InputMaybe<Array<Scalars['String']['input']>>;
  fork?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}

export interface QueryTooLongDataType {
  __typename?: 'QueryTooLongDataType';
  max: Scalars['Int']['output'];
}

/**
 * Bulk owner assignment for live rows. Set exactly one of rowIds,
 * onlyWithoutOwner or fromOwner. At most 5000 rows change per call; repeat while
 * remainingRows > 0.
 */
export interface ReassignAppBaseRowOwnersInput {
  appBaseId: Scalars['String']['input'];
  databaseId: Scalars['String']['input'];
  fromOwner?: InputMaybe<AppBaseRowOwnerInput>;
  onlyWithoutOwner?: InputMaybe<Scalars['Boolean']['input']>;
  rowIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Workspace member, or portal user of this App. */
  toOwner: AppBaseRowOwnerInput;
  workspaceId: Scalars['String']['input'];
}

/** Refresh placement hints after a bound database moved between docs. */
export interface RebindAppBaseDatabaseInput {
  blockId: Scalars['String']['input'];
  confirmed: Scalars['Boolean']['input'];
  docId: Scalars['String']['input'];
  sourceKey: Scalars['String']['input'];
}

/** Input for rebuilding doc from history */
export interface RebuildDocFromHistoryInput {
  docId: Scalars['String']['input'];
  untilTimestamp: Scalars['DateTime']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface RebuildMailSearchIndexInput {
  accountId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface RebuildMailSearchIndexResult {
  __typename?: 'RebuildMailSearchIndexResult';
  jobId: Scalars['String']['output'];
  queuedMessages: Scalars['Int']['output'];
  skippedMessages: Scalars['Int']['output'];
  status: Scalars['String']['output'];
}

/** sl-qhe4: Recovery operation processing state */
export enum RecoveryLogStatus {
  failed = 'failed',
  pending = 'pending',
  running = 'running',
  success = 'success',
}

/** sl-lkdb.4.1: Recovery log entry for admin PITR operations */
export interface RecoveryLogType {
  __typename?: 'RecoveryLogType';
  adminUserId: Scalars['String']['output'];
  blobsRestored: Maybe<Scalars['Int']['output']>;
  completedAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  durationMs: Maybe<Scalars['Int']['output']>;
  errorMessage: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  phase: Maybe<Scalars['String']['output']>;
  rowsDeleted: Maybe<Scalars['Int']['output']>;
  rowsInserted: Maybe<Scalars['Int']['output']>;
  startedAt: Maybe<Scalars['DateTime']['output']>;
  status: RecoveryLogStatus;
  tablesRestored: Maybe<Scalars['Int']['output']>;
  targetTimestamp: Scalars['DateTime']['output'];
  workspaceId: Scalars['String']['output'];
}

/** Result of doc recovery operation */
export interface RecoveryResultType {
  __typename?: 'RecoveryResultType';
  corruptEntriesSkipped: Scalars['Int']['output'];
  error: Maybe<Scalars['String']['output']>;
  newSnapshotSize: Scalars['Int']['output'];
  restoredToTimestamp: Scalars['DateTime']['output'];
  success: Scalars['Boolean']['output'];
  validEntriesApplied: Scalars['Int']['output'];
}

/** sl-lkdb.4.1: Available PITR time range for workspace recovery */
export interface RecoveryTimeRangeType {
  __typename?: 'RecoveryTimeRangeType';
  earliest: Scalars['DateTime']['output'];
  latest: Scalars['DateTime']['output'];
}

/** Result of a workspace embedding re-index operation (sl-nagw.4.1) */
export interface ReindexWorkspaceEmbeddingsResult {
  __typename?: 'ReindexWorkspaceEmbeddingsResult';
  /** Number of embedding chunks deleted */
  deletedChunks: Scalars['SafeInt']['output'];
  /** Number of documents queued for re-indexing */
  queuedDocs: Scalars['SafeInt']['output'];
}

/** Candidate row for ambiguous relation matches */
export interface RelationCandidateType {
  __typename?: 'RelationCandidateType';
  context: Maybe<Scalars['JSON']['output']>;
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
}

export interface ReleaseVersionType {
  __typename?: 'ReleaseVersionType';
  changelog: Scalars['String']['output'];
  publishedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
  version: Scalars['String']['output'];
}

export interface RemoveAvatar {
  __typename?: 'RemoveAvatar';
  success: Scalars['Boolean']['output'];
}

export interface RemoveContextBlobInput {
  blobId: Scalars['String']['input'];
  contextId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface RemoveContextCategoryInput {
  categoryId: Scalars['String']['input'];
  contextId: Scalars['String']['input'];
  type: ContextCategories;
  workspaceId: Scalars['String']['input'];
}

export interface RemoveContextDocInput {
  contextId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface RemoveContextFileInput {
  contextId: Scalars['String']['input'];
  fileId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface ReplyCreateInput {
  commentId: Scalars['ID']['input'];
  content: Scalars['JSONObject']['input'];
  docMode: DocMode;
  docTitle: Scalars['String']['input'];
  /** The mention user ids, if not provided, the comment reply will not be mentioned */
  mentions?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceId: Scalars['ID']['input'];
}

export interface ReplyObjectType {
  __typename?: 'ReplyObjectType';
  commentId: Scalars['ID']['output'];
  /** The content of the reply */
  content: Scalars['JSONObject']['output'];
  /** The created at time of the reply */
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The updated at time of the reply */
  updatedAt: Scalars['DateTime']['output'];
  /** The user who created the reply */
  user: PublicUserType;
}

export interface ReplyUpdateInput {
  content: Scalars['JSONObject']['input'];
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
}

export interface ReportCorruptionInput {
  appVersion?: InputMaybe<Scalars['String']['input']>;
  binLength: Scalars['Int']['input'];
  binPreview?: InputMaybe<Scalars['String']['input']>;
  browser?: InputMaybe<Scalars['String']['input']>;
  clientTimestamp: Scalars['DateTime']['input'];
  clientTimezone: Scalars['String']['input'];
  docId: Scalars['String']['input'];
  docTitleSnapshot?: InputMaybe<Scalars['String']['input']>;
  errorMessage: Scalars['String']['input'];
  errorType: Scalars['String']['input'];
  operation: Scalars['String']['input'];
  os?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CorruptionReportStatus>;
  wasOnline?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['String']['input'];
}

/** sl-4cgk: Research Credit Balance — governance credit system */
export interface ResearchBalanceType {
  __typename?: 'ResearchBalanceType';
  /** Available (earned - committed) in micro-credits */
  availableMicro: Scalars['String']['output'];
  /** Currently committed to sinks in micro-credits */
  committedMicro: Scalars['String']['output'];
  /** Lifetime earned in micro-credits (string for BigInt serialization) */
  earnedMicro: Scalars['String']['output'];
}

/** Input for revealing a newly granted workspace MCP config once */
export interface RevealWorkspaceMcpGrantInput {
  revealId: Scalars['String']['input'];
}

export interface RevealedAccessToken {
  __typename?: 'RevealedAccessToken';
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  token: Scalars['String']['output'];
}

export interface RevokeDocUserRoleInput {
  docId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface RuntimeConfigNotFoundDataType {
  __typename?: 'RuntimeConfigNotFoundDataType';
  key: Scalars['String']['output'];
}

export interface SameSubscriptionRecurringDataType {
  __typename?: 'SameSubscriptionRecurringDataType';
  recurring: Scalars['String']['output'];
}

export interface SaveMailDraftInput {
  accountId: Scalars['String']['input'];
  attachments?: InputMaybe<Array<SendMailAttachmentInput>>;
  bcc?: InputMaybe<Array<Scalars['String']['input']>>;
  bodyHtml?: InputMaybe<Scalars['String']['input']>;
  bodyText?: InputMaybe<Scalars['String']['input']>;
  cc?: InputMaybe<Array<Scalars['String']['input']>>;
  composeKind?: InputMaybe<MailComposeKind>;
  draftMessageId?: InputMaybe<Scalars['String']['input']>;
  inReplyToHeader?: InputMaybe<Scalars['String']['input']>;
  referencesHeader?: InputMaybe<Scalars['String']['input']>;
  sourceMessageId?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceId: Scalars['String']['input'];
}

export interface SaveMailDraftResult {
  __typename?: 'SaveMailDraftResult';
  accountId: Scalars['String']['output'];
  draftMessageId: Scalars['String']['output'];
  providerDraftUid: Maybe<Scalars['String']['output']>;
  rowId: Scalars['String']['output'];
  savedAt: Scalars['DateTime']['output'];
}

export interface SearchDocObjectType {
  __typename?: 'SearchDocObjectType';
  /** Image blob of an image block hit, for its miniature. */
  blobId: Maybe<Scalars['String']['output']>;
  blockId: Maybe<Scalars['String']['output']>;
  columnId: Maybe<Scalars['String']['output']>;
  columnName: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdByUser: Maybe<PublicUserType>;
  databaseId: Maybe<Scalars['String']['output']>;
  databaseTitle: Maybe<Scalars['String']['output']>;
  docId: Scalars['String']['output'];
  /** Block flavour of a block hit, e.g. a sticky note among text blocks. */
  flavour: Maybe<Scalars['String']['output']>;
  highlight: Maybe<Scalars['String']['output']>;
  rowId: Maybe<Scalars['String']['output']>;
  rowLabel: Maybe<Scalars['String']['output']>;
  rowShardDocId: Maybe<Scalars['String']['output']>;
  /** Base64 Yjs state vector of the row shard content the hit was indexed from. Absent until the shard was indexed on its own. */
  rowShardVersion: Maybe<Scalars['String']['output']>;
  /** What the hit is: doc, text, image, attachment, database, edgeless or embed. */
  sourceType: Maybe<Scalars['String']['output']>;
  technicalSourceKind: Maybe<WorkspaceSearchTechnicalSourceKind>;
  title: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  updatedByUser: Maybe<PublicUserType>;
  visibility: Maybe<WorkspaceSearchResultVisibility>;
}

export interface SearchDocsInput {
  /** Search partitions the client answers from its own current index; their pages are left out. At most 64 partition indexes, never page ids. */
  excludedPartitions?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Include underlying technical storage docs/databases in addition to semantic results. */
  includeTechnicalSources?: InputMaybe<Scalars['Boolean']['input']>;
  keyword: Scalars['String']['input'];
  /** Limit the number of docs to return, default is 20 */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Search only database rows stored in these row shard docs. Pages, blocks and other databases are left out. */
  rowShardDocIds?: InputMaybe<Array<Scalars['String']['input']>>;
  similar?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface SearchHighlight {
  before: Scalars['String']['input'];
  end: Scalars['String']['input'];
  field: Scalars['String']['input'];
}

export interface SearchInput {
  options: SearchOptions;
  query: SearchQuery;
  table: SearchTable;
}

/** Search mode for copilot */
export enum SearchMode {
  AUTO = 'AUTO',
  LOCAL = 'LOCAL',
  WEB = 'WEB',
}

export interface SearchNodeObjectType {
  __typename?: 'SearchNodeObjectType';
  /** The search result fields, see UnionSearchItemObjectType */
  fields: Scalars['JSONObject']['output'];
  /** The search result fields, see UnionSearchItemObjectType */
  highlights: Maybe<Scalars['JSONObject']['output']>;
}

export interface SearchOptions {
  fields: Array<Scalars['String']['input']>;
  highlights?: InputMaybe<Array<SearchHighlight>>;
  includeTechnicalSources?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<SearchPagination>;
}

export interface SearchPagination {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}

export interface SearchQuery {
  boost?: InputMaybe<Scalars['Float']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  match?: InputMaybe<Scalars['String']['input']>;
  occur?: InputMaybe<SearchQueryOccur>;
  queries?: InputMaybe<Array<SearchQuery>>;
  query?: InputMaybe<SearchQuery>;
  type: SearchQueryType;
}

/** Search query occur */
export enum SearchQueryOccur {
  must = 'must',
  must_not = 'must_not',
  should = 'should',
}

/** Search query type */
export enum SearchQueryType {
  all = 'all',
  boolean = 'boolean',
  boost = 'boost',
  exists = 'exists',
  match = 'match',
}

export interface SearchResultObjectType {
  __typename?: 'SearchResultObjectType';
  nodes: Array<SearchNodeObjectType>;
  pagination: SearchResultPagination;
}

export interface SearchResultPagination {
  __typename?: 'SearchResultPagination';
  count: Scalars['Int']['output'];
  hasMore: Scalars['Boolean']['output'];
  nextCursor: Maybe<Scalars['String']['output']>;
}

/** Search table */
export enum SearchTable {
  block = 'block',
  doc = 'doc',
}

/** sl-apue: Result of a seat addon purchase/update operation */
export interface SeatAddonResultType {
  __typename?: 'SeatAddonResultType';
  /** Updated addon state */
  addon: Maybe<WorkspaceSeatAddonType>;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
}

/** sl-qhe4: Seat addon billing lifecycle state */
export enum SeatAddonStatus {
  active = 'active',
  canceled = 'canceled',
  past_due = 'past_due',
}

export interface SendBlockInviteResultType {
  __typename?: 'SendBlockInviteResultType';
  createdCount: Scalars['Int']['output'];
  ineligible: Array<BlockInviteIneligibleTargetType>;
  skippedCount: Scalars['Int']['output'];
  userIds: Array<Scalars['String']['output']>;
}

export interface SendMailAttachmentInput {
  blobKey: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  mimeType?: InputMaybe<Scalars['String']['input']>;
}

export interface SendMailInput {
  accountId: Scalars['String']['input'];
  attachments?: InputMaybe<Array<SendMailAttachmentInput>>;
  bcc?: InputMaybe<Array<Scalars['String']['input']>>;
  bodyHtml?: InputMaybe<Scalars['String']['input']>;
  bodyText?: InputMaybe<Scalars['String']['input']>;
  cc?: InputMaybe<Array<Scalars['String']['input']>>;
  composeKind?: InputMaybe<MailComposeKind>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  inReplyToHeader?: InputMaybe<Scalars['String']['input']>;
  referencesHeader?: InputMaybe<Scalars['String']['input']>;
  signatureId?: InputMaybe<Scalars['String']['input']>;
  sourceMessageId?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  to: Array<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface SendMailResult {
  __typename?: 'SendMailResult';
  accepted: Array<Scalars['String']['output']>;
  persistedMessageId: Scalars['String']['output'];
  providerMessageId: Maybe<Scalars['String']['output']>;
  rejected: Array<Scalars['String']['output']>;
  rowId: Scalars['String']['output'];
}

export interface SendSavedMailDraftInput {
  attachments?: InputMaybe<Array<SendMailAttachmentInput>>;
  draftMessageId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface ServerConfigType {
  __typename?: 'ServerConfigType';
  /** fetch latest available upgradable release of server */
  availableUpgrade: Maybe<ReleaseVersionType>;
  /** Features for user that can be configured */
  availableUserFeatures: Array<FeatureType>;
  /** server base url */
  baseUrl: Scalars['String']['output'];
  /** credentials requirement */
  credentialsRequirement: CredentialsRequirementType;
  /** enabled server features */
  features: Array<ServerFeature>;
  /** whether server has been initialized */
  initialized: Scalars['Boolean']['output'];
  /** server identical name could be shown as badge on user interface */
  name: Scalars['String']['output'];
  oauthProviders: Array<OAuthProviderType>;
  /** sl-m3s8: dedicated WebSocket endpoint URL */
  syncUrl: Maybe<Scalars['String']['output']>;
  /** server type */
  type: ServerDeploymentType;
  /** server version */
  version: Scalars['String']['output'];
}

export enum ServerDeploymentType {
  Affine = 'Affine',
  Managed = 'Managed',
  Selfhosted = 'Selfhosted',
}

export enum ServerFeature {
  BusinessIntelligence = 'BusinessIntelligence',
  Captcha = 'Captcha',
  Comment = 'Comment',
  Copilot = 'Copilot',
  CopilotEmbedding = 'CopilotEmbedding',
  CopilotMemory = 'CopilotMemory',
  Indexer = 'Indexer',
  LocalWorkspace = 'LocalWorkspace',
  OAuth = 'OAuth',
  Payment = 'Payment',
}

/** sl-hle4.2 REWORK: Input for setAppBaseBandwidthBudget. */
export interface SetAppBaseBandwidthBudgetInput {
  /** Optional alert thresholds in percent of the budget. Defaults to [60, 80, 100]. Each entry must be an integer in (0, 100]. */
  alertThresholds?: InputMaybe<Array<Scalars['Int']['input']>>;
  appBaseId: Scalars['String']['input'];
  /** Defaults to `block`. One of: `block`, `warn`. */
  behavior?: InputMaybe<Scalars['String']['input']>;
  /** Monthly cap in micro-credits (1 credit = 10_000 micro-credits). Must be > 0. */
  monthlyLimitMicro: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

/** sl-hle4.16: Input for setMyNotificationPreference. Omitted fields fall back to the trigger's defaults. */
export interface SetMyNotificationPreferenceInput {
  accountId?: InputMaybe<Scalars['String']['input']>;
  channelInApp?: InputMaybe<Scalars['Boolean']['input']>;
  channelMail?: InputMaybe<Scalars['Boolean']['input']>;
  channelWebPush?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  folderKey?: InputMaybe<Scalars['String']['input']>;
  quietHours?: InputMaybe<Scalars['JSONObject']['input']>;
  thresholds?: InputMaybe<Array<Scalars['Int']['input']>>;
  triggerType: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface ShareMateInput {
  mateId: Scalars['String']['input'];
  /** intersection when left out */
  mode?: InputMaybe<MateShareMode>;
  principalId: Scalars['String']['input'];
  principalKind: MateSharePrincipalKind;
  shareMemory?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['String']['input'];
}

export enum SignupTrendGranularity {
  Day = 'Day',
  Month = 'Month',
  Week = 'Week',
}

export interface SignupTrendInput {
  from: Scalars['DateTime']['input'];
  granularity: SignupTrendGranularity;
  to: Scalars['DateTime']['input'];
}

/** sl-ncr1.3.1: A pair of similar nodes found by quality tools */
export interface SimilarNodePair {
  __typename?: 'SimilarNodePair';
  cosineSimilarity: Scalars['Float']['output'];
  entityIdA: Scalars['String']['output'];
  entityIdB: Scalars['String']['output'];
  levenshteinDistance: Scalars['Int']['output'];
  nameA: Scalars['String']['output'];
  nameB: Scalars['String']['output'];
  typeA: Scalars['String']['output'];
  typeB: Scalars['String']['output'];
}

/** A skill of the workspace library: instructions a Mate loads when it needs them */
export interface SkillGql {
  __typename?: 'SkillGql';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  instructions: Scalars['String']['output'];
  name: Scalars['String']['output'];
  toolNames: Array<Scalars['String']['output']>;
}

/** A tool a skill may name */
export interface SkillToolGql {
  __typename?: 'SkillToolGql';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  source: Scalars['String']['output'];
}

/** The tools of one category a skill may name */
export interface SkillToolGroupGql {
  __typename?: 'SkillToolGroupGql';
  category: Scalars['String']['output'];
  tools: Array<SkillToolGql>;
}

export interface SpaceAccessDeniedDataType {
  __typename?: 'SpaceAccessDeniedDataType';
  spaceId: Scalars['String']['output'];
}

export interface SpaceNotFoundDataType {
  __typename?: 'SpaceNotFoundDataType';
  spaceId: Scalars['String']['output'];
}

export interface SpaceOwnerNotFoundDataType {
  __typename?: 'SpaceOwnerNotFoundDataType';
  spaceId: Scalars['String']['output'];
}

export interface SpaceShouldHaveOnlyOneOwnerDataType {
  __typename?: 'SpaceShouldHaveOnlyOneOwnerDataType';
  spaceId: Scalars['String']['output'];
}

export interface SplitEntityGql {
  __typename?: 'SplitEntityGql';
  description: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
}

export interface SplitEntityInput {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
}

/** sl-n1hp.3.1: LLM-generated split preview for a node */
export interface SplitNodePreviewGql {
  __typename?: 'SplitNodePreviewGql';
  /** Reason why no split is recommended (null if split is suggested) */
  noSplitReason: Maybe<Scalars['String']['output']>;
  suggestedRelations: Array<SplitRelationGql>;
  suggestedSplits: Array<SplitEntityGql>;
}

export interface SplitRelationGql {
  __typename?: 'SplitRelationGql';
  relationType: Scalars['String']['output'];
  source: Scalars['String']['output'];
  sourceType: Scalars['String']['output'];
  target: Scalars['String']['output'];
  targetType: Scalars['String']['output'];
}

export interface StreamObject {
  __typename?: 'StreamObject';
  args: Maybe<Scalars['JSON']['output']>;
  /** A tool result: how long the step ran. Reasoning: how long the model thought. */
  durationMs: Maybe<Scalars['Int']['output']>;
  result: Maybe<Scalars['JSON']['output']>;
  textDelta: Maybe<Scalars['String']['output']>;
  toolCallId: Maybe<Scalars['String']['output']>;
  toolName: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
}

/** E040: Input for doc history strip operations */
export interface StripDocHistoryInput {
  docId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

/** E040: Result of stripping doc history */
export interface StripDocHistoryResultType {
  __typename?: 'StripDocHistoryResultType';
  error: Maybe<Scalars['String']['output']>;
  historiesDeleted: Scalars['Int']['output'];
  newSizeBytes: Scalars['Int']['output'];
  originalTotalBytes: Scalars['Int']['output'];
  reductionPercent: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
}

export interface StripePricingPlanPriceType {
  __typename?: 'StripePricingPlanPriceType';
  currency: Scalars['String']['output'];
  interval: Scalars['String']['output'];
  priceId: Scalars['String']['output'];
  unitAmount: Scalars['Int']['output'];
}

export interface StripePricingPlanType {
  __typename?: 'StripePricingPlanType';
  automationsEnabled: Maybe<Scalars['Boolean']['output']>;
  description: Maybe<Scalars['String']['output']>;
  features: Maybe<Array<PlanFeatureType>>;
  historyDays: Maybe<Scalars['Int']['output']>;
  memberLimit: Maybe<Scalars['Int']['output']>;
  prices: Array<StripePricingPlanPriceType>;
  productId: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  storage: Maybe<Scalars['String']['output']>;
}

export interface StripeUserSubscriptionType {
  __typename?: 'StripeUserSubscriptionType';
  cancelAtPeriodEnd: Maybe<Scalars['Boolean']['output']>;
  currency: Scalars['String']['output'];
  currentPeriodEnd: Scalars['DateTime']['output'];
  currentPeriodStart: Scalars['DateTime']['output'];
  interval: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  status: Scalars['String']['output'];
  subscriptionId: Scalars['String']['output'];
  unitAmount: Scalars['Int']['output'];
}

export interface SubscriptionAlreadyExistsDataType {
  __typename?: 'SubscriptionAlreadyExistsDataType';
  plan: Scalars['String']['output'];
}

export interface SubscriptionNotExistsDataType {
  __typename?: 'SubscriptionNotExistsDataType';
  plan: Scalars['String']['output'];
}

export interface SubscriptionPlanNotFoundDataType {
  __typename?: 'SubscriptionPlanNotFoundDataType';
  plan: Scalars['String']['output'];
  recurring: Scalars['String']['output'];
}

/** sl-zvjz: Active subscription summary for the deletion-modal preview. */
export interface SubscriptionPreview {
  __typename?: 'SubscriptionPreview';
  amount: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['String']['output'];
  periodEnd: Scalars['DateTime']['output'];
  plan: Scalars['String']['output'];
}

export interface SubscriptionPrice {
  __typename?: 'SubscriptionPrice';
  amount: Maybe<Scalars['Int']['output']>;
  currency: Scalars['String']['output'];
  /** Monthly launch price while the launch offer is bookable */
  launchAmount: Maybe<Scalars['Int']['output']>;
  /** Yearly launch price while the launch offer is bookable */
  launchYearlyAmount: Maybe<Scalars['Int']['output']>;
  lifetimeAmount: Maybe<Scalars['Int']['output']>;
  plan: Scalars['String']['output'];
  type: Scalars['String']['output'];
  yearlyAmount: Maybe<Scalars['Int']['output']>;
}

export enum SubscriptionRecurring {
  Lifetime = 'Lifetime',
  Monthly = 'Monthly',
  Yearly = 'Yearly',
}

export enum SubscriptionStatus {
  Active = 'Active',
  Canceled = 'Canceled',
  Incomplete = 'Incomplete',
  PastDue = 'PastDue',
  Trialing = 'Trialing',
  Unpaid = 'Unpaid',
}

export interface SubscriptionType {
  __typename?: 'SubscriptionType';
  canWithdraw: Maybe<Scalars['Boolean']['output']>;
  canceledAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  end: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated removed */
  id: Maybe<Scalars['String']['output']>;
  /** The plan of the subscription is the base plan (plan role base) */
  isBasePlan: Scalars['Boolean']['output'];
  nextBillAt: Maybe<Scalars['DateTime']['output']>;
  /** The plan of the subscription: the name of a plan row (Admin › Plans). */
  plan: Scalars['String']['output'];
  /** Payment provider of this subscription. Read-only. One of: stripe | revenuecat */
  provider: Maybe<Scalars['String']['output']>;
  recurring: SubscriptionRecurring;
  start: Scalars['DateTime']['output'];
  status: SubscriptionStatus;
  trialEnd: Maybe<Scalars['DateTime']['output']>;
  trialStart: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  variant: Maybe<SubscriptionVariant>;
  withdrawalEligibleUntil: Maybe<Scalars['DateTime']['output']>;
  withdrawalUnavailableReason: Maybe<Scalars['String']['output']>;
}

export enum SubscriptionVariant {
  EA = 'EA',
  Onetime = 'Onetime',
}

/** sl-b828.12: Admin-managed system prompt template */
export interface SystemPromptTemplateType {
  __typename?: 'SystemPromptTemplateType';
  createdAt: Scalars['DateTime']['output'];
  currentBody: Scalars['String']['output'];
  currentVersion: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Maybe<Scalars['String']['output']>;
  versions: Array<SystemPromptVersionType>;
}

/** sl-b828.12: Append-only version history entry for a system prompt */
export interface SystemPromptVersionType {
  __typename?: 'SystemPromptVersionType';
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  updatedBy: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
}

/** sl-qsjm: TOTP setup response with QR code and secret */
export interface TotpSetupResponse {
  __typename?: 'TOTPSetupResponse';
  otpauthUri: Scalars['String']['output'];
  qrCodeDataUrl: Scalars['String']['output'];
  secretKey: Scalars['String']['output'];
}

/** sl-qsjm: TOTP status for current user */
export interface TotpStatusResponse {
  __typename?: 'TOTPStatusResponse';
  /** sl-qsjm.3: Number of remaining backup codes (for ≤2 warning) */
  backupCodesCount: Scalars['Int']['output'];
  enabled: Scalars['Boolean']['output'];
  hasBackupCodes: Scalars['Boolean']['output'];
  preferredMethod: Scalars['String']['output'];
  verifiedAt: Maybe<Scalars['DateTime']['output']>;
}

/** sl-kaqr.2.2: Tenant membership */
export interface TenantMemberType {
  __typename?: 'TenantMemberType';
  accepted: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  invitedBy: Maybe<Scalars['String']['output']>;
  role: TenantRoleEnum;
  tenantId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
}

/** sl-kaqr.2.2: Tenant role enum */
export enum TenantRoleEnum {
  Admin = 'Admin',
  Billing = 'Billing',
  Owner = 'Owner',
}

/** sl-kaqr.2.2: Tenant organization */
export interface TenantType {
  __typename?: 'TenantType';
  billingEmail: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  members: Array<TenantMemberType>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  stripeCustomerId: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
}

/** Tool call information */
export interface ToolCallInfo {
  __typename?: 'ToolCallInfo';
  arguments: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
}

/** sl-canvas2-8.31: Tool-related data for typed messages */
export interface ToolMessageData {
  __typename?: 'ToolMessageData';
  /** For tool-approval-request: The approval ID */
  approvalId: Maybe<Scalars['String']['output']>;
  /** For tool-approval-response: Whether approved */
  approved: Maybe<Scalars['Boolean']['output']>;
  /** For tool-approval-request: Translatable text of the question (key and params) */
  confirmationCopy: Maybe<Scalars['JSON']['output']>;
  /** sl-tkri.3.1: Persisted credit charge for history display */
  creditsUsed: Maybe<Scalars['Float']['output']>;
  /** For tool-approval-request: Description of the operation */
  description: Maybe<Scalars['String']['output']>;
  /** For tool-result: Error message */
  error: Maybe<Scalars['String']['output']>;
  /** For a goal turn's message: the goal and what the turn does */
  goalTurn: Maybe<ChatGoalTurnMessage>;
  /** For tool-approval-response: The answered offer included switching to agent mode */
  includesAgentMode: Maybe<Scalars['Boolean']['output']>;
  /** For tool-approval-response: The answered offer included switching to target mode */
  includesTargetMode: Maybe<Scalars['Boolean']['output']>;
  /** sl-tkri.3.1: Model used (for credit badge tooltip) */
  model: Maybe<Scalars['String']['output']>;
  /** For tool-approval-response: Rejection reason */
  reason: Maybe<Scalars['String']['output']>;
  /** For tool-result: Result data */
  result: Maybe<Scalars['JSON']['output']>;
  /** For tool-result: Whether successful */
  success: Maybe<Scalars['Boolean']['output']>;
  /** For tool-approval-request/tool-call: Tool call details */
  toolCall: Maybe<ToolCallInfo>;
  /** For tool-result: Tool call ID */
  toolCallId: Maybe<Scalars['String']['output']>;
  /** For tool-result: Tool name */
  toolName: Maybe<Scalars['String']['output']>;
  /** sl-jkhk: Embedded tool results for history rendering */
  toolResults: Maybe<Array<ToolResultSummary>>;
}

/** sl-jkhk: Summary of a tool execution result */
export interface ToolResultSummary {
  __typename?: 'ToolResultSummary';
  /** Human-readable display name resolved by backend */
  displayName: Maybe<Scalars['String']['output']>;
  /** How long the step ran, from its call to its result; absent for a step that never ran */
  durationMs: Maybe<Scalars['Int']['output']>;
  /** sl-vt9e: Rich result data for history reconstruction (KG sources, counts) */
  result: Maybe<Scalars['JSON']['output']>;
  success: Scalars['Boolean']['output'];
  toolCallId: Scalars['String']['output'];
  toolName: Scalars['String']['output'];
}

export interface TranscriptionItemType {
  __typename?: 'TranscriptionItemType';
  end: Scalars['String']['output'];
  speaker: Scalars['String']['output'];
  start: Scalars['String']['output'];
  transcription: Scalars['String']['output'];
}

/** sl-qhe4: Transcription operation discriminator — 'stt' today; future: video-transcode, bulk-ai */
export enum TranscriptionJobKind {
  stt = 'stt',
}

/** sl-qhe4: Transcription job processing state */
export enum TranscriptionJobStatus {
  pending = 'pending',
  resuming = 'resuming',
}

export interface TranscriptionResultType {
  __typename?: 'TranscriptionResultType';
  actions: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status: AiJobStatus;
  summary: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  transcription: Maybe<Array<TranscriptionItemType>>;
}

export interface TransferMailSyncAuthorityInput {
  accountId: Scalars['String']['input'];
  candidateUserId: Scalars['String']['input'];
  expectedPermissionGraphVersion: Scalars['Int']['input'];
  workspaceId: Scalars['String']['input'];
}

/** sl-hle4.7: Translatable metadata field selector. */
export enum TranslatableMetadataField {
  DESCRIPTION = 'DESCRIPTION',
  SLUG = 'SLUG',
  TITLE = 'TITLE',
}

/**
 * sl-i7kr.5.3: Input for AI-driven TranslationDB content rows. Source
 * content is read from the canonical database source; translated values are
 * written back to TranslationDB as database rows, not to view config.
 */
export interface TranslateAppBaseContentInput {
  appBaseId: Scalars['ID']['input'];
  /**
   * Optional field allow-list by column id or column name. Defaults to all
   * public title/text/rich-text fields.
   */
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * If true, existing non-rejected TranslationDB rows are updated. Default
   * false skips them without LLM calls or credit charge.
   */
  overrideExisting?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Page of the App Container the translations are for. They are written to
   * the translation table of the App that page belongs to. Defaults to `/`.
   */
  routePath?: InputMaybe<Scalars['String']['input']>;
  /** Optional row id allow-list. Defaults to all rows in the source. */
  rowIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** AppBase data source key. Defaults to `content`. */
  sourceKey?: InputMaybe<Scalars['String']['input']>;
  /**
   * Must match the AppBase defaultLocale because canonical content rows are the
   * source text for this workflow.
   */
  sourceLocale: Scalars['String']['input'];
  /**
   * TranslationDB status for written rows: draft, pending, approved,
   * published, rejected. Defaults to pending.
   */
  status?: InputMaybe<Scalars['String']['input']>;
  /** One or more BCP-47 target locales. Must not include sourceLocale. */
  targetLocales: Array<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
}

/**
 * sl-i7kr.5.3: Result of a translateAppBaseContent call. `microCreditsCharged`
 * is the batch's managed-credit deduction, stringified for BigInt parity.
 */
export interface TranslateAppBaseContentResult {
  __typename?: 'TranslateAppBaseContentResult';
  appBaseId: Scalars['ID']['output'];
  jobId: Scalars['ID']['output'];
  microCreditsCharged: Scalars['String']['output'];
  skippedCount: Scalars['Int']['output'];
  translatedCount: Scalars['Int']['output'];
  updatedRowIds: Array<Scalars['String']['output']>;
  workspaceId: Scalars['ID']['output'];
  writtenRowIds: Array<Scalars['String']['output']>;
}

/**
 * sl-hle4.7: Input for AI-driven translation of an AppBase's
 * title/description/slug i18n maps.
 */
export interface TranslateAppBaseMetadataInput {
  appBaseId: Scalars['ID']['input'];
  /** Which fields to translate. */
  fields: Array<TranslatableMetadataField>;
  /**
   * If true, locales whose target value is already filled will be
   * re-translated and overwritten. Default false (idempotent skip).
   */
  overrideExisting?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * BCP-47 source locale. Must already have non-empty entries in
   * `titlesI18n` / `descriptionsI18n` / `slugsI18n` for every requested field.
   */
  sourceLocale: Scalars['String']['input'];
  /** One or more BCP-47 target locales. Must not include sourceLocale. */
  targetLocales: Array<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
}

/**
 * sl-hle4.7 + sl-hle4 Phase-4b cluster C+J: Result of a translateAppBaseMetadata
 * call. `jobId` joins to `ai_usage_log` rows for billing reconciliation;
 * `microCreditsCharged` carries the batch's deduction so the UI can render
 * the cost without an extra ledger read.
 */
export interface TranslateAppBaseMetadataResult {
  __typename?: 'TranslateAppBaseMetadataResult';
  appBaseId: Scalars['ID']['output'];
  /** Opaque correlation id for `ai_usage_log` lookup. */
  jobId: Scalars['ID']['output'];
  /**
   * sl-hle4 Phase-4b cluster C+J: Sum of micro-credits charged for this
   * batch across all (locale × field) pairs that actually went to the LLM.
   * Wire as string for BigInt parity. `0` for a no-op batch.
   */
  microCreditsCharged: Scalars['String']['output'];
  /**
   * Locales for which every requested field was already filled (no
   * LLM call, no credit charge).
   */
  skippedLocales: Array<Scalars['String']['output']>;
  /** Locales for which at least one field was actually translated. */
  translatedLocales: Array<Scalars['String']['output']>;
  workspaceId: Scalars['ID']['output'];
}

export interface TrashedAppType {
  __typename?: 'TrashedAppType';
  appBaseId: Scalars['String']['output'];
  appId: Scalars['String']['output'];
  mountPoint: Scalars['String']['output'];
  title: Scalars['String']['output'];
  trashedAt: Scalars['String']['output'];
}

export interface TrustMailSenderInput {
  senderAddress: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

/** sl-qsjm.3: Result of 2FA login verification */
export interface TwoFactorVerifyResult {
  __typename?: 'TwoFactorVerifyResult';
  backupCodesRemaining: Maybe<Scalars['Int']['output']>;
  localDataAccountId: Maybe<Scalars['String']['output']>;
  localDataLoginProof: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
}

/** Opaque per-user UI settings payload synced across clients. */
export interface UiSettingsVaultEntry {
  __typename?: 'UiSettingsVaultEntry';
  clientUpdatedAt: Scalars['DateTime']['output'];
  key: Scalars['String']['output'];
  revision: Scalars['Int']['output'];
  scope: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['String']['output'];
}

export interface UiSettingsVaultEntryInput {
  clientUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  key: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  value: Scalars['String']['input'];
}

export type UnionNotificationBodyType =
  | BlockInviteNotificationBodyType
  | InvitationAcceptedNotificationBodyType
  | InvitationBlockedNotificationBodyType
  | InvitationNotificationBodyType
  | InvitationReviewApprovedNotificationBodyType
  | InvitationReviewDeclinedNotificationBodyType
  | InvitationReviewRequestNotificationBodyType
  | MentionNotificationBodyType
  | PendingDecisionNotificationBodyType;

export interface UnknownOauthProviderDataType {
  __typename?: 'UnknownOauthProviderDataType';
  name: Scalars['String']['output'];
}

export interface UnsupportedClientVersionDataType {
  __typename?: 'UnsupportedClientVersionDataType';
  clientVersion: Scalars['String']['output'];
  requiredVersion: Scalars['String']['output'];
}

export interface UnsupportedSubscriptionPlanDataType {
  __typename?: 'UnsupportedSubscriptionPlanDataType';
  plan: Scalars['String']['output'];
}

/**
 * sl-hle4.6: Mutation input for AIEO settings. Same null-vs-undefined
 * contract as UpdateAppBaseSEOInput.
 */
export interface UpdateAppBaseAieoInput {
  appBaseId: Scalars['ID']['input'];
  attributionUrl?: InputMaybe<Scalars['String']['input']>;
  crawlerPolicy?: InputMaybe<Scalars['String']['input']>;
  crawlerPolicyDetails?: InputMaybe<Scalars['JSONObject']['input']>;
  declaration?: InputMaybe<Scalars['String']['input']>;
  llmsTextOverride?: InputMaybe<Scalars['String']['input']>;
  trainingDataConsent?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['ID']['input'];
}

/** Persist an AI-first app-base brief after explicit confirmation. */
export interface UpdateAppBaseBriefInput {
  brief: Scalars['JSONObject']['input'];
  confirmed: Scalars['Boolean']['input'];
}

/** sl-9qm.1.4: Input for updating an AppBase */
export interface UpdateAppBaseInput {
  config?: InputMaybe<Scalars['JSONObject']['input']>;
  /** null clears the override, so the App follows the workspace's App window */
  offlineAccessTtlHours?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
}

/**
 * sl-hle4.5: Mutation input for SEO settings. Omitted fields are not
 * modified; null clears optional fields; pass an explicit empty object/array to
 * clear a list/map.
 */
export interface UpdateAppBaseSeoInput {
  appBaseId: Scalars['ID']['input'];
  canonicalUrlOverride?: InputMaybe<Scalars['String']['input']>;
  descriptionsI18n?: InputMaybe<Scalars['JSONObject']['input']>;
  indexing?: InputMaybe<Scalars['Boolean']['input']>;
  jsonLdType?: InputMaybe<Scalars['String']['input']>;
  ogImagesI18n?: InputMaybe<Scalars['JSONObject']['input']>;
  robotsDirectives?: InputMaybe<Array<Scalars['String']['input']>>;
  slugsI18n?: InputMaybe<Scalars['JSONObject']['input']>;
  structuredData?: InputMaybe<Scalars['JSONObject']['input']>;
  titlesI18n?: InputMaybe<Scalars['JSONObject']['input']>;
  twitterCardType?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
}

export interface UpdateAppConfigInput {
  key: Scalars['String']['input'];
  module: Scalars['String']['input'];
  /** Config value serialized as a JSON document */
  value: Scalars['String']['input'];
}

export interface UpdateChatSessionInput {
  /** The workspace id of the session */
  docId?: InputMaybe<Scalars['String']['input']>;
  /** Model of this session's agent */
  model?: InputMaybe<Scalars['String']['input']>;
  /** Whether to pin the session */
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  /** The prompt name to use for the session */
  promptName?: InputMaybe<Scalars['String']['input']>;
  /** Thinking depth of this session's agent */
  reasoningMode?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['String']['input'];
  /** Session title (auto-generated or user-renamed) */
  title?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
}

/** sl-tdgy.7: Update circuit breaker config for a workspace */
export interface UpdateCircuitBreakerConfigInput {
  cooldownMode?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  threshold?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface UpdateDocDefaultRoleInput {
  docId: Scalars['String']['input'];
  inheritFromFolder?: InputMaybe<Scalars['Boolean']['input']>;
  role: DocRole;
  workspaceId: Scalars['String']['input'];
}

export interface UpdateDocTitleInput {
  docId: Scalars['String']['input'];
  title: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface UpdateDocUserRoleInput {
  docId: Scalars['String']['input'];
  role: DocRole;
  userId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface UpdateFolderInput {
  folderId: Scalars['String']['input'];
  inheritPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
}

/** sl-k94y.8.1: Input for `updateLocaleSettings`. */
export interface UpdateLocaleSettingsInput {
  /** BCP-47 tags the deployment will accept on inbound writes (e.g. publish boundaries). */
  availableLocales: Array<Scalars['String']['input']>;
  /** Must be a member of `availableLocales`. Service rejects with 422 otherwise. */
  defaultLocale: Scalars['String']['input'];
}

export interface UpdateMailAccountInput {
  accountId: Scalars['String']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
  showInWorkspace?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<MailAccountStatus>;
  syncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface UpdateMailFolderInput {
  displayName?: InputMaybe<Scalars['String']['input']>;
  folderId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface UpdateMailMessageStateInput {
  isFlagged?: InputMaybe<Scalars['Boolean']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  isStarred?: InputMaybe<Scalars['Boolean']['input']>;
  messageId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface UpdateMailPolicyInput {
  mailWindowDays?: InputMaybe<Scalars['Int']['input']>;
  retentionDays?: InputMaybe<Scalars['Int']['input']>;
  retentionMode?: InputMaybe<MailRetentionMode>;
  searchIndexAttachmentsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  searchIndexEnabled?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface UpdateMateInput {
  description?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  memoryEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}

/** sl-sdk6.7.2: Input for setting a role permission override. */
export interface UpdateRolePermissionInput {
  /** true = grant, false = deny, null = reset to default */
  granted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Permission key (e.g. Workspace_PersonalMemory) */
  permission: Scalars['String']['input'];
  /** Role name: Reader, Editor, or Admin (Owner is not overridable) */
  role: Permission;
  workspaceId: Scalars['String']['input'];
}

export interface UpdateSkillInput {
  description?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  skillId: Scalars['String']['input'];
  toolNames?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceId: Scalars['String']['input'];
}

/** sl-kaqr.2.2: Input for updating tenant details */
export interface UpdateTenantInput {
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateUserInput {
  /** User name */
  name?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateUserSettingsInput {
  /** Enable AI-based relation matching in automations (sl-6kj) */
  aiRelationMatchingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Dismiss PDF search coverage coachmark */
  pdfSearchCoverageCoachmarkDismissed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Receive comment email */
  receiveCommentEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Receive invitation email */
  receiveInvitationEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Receive mention email */
  receiveMentionEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** IANA time zone of the user's device; a date-time without offset is that wall time in it */
  timeZone?: InputMaybe<Scalars['String']['input']>;
}

/**
 * Workspace-level downward override of plan step/workflow timeouts.
 * Both values are clamped server-side to the current plan cap, and
 * workflow timeout is clamped up to at least step timeout.
 */
export interface UpdateWorkflowLimitsInput {
  stepTimeoutMs: Scalars['Int']['input'];
  workflowTimeoutMs: Scalars['Int']['input'];
  workspaceId: Scalars['String']['input'];
}

export interface UpdateWorkspaceInput {
  /** sl-xm1c.2.1: Workspace-Admin Toggle for the AppBases feature */
  appBasesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** German decimal comma for workflow text inputs; false selects English decimal point. */
  automationDecimalComma?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable AI */
  enableAi?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable automatic Y.js document compaction (daily at 03:00 UTC) */
  enableAutoCompaction?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable Budget Limits enforcement for this workspace */
  enableBudgetLimits?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable doc embedding */
  enableDocEmbedding?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable workspace-wide knowledge graph */
  enableKnowledgeGraph?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable per-user AI personal memory */
  enablePersonalMemory?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable url previous when sharing */
  enableUrlPreview?: InputMaybe<Scalars['Boolean']['input']>;
  /** sl-9fmv.10.5: Opt in to insert/invoke experimental lifecycle node types */
  experimentalNodesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  /** Interactive Managed-AI access policy: all_members or selected_assignments */
  managedAIAccessMode?: InputMaybe<Scalars['String']['input']>;
  /** Whether Mates remember in this workspace */
  mateMemoryEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** How a turn of a personal Mate combines rights */
  matePersonalReadMode?: InputMaybe<MateRuleMode>;
  /** How a turn of a workspace Mate combines read rights */
  mateWorkspaceReadMode?: InputMaybe<MateRuleMode>;
  presenceDiscoveryEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** is Public workspace */
  public?: InputMaybe<Scalars['Boolean']['input']>;
}

/** sl-ddz8.7.2: Input for updating workspace memory configuration */
export interface UpdateWorkspaceMemoryConfigInput {
  alpha?: InputMaybe<Scalars['Float']['input']>;
  beta?: InputMaybe<Scalars['Float']['input']>;
  categories?: InputMaybe<Scalars['JSON']['input']>;
  decayHalfLife?: InputMaybe<Scalars['Int']['input']>;
  deletionPolicy?: InputMaybe<Scalars['String']['input']>;
  exclusionRules?: InputMaybe<Scalars['JSON']['input']>;
  extractionModel?: InputMaybe<Scalars['String']['input']>;
  gamma?: InputMaybe<Scalars['Float']['input']>;
}

/** sl-qsjm.5: Input for updating workspace 2FA policy */
export interface UpdateWorkspacePolicyInput {
  allowEmailOTP?: InputMaybe<Scalars['Boolean']['input']>;
  /** null clears the override, so the Apps follow offlineAccessTtlHours */
  appsOfflineAccessTtlHours?: InputMaybe<Scalars['Int']['input']>;
  gracePeriodDays?: InputMaybe<Scalars['Int']['input']>;
  offlineAccessTtlHours?: InputMaybe<Scalars['Int']['input']>;
  requireTOTP?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Input for updating workspace routing configuration */
export interface UpdateWorkspaceRoutingConfigInput {
  /** Enable budget-aware downgrade */
  budgetAwareDowngrade?: InputMaybe<Scalars['Boolean']['input']>;
  /** Routing mode: 'off' or 'auto' */
  routingMode?: InputMaybe<Scalars['String']['input']>;
}

export interface UpsertMailAutoresponderInput {
  accountId?: InputMaybe<Scalars['String']['input']>;
  bodyHtml?: InputMaybe<Scalars['String']['input']>;
  bodyText?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  signatureId?: InputMaybe<Scalars['String']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface UpsertMailRuleInput {
  accountId?: InputMaybe<Scalars['String']['input']>;
  actions: Scalars['JSONObject']['input'];
  conditions: Scalars['JSONObject']['input'];
  name: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  requestedEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  ruleId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
}

export interface UpsertMailSignatureInput {
  bodyHtml?: InputMaybe<Scalars['String']['input']>;
  bodyText?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  signatureId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
}

/** A Mate a member may pick */
export interface UsableMateGql {
  __typename?: 'UsableMateGql';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Only for whoever manages the Mate */
  instructions: Maybe<Scalars['String']['output']>;
  /** personal or workspace */
  kind: Scalars['String']['output'];
  markColor: Scalars['String']['output'];
  memoryEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  shareMemory: Scalars['Boolean']['output'];
}

/** E035.5: Doc grant info for a specific user */
export interface UserDocGrantType {
  __typename?: 'UserDocGrantType';
  areaBoundaryKind: Maybe<Scalars['String']['output']>;
  areaBoundaryRootFolderId: Maybe<Scalars['String']['output']>;
  areaBoundaryRootName: Maybe<Scalars['String']['output']>;
  docId: Scalars['String']['output'];
  isAreaBlocked: Scalars['Boolean']['output'];
  role: DocRole;
}

/** E035.5: Folder grant info for a specific user */
export interface UserFolderGrantType {
  __typename?: 'UserFolderGrantType';
  areaBoundaryKind: Maybe<Scalars['String']['output']>;
  areaBoundaryRootFolderId: Maybe<Scalars['String']['output']>;
  areaBoundaryRootName: Maybe<Scalars['String']['output']>;
  folderId: Scalars['String']['output'];
  isAreaBlocked: Scalars['Boolean']['output'];
  role: FolderRole;
}

/** sl-jsx3.11.5: Group membership */
export interface UserGroupMemberType {
  __typename?: 'UserGroupMemberType';
  groupId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  userId: Scalars['String']['output'];
}

/** sl-jsx3.11.5: User group for role-based access control */
export interface UserGroupType {
  __typename?: 'UserGroupType';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isAutoSync: Scalars['Boolean']['output'];
  memberWorkspaceRoles: Array<Permission>;
  name: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
}

export interface UserImportFailedType {
  __typename?: 'UserImportFailedType';
  email: Scalars['String']['output'];
  error: Scalars['String']['output'];
}

export type UserImportResultType = UserImportFailedType | UserType;

/** sl-pmcz.1.1: User AI Memory entry */
export interface UserMemory {
  __typename?: 'UserMemory';
  category: Scalars['String']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Effective importance after decay: importance * exp(-0.693 * age_days/30) */
  effectiveImportance: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  importance: Scalars['Int']['output'];
  pinned: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
}

/**
 * sl-hle4.16: Per-user notification preference merged with the trigger's
 * registry metadata. The dispatcher routes a trigger to the user only when
 * `enabled=true` AND the user is eligible per the trigger's required role
 * and plan (which the UI surfaces via `requiredRole` for hint copy).
 */
export interface UserNotificationPreferenceType {
  __typename?: 'UserNotificationPreferenceType';
  accountId: Scalars['String']['output'];
  category: Scalars['String']['output'];
  channelInApp: Scalars['Boolean']['output'];
  channelMail: Scalars['Boolean']['output'];
  channelWebPush: Scalars['Boolean']['output'];
  defaultThresholds: Array<Scalars['Int']['output']>;
  descriptionI18nKey: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  folderKey: Scalars['String']['output'];
  i18nKey: Scalars['String']['output'];
  quietHours: Maybe<Scalars['JSONObject']['output']>;
  requiredRole: Scalars['String']['output'];
  /** True when the user has explicitly stored a row; false means values come from trigger defaults. */
  stored: Scalars['Boolean']['output'];
  supportsInApp: Scalars['Boolean']['output'];
  supportsMail: Scalars['Boolean']['output'];
  supportsWebPush: Scalars['Boolean']['output'];
  thresholds: Array<Scalars['Int']['output']>;
  triggerType: Scalars['String']['output'];
}

export type UserOrLimitedUser = LimitedUserType | UserType;

export interface UserQuotaHumanReadableType {
  __typename?: 'UserQuotaHumanReadableType';
  blobLimit: Scalars['String']['output'];
  historyPeriod: Scalars['String']['output'];
  memberLimit: Scalars['String']['output'];
  name: Scalars['String']['output'];
  storageQuota: Scalars['String']['output'];
  usedStorageQuota: Scalars['String']['output'];
}

export interface UserQuotaType {
  __typename?: 'UserQuotaType';
  blobLimit: Scalars['SafeInt']['output'];
  historyPeriod: Scalars['SafeInt']['output'];
  humanReadable: UserQuotaHumanReadableType;
  memberLimit: Scalars['SafeInt']['output'];
  name: Scalars['String']['output'];
  storageQuota: Scalars['SafeInt']['output'];
  usedStorageQuota: Scalars['SafeInt']['output'];
}

export interface UserQuotaUsageType {
  __typename?: 'UserQuotaUsageType';
  /** @deprecated use `UserQuotaType['usedStorageQuota']` instead */
  storageQuota: Scalars['SafeInt']['output'];
}

export interface UserSettingsType {
  __typename?: 'UserSettingsType';
  /** Enable AI-based relation matching in automations (sl-6kj) */
  aiRelationMatchingEnabled: Scalars['Boolean']['output'];
  /** Dismiss PDF search coverage coachmark */
  pdfSearchCoverageCoachmarkDismissed: Scalars['Boolean']['output'];
  /** Receive comment email */
  receiveCommentEmail: Scalars['Boolean']['output'];
  /** Receive invitation email */
  receiveInvitationEmail: Scalars['Boolean']['output'];
  /** Receive mention email */
  receiveMentionEmail: Scalars['Boolean']['output'];
  /** IANA time zone of the user's device; null until the app reported one */
  timeZone: Maybe<Scalars['String']['output']>;
}

export interface UserType {
  __typename?: 'UserType';
  /** User avatar url */
  avatarUrl: Maybe<Scalars['String']['output']>;
  copilot: Copilot;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** User current plan */
  currentPlan: Maybe<Scalars['String']['output']>;
  /** User is disabled */
  disabled: Scalars['Boolean']['output'];
  /** User email */
  email: Scalars['String']['output'];
  /** User email verified */
  emailVerified: Scalars['Boolean']['output'];
  /** Enabled features of a user */
  features: Array<FeatureType>;
  /** User password has been set */
  hasPassword: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Last active timestamp */
  lastActiveAt: Maybe<Scalars['DateTime']['output']>;
  /** sl-dkgt.3: Number of workspace memberships */
  memberWorkspaceCount: Maybe<Scalars['Int']['output']>;
  /** User name */
  name: Scalars['String']['output'];
  /** Get user notification count */
  notificationCount: Scalars['Int']['output'];
  /** Get current user notifications */
  notifications: PaginatedNotificationObjectType;
  /** sl-dkgt.3: Number of workspaces owned by this user */
  ownedWorkspaceCount: Maybe<Scalars['Int']['output']>;
  quota: UserQuotaType;
  quotaUsage: UserQuotaUsageType;
  /** Get user settings */
  settings: UserSettingsType;
  subscriptions: Array<SubscriptionType>;
  /** @deprecated use [/api/auth/sign-in?native=true] instead */
  token: TokenType;
  /** Whether user has TOTP 2FA enabled */
  totpEnabled: Scalars['Boolean']['output'];
}

export interface UserTypeCopilotArgs {
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}

export interface UserTypeNotificationsArgs {
  pagination: PaginationInput;
}

export interface ValidationErrorDataType {
  __typename?: 'ValidationErrorDataType';
  errors: Scalars['String']['output'];
}

export interface VersionRejectedDataType {
  __typename?: 'VersionRejectedDataType';
  serverVersion: Scalars['String']['output'];
  version: Scalars['String']['output'];
}

export interface WebhookHealthType {
  __typename?: 'WebhookHealthType';
  lastErrorAt: Maybe<Scalars['String']['output']>;
  lastErrorMessage: Maybe<Scalars['String']['output']>;
  lastEventAt: Maybe<Scalars['String']['output']>;
  lastEventType: Maybe<Scalars['String']['output']>;
  totalErrors: Scalars['Int']['output'];
  totalEventsReceived: Scalars['Int']['output'];
}

/** sl-tdgy.5: Workflow execution plan limits + live concurrency */
export interface WorkflowLimitsType {
  __typename?: 'WorkflowLimitsType';
  /** Cooldown mode: manual, 1h, 6h, 24h */
  circuitBreakerCooldownMode: Scalars['String']['output'];
  /** Circuit breaker enabled for this workspace */
  circuitBreakerEnabled: Scalars['Boolean']['output'];
  /** Consecutive failures before auto-disable (3-10) */
  circuitBreakerThreshold: Scalars['Int']['output'];
  /** Current concurrent workflow executions */
  concurrentCurrent: Scalars['Int']['output'];
  /** Max concurrent workflow executions */
  maxConcurrentWorkflows: Scalars['Int']['output'];
  /** Max duration per step (milliseconds) */
  maxStepDurationMs: Scalars['Int']['output'];
  /** Max steps per workflow definition */
  maxStepsPerWorkflow: Scalars['Int']['output'];
  /** Max total workflow duration (milliseconds) */
  maxWorkflowDurationMs: Scalars['Int']['output'];
  /** Plan ceiling for per-step duration (slider upper bound) */
  planMaxStepDurationMs: Scalars['Int']['output'];
  /** Plan ceiling for workflow duration (slider upper bound) */
  planMaxWorkflowDurationMs: Scalars['Int']['output'];
  /** sl-38sb.2.1: Average queue wait time in ms (last 24h) */
  queueAvgWaitMs: Scalars['Float']['output'];
  /** sl-38sb.2.1: Rejected execution count in last 24h */
  queueRejectCount24h: Scalars['Int']['output'];
  /** sl-38sb.2.1: Number of queue wait time samples (last 24h) */
  queueWaitSamples: Scalars['Int']['output'];
}

/** sl-7q0s.5.1: Single workflow usage entry */
export interface WorkflowUsageEntryType {
  __typename?: 'WorkflowUsageEntryType';
  credits: Scalars['Float']['output'];
  executions: Scalars['Int']['output'];
  workflowId: Scalars['String']['output'];
}

/** sl-7q0s.5.1: Workflow usage summary for a workspace */
export interface WorkflowUsageSummaryType {
  __typename?: 'WorkflowUsageSummaryType';
  /** Total credits consumed by workflows */
  creditsUsed: Scalars['Float']['output'];
  /** Number of workflow executions */
  executionCount: Scalars['Int']['output'];
  /** Total workflow minutes used this month */
  minutesUsed: Scalars['Float']['output'];
  /** Top workflows by credit consumption */
  topWorkflows: Array<WorkflowUsageEntryType>;
}

/** sl-wmbt.4.1: Unified workspace audit event */
export interface WorkspaceAuditEventType {
  __typename?: 'WorkspaceAuditEventType';
  action: Scalars['String']['output'];
  category: AuditEventCategory;
  createdAt: Scalars['DateTime']['output'];
  details: Maybe<Scalars['JSONObject']['output']>;
  id: Scalars['String']['output'];
  ipAddress: Maybe<Scalars['String']['output']>;
  targetId: Maybe<Scalars['String']['output']>;
  targetName: Maybe<Scalars['String']['output']>;
  targetType: Maybe<Scalars['String']['output']>;
  userAvatarUrl: Maybe<Scalars['String']['output']>;
  userEmail: Maybe<Scalars['String']['output']>;
  userId: Maybe<Scalars['String']['output']>;
  userName: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
}

export interface WorkspaceBillingStateType {
  __typename?: 'WorkspaceBillingStateType';
  /** Active admin entitlement grant, if any. */
  adminOverride: Maybe<WorkspacePlanOverrideType>;
  /** Real billing subscription. Never represents an admin override. */
  billingSubscription: Maybe<SubscriptionType>;
  /** Effective access plan used for feature gates and quotas. */
  effectivePlan: Scalars['String']['output'];
  /** Plan that applies after the admin override expires or is cleared. */
  fallbackPlanAfterOverride: Scalars['String']['output'];
}

export interface WorkspaceBlobSizes {
  __typename?: 'WorkspaceBlobSizes';
  size: Scalars['SafeInt']['output'];
}

/** sl-t828.1: Workspace creation quota — can the user create more workspaces? */
export interface WorkspaceCreationQuotaType {
  __typename?: 'WorkspaceCreationQuotaType';
  /** Whether the user can create another workspace */
  canCreate: Scalars['Boolean']['output'];
  /** Maximum workspaces allowed by the plan (-1 = unlimited) */
  limit: Scalars['Int']['output'];
  /** Number of workspaces owned by this user */
  ownedCount: Scalars['Int']['output'];
  /** Current plan name */
  plan: Scalars['String']['output'];
  /** Whether a published plan with higher workspace limit exists (for upsell) */
  upgradeAvailable: Scalars['Boolean']['output'];
}

/** Active credit pack subscription for a workspace. */
export interface WorkspaceCreditSubscriptionType {
  __typename?: 'WorkspaceCreditSubscriptionType';
  /** sl-dl66.3.3: Current billing interval from Stripe ('month' or 'year') */
  billingInterval: Maybe<Scalars['String']['output']>;
  cancelAtPeriodEnd: Scalars['Boolean']['output'];
  creditPackId: Scalars['String']['output'];
  creditPackName: Scalars['String']['output'];
  credits: Scalars['Int']['output'];
  currentPeriodEnd: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  status: CreditSubscriptionStatus;
}

export interface WorkspaceDocMeta {
  __typename?: 'WorkspaceDocMeta';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Maybe<EditorType>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Maybe<EditorType>;
}

/** E040: Input for workspace doc sizes query */
export interface WorkspaceDocSizesInput {
  workspaceId: Scalars['String']['input'];
}

/** sl-sdk6.6.3: Complete workspace graph data for the Graph Explorer */
export interface WorkspaceGraphData {
  __typename?: 'WorkspaceGraphData';
  edges: Array<GraphEdgeGql>;
  nodes: Array<GraphNodeGql>;
  /** Graph Explorer visual sweep interval in ms; not a backend indexing debounce. */
  sweepPeriodMs: Scalars['Int']['output'];
}

/** Workspace invite link expire time */
export enum WorkspaceInviteLinkExpireTime {
  OneDay = 'OneDay',
  OneWeek = 'OneWeek',
  ThreeDays = 'ThreeDays',
}

/** One-time workspace MCP grant reveal payload */
export interface WorkspaceMcpGrantReveal {
  __typename?: 'WorkspaceMcpGrantReveal';
  config: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Maybe<Scalars['DateTime']['output']>;
  tokenId: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
}

/** Outcome of granting MCP access to the current members of a group */
export interface WorkspaceMcpGroupGrantResult {
  __typename?: 'WorkspaceMcpGroupGrantResult';
  /** Members whose grant failed */
  failed: Scalars['Int']['output'];
  /** Members who received a new MCP access */
  granted: Scalars['Int']['output'];
  /** Members skipped because they already hold a personal MCP access */
  skipped: Scalars['Int']['output'];
}

/** sl-xk37: Workspace-scoped MCP token info (masked) */
export interface WorkspaceMcpToken {
  __typename?: 'WorkspaceMcpToken';
  /** The app connected through this access; null for a personal MCP token. */
  connectedApp: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  createdByName: Maybe<Scalars['String']['output']>;
  expiresAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  maskedToken: Scalars['String']['output'];
  toolPolicy: WorkspaceMcpToolPolicy;
  userEmail: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  userName: Maybe<Scalars['String']['output']>;
  userRole: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
}

/** sl-xk37: MCP token with config for clipboard copy */
export interface WorkspaceMcpTokenWithConfig {
  __typename?: 'WorkspaceMcpTokenWithConfig';
  config: Scalars['String']['output'];
  token: WorkspaceMcpToken;
}

/** Deny-only MCP tool policy stored on a single workspace MCP token. */
export interface WorkspaceMcpToolPolicy {
  __typename?: 'WorkspaceMcpToolPolicy';
  disabledCategories: Array<Scalars['String']['output']>;
  disabledTools: Array<Scalars['String']['output']>;
}

/** Deny-only MCP tool policy input for a single workspace MCP token. */
export interface WorkspaceMcpToolPolicyInput {
  disabledCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  disabledTools?: InputMaybe<Array<Scalars['String']['input']>>;
}

/** Member invite status in workspace */
export enum WorkspaceMemberStatus {
  Accepted = 'Accepted',
  AllocatingSeat = 'AllocatingSeat',
  NeedMoreSeat = 'NeedMoreSeat',
  NeedMoreSeatAndReview = 'NeedMoreSeatAndReview',
  Pending = 'Pending',
  UnderReview = 'UnderReview',
}

export enum WorkspaceMembershipKind {
  external_guests = 'external_guests',
  house_guests = 'house_guests',
  member = 'member',
}

/** sl-ddz8.7.2: Workspace memory configuration */
export interface WorkspaceMemoryConfigGql {
  __typename?: 'WorkspaceMemoryConfigGql';
  alpha: Scalars['Float']['output'];
  beta: Scalars['Float']['output'];
  categories: Scalars['JSON']['output'];
  decayHalfLife: Scalars['Int']['output'];
  deletionPolicy: Scalars['String']['output'];
  exclusionRules: Scalars['JSON']['output'];
  extractionModel: Maybe<Scalars['String']['output']>;
  gamma: Scalars['Float']['output'];
  workspaceId: Scalars['String']['output'];
}

export interface WorkspacePermissionNotFoundDataType {
  __typename?: 'WorkspacePermissionNotFoundDataType';
  spaceId: Scalars['String']['output'];
}

export interface WorkspacePermissions {
  __typename?: 'WorkspacePermissions';
  Workspace_Administrators_Manage: Scalars['Boolean']['output'];
  Workspace_AppBases_Create: Scalars['Boolean']['output'];
  Workspace_AppBases_Delete: Scalars['Boolean']['output'];
  Workspace_AppBases_Edit: Scalars['Boolean']['output'];
  Workspace_AppBases_Import: Scalars['Boolean']['output'];
  Workspace_AppBases_Publish: Scalars['Boolean']['output'];
  Workspace_AppBases_View: Scalars['Boolean']['output'];
  Workspace_Automation: Scalars['Boolean']['output'];
  Workspace_Automation_Create: Scalars['Boolean']['output'];
  Workspace_Automation_Delete: Scalars['Boolean']['output'];
  Workspace_Automation_Edit: Scalars['Boolean']['output'];
  Workspace_Automation_Execute: Scalars['Boolean']['output'];
  Workspace_Automation_View: Scalars['Boolean']['output'];
  Workspace_Blobs_List: Scalars['Boolean']['output'];
  Workspace_Blobs_Read: Scalars['Boolean']['output'];
  Workspace_Blobs_Write: Scalars['Boolean']['output'];
  Workspace_Copilot: Scalars['Boolean']['output'];
  Workspace_CreateDoc: Scalars['Boolean']['output'];
  Workspace_Delete: Scalars['Boolean']['output'];
  Workspace_ExpertBots: Scalars['Boolean']['output'];
  Workspace_KnowledgeGraph: Scalars['Boolean']['output'];
  Workspace_Organize_Read: Scalars['Boolean']['output'];
  Workspace_Payment_Manage: Scalars['Boolean']['output'];
  Workspace_PersonalMemory: Scalars['Boolean']['output'];
  Workspace_Properties_Create: Scalars['Boolean']['output'];
  Workspace_Properties_Delete: Scalars['Boolean']['output'];
  Workspace_Properties_Read: Scalars['Boolean']['output'];
  Workspace_Properties_Update: Scalars['Boolean']['output'];
  Workspace_Read: Scalars['Boolean']['output'];
  Workspace_Settings_Read: Scalars['Boolean']['output'];
  Workspace_Settings_Update: Scalars['Boolean']['output'];
  Workspace_Sync: Scalars['Boolean']['output'];
  Workspace_TransferOwner: Scalars['Boolean']['output'];
  Workspace_Users_Manage: Scalars['Boolean']['output'];
  Workspace_Users_Read: Scalars['Boolean']['output'];
  Workspace_Workflow_Manage: Scalars['Boolean']['output'];
}

export interface WorkspacePlanOverrideType {
  __typename?: 'WorkspacePlanOverrideType';
  expiresAt: Maybe<Scalars['DateTime']['output']>;
  plan: Scalars['String']['output'];
}

/** sl-qsjm.5: Workspace 2FA enforcement policy */
export interface WorkspacePolicyType {
  __typename?: 'WorkspacePolicyType';
  allowEmailOTP: Scalars['Boolean']['output'];
  /** Offline access window in hours (1..672) of the workspace's Apps; null = offlineAccessTtlHours */
  appsOfflineAccessTtlHours: Maybe<Scalars['Int']['output']>;
  enforcedAt: Maybe<Scalars['DateTime']['output']>;
  /** sl-d6mh.2.3: Computed — true if enforcedAt is in the future (grace period running) */
  gracePeriodActive: Scalars['Boolean']['output'];
  gracePeriodDays: Scalars['Int']['output'];
  /** sl-d6mh.2.3: Computed — days remaining until enforcement, null if not in grace period */
  gracePeriodRemainingDays: Maybe<Scalars['Int']['output']>;
  /** Offline access window in hours (1..672) for signed local permission grants */
  offlineAccessTtlHours: Scalars['Int']['output'];
  requireTOTP: Scalars['Boolean']['output'];
}

/** sl-zvjz: Owned workspace summary for the deletion-modal preview. */
export interface WorkspacePreview {
  __typename?: 'WorkspacePreview';
  id: Scalars['String']['output'];
  memberCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
}

/** sl-ya4v.5: Workspace public-host snapshot (default + branded + custom + effective). Returned only for workspaces on Pro+; Free returns null at the WorkspaceType.publicHost field. */
export interface WorkspacePublicHostType {
  __typename?: 'WorkspacePublicHostType';
  /** Active branded subdomain, or null when not registered (Pro+) */
  brandedHost: Maybe<Scalars['String']['output']>;
  /** sl-ya4v.8: Full URL for brandedHost, or null. */
  brandedUrl: Maybe<Scalars['String']['output']>;
  /** Active CNAME-verified custom domain, or null (Enterprise+) */
  customDomain: Maybe<Scalars['String']['output']>;
  /** sl-ya4v.8: Full URL for customDomain, or null. */
  customDomainUrl: Maybe<Scalars['String']['output']>;
  /** Always present: <shortId>.streamlain.site */
  defaultHost: Scalars['String']['output'];
  /** sl-ya4v.8: Full URL for defaultHost. Frontend MUST use this — never concat. */
  defaultUrl: Scalars['String']['output'];
  /** Effective host: customDomain > brandedHost > defaultHost */
  effectiveHost: Scalars['String']['output'];
  /** sl-ya4v.8: Full URL for effectiveHost. Frontend MUST use this — never concat. */
  effectiveUrl: Scalars['String']['output'];
}

export interface WorkspaceQuotaHumanReadableType {
  __typename?: 'WorkspaceQuotaHumanReadableType';
  automationCount: Scalars['String']['output'];
  blobLimit: Scalars['String']['output'];
  historyPeriod: Scalars['String']['output'];
  memberCount: Scalars['String']['output'];
  memberLimit: Scalars['String']['output'];
  name: Scalars['String']['output'];
  overcapacityMemberCount: Scalars['String']['output'];
  storageQuota: Scalars['String']['output'];
  storageQuotaUsed: Scalars['String']['output'];
}

export interface WorkspaceQuotaType {
  __typename?: 'WorkspaceQuotaType';
  /** Number of active automations in this workspace */
  automationCount: Scalars['Int']['output'];
  blobLimit: Scalars['SafeInt']['output'];
  externalAccessPerDocLimit: Scalars['SafeInt']['output'];
  /** Number of active (non-expired) guests in this workspace */
  guestCount: Scalars['Int']['output'];
  /** Default TTL in hours for new guest invitations */
  guestDefaultTtlHours: Scalars['Int']['output'];
  /** Maximum guest count allowed by the plan (0=disabled, -1=unlimited) */
  guestLimit: Scalars['SafeInt']['output'];
  /** Maximum TTL in hours allowed by the plan */
  guestMaxTtlHours: Scalars['Int']['output'];
  /** Minimum TTL in hours allowed by the plan */
  guestMinTtlHours: Scalars['Int']['output'];
  historyPeriod: Scalars['SafeInt']['output'];
  humanReadable: WorkspaceQuotaHumanReadableType;
  memberCount: Scalars['Int']['output'];
  memberLimit: Scalars['SafeInt']['output'];
  name: Scalars['String']['output'];
  overcapacityMemberCount: Scalars['Int']['output'];
  storageQuota: Scalars['SafeInt']['output'];
  /** Batch transcription limits of the plan (Admin › Plans) */
  sttBatch: WorkspaceSttBatchQuotaType;
  /** Whether tus resumable uploads are enabled (for large file support) */
  tusUploadEnabled: Scalars['Boolean']['output'];
  /** tus upload endpoint path (only relevant when tusUploadEnabled is true) */
  tusUploadPath: Maybe<Scalars['String']['output']>;
  /** @deprecated use `usedStorageQuota` instead */
  usedSize: Scalars['SafeInt']['output'];
  usedStorageQuota: Scalars['SafeInt']['output'];
}

/** Default permission values for one workspace role. */
export interface WorkspaceRolePermissionDefaults {
  __typename?: 'WorkspaceRolePermissionDefaults';
  permissions: Scalars['JSONObject']['output'];
  role: Permission;
}

/** A configurable workspace role permission surfaced in the roles matrix. */
export interface WorkspaceRolePermissionDefinition {
  __typename?: 'WorkspaceRolePermissionDefinition';
  category: Scalars['String']['output'];
  featureKey: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
}

/** Source-of-truth role permission matrix for Workspace Settings. */
export interface WorkspaceRolePermissionMatrix {
  __typename?: 'WorkspaceRolePermissionMatrix';
  defaults: Array<WorkspaceRolePermissionDefaults>;
  definitions: Array<WorkspaceRolePermissionDefinition>;
  overrides: Array<WorkspaceRolePermissionOverride>;
  ownerRole: Permission;
  roles: Array<Permission>;
}

/** sl-sdk6.7.2: A single permission override for a role in a workspace. */
export interface WorkspaceRolePermissionOverride {
  __typename?: 'WorkspaceRolePermissionOverride';
  granted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  permission: Scalars['String']['output'];
  role: Permission;
  workspaceId: Scalars['String']['output'];
}

export interface WorkspaceRolePermissions {
  __typename?: 'WorkspaceRolePermissions';
  permissions: WorkspacePermissions;
  role: Permission;
}

/** Workspace-level model routing configuration */
export interface WorkspaceRoutingConfigType {
  __typename?: 'WorkspaceRoutingConfigType';
  /** Whether to downgrade to cheaper model when budget is tight */
  budgetAwareDowngrade: Scalars['Boolean']['output'];
  /** Current routing mode: 'off' or 'auto' */
  routingMode: Scalars['String']['output'];
}

/** sl-67kc.3.4: Workspace-wide aggregator chip data for parked LROs. */
export interface WorkspaceRunningOperationType {
  __typename?: 'WorkspaceRunningOperationType';
  /** AutomationConfig id (workflow runtime ownership). */
  automationConfigId: Scalars['String']['output'];
  /** Title of the AutomationConfig. Null when the user never set one — frontend renders an i18n placeholder; the backend never invents a title. */
  automationTitle: Maybe<Scalars['String']['output']>;
  /** BlockId hosting the automation, used for History-panel scroll. */
  blockId: Scalars['String']['output'];
  /** Doc the automation lives in. Frontend uses this for navigation. */
  docId: Scalars['String']['output'];
  /** Doc title. Null when the doc has no title yet — same rationale as `automationTitle`. */
  docTitle: Maybe<Scalars['String']['output']>;
  /** AutomationExecutionLog id, deep-link target. */
  executionLogId: Scalars['String']['output'];
  /** When the 25h provider ceiling forces a 'timeout'. */
  expiresAt: Scalars['DateTime']['output'];
  /** Provider-friendly job id — passes through to /api/stt/jobs/:jobId. */
  jobId: Scalars['String']['output'];
  /** Operation discriminator — 'stt' today; future: 'video-transcode', 'bulk-ai'. */
  kind: TranscriptionJobKind;
  /** 'pending' (Google LRO outstanding) | 'resuming' (resume in flight). */
  status: TranscriptionJobStatus;
  /** When the row entered 'pending'. */
  submittedAt: Scalars['DateTime']['output'];
  /** SuspendedExecution PK — stable handle for cancel/retry actions. */
  suspendedExecutionId: Scalars['String']['output'];
  /** Workflow execution that is parked (1:N suspensions per execution). */
  workflowExecutionId: Scalars['String']['output'];
}

export interface WorkspaceSearchInput {
  cursor?: InputMaybe<Scalars['String']['input']>;
  includeTechnicalSources?: InputMaybe<Scalars['Boolean']['input']>;
  keyword: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  sourceKinds?: InputMaybe<Array<WorkspaceSearchSourceKind>>;
}

export interface WorkspaceSearchMailAttachmentHit {
  __typename?: 'WorkspaceSearchMailAttachmentHit';
  coverageStatus: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  pageIndex: Maybe<Scalars['Int']['output']>;
  snippet: Maybe<Scalars['String']['output']>;
  source: WorkspaceSearchMailAttachmentHitSource;
}

export enum WorkspaceSearchMailAttachmentHitSource {
  filename = 'filename',
  pdf_ocr = 'pdf_ocr',
}

export interface WorkspaceSearchOpenTarget {
  __typename?: 'WorkspaceSearchOpenTarget';
  kind: WorkspaceSearchOpenTargetKind;
  mailAccountId: Maybe<Scalars['String']['output']>;
  mailFolderId: Maybe<Scalars['String']['output']>;
  mailMessageId: Maybe<Scalars['String']['output']>;
  route: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
}

export enum WorkspaceSearchOpenTargetKind {
  mail_message = 'mail_message',
}

export interface WorkspaceSearchResult {
  __typename?: 'WorkspaceSearchResult';
  attachmentHits: Array<WorkspaceSearchMailAttachmentHit>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  kind: WorkspaceSearchSourceKind;
  mailAccountId: Maybe<Scalars['String']['output']>;
  mailFolderId: Maybe<Scalars['String']['output']>;
  mailFrom: Maybe<Scalars['String']['output']>;
  mailMessageId: Maybe<Scalars['String']['output']>;
  mailSubject: Maybe<Scalars['String']['output']>;
  mailTo: Array<Scalars['String']['output']>;
  openTarget: WorkspaceSearchOpenTarget;
  receivedAt: Maybe<Scalars['DateTime']['output']>;
  score: Scalars['Float']['output'];
  snippet: Maybe<Scalars['String']['output']>;
  subtitle: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  visibility: WorkspaceSearchResultVisibility;
}

export enum WorkspaceSearchResultVisibility {
  semantic = 'semantic',
  technical = 'technical',
}

export enum WorkspaceSearchSourceKind {
  mail_message = 'mail_message',
  technical_mail_source = 'technical_mail_source',
}

export enum WorkspaceSearchTechnicalSourceKind {
  mail_storage = 'mail_storage',
}

/** sl-apue: Current seat addon status for a workspace */
export interface WorkspaceSeatAddonType {
  __typename?: 'WorkspaceSeatAddonType';
  /** Next billing date */
  nextBillingDate: Maybe<Scalars['DateTime']['output']>;
  /** sl-7vu4: Monthly graduated pricing tiers as JSON string */
  pricingTiersMonthly: Maybe<Scalars['String']['output']>;
  /** sl-7vu4: Yearly graduated pricing tiers as JSON string */
  pricingTiersYearly: Maybe<Scalars['String']['output']>;
  /** Number of extra seats purchased */
  quantity: Scalars['Int']['output'];
  /** sl-dl66: The addon's actual Stripe billing interval (Yearly or Monthly) */
  recurring: Maybe<Scalars['String']['output']>;
  /** Addon status: active, canceled, past_due */
  status: SeatAddonStatus;
  /** Total monthly cost in cents (graduated calculation across all tiers) */
  totalMonthly: Maybe<Scalars['Int']['output']>;
  /** Total yearly cost in cents (graduated calculation across all tiers) */
  totalYearly: Maybe<Scalars['Int']['output']>;
}

/** sl-wqvr.2.5: Cached per-workspace storage usage (recalculated periodically from S3) */
export interface WorkspaceStorageUsageType {
  __typename?: 'WorkspaceStorageUsageType';
  /** Number of blobs stored */
  blobCount: Scalars['Int']['output'];
  /** When usage was last recalculated */
  calculatedAt: Scalars['DateTime']['output'];
  /** Storage limit from plan in bytes */
  storageLimit: Scalars['SafeInt']['output'];
  /** Total storage used in bytes */
  totalBytes: Scalars['SafeInt']['output'];
  /** Usage as percentage of limit (0-100+) */
  usagePercent: Scalars['Float']['output'];
}

export interface WorkspaceSttBatchQuotaType {
  __typename?: 'WorkspaceSttBatchQuotaType';
  /** Largest batch transcription file in MiB (0 = not on this plan) */
  maxMib: Scalars['Int']['output'];
  /** Longest batch transcription in minutes */
  maxMinutes: Scalars['Int']['output'];
  /** Largest batch file of the upgrade plan in MiB */
  upgradeMaxMib: Maybe<Scalars['Int']['output']>;
  /** Lowest published plan above this one with larger batch files */
  upgradePlan: Maybe<Scalars['String']['output']>;
}

/** sl-xbxb: Workspace-level tag definition */
export interface WorkspaceTagType {
  __typename?: 'WorkspaceTagType';
  color: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  workspaceId: Scalars['String']['output'];
}

export interface WorkspaceType {
  __typename?: 'WorkspaceType';
  /** Search a specific table with aggregate */
  aggregate: AggregateResultObjectType;
  /** sl-9qm.1.4: AppBases in this workspace */
  appBases: Array<AppBaseType>;
  /** sl-xm1c.2.1: Workspace-Admin Toggle for the AppBases feature */
  appBasesEnabled: Scalars['Boolean']['output'];
  /** Workspace-wide number format for automation text inputs. */
  automationDecimalComma: Scalars['Boolean']['output'];
  /** Workspace avatar blob key/url. Safe for authenticated workspace members. */
  avatarUrl: Maybe<Scalars['String']['output']>;
  /** Effective access plan plus real billing subscription, separated. */
  billingState: WorkspaceBillingStateType;
  /** List blobs of workspace */
  blobs: Array<ListedBlob>;
  /** Blobs size of workspace */
  blobsSize: Scalars['Int']['output'];
  /** Get comment changes of a doc */
  commentChanges: PaginatedCommentChangeObjectType;
  /** Get comments of a doc */
  comments: PaginatedCommentObjectType;
  /** Workspace created date */
  createdAt: Scalars['DateTime']['output'];
  /** sl-j66d: Check which folder IDs have been permanently deleted (tombstone query for reconcile) */
  deletedFolderIds: Array<Scalars['String']['output']>;
  /** When this workspace is scheduled for deletion during the grace period */
  deletionScheduledAt: Maybe<Scalars['DateTime']['output']>;
  /** Get doc with given id. Null when the doc is not server-confirmed yet or the user has no access. */
  doc: Maybe<DocType>;
  docs: PaginatedDocType;
  embedding: CopilotWorkspaceConfig;
  /** Enable AI */
  enableAi: Scalars['Boolean']['output'];
  /** Enable automatic Y.js document compaction (daily at 03:00 UTC) */
  enableAutoCompaction: Scalars['Boolean']['output'];
  /** Enable Budget Limits enforcement for this workspace */
  enableBudgetLimits: Scalars['Boolean']['output'];
  /** Enable doc embedding */
  enableDocEmbedding: Scalars['Boolean']['output'];
  /** Enable workspace-wide knowledge graph */
  enableKnowledgeGraph: Scalars['Boolean']['output'];
  /** Enable per-user AI personal memory */
  enablePersonalMemory: Scalars['Boolean']['output'];
  /** Enable url previous when sharing */
  enableUrlPreview: Scalars['Boolean']['output'];
  /** sl-9fmv.10.5: Opt in to insert/invoke experimental lifecycle node types */
  experimentalNodesEnabled: Scalars['Boolean']['output'];
  /** Get a specific folder */
  folder: Maybe<FolderType>;
  /** Get folders (optionally filtered by parent) */
  folders: Array<FolderType>;
  /** Number of active (non-expired) guests in workspace */
  guestCount: Scalars['Int']['output'];
  /** Check if a document or concrete block has indexed search content */
  hasDocEmbeddings: Scalars['Boolean']['output'];
  histories: Array<DocHistoryType>;
  id: Scalars['ID']['output'];
  /** Get all doc IDs that have embeddings in the workspace (sl-amc0.14) */
  indexedDocIds: Array<Scalars['String']['output']>;
  /** is current workspace initialized */
  initialized: Scalars['Boolean']['output'];
  /** invite link for workspace */
  inviteLink: Maybe<InviteLink>;
  /** Get user invoice count */
  invoiceCount: Scalars['Int']['output'];
  invoices: Array<InvoiceType>;
  /** Diagnose mail search/index coverage for the current user. */
  mailSearchDiagnostics: MailSearchDiagnostics;
  /** Interactive Managed-AI access policy: all_members or selected_assignments */
  managedAIAccessMode: Scalars['String']['output'];
  /** Whether Mates remember in this workspace */
  mateMemoryEnabled: Scalars['Boolean']['output'];
  /** How a turn of a personal Mate combines rights */
  matePersonalReadMode: MateRuleMode;
  /** How a turn of a workspace Mate combines read rights */
  mateWorkspaceReadMode: MateRuleMode;
  /** member count of workspace */
  memberCount: Scalars['Int']['output'];
  /** Members of workspace */
  members: Array<InviteUserType>;
  /** Membership kind of the current signed in user in this workspace */
  membershipKind: WorkspaceMembershipKind;
  /** Get all folders the current user can access (flat list, permission-filtered) */
  myAccessibleFolders: Array<FolderType>;
  /** Workspace display name. Safe for authenticated workspace members. */
  name: Scalars['String']['output'];
  /** sl-tdgy.5: Per-operation rate limits and current usage */
  operationLimits: Array<OperationLimitType>;
  /** Owner of workspace */
  owner: UserType;
  /**
   * Cloud page metadata of workspace
   * @deprecated use [WorkspaceType.doc] instead
   */
  pageMeta: WorkspaceDocMeta;
  /** Search PDF attachment pages by keyword */
  pdfSearch: Array<PdfSearchHitObjectType>;
  /** Count of pending decisions */
  pendingDecisionCount: Scalars['Int']['output'];
  /** Pending decisions for manual relation resolution */
  pendingDecisions: Array<PendingDecisionType>;
  /** map of action permissions */
  permissions: WorkspacePermissions;
  /** sl-jmyl.3: Current presence — which users are viewing which docs */
  presence: Array<PresenceDocEntry>;
  presenceDiscoveryEnabled: Scalars['Boolean']['output'];
  /** is Public workspace */
  public: Scalars['Boolean']['output'];
  /** Get public docs of a workspace */
  publicDocs: Array<DocType>;
  /** sl-ya4v.5 + sl-ya4v.12: Public-host snapshot (default + branded + custom + effective). Null for Free-tier workspaces. */
  publicHost: Maybe<WorkspacePublicHostType>;
  /**
   * Get public page of a workspace by page id.
   * @deprecated use [WorkspaceType.doc] instead
   */
  publicPage: Maybe<DocType>;
  /** @deprecated use [WorkspaceType.publicDocs] instead */
  publicPages: Array<DocType>;
  /** quota of workspace */
  quota: WorkspaceQuotaType;
  /** Get recently updated docs of a workspace */
  recentlyUpdatedDocs: PaginatedDocType;
  /** sl-lkdb.3.1: Recovery version counter — clients compare to detect stale local data after PITR */
  recoveryVersion: Scalars['Int']['output'];
  /** Role of current signed in user in workspace */
  role: Permission;
  /** Get the workspace root folder */
  rootFolder: Maybe<FolderType>;
  /** Search a specific table */
  search: SearchResultObjectType;
  /** Search docs by keyword */
  searchDocs: Array<SearchDocObjectType>;
  /** sl-wqvr.2.5: Cached storage usage from S3 */
  storageUsage: Maybe<WorkspaceStorageUsageType>;
  /** The team subscription of the workspace, if exists. */
  subscription: Maybe<SubscriptionType>;
  /** if workspace is team workspace */
  team: Scalars['Boolean']['output'];
  /** Get all trashed folders in this workspace (Owner/Admin only) */
  trashedFolders: Array<FolderType>;
  /** Get docs where a specific user has explicit permissions (E035.5) */
  userDocGrants: Array<UserDocGrantType>;
  /** Get folders where a specific user has explicit permissions (E035.5) */
  userFolderGrants: Array<UserFolderGrantType>;
  /** sl-tdgy.5: Workflow execution plan limits and live concurrency */
  workflowLimits: WorkflowLimitsType;
  /** Search semantic workspace entities such as mail messages. */
  workspaceSearch: Array<WorkspaceSearchResult>;
}

export interface WorkspaceTypeAggregateArgs {
  input: AggregateInput;
}

export interface WorkspaceTypeCommentChangesArgs {
  docId: Scalars['String']['input'];
  pagination: PaginationInput;
}

export interface WorkspaceTypeCommentsArgs {
  docId: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
}

export interface WorkspaceTypeDeletedFolderIdsArgs {
  folderIds: Array<Scalars['String']['input']>;
}

export interface WorkspaceTypeDocArgs {
  docId: Scalars['String']['input'];
}

export interface WorkspaceTypeDocsArgs {
  docIds?: InputMaybe<Array<Scalars['String']['input']>>;
  pagination: PaginationInput;
}

export interface WorkspaceTypeFolderArgs {
  folderId: Scalars['String']['input'];
}

export interface WorkspaceTypeFoldersArgs {
  parentId?: InputMaybe<Scalars['String']['input']>;
}

export interface WorkspaceTypeHasDocEmbeddingsArgs {
  blockId?: InputMaybe<Scalars['String']['input']>;
  docId: Scalars['String']['input'];
}

export interface WorkspaceTypeHistoriesArgs {
  before?: InputMaybe<Scalars['DateTime']['input']>;
  guid: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
}

export interface WorkspaceTypeInvoicesArgs {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}

export interface WorkspaceTypeMailSearchDiagnosticsArgs {
  input?: InputMaybe<MailSearchDiagnosticsInput>;
}

export interface WorkspaceTypeMembersArgs {
  isHouseGuest?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}

export interface WorkspaceTypePageMetaArgs {
  pageId: Scalars['String']['input'];
}

export interface WorkspaceTypePdfSearchArgs {
  input: PdfPageSearchInput;
}

export interface WorkspaceTypePublicPageArgs {
  pageId: Scalars['String']['input'];
}

export interface WorkspaceTypeRecentlyUpdatedDocsArgs {
  pagination: PaginationInput;
}

export interface WorkspaceTypeSearchArgs {
  input: SearchInput;
}

export interface WorkspaceTypeSearchDocsArgs {
  input: SearchDocsInput;
}

export interface WorkspaceTypeUserDocGrantsArgs {
  userId: Scalars['String']['input'];
}

export interface WorkspaceTypeUserFolderGrantsArgs {
  userId: Scalars['String']['input'];
}

export interface WorkspaceTypeWorkspaceSearchArgs {
  input: WorkspaceSearchInput;
}

export interface WorkspaceUserType {
  __typename?: 'WorkspaceUserType';
  avatarUrl: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface WrongSignInCredentialsDataType {
  __typename?: 'WrongSignInCredentialsDataType';
  email: Scalars['String']['output'];
}

export interface TokenType {
  __typename?: 'tokenType';
  refresh: Scalars['String']['output'];
  sessionToken: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
}

export type GenerateUserAccessTokenMutationVariables = Exact<{
  input: GenerateAccessTokenInput;
}>;

export type GenerateUserAccessTokenMutation = {
  __typename?: 'Mutation';
  generateUserAccessToken: {
    __typename?: 'RevealedAccessToken';
    id: string;
    name: string;
    token: string;
    createdAt: string;
    expiresAt: string | null;
  };
};

export type ListUserAccessTokensQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ListUserAccessTokensQuery = {
  __typename?: 'Query';
  revealedAccessTokens: Array<{
    __typename?: 'RevealedAccessToken';
    id: string;
    name: string;
    createdAt: string;
    expiresAt: string | null;
    token: string;
  }>;
};

export type RevokeUserAccessTokenMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type RevokeUserAccessTokenMutation = {
  __typename?: 'Mutation';
  revokeUserAccessToken: boolean;
};

export type AccountDeletionPreviewQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AccountDeletionPreviewQuery = {
  __typename?: 'Query';
  accountDeletionPreview: {
    __typename?: 'AccountDeletionPreview';
    blockedReason: AccountDeletionBlockReason | null;
    gracePeriodDays: number;
    scheduledFinalizeDate: string;
    activeSubscriptions: Array<{
      __typename?: 'SubscriptionPreview';
      id: string;
      plan: string;
      periodEnd: string;
      amount: number;
      currency: string;
    }>;
    ownedWorkspaces: Array<{
      __typename?: 'WorkspacePreview';
      id: string;
      name: string;
      memberCount: number;
    }>;
    pendingInvoices: Array<{
      __typename?: 'InvoicePreview';
      id: string;
      amount: number;
      currency: string;
      dueDate: string;
    }>;
  };
};

export type AccountDeletionStatusQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AccountDeletionStatusQuery = {
  __typename?: 'Query';
  accountDeletionStatus: {
    __typename?: 'AccountDeletionStatus';
    scheduled: boolean;
    scheduledAt: string | null;
    finalizesAt: string | null;
    reactivatable: boolean;
    gracePeriodDays: number;
  };
};

export type AddTenantMemberMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  userId: Scalars['String']['input'];
  role: TenantRoleEnum;
}>;

export type AddTenantMemberMutation = {
  __typename?: 'Mutation';
  addTenantMember: {
    __typename?: 'TenantMemberType';
    id: string;
    tenantId: string;
    userId: string;
    role: TenantRoleEnum;
    createdAt: string;
  };
};

export type AdminWorkspaceStatsQueryVariables = Exact<{ [key: string]: never }>;

export type AdminWorkspaceStatsQuery = {
  __typename?: 'Query';
  adminWorkspaceStats: {
    __typename?: 'AdminWorkspaceStatsType';
    totalWorkspaces: number;
    avgMembersPerWorkspace: number;
    totalStorageUsed: number;
    avgStoragePerWorkspace: number;
    storageBreakdown: {
      __typename?: 'AdminStorageBreakdownType';
      blobBytes: number;
      documentSnapshotBytes: number;
      documentHistoryBytes: number;
      databaseBytes: number;
      derivedBytes: number;
      mailSearchIndexBytes: number;
    };
    top10ByStorage: Array<{
      __typename?: 'AdminWorkspaceType';
      id: string;
      name: string;
      ownerName: string;
      plan: string;
      memberCount: number;
      totalStorageBytes: number;
      createdAt: string;
      storageBreakdown: {
        __typename?: 'AdminStorageBreakdownType';
        blobBytes: number;
        documentSnapshotBytes: number;
        documentHistoryBytes: number;
        databaseBytes: number;
        derivedBytes: number;
        mailSearchIndexBytes: number;
      };
    }>;
    top10ByMembers: Array<{
      __typename?: 'AdminWorkspaceType';
      id: string;
      name: string;
      ownerName: string;
      plan: string;
      memberCount: number;
      totalStorageBytes: number;
      createdAt: string;
      storageBreakdown: {
        __typename?: 'AdminStorageBreakdownType';
        blobBytes: number;
        documentSnapshotBytes: number;
        documentHistoryBytes: number;
        databaseBytes: number;
        derivedBytes: number;
        mailSearchIndexBytes: number;
      };
    }>;
    top10ByAIUsage: Array<{
      __typename?: 'AdminWorkspaceType';
      id: string;
      name: string;
      ownerName: string;
      plan: string;
      memberCount: number;
      totalStorageBytes: number;
      createdAt: string;
      storageBreakdown: {
        __typename?: 'AdminStorageBreakdownType';
        blobBytes: number;
        documentSnapshotBytes: number;
        documentHistoryBytes: number;
        databaseBytes: number;
        derivedBytes: number;
        mailSearchIndexBytes: number;
      };
    }>;
  };
};

export type AdminAiProfitabilityQueryVariables = Exact<{
  input: AiProfitabilityQueryInput;
}>;

export type AdminAiProfitabilityQuery = {
  __typename?: 'Query';
  adminAIProfitability: {
    __typename?: 'AIProfitabilityReportType';
    overview: {
      __typename?: 'AIProfitabilityMoneyType';
      providerCostMicroUsd: string;
      providerCostMicroEur: string;
      providerCostMicroCredits: string;
      customerCostBasisMicroCredits: string;
      customerChargedMicroCredits: string;
      marginMicroCredits: string;
      lineCount: number;
      eurComplete: boolean;
    };
    managedBackendRows: Array<{
      __typename?: 'AIProfitabilityDimensionRowType';
      tenantId: string | null;
      workspaceId: string | null;
      managedBackendId: string | null;
      provider: string | null;
      model: string | null;
      cacheScope: string | null;
      cacheMode: string | null;
      cacheWindowSeconds: number | null;
      totals: {
        __typename?: 'AIProfitabilityMoneyType';
        providerCostMicroUsd: string;
        providerCostMicroEur: string;
        providerCostMicroCredits: string;
        customerCostBasisMicroCredits: string;
        customerChargedMicroCredits: string;
        marginMicroCredits: string;
        lineCount: number;
        eurComplete: boolean;
      };
    }>;
    providerModelRows: Array<{
      __typename?: 'AIProfitabilityDimensionRowType';
      tenantId: string | null;
      workspaceId: string | null;
      managedBackendId: string | null;
      provider: string | null;
      model: string | null;
      cacheScope: string | null;
      cacheMode: string | null;
      cacheWindowSeconds: number | null;
      totals: {
        __typename?: 'AIProfitabilityMoneyType';
        providerCostMicroUsd: string;
        providerCostMicroEur: string;
        providerCostMicroCredits: string;
        customerCostBasisMicroCredits: string;
        customerChargedMicroCredits: string;
        marginMicroCredits: string;
        lineCount: number;
        eurComplete: boolean;
      };
    }>;
    tenantRows: Array<{
      __typename?: 'AIProfitabilityDimensionRowType';
      tenantId: string | null;
      workspaceId: string | null;
      managedBackendId: string | null;
      provider: string | null;
      model: string | null;
      cacheScope: string | null;
      cacheMode: string | null;
      cacheWindowSeconds: number | null;
      totals: {
        __typename?: 'AIProfitabilityMoneyType';
        providerCostMicroUsd: string;
        providerCostMicroEur: string;
        providerCostMicroCredits: string;
        customerCostBasisMicroCredits: string;
        customerChargedMicroCredits: string;
        marginMicroCredits: string;
        lineCount: number;
        eurComplete: boolean;
      };
    }>;
    workspaceRows: Array<{
      __typename?: 'AIProfitabilityDimensionRowType';
      tenantId: string | null;
      workspaceId: string | null;
      managedBackendId: string | null;
      provider: string | null;
      model: string | null;
      cacheScope: string | null;
      cacheMode: string | null;
      cacheWindowSeconds: number | null;
      totals: {
        __typename?: 'AIProfitabilityMoneyType';
        providerCostMicroUsd: string;
        providerCostMicroEur: string;
        providerCostMicroCredits: string;
        customerCostBasisMicroCredits: string;
        customerChargedMicroCredits: string;
        marginMicroCredits: string;
        lineCount: number;
        eurComplete: boolean;
      };
    }>;
    cacheWindowRows: Array<{
      __typename?: 'AIProfitabilityDimensionRowType';
      tenantId: string | null;
      workspaceId: string | null;
      managedBackendId: string | null;
      provider: string | null;
      model: string | null;
      cacheScope: string | null;
      cacheMode: string | null;
      cacheWindowSeconds: number | null;
      totals: {
        __typename?: 'AIProfitabilityMoneyType';
        providerCostMicroUsd: string;
        providerCostMicroEur: string;
        providerCostMicroCredits: string;
        customerCostBasisMicroCredits: string;
        customerChargedMicroCredits: string;
        marginMicroCredits: string;
        lineCount: number;
        eurComplete: boolean;
      };
    }>;
    alerts: Array<{
      __typename?: 'AIProfitabilityAlertType';
      kind: string;
      severity: string;
      scope: string;
      cause: string;
      provider: string | null;
      model: string | null;
      tenantId: string | null;
      workspaceId: string | null;
      cacheScope: string | null;
      cacheMode: string | null;
      cacheWindowSeconds: number | null;
      marginMicroCredits: string;
    }>;
    requestTrace: {
      __typename?: 'AIProfitabilityTracePageType';
      nextOffset: number | null;
      rows: Array<{
        __typename?: 'AIProfitabilityTraceRowType';
        id: string;
        aiUsageLogId: string;
        creditTransactionId: string | null;
        createdAt: string;
        tenantId: string;
        workspaceId: string;
        userId: string | null;
        triggerId: string | null;
        provider: string;
        model: string;
        capability: string;
        providerUsed: string | null;
        modelUsed: string | null;
        routingPolicy: string | null;
        managedBackendId: string | null;
        costKind: string;
        costSource: string;
        cacheScope: string | null;
        cacheMode: string | null;
        cacheKey: string | null;
        cacheWindowSeconds: number | null;
        providerCostMicroUsd: string;
        providerCostMicroEur: string | null;
        providerCostMicroCredits: string;
        customerCostBasisMicroCredits: string;
        customerChargedMicroCredits: string;
      }>;
    };
  };
};

export type AdminAssignPlanMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  plan: Scalars['String']['input'];
}>;

export type AdminAssignPlanMutation = {
  __typename?: 'Mutation';
  adminAssignPlan: {
    __typename?: 'SubscriptionType';
    plan: string;
    status: SubscriptionStatus;
    recurring: SubscriptionRecurring;
    start: string;
    createdAt: string;
    updatedAt: string;
    provider: string | null;
  };
};

export type AdminAuditLogFacetsQueryVariables = Exact<{ [key: string]: never }>;

export type AdminAuditLogFacetsQuery = {
  __typename?: 'Query';
  adminAuditLogFacets: {
    __typename?: 'AdminAuditLogFacetsType';
    actions: Array<string>;
    targetTypes: Array<string>;
    admins: Array<{
      __typename?: 'AdminAuditLogAdminType';
      id: string;
      name: string | null;
      email: string;
    }>;
  };
};

export type AdminAuditLogsQueryVariables = Exact<{
  filter: AuditLogFilterInput;
}>;

export type AdminAuditLogsQuery = {
  __typename?: 'Query';
  adminAuditLogs: {
    __typename?: 'PaginatedAuditLogsType';
    total: number;
    entries: Array<{
      __typename?: 'AdminAuditLogEntryType';
      id: string;
      adminId: string;
      action: string;
      targetType: string | null;
      targetId: string | null;
      details: string | null;
      createdAt: string;
      admin: {
        __typename?: 'AdminAuditLogAdminType';
        id: string;
        name: string | null;
        email: string;
      };
    }>;
  };
};

export type AdminBillingStatsQueryVariables = Exact<{ [key: string]: never }>;

export type AdminBillingStatsQuery = {
  __typename?: 'Query';
  adminBillingStats: {
    __typename?: 'BillingStatsType';
    totalActive: number;
    totalSubscriptions: number;
    planDistribution: Array<{
      __typename?: 'PlanCountType';
      plan: string;
      count: number;
    }>;
  };
};

export type AdminTenantCachePerformanceQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  input: CachePerformanceQueryInput;
}>;

export type AdminTenantCachePerformanceQuery = {
  __typename?: 'Query';
  adminTenantCachePerformance: {
    __typename?: 'CachePerformanceReportType';
    buckets: Array<{
      __typename?: 'CachePerformanceBucketType';
      bucket: string;
      paidMicro: string;
      savedMicro: string;
      chargedMicro: string;
      hitRate: number;
      hits: number;
      misses: number;
      callCount: number;
    }>;
    totals: {
      __typename?: 'CachePerformanceTotalsType';
      paidMicro: string;
      savedMicro: string;
      chargedMicro: string;
      uncachedHypotheticalMicro: string;
      hitRateAvg: number;
      callCount: number;
    };
  };
};

export type AdminSystemCachePerformanceQueryVariables = Exact<{
  input: CachePerformanceQueryInput;
}>;

export type AdminSystemCachePerformanceQuery = {
  __typename?: 'Query';
  adminSystemCachePerformance: {
    __typename?: 'CachePerformanceReportType';
    buckets: Array<{
      __typename?: 'CachePerformanceBucketType';
      bucket: string;
      paidMicro: string;
      savedMicro: string;
      chargedMicro: string;
      hitRate: number;
      hits: number;
      misses: number;
      callCount: number;
    }>;
    totals: {
      __typename?: 'CachePerformanceTotalsType';
      paidMicro: string;
      savedMicro: string;
      chargedMicro: string;
      uncachedHypotheticalMicro: string;
      hitRateAvg: number;
      callCount: number;
    };
  };
};

export type AdminGetUserSubscriptionsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;

export type AdminGetUserSubscriptionsQuery = {
  __typename?: 'Query';
  adminGetUserSubscriptions: Array<{
    __typename?: 'SubscriptionType';
    plan: string;
    recurring: SubscriptionRecurring;
    status: SubscriptionStatus;
    start: string;
    end: string | null;
    nextBillAt: string | null;
    canceledAt: string | null;
    createdAt: string;
    provider: string | null;
  }>;
};

export type AdminListSubscriptionsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  planFilter?: InputMaybe<Scalars['String']['input']>;
  statusFilter?: InputMaybe<SubscriptionStatus>;
}>;

export type AdminListSubscriptionsQuery = {
  __typename?: 'Query';
  adminListSubscriptions: Array<{
    __typename?: 'AdminSubscriptionType';
    plan: string;
    recurring: SubscriptionRecurring;
    status: SubscriptionStatus;
    start: string;
    end: string | null;
    canceledAt: string | null;
    createdAt: string;
    userEmail: string;
    userName: string | null;
    provider: string | null;
  }>;
};

export type AdminPermissionGraphDiagnosticsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  sampleDocs: Scalars['Int']['input'];
}>;

export type AdminPermissionGraphDiagnosticsQuery = {
  __typename?: 'Query';
  permissionGraphProjectionDiagnostics: {
    __typename?: 'PermissionGraphDriftDiagnosticsResultType';
    rightsEpoch: number;
    sampledDocs: number;
    sampledPrincipals: number;
    truncated: boolean;
    findings: Array<{
      __typename?: 'PermissionGraphDriftFindingType';
      kind: string;
      docId: string | null;
      userId: string | null;
      sourceId: string | null;
    }>;
  };
};

export type AdminPermissionGraphQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  isRoots: Scalars['Boolean']['input'];
  isFolderSubtree: Scalars['Boolean']['input'];
  isRelationships: Scalars['Boolean']['input'];
  isResourceSubjects: Scalars['Boolean']['input'];
  isSubjectResources: Scalars['Boolean']['input'];
  isChanges: Scalars['Boolean']['input'];
  filter?: InputMaybe<PermissionGraphFilterInput>;
  folderId: Scalars['String']['input'];
  depth: Scalars['Int']['input'];
  subjectId: Scalars['String']['input'];
  subjectKind: Scalars['String']['input'];
  resourceId: Scalars['String']['input'];
  resourceKind: Scalars['String']['input'];
  permission?: InputMaybe<Scalars['String']['input']>;
  sinceToken?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type AdminPermissionGraphQuery = {
  __typename?: 'Query';
  permissionGraphRoots?: {
    __typename?: 'PermissionGraphConnectionType';
    rightsEpoch: number;
    edges: Array<{
      __typename?: 'PermissionGraphEdgeType';
      cursor: string;
      sortKey: string;
      node:
        | {
            __typename: 'PermissionGraphNodeType';
            id: string;
            kind: string;
            label: string;
            workspaceId: string;
            metadata: Record<string, string> | null;
          }
        | {
            __typename: 'PermissionGraphRelationshipType';
            id: string;
            relationshipType: string;
            sourceType: string;
            sourceId: string;
            targetType: string;
            targetId: string;
            role: string | null;
            updatedAt: string | null;
            provenance: {
              __typename?: 'PermissionGraphProvenanceType';
              sourceType: string;
              sourceId: string;
              viaGroupId: string | null;
              viaFolderId: string | null;
              inherited: boolean;
              effective: boolean;
            };
          };
    }>;
    pageInfo: {
      __typename?: 'PermissionGraphPageInfoType';
      hasNextPage: boolean;
      endCursor: string | null;
      token: string | null;
      resetRequired: string | null;
    };
    diagnostics: {
      __typename?: 'PermissionGraphDiagnosticsType';
      bounded: boolean;
      maxPageSize: number;
      maxSubtreeDepth: number;
      projectionStatus: string;
      resetReason: string | null;
    };
  };
  permissionFolderSubtree?: {
    __typename?: 'PermissionGraphConnectionType';
    rightsEpoch: number;
    edges: Array<{
      __typename?: 'PermissionGraphEdgeType';
      cursor: string;
      sortKey: string;
      node:
        | {
            __typename: 'PermissionGraphNodeType';
            id: string;
            kind: string;
            label: string;
            workspaceId: string;
            metadata: Record<string, string> | null;
          }
        | {
            __typename: 'PermissionGraphRelationshipType';
            id: string;
            relationshipType: string;
            sourceType: string;
            sourceId: string;
            targetType: string;
            targetId: string;
            role: string | null;
            updatedAt: string | null;
            provenance: {
              __typename?: 'PermissionGraphProvenanceType';
              sourceType: string;
              sourceId: string;
              viaGroupId: string | null;
              viaFolderId: string | null;
              inherited: boolean;
              effective: boolean;
            };
          };
    }>;
    pageInfo: {
      __typename?: 'PermissionGraphPageInfoType';
      hasNextPage: boolean;
      endCursor: string | null;
      token: string | null;
      resetRequired: string | null;
    };
    diagnostics: {
      __typename?: 'PermissionGraphDiagnosticsType';
      bounded: boolean;
      maxPageSize: number;
      maxSubtreeDepth: number;
      projectionStatus: string;
      resetReason: string | null;
    };
  };
  permissionGraphRelationships?: {
    __typename?: 'PermissionGraphConnectionType';
    rightsEpoch: number;
    edges: Array<{
      __typename?: 'PermissionGraphEdgeType';
      cursor: string;
      sortKey: string;
      node:
        | {
            __typename: 'PermissionGraphNodeType';
            id: string;
            kind: string;
            label: string;
            workspaceId: string;
            metadata: Record<string, string> | null;
          }
        | {
            __typename: 'PermissionGraphRelationshipType';
            id: string;
            relationshipType: string;
            sourceType: string;
            sourceId: string;
            targetType: string;
            targetId: string;
            role: string | null;
            updatedAt: string | null;
            provenance: {
              __typename?: 'PermissionGraphProvenanceType';
              sourceType: string;
              sourceId: string;
              viaGroupId: string | null;
              viaFolderId: string | null;
              inherited: boolean;
              effective: boolean;
            };
          };
    }>;
    pageInfo: {
      __typename?: 'PermissionGraphPageInfoType';
      hasNextPage: boolean;
      endCursor: string | null;
      token: string | null;
      resetRequired: string | null;
    };
    diagnostics: {
      __typename?: 'PermissionGraphDiagnosticsType';
      bounded: boolean;
      maxPageSize: number;
      maxSubtreeDepth: number;
      projectionStatus: string;
      resetReason: string | null;
    };
  };
  permissionResourceSubjects?: {
    __typename?: 'PermissionGraphConnectionType';
    rightsEpoch: number;
    edges: Array<{
      __typename?: 'PermissionGraphEdgeType';
      cursor: string;
      sortKey: string;
      node:
        | {
            __typename: 'PermissionGraphNodeType';
            id: string;
            kind: string;
            label: string;
            workspaceId: string;
            metadata: Record<string, string> | null;
          }
        | {
            __typename: 'PermissionGraphRelationshipType';
            id: string;
            relationshipType: string;
            sourceType: string;
            sourceId: string;
            targetType: string;
            targetId: string;
            role: string | null;
            updatedAt: string | null;
            provenance: {
              __typename?: 'PermissionGraphProvenanceType';
              sourceType: string;
              sourceId: string;
              viaGroupId: string | null;
              viaFolderId: string | null;
              inherited: boolean;
              effective: boolean;
            };
          };
    }>;
    pageInfo: {
      __typename?: 'PermissionGraphPageInfoType';
      hasNextPage: boolean;
      endCursor: string | null;
      token: string | null;
      resetRequired: string | null;
    };
    diagnostics: {
      __typename?: 'PermissionGraphDiagnosticsType';
      bounded: boolean;
      maxPageSize: number;
      maxSubtreeDepth: number;
      projectionStatus: string;
      resetReason: string | null;
    };
  };
  permissionSubjectResources?: {
    __typename?: 'PermissionGraphConnectionType';
    rightsEpoch: number;
    edges: Array<{
      __typename?: 'PermissionGraphEdgeType';
      cursor: string;
      sortKey: string;
      node:
        | {
            __typename: 'PermissionGraphNodeType';
            id: string;
            kind: string;
            label: string;
            workspaceId: string;
            metadata: Record<string, string> | null;
          }
        | {
            __typename: 'PermissionGraphRelationshipType';
            id: string;
            relationshipType: string;
            sourceType: string;
            sourceId: string;
            targetType: string;
            targetId: string;
            role: string | null;
            updatedAt: string | null;
            provenance: {
              __typename?: 'PermissionGraphProvenanceType';
              sourceType: string;
              sourceId: string;
              viaGroupId: string | null;
              viaFolderId: string | null;
              inherited: boolean;
              effective: boolean;
            };
          };
    }>;
    pageInfo: {
      __typename?: 'PermissionGraphPageInfoType';
      hasNextPage: boolean;
      endCursor: string | null;
      token: string | null;
      resetRequired: string | null;
    };
    diagnostics: {
      __typename?: 'PermissionGraphDiagnosticsType';
      bounded: boolean;
      maxPageSize: number;
      maxSubtreeDepth: number;
      projectionStatus: string;
      resetReason: string | null;
    };
  };
  permissionGraphChanges?: {
    __typename?: 'PermissionGraphConnectionType';
    rightsEpoch: number;
    edges: Array<{
      __typename?: 'PermissionGraphEdgeType';
      cursor: string;
      sortKey: string;
      node:
        | {
            __typename: 'PermissionGraphNodeType';
            id: string;
            kind: string;
            label: string;
            workspaceId: string;
            metadata: Record<string, string> | null;
          }
        | {
            __typename: 'PermissionGraphRelationshipType';
            id: string;
            relationshipType: string;
            sourceType: string;
            sourceId: string;
            targetType: string;
            targetId: string;
            role: string | null;
            updatedAt: string | null;
            provenance: {
              __typename?: 'PermissionGraphProvenanceType';
              sourceType: string;
              sourceId: string;
              viaGroupId: string | null;
              viaFolderId: string | null;
              inherited: boolean;
              effective: boolean;
            };
          };
    }>;
    pageInfo: {
      __typename?: 'PermissionGraphPageInfoType';
      hasNextPage: boolean;
      endCursor: string | null;
      token: string | null;
      resetRequired: string | null;
    };
    diagnostics: {
      __typename?: 'PermissionGraphDiagnosticsType';
      bounded: boolean;
      maxPageSize: number;
      maxSubtreeDepth: number;
      projectionStatus: string;
      resetReason: string | null;
    };
  };
};

export type AdminPlanDistributionQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminPlanDistributionQuery = {
  __typename?: 'Query';
  adminPlanDistribution: Array<{
    __typename?: 'AdminPlanCountType';
    plan: string;
    count: number;
    percentage: number;
  }>;
};

export type RestoreWorkspaceMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  targetTimestamp: Scalars['DateTime']['input'];
}>;

export type RestoreWorkspaceMutation = {
  __typename?: 'Mutation';
  restoreWorkspace: {
    __typename?: 'RecoveryLogType';
    id: string;
    workspaceId: string;
    adminUserId: string;
    targetTimestamp: string;
    status: RecoveryLogStatus;
    phase: string | null;
    startedAt: string | null;
    completedAt: string | null;
    durationMs: number | null;
    tablesRestored: number | null;
    rowsDeleted: number | null;
    rowsInserted: number | null;
    blobsRestored: number | null;
    errorMessage: string | null;
    createdAt: string;
  };
};

export type RecoveryLogQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  logId: Scalars['String']['input'];
}>;

export type RecoveryLogQuery = {
  __typename?: 'Query';
  recoveryLog: {
    __typename?: 'RecoveryLogType';
    id: string;
    workspaceId: string;
    adminUserId: string;
    targetTimestamp: string;
    status: RecoveryLogStatus;
    phase: string | null;
    startedAt: string | null;
    completedAt: string | null;
    durationMs: number | null;
    tablesRestored: number | null;
    rowsDeleted: number | null;
    rowsInserted: number | null;
    blobsRestored: number | null;
    errorMessage: string | null;
    createdAt: string;
  };
};

export type RecoveryHistoryQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type RecoveryHistoryQuery = {
  __typename?: 'Query';
  recoveryHistory: Array<{
    __typename?: 'RecoveryLogType';
    id: string;
    workspaceId: string;
    adminUserId: string;
    targetTimestamp: string;
    status: RecoveryLogStatus;
    phase: string | null;
    startedAt: string | null;
    completedAt: string | null;
    durationMs: number | null;
    tablesRestored: number | null;
    rowsDeleted: number | null;
    rowsInserted: number | null;
    blobsRestored: number | null;
    errorMessage: string | null;
    createdAt: string;
  }>;
};

export type RecoveryTimeRangeQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type RecoveryTimeRangeQuery = {
  __typename?: 'Query';
  recoveryTimeRange: {
    __typename?: 'RecoveryTimeRangeType';
    earliest: string;
    latest: string;
  };
};

export type AdminServerConfigQueryVariables = Exact<{ [key: string]: never }>;

export type AdminServerConfigQuery = {
  __typename?: 'Query';
  serverConfig: {
    __typename?: 'ServerConfigType';
    version: string;
    baseUrl: string;
    name: string;
    features: Array<ServerFeature>;
    type: ServerDeploymentType;
    initialized: boolean;
    availableUserFeatures: Array<FeatureType>;
    credentialsRequirement: {
      __typename?: 'CredentialsRequirementType';
      password: {
        __typename?: 'PasswordLimitsType';
        minLength: number;
        maxLength: number;
      };
    };
    availableUpgrade: {
      __typename?: 'ReleaseVersionType';
      changelog: string;
      version: string;
      publishedAt: string;
      url: string;
    } | null;
  };
};

export type AdminSignupTrendQueryVariables = Exact<{
  input: SignupTrendInput;
}>;

export type AdminSignupTrendQuery = {
  __typename?: 'Query';
  adminSignupTrend: Array<{
    __typename?: 'AdminSignupTrendEntryType';
    date: string;
    count: number;
  }>;
};

export type AdminStripeProductsQueryVariables = Exact<{ [key: string]: never }>;

export type AdminStripeProductsQuery = {
  __typename?: 'Query';
  adminStripeProducts: Array<{
    __typename?: 'AdminStripePriceType';
    priceId: string;
    productName: string;
    unitAmount: number;
    currency: string;
    recurring: string;
    active: boolean;
  }>;
};

export type AdminTenantDetailQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;

export type AdminTenantDetailQuery = {
  __typename?: 'Query';
  adminTenantDetail: {
    __typename?: 'AdminTenantDetailType';
    id: string;
    name: string;
    slug: string;
    billingEmail: string;
    ownerName: string;
    ownerEmail: string;
    plan: string;
    stripePlan: string | null;
    planOverride: string | null;
    memberCount: number;
    workspaceCount: number;
    totalStorageBytes: number;
    createdAt: string;
    databaseType: string;
    databaseName: string | null;
    planOverrideExpiresAt: string | null;
    planOverrideSetBy: string | null;
    planMemberLimit: number | null;
    planMonthlyCreditGrant: number | null;
    creditBalance: number;
    creditEnabled: boolean;
    creditSuspended: boolean;
    members: Array<{
      __typename?: 'AdminTenantMemberType';
      userId: string;
      name: string;
      email: string;
      role: TenantRoleEnum;
      accepted: boolean;
      joinedAt: string;
    }>;
    workspaces: Array<{
      __typename?: 'AdminTenantWorkspaceType';
      id: string;
      name: string;
      memberCount: number;
      docCount: number;
      totalStorageBytes: number;
      createdAt: string;
      seatAddonQuantity: number;
      seatAddonBilled: boolean;
    }>;
  };
};

export type AdminTenantsCountQueryVariables = Exact<{
  filter: ListTenantInput;
}>;

export type AdminTenantsCountQuery = {
  __typename?: 'Query';
  adminTenantsCount: number;
};

export type AdminTenantsQueryVariables = Exact<{
  filter: ListTenantInput;
}>;

export type AdminTenantsQuery = {
  __typename?: 'Query';
  adminTenants: Array<{
    __typename?: 'AdminTenantType';
    id: string;
    name: string;
    slug: string;
    billingEmail: string;
    ownerName: string;
    ownerEmail: string;
    plan: string;
    stripePlan: string | null;
    planOverride: string | null;
    memberCount: number;
    workspaceCount: number;
    totalStorageBytes: number;
    createdAt: string;
    databaseType: string;
    databaseName: string | null;
  }>;
};

export type AdminTopWorkspacesByActivityQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  kind: Scalars['String']['input'];
}>;

export type AdminTopWorkspacesByActivityQuery = {
  __typename?: 'Query';
  adminTopWorkspacesByActivity: Array<{
    __typename?: 'AdminActivityKindRank';
    workspaceId: string;
    kind: string;
    unit: string;
    amount: string;
  }>;
};

export type AdminTopWorkspacesQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
}>;

export type AdminTopWorkspacesQuery = {
  __typename?: 'Query';
  adminTopWorkspaces: Array<{
    __typename?: 'AdminWorkspaceActivity';
    workspaceId: string;
    creditsMicro: string;
  }>;
};

export type AdminUserStatsQueryVariables = Exact<{ [key: string]: never }>;

export type AdminUserStatsQuery = {
  __typename?: 'Query';
  adminUserStats: {
    __typename?: 'AdminUserStatsType';
    totalUsers: number;
    signupsThisWeek: number;
    signupsThisMonth: number;
    activeLastSevenDays: number;
    activeLastThirtyDays: number;
    planCounts: Array<{
      __typename?: 'AdminPlanCountType';
      plan: string;
      count: number;
      percentage: number;
    }>;
  };
};

export type AdminWebhookHealthQueryVariables = Exact<{ [key: string]: never }>;

export type AdminWebhookHealthQuery = {
  __typename?: 'Query';
  adminWebhookHealth: {
    __typename?: 'WebhookHealthType';
    totalEventsReceived: number;
    totalErrors: number;
    lastEventAt: string | null;
    lastEventType: string | null;
    lastErrorAt: string | null;
    lastErrorMessage: string | null;
  };
};

export type AdminWorkerJobPlacesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminWorkerJobPlacesQuery = {
  __typename?: 'Query';
  adminWorkerJobPlaces: {
    __typename?: 'AdminWorkerJobPlaces';
    placesPerPod: number;
    pods: number;
    held: number;
    workspaceCount: number;
    workspaces: Array<{
      __typename?: 'AdminWorkerJobWorkspaceStanding';
      workspaceId: string;
      claim: number;
      limit: number | null;
      held: number;
      borrowed: number;
      tiers: Array<{
        __typename?: 'AdminWorkerJobTierStanding';
        tier: string;
        waiting: number;
        oldestWaitMs: number;
        underClaim: number;
      }>;
    }>;
  };
};

export type AdminWorkspaceActivityCountersQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  workspaceId: Scalars['String']['input'];
}>;

export type AdminWorkspaceActivityCountersQuery = {
  __typename?: 'Query';
  adminWorkspaceActivityCounters: {
    __typename?: 'AdminWorkspaceActivityCounters';
    workspaceId: string;
    bucket: string;
    retentionDays: number;
    incomplete: boolean;
    series: Array<{
      __typename?: 'AdminActivityCounterPoint';
      periodStart: string;
      kind: string;
      unit: string;
      amount: string;
    }>;
    queues: Array<{
      __typename?: 'AdminActivityCounterTotal';
      kind: string;
      unit: string;
      amount: string;
      queue: string | null;
      appBaseId: string | null;
      route: string | null;
    }>;
    routes: Array<{
      __typename?: 'AdminActivityCounterTotal';
      kind: string;
      unit: string;
      amount: string;
      queue: string | null;
      appBaseId: string | null;
      route: string | null;
    }>;
  };
};

export type AdminWorkspaceActivityQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  workspaceId: Scalars['String']['input'];
}>;

export type AdminWorkspaceActivityQuery = {
  __typename?: 'Query';
  adminWorkspaceActivity: {
    __typename?: 'AdminWorkspaceActivity';
    workspaceId: string;
    creditsMicro: string;
    sources: Array<{
      __typename?: 'AdminActivitySource';
      source: string;
      retentionDays: number | null;
      retentionPolicy: string;
      incomplete: boolean;
      observedAt: string | null;
      quantities: Array<{
        __typename?: 'AdminActivityMeasurement';
        name: string;
        value: string;
        unit: string;
        dimension: string | null;
      }>;
      costs: Array<{
        __typename?: 'AdminActivityMeasurement';
        name: string;
        value: string;
        unit: string;
        dimension: string | null;
      }> | null;
    }>;
    apps: Array<{
      __typename?: 'AdminActivityAppCost';
      appBaseId: string;
      title: string | null;
      deleted: boolean;
      costKind: string;
      quantity: string;
      unit: string;
      creditsMicro: string;
    }>;
  };
};

export type AdminWorkspaceDetailQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type AdminWorkspaceDetailQuery = {
  __typename?: 'Query';
  adminWorkspaceDetail: {
    __typename?: 'AdminWorkspaceDetailType';
    id: string;
    name: string;
    ownerId: string;
    ownerName: string;
    ownerEmail: string;
    plan: string;
    memberCount: number;
    docCount: number;
    totalStorageBytes: number;
    aiUsageThisMonth: number;
    createdAt: string;
    deletionScheduledAt: string | null;
    members: Array<{
      __typename?: 'AdminWorkspaceMemberType';
      userId: string;
      name: string;
      email: string;
      role: Permission;
      membershipKind: WorkspaceMembershipKind;
      accepted: boolean;
      joinedAt: string;
    }>;
    quotaUsage: {
      __typename?: 'AdminWorkspaceQuotaUsageType';
      members: number;
      membersLimit: number;
      storageBytes: number;
      storageBytesLimit: number;
      aiActions: number;
      aiActionsLimit: number;
    };
    aiKeyStatus: {
      __typename?: 'AdminWorkspaceAIKeyStatusType';
      hasServerKey: boolean;
      hasWorkspaceKey: boolean;
      userKeysCount: number;
    };
  };
};

export type AdminWorkspacesQueryVariables = Exact<{
  filter: ListWorkspaceInput;
}>;

export type AdminWorkspacesQuery = {
  __typename?: 'Query';
  adminWorkspaces: Array<{
    __typename?: 'AdminWorkspaceType';
    id: string;
    name: string;
    ownerId: string;
    ownerName: string;
    ownerEmail: string;
    plan: string;
    memberCount: number;
    docCount: number;
    totalStorageBytes: number;
    aiUsageThisMonth: number;
    createdAt: string;
    deletionScheduledAt: string | null;
  }>;
};

export type CreateChangePasswordUrlMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;

export type CreateChangePasswordUrlMutation = {
  __typename?: 'Mutation';
  createChangePasswordUrl: string;
};

export type AppConfigQueryVariables = Exact<{ [key: string]: never }>;

export type AppConfigQuery = { __typename?: 'Query'; appConfig: any };

export type GetPromptsQueryVariables = Exact<{ [key: string]: never }>;

export type GetPromptsQuery = {
  __typename?: 'Query';
  listCopilotPrompts: Array<{
    __typename?: 'CopilotPromptType';
    name: string;
    model: string;
    action: string | null;
    config: {
      __typename?: 'CopilotPromptConfigType';
      frequencyPenalty: number | null;
      presencePenalty: number | null;
      temperature: number | null;
      topP: number | null;
    } | null;
    messages: Array<{
      __typename?: 'CopilotPromptMessageType';
      role: CopilotPromptMessageRole;
      content: string;
      params: Record<string, string> | null;
    }>;
  }>;
};

export type UpdatePromptMutationVariables = Exact<{
  name: Scalars['String']['input'];
  messages: Array<CopilotPromptMessageInput> | CopilotPromptMessageInput;
}>;

export type UpdatePromptMutation = {
  __typename?: 'Mutation';
  updateCopilotPrompt: {
    __typename?: 'CopilotPromptType';
    name: string;
    model: string;
    action: string | null;
    config: {
      __typename?: 'CopilotPromptConfigType';
      frequencyPenalty: number | null;
      presencePenalty: number | null;
      temperature: number | null;
      topP: number | null;
    } | null;
    messages: Array<{
      __typename?: 'CopilotPromptMessageType';
      role: CopilotPromptMessageRole;
      content: string;
      params: Record<string, string> | null;
    }>;
  };
};

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;

export type CreateUserMutation = {
  __typename?: 'Mutation';
  createUser: { __typename?: 'UserType'; id: string };
};

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type DeleteUserMutation = {
  __typename?: 'Mutation';
  deleteUser: { __typename?: 'DeleteAccount'; success: boolean };
};

export type DisableUserMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type DisableUserMutation = {
  __typename?: 'Mutation';
  banUser: { __typename?: 'UserType'; email: string; disabled: boolean };
};

export type EnableUserMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type EnableUserMutation = {
  __typename?: 'Mutation';
  enableUser: { __typename?: 'UserType'; email: string; disabled: boolean };
};

export type ImportUsersMutationVariables = Exact<{
  input: ImportUsersInput;
}>;

export type ImportUsersMutation = {
  __typename?: 'Mutation';
  importUsers: Array<
    | { __typename: 'UserImportFailedType'; email: string; error: string }
    | { __typename: 'UserType'; id: string; name: string; email: string }
  >;
};

export type ListUsersQueryVariables = Exact<{
  filter: ListUserInput;
}>;

export type ListUsersQuery = {
  __typename?: 'Query';
  usersCount: number;
  users: Array<{
    __typename?: 'UserType';
    id: string;
    name: string;
    email: string;
    disabled: boolean;
    features: Array<FeatureType>;
    hasPassword: boolean | null;
    emailVerified: boolean;
    avatarUrl: string | null;
    currentPlan: string | null;
    totpEnabled: boolean;
    lastActiveAt: string | null;
    createdAt: string | null;
    ownedWorkspaceCount: number | null;
    memberWorkspaceCount: number | null;
  }>;
};

export type SendTestEmailMutationVariables = Exact<{
  config: Scalars['JSONObject']['input'];
}>;

export type SendTestEmailMutation = {
  __typename?: 'Mutation';
  sendTestEmail: boolean;
};

export type UpdateAccountFeaturesMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  features: Array<FeatureType> | FeatureType;
}>;

export type UpdateAccountFeaturesMutation = {
  __typename?: 'Mutation';
  updateUserFeatures: Array<FeatureType>;
};

export type UpdateAccountMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: ManageUserInput;
}>;

export type UpdateAccountMutation = {
  __typename?: 'Mutation';
  updateUser: {
    __typename?: 'UserType';
    id: string;
    name: string;
    email: string;
  };
};

export type UpdateAppConfigMutationVariables = Exact<{
  updates: Array<UpdateAppConfigInput> | UpdateAppConfigInput;
}>;

export type UpdateAppConfigMutation = {
  __typename?: 'Mutation';
  updateAppConfig: any;
};

export type ValidateConfigMutationVariables = Exact<{
  updates: Array<UpdateAppConfigInput> | UpdateAppConfigInput;
}>;

export type ValidateConfigMutation = {
  __typename?: 'Mutation';
  validateAppConfig: Array<{
    __typename?: 'AppConfigValidateResult';
    module: string;
    key: string;
    value: Record<string, string>;
    valid: boolean;
    error: string | null;
  }>;
};

export type AppBaseAieoQueryVariables = Exact<{
  appBaseId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
}>;

export type AppBaseAieoQuery = {
  __typename?: 'Query';
  appBaseAIEO: {
    __typename?: 'AppBaseAIEOSettingsType';
    appBaseId: string;
    workspaceId: string;
    crawlerPolicy: string | null;
    crawlerPolicyDetails: any | null;
    declaration: string | null;
    trainingDataConsent: boolean | null;
    attributionUrl: string | null;
    llmsTextOverride: string | null;
    updatedAt: string;
  } | null;
};

export type AppBaseBandwidthBudgetQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  appBaseId: Scalars['String']['input'];
}>;

export type AppBaseBandwidthBudgetQuery = {
  __typename?: 'Query';
  appBaseBandwidthBudget: {
    __typename?: 'AppBaseBandwidthBudgetType';
    id: string;
    workspaceId: string;
    appBaseId: string;
    monthlyLimitMicro: string;
    monthToDateUsedMicro: string;
    alertThresholds: Array<number>;
    behavior: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type AppBaseDatabaseBindingHealthQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;

export type AppBaseDatabaseBindingHealthQuery = {
  __typename?: 'Query';
  appBaseDatabaseBindingHealth: any;
};

export type AppBaseDatabaseBindingsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;

export type AppBaseDatabaseBindingsQuery = {
  __typename?: 'Query';
  appBaseDatabaseBindings: any;
};

export type AppBaseDevelopmentInspectQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  target: Scalars['JSONObject']['input'];
}>;

export type AppBaseDevelopmentInspectQuery = {
  __typename?: 'Query';
  appBaseDevelopmentInspect: any;
};

export type AppBaseInvocationStatusQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  appBaseId: Scalars['String']['input'];
}>;

export type AppBaseInvocationStatusQuery = {
  __typename?: 'Query';
  appBaseInvocationStatus: {
    __typename?: 'AppBaseInvocationStatusType';
    planSlug: string;
    exposure: string;
    origin: string;
    actions: Array<{
      __typename?: 'AppBaseInvocationActionStatusType';
      actionId: string;
      label: string;
      operation: string;
      allowed: boolean;
      policyReason: string;
      effectiveRatePerHour: number;
      usedLastHour: number;
      concurrencyLimit: number;
      concurrencyUsed: number;
    }>;
  };
};

export type AppBaseOwnRowIdsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  appBaseId: Scalars['String']['input'];
  databaseId: Scalars['String']['input'];
}>;

export type AppBaseOwnRowIdsQuery = {
  __typename?: 'Query';
  appBaseOwnRowIds: Array<string>;
};

export type AppBasePortalInvitationsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  appBaseId: Scalars['String']['input'];
}>;

export type AppBasePortalInvitationsQuery = {
  __typename?: 'Query';
  appBasePortalInvitations: Array<any>;
};

export type CreateAppBasePortalInvitationMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  appBaseId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type CreateAppBasePortalInvitationMutation = {
  __typename?: 'Mutation';
  createAppBasePortalInvitation: any;
};

export type RevokeAppBasePortalInvitationMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  appBaseId: Scalars['String']['input'];
  invitationId: Scalars['String']['input'];
}>;

export type RevokeAppBasePortalInvitationMutation = {
  __typename?: 'Mutation';
  revokeAppBasePortalInvitation: boolean;
};

export type AppBasePortalMembersQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  appBaseId: Scalars['String']['input'];
}>;

export type AppBasePortalMembersQuery = {
  __typename?: 'Query';
  appBasePortalMembers: Array<any>;
};

export type AppBaseProductQuotaQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type AppBaseProductQuotaQuery = {
  __typename?: 'Query';
  appBaseProductQuota: any;
};

export type AppBasePublicViewerStateQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  appBaseId: Scalars['String']['input'];
}>;

export type AppBasePublicViewerStateQuery = {
  __typename?: 'Query';
  appBasePublicViewerState: {
    __typename?: 'AppBasePublicViewerStateType';
    viewConfig: any | null;
    publishedVersion: number | null;
  };
};

export type AppBaseRowOwnershipSummaryQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  appBaseId: Scalars['String']['input'];
  databaseId: Scalars['String']['input'];
}>;

export type AppBaseRowOwnershipSummaryQuery = {
  __typename?: 'Query';
  appBaseRowOwnershipSummary: {
    __typename?: 'AppBaseRowOwnershipSummaryType';
    totalRows: number;
    rowsWithoutOwner: number;
    moreOwners: boolean;
    owners: Array<{
      __typename?: 'AppBaseRowOwnerType';
      type: string;
      id: string;
      appBaseId: string | null;
      displayName: string | null;
      rowCount: number;
    }>;
  };
};

export type AppBaseSeoCheckQueryVariables = Exact<{
  appBaseId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
}>;

export type AppBaseSeoCheckQuery = {
  __typename?: 'Query';
  appBaseSeoCheck: {
    __typename?: 'AppBaseSeoCheckType';
    published: boolean;
    apps: Array<{
      __typename?: 'AppSeoCheckAppType';
      key: string;
      title: string;
      status: AppSeoCheckStatus;
      findings: Array<{
        __typename?: 'AppSeoCheckFindingType';
        code: AppSeoCheckCode;
        severity: AppSeoCheckSeverity;
        count: number;
      }>;
    }>;
  } | null;
};

export type AppBaseSeoQueryVariables = Exact<{
  appBaseId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
}>;

export type AppBaseSeoQuery = {
  __typename?: 'Query';
  appBaseSEO: {
    __typename?: 'AppBaseSEOSettingsType';
    appBaseId: string;
    workspaceId: string;
    titlesI18n: any | null;
    descriptionsI18n: any | null;
    slugsI18n: any | null;
    ogImagesI18n: any | null;
    indexing: boolean | null;
    canonicalUrlOverride: string | null;
    jsonLdType: string | null;
    twitterCardType: string | null;
    robotsDirectives: Array<string>;
    structuredData: any | null;
    updatedAt: string;
  } | null;
};

export type AppBaseStateQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;

export type AppBaseStateQuery = { __typename?: 'Query'; appBaseState: any };

export type AppBaseVersionHistoryQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  appBaseId: Scalars['String']['input'];
}>;

export type AppBaseVersionHistoryQuery = {
  __typename?: 'Query';
  appBaseVersionHistory: Array<{
    __typename?: 'AppBaseVersionHistoryEntryType';
    version: number;
    role: AppBaseVersionRole;
    active: boolean;
    current: boolean;
    changeLabel: string | null;
    changeSource: AppBaseVersionChangeSource | null;
    baseVersion: number | null;
    restoredFromVersion: number | null;
    createdBy: string | null;
    createdAt: string;
    publishedAt: string | null;
  }>;
};

export type AppBaseVersionModulesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  appBaseId: Scalars['String']['input'];
  version: Scalars['Int']['input'];
}>;

export type AppBaseVersionModulesQuery = {
  __typename?: 'Query';
  appBaseVersionModules: Array<{
    __typename?: 'AppBaseVersionModuleType';
    mountId: string;
    title: string;
  }>;
};

export type AppBasesByDocIdQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
}>;

export type AppBasesByDocIdQuery = {
  __typename?: 'Query';
  appBasesByDocId: Array<{
    __typename?: 'AppBaseType';
    id: string;
    workspaceId: string;
    docId: string;
    slug: string;
    title: string;
    isPublished: boolean;
  }>;
};

export type AppBasesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type AppBasesQuery = {
  __typename?: 'Query';
  appBases: Array<{
    __typename?: 'AppBaseType';
    id: string;
    workspaceId: string;
    docId: string;
    slug: string;
    title: string;
    config: any;
    isPublished: boolean;
    publishedAt: string | null;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type AppBaseAppsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type AppBaseAppsQuery = { __typename?: 'Query'; appBaseApps: any };

export type AppBaseAppAccessQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;

export type AppBaseAppAccessQuery = {
  __typename?: 'Query';
  appBaseAppAccess: any;
};

export type AppBaseAppPermissionMatrixQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;

export type AppBaseAppPermissionMatrixQuery = {
  __typename?: 'Query';
  appBaseAppPermissionMatrix: any;
};

export type AppContainerPlanOverviewQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type AppContainerPlanOverviewQuery = {
  __typename?: 'Query';
  appContainerPlanOverview: any;
};

export type AppContainerPublishedPlanUsageQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  appBaseId: Scalars['String']['input'];
}>;

export type AppContainerPublishedPlanUsageQuery = {
  __typename?: 'Query';
  appContainerPublishedPlanUsage: any | null;
};

export type AppContainersForDeletionQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  docIds?: Array<Scalars['String']['input']> | Scalars['String']['input'];
  appBaseIds?: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type AppContainersForDeletionQuery = {
  __typename?: 'Query';
  appContainersForDeletion: Array<{
    __typename?: 'AppContainerDeletionSource';
    appBaseId: string;
    title: string;
    hasMountedApps: boolean;
  }>;
};

export type AppTableChoicesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  appId?: InputMaybe<Scalars['String']['input']>;
}>;

export type AppTableChoicesQuery = {
  __typename?: 'Query';
  appTableChoices: {
    __typename?: 'AppTableChoicesType';
    choices: Array<{
      __typename?: 'AppTableChoiceType';
      sourceKey: string;
      label: string;
      reason: string;
    }>;
    retained: Array<{
      __typename?: 'AppTableChoiceType';
      sourceKey: string;
      label: string;
      reason: string;
    }>;
  };
};

export type ApplyAppBaseDevelopmentMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  input: Scalars['JSONObject']['input'];
  change?: InputMaybe<AppBaseDraftChangeInput>;
}>;

export type ApplyAppBaseDevelopmentMutation = {
  __typename?: 'Mutation';
  applyAppBaseDevelopment: any;
};

export type AttachExistingAppBaseDatabaseMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  input: AttachAppBaseDatabaseInput;
}>;

export type AttachExistingAppBaseDatabaseMutation = {
  __typename?: 'Mutation';
  attachExistingAppBaseDatabase: any;
};

export type AutomationTrashMutationVariables = Exact<{
  input: AutomationLifecycleInput;
}>;

export type AutomationTrashMutation = {
  __typename?: 'Mutation';
  automationTrash: {
    __typename?: 'AutomationLifecycleReceipt';
    operationId: string;
    state: string;
  };
};

export type AutomationRestoreMutationVariables = Exact<{
  input: AutomationLifecycleInput;
}>;

export type AutomationRestoreMutation = {
  __typename?: 'Mutation';
  automationRestore: {
    __typename?: 'AutomationLifecycleReceipt';
    operationId: string;
    state: string;
  };
};

export type AutomationDeleteMutationVariables = Exact<{
  input: AutomationLifecycleInput;
}>;

export type AutomationDeleteMutation = {
  __typename?: 'Mutation';
  automationDelete: {
    __typename?: 'AutomationLifecycleReceipt';
    operationId: string;
    state: string;
  };
};

export type BeginContentEntryChangeMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  appBaseId: Scalars['String']['input'];
  sourceKey: Scalars['String']['input'];
  rowId: Scalars['String']['input'];
}>;

export type BeginContentEntryChangeMutation = {
  __typename?: 'Mutation';
  beginContentEntryChange: {
    __typename?: 'ContentEntryResultType';
    rowId: string;
    status: ContentEntryResultStatus;
    liveVersion: number | null;
    hasOpenChanges: boolean;
  };
};

export type DeleteBlobMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  key: Scalars['String']['input'];
  permanently?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type DeleteBlobMutation = {
  __typename?: 'Mutation';
  deleteBlob: boolean;
};

export type ListBlobsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type ListBlobsQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    blobs: Array<{
      __typename?: 'ListedBlob';
      key: string;
      size: number;
      mime: string;
      createdAt: string;
    }>;
  };
};

export type ReleaseDeletedBlobsMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type ReleaseDeletedBlobsMutation = {
  __typename?: 'Mutation';
  releaseDeletedBlobs: boolean;
};

export type SetBlobMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  blob: Scalars['Upload']['input'];
}>;

export type SetBlobMutation = { __typename?: 'Mutation'; setBlob: string };

export type BlockInviteEligibleRecipientsQueryVariables = Exact<{
  input: BlockInviteEligibilityInput;
}>;

export type BlockInviteEligibleRecipientsQuery = {
  __typename?: 'Query';
  blockInviteEligibleRecipients: {
    __typename?: 'BlockInviteEligibleRecipientsType';
    users: Array<{
      __typename?: 'BlockInviteEligibleUserType';
      id: string;
      name: string | null;
      email: string;
      avatarUrl: string | null;
      role: DocRole;
    }>;
    groups: Array<{
      __typename?: 'BlockInviteEligibleGroupType';
      id: string;
      name: string;
      description: string | null;
      memberCount: number;
    }>;
    ineligible: Array<{
      __typename?: 'BlockInviteIneligibleTargetType';
      id: string;
      type: BlockInviteTargetType;
      reason: BlockInviteIneligibleReason;
      detail: string | null;
    }>;
  };
};

export type BrandedSubdomainRenameAvailabilityQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type BrandedSubdomainRenameAvailabilityQuery = {
  __typename?: 'Query';
  brandedSubdomainRenameAvailability: {
    __typename?: 'BrandedSubdomainRenameAvailabilityType';
    canRename: boolean;
    nextRenameAt: string | null;
    currentLabel: string | null;
  };
};

export type CancelAccountDeletionMutationVariables = Exact<{
  [key: string]: never;
}>;

export type CancelAccountDeletionMutation = {
  __typename?: 'Mutation';
  cancelAccountDeletion: {
    __typename?: 'AccountDeletionStatus';
    scheduled: boolean;
    scheduledAt: string | null;
    finalizesAt: string | null;
    reactivatable: boolean;
    gracePeriodDays: number;
  };
};

export type CancelCreditSubscriptionMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  creditPackId: Scalars['String']['input'];
}>;

export type CancelCreditSubscriptionMutation = {
  __typename?: 'Mutation';
  cancelCreditSubscription: boolean;
};

export type CancelPendingIntervalChangeMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  type: Scalars['String']['input'];
  creditPackId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CancelPendingIntervalChangeMutation = {
  __typename?: 'Mutation';
  cancelPendingIntervalChange: boolean;
};

export type CancelSubscriptionMutationVariables = Exact<{
  language?: InputMaybe<Scalars['String']['input']>;
  plan: Scalars['String']['input'];
  terminationReason?: InputMaybe<Scalars['String']['input']>;
  terminationType?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CancelSubscriptionMutation = {
  __typename?: 'Mutation';
  cancelSubscription: {
    __typename?: 'SubscriptionType';
    id: string | null;
    status: SubscriptionStatus;
    nextBillAt: string | null;
    canceledAt: string | null;
  };
};

export type ChangeEmailMutationVariables = Exact<{
  token: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;

export type ChangeEmailMutation = {
  __typename?: 'Mutation';
  changeEmail: { __typename?: 'UserType'; id: string; email: string };
};

export type ChangePasswordMutationVariables = Exact<{
  token: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;

export type ChangePasswordMutation = {
  __typename?: 'Mutation';
  changePassword: boolean;
};

export type ClearAppBaseBandwidthBudgetMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  appBaseId: Scalars['String']['input'];
}>;

export type ClearAppBaseBandwidthBudgetMutation = {
  __typename?: 'Mutation';
  clearAppBaseBandwidthBudget: boolean;
};

export type ListCommentChangesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
  pagination: PaginationInput;
}>;

export type ListCommentChangesQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    commentChanges: {
      __typename?: 'PaginatedCommentChangeObjectType';
      totalCount: number;
      edges: Array<{
        __typename?: 'CommentChangeObjectTypeEdge';
        cursor: string;
        node: {
          __typename?: 'CommentChangeObjectType';
          action: CommentChangeAction;
          id: string;
          commentId: string | null;
          item: any;
        };
      }>;
      pageInfo: {
        __typename?: 'PageInfo';
        startCursor: string | null;
        endCursor: string | null;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
      };
    };
  };
};

export type CreateCommentMutationVariables = Exact<{
  input: CommentCreateInput;
}>;

export type CreateCommentMutation = {
  __typename?: 'Mutation';
  createComment: {
    __typename?: 'CommentObjectType';
    id: string;
    content: any;
    resolved: boolean;
    targetBlockIds: Array<string>;
    createdAt: string;
    updatedAt: string;
    user: {
      __typename?: 'PublicUserType';
      id: string;
      name: string;
      avatarUrl: string | null;
    };
    replies: Array<{
      __typename?: 'ReplyObjectType';
      commentId: string;
      id: string;
      content: any;
      createdAt: string;
      updatedAt: string;
      user: {
        __typename?: 'PublicUserType';
        id: string;
        name: string;
        avatarUrl: string | null;
      };
    }>;
  };
};

export type DeleteCommentMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;

export type DeleteCommentMutation = {
  __typename?: 'Mutation';
  deleteComment: boolean;
};

export type ListCommentsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
}>;

export type ListCommentsQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    comments: {
      __typename?: 'PaginatedCommentObjectType';
      totalCount: number;
      edges: Array<{
        __typename?: 'CommentObjectTypeEdge';
        cursor: string;
        node: {
          __typename?: 'CommentObjectType';
          id: string;
          content: any;
          resolved: boolean;
          targetBlockIds: Array<string>;
          createdAt: string;
          updatedAt: string;
          user: {
            __typename?: 'PublicUserType';
            id: string;
            name: string;
            avatarUrl: string | null;
          };
          replies: Array<{
            __typename?: 'ReplyObjectType';
            commentId: string;
            id: string;
            content: any;
            createdAt: string;
            updatedAt: string;
            user: {
              __typename?: 'PublicUserType';
              id: string;
              name: string;
              avatarUrl: string | null;
            };
          }>;
        };
      }>;
      pageInfo: {
        __typename?: 'PageInfo';
        startCursor: string | null;
        endCursor: string | null;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
      };
    };
  };
};

export type CreateReplyMutationVariables = Exact<{
  input: ReplyCreateInput;
}>;

export type CreateReplyMutation = {
  __typename?: 'Mutation';
  createReply: {
    __typename?: 'ReplyObjectType';
    commentId: string;
    id: string;
    content: any;
    createdAt: string;
    updatedAt: string;
    user: {
      __typename?: 'PublicUserType';
      id: string;
      name: string;
      avatarUrl: string | null;
    };
  };
};

export type DeleteReplyMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;

export type DeleteReplyMutation = {
  __typename?: 'Mutation';
  deleteReply: boolean;
};

export type UpdateReplyMutationVariables = Exact<{
  input: ReplyUpdateInput;
}>;

export type UpdateReplyMutation = {
  __typename?: 'Mutation';
  updateReply: boolean;
};

export type ResolveCommentMutationVariables = Exact<{
  input: CommentResolveInput;
}>;

export type ResolveCommentMutation = {
  __typename?: 'Mutation';
  resolveComment: boolean;
};

export type UpdateCommentMutationVariables = Exact<{
  input: CommentUpdateInput;
}>;

export type UpdateCommentMutation = {
  __typename?: 'Mutation';
  updateComment: boolean;
};

export type UploadCommentAttachmentMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
  attachment: Scalars['Upload']['input'];
}>;

export type UploadCommentAttachmentMutation = {
  __typename?: 'Mutation';
  uploadCommentAttachment: string;
};

export type ContentEntryOpenChangesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  appBaseId: Scalars['String']['input'];
  sourceKey: Scalars['String']['input'];
}>;

export type ContentEntryOpenChangesQuery = {
  __typename?: 'Query';
  contentEntryOpenChanges: Array<{
    __typename?: 'ContentEntryOpenChangeType';
    rowId: string;
    liveVersion: number;
    openedAt: string;
    openedBy: string;
  }>;
};

export type ContentEntryVersionsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  appBaseId: Scalars['String']['input'];
  sourceKey: Scalars['String']['input'];
  rowId: Scalars['String']['input'];
}>;

export type ContentEntryVersionsQuery = {
  __typename?: 'Query';
  contentEntryVersions: Array<{
    __typename?: 'ContentEntryVersionType';
    version: number;
    live: boolean;
    createdAt: string;
    createdBy: string | null;
  }>;
};

export type AddContextBlobMutationVariables = Exact<{
  options: AddContextBlobInput;
}>;

export type AddContextBlobMutation = {
  __typename?: 'Mutation';
  addContextBlob: {
    __typename?: 'CopilotContextBlob';
    id: string;
    createdAt: number;
  };
};

export type RemoveContextBlobMutationVariables = Exact<{
  options: RemoveContextBlobInput;
}>;

export type RemoveContextBlobMutation = {
  __typename?: 'Mutation';
  removeContextBlob: boolean;
};

export type AddContextCategoryMutationVariables = Exact<{
  options: AddContextCategoryInput;
}>;

export type AddContextCategoryMutation = {
  __typename?: 'Mutation';
  addContextCategory: {
    __typename?: 'CopilotContextCategory';
    id: string;
    createdAt: number;
    type: ContextCategories;
    docs: Array<{
      __typename?: 'CopilotContextDoc';
      id: string;
      createdAt: number;
    }>;
  };
};

export type RemoveContextCategoryMutationVariables = Exact<{
  options: RemoveContextCategoryInput;
}>;

export type RemoveContextCategoryMutation = {
  __typename?: 'Mutation';
  removeContextCategory: boolean;
};

export type CreateCopilotContextMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
}>;

export type CreateCopilotContextMutation = {
  __typename?: 'Mutation';
  createCopilotContext: string;
};

export type AddContextDocMutationVariables = Exact<{
  options: AddContextDocInput;
}>;

export type AddContextDocMutation = {
  __typename?: 'Mutation';
  addContextDoc: {
    __typename?: 'CopilotContextDoc';
    id: string;
    createdAt: number;
  };
};

export type RemoveContextDocMutationVariables = Exact<{
  options: RemoveContextDocInput;
}>;

export type RemoveContextDocMutation = {
  __typename?: 'Mutation';
  removeContextDoc: boolean;
};

export type AddContextFileMutationVariables = Exact<{
  content: Scalars['Upload']['input'];
  options: AddContextFileInput;
}>;

export type AddContextFileMutation = {
  __typename?: 'Mutation';
  addContextFile: {
    __typename?: 'CopilotContextFile';
    id: string;
    createdAt: number;
    name: string;
    mimeType: string;
    chunkSize: number;
    blobId: string;
  };
};

export type RemoveContextFileMutationVariables = Exact<{
  options: RemoveContextFileInput;
}>;

export type RemoveContextFileMutation = {
  __typename?: 'Mutation';
  removeContextFile: boolean;
};

export type ListContextObjectQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
  contextId: Scalars['String']['input'];
}>;

export type ListContextObjectQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'UserType';
    copilot: {
      __typename?: 'Copilot';
      contexts: Array<{
        __typename?: 'CopilotContext';
        blobs: Array<{
          __typename?: 'CopilotContextBlob';
          id: string;
          createdAt: number;
        }>;
        docs: Array<{
          __typename?: 'CopilotContextDoc';
          id: string;
          createdAt: number;
        }>;
        files: Array<{
          __typename?: 'CopilotContextFile';
          id: string;
          name: string;
          mimeType: string;
          blobId: string;
          chunkSize: number;
          createdAt: number;
        }>;
        tags: Array<{
          __typename?: 'CopilotContextCategory';
          type: ContextCategories;
          id: string;
          createdAt: number;
          docs: Array<{
            __typename?: 'CopilotContextDoc';
            id: string;
            createdAt: number;
          }>;
        }>;
        collections: Array<{
          __typename?: 'CopilotContextCategory';
          type: ContextCategories;
          id: string;
          createdAt: number;
          docs: Array<{
            __typename?: 'CopilotContextDoc';
            id: string;
            createdAt: number;
          }>;
        }>;
      }>;
    };
  } | null;
};

export type ListContextQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
}>;

export type ListContextQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'UserType';
    copilot: {
      __typename?: 'Copilot';
      contexts: Array<{
        __typename?: 'CopilotContext';
        id: string | null;
        workspaceId: string;
      }>;
    };
  } | null;
};

export type MatchContextQueryVariables = Exact<{
  contextId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['SafeInt']['input']>;
  scopedThreshold?: InputMaybe<Scalars['Float']['input']>;
  threshold?: InputMaybe<Scalars['Float']['input']>;
}>;

export type MatchContextQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'UserType';
    copilot: {
      __typename?: 'Copilot';
      contexts: Array<{
        __typename?: 'CopilotContext';
        matchFiles: Array<{
          __typename?: 'ContextMatchedFileChunk';
          fileId: string;
          blobId: string;
          name: string;
          mimeType: string;
          chunk: number;
          content: string;
          distance: number | null;
        }>;
        matchWorkspaceDocs: Array<{
          __typename?: 'ContextMatchedDocChunk';
          docId: string;
          chunk: number;
          content: string;
          distance: number | null;
        }>;
      }>;
    };
  } | null;
};

export type MatchWorkspaceDocsQueryVariables = Exact<{
  contextId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['SafeInt']['input']>;
  scopedThreshold?: InputMaybe<Scalars['Float']['input']>;
  threshold?: InputMaybe<Scalars['Float']['input']>;
}>;

export type MatchWorkspaceDocsQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'UserType';
    copilot: {
      __typename?: 'Copilot';
      contexts: Array<{
        __typename?: 'CopilotContext';
        matchWorkspaceDocs: Array<{
          __typename?: 'ContextMatchedDocChunk';
          docId: string;
          chunk: number;
          content: string;
          distance: number | null;
        }>;
      }>;
    };
  } | null;
};

export type MatchFilesQueryVariables = Exact<{
  contextId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['SafeInt']['input']>;
  scopedThreshold?: InputMaybe<Scalars['Float']['input']>;
  threshold?: InputMaybe<Scalars['Float']['input']>;
}>;

export type MatchFilesQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'UserType';
    copilot: {
      __typename?: 'Copilot';
      contexts: Array<{
        __typename?: 'CopilotContext';
        matchFiles: Array<{
          __typename?: 'ContextMatchedFileChunk';
          fileId: string;
          blobId: string;
          chunk: number;
          content: string;
          distance: number | null;
        }>;
      }>;
    };
  } | null;
};

export type GetWorkspaceEmbeddingStatusQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type GetWorkspaceEmbeddingStatusQuery = {
  __typename?: 'Query';
  queryWorkspaceEmbeddingStatus: {
    __typename?: 'ContextWorkspaceEmbeddingStatus';
    total: number;
    embedded: number;
  };
};

export type QueueWorkspaceEmbeddingMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  docId: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type QueueWorkspaceEmbeddingMutation = {
  __typename?: 'Mutation';
  queueWorkspaceEmbedding: boolean;
};

export type GetCopilotHistoryIdsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  pagination: PaginationInput;
  docId?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<QueryChatHistoriesInput>;
}>;

export type GetCopilotHistoryIdsQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'UserType';
    copilot: {
      __typename?: 'Copilot';
      chats: {
        __typename?: 'PaginatedCopilotHistoriesType';
        pageInfo: {
          __typename?: 'PageInfo';
          hasNextPage: boolean;
          hasPreviousPage: boolean;
          startCursor: string | null;
          endCursor: string | null;
        };
        edges: Array<{
          __typename?: 'CopilotHistoriesTypeEdge';
          cursor: string;
          node: {
            __typename?: 'CopilotHistories';
            sessionId: string;
            pinned: boolean;
            messages: Array<{
              __typename?: 'ChatMessage';
              id: string | null;
              role: string;
              createdAt: string;
            }>;
          };
        }>;
      };
    };
  } | null;
};

export type GetCopilotDocSessionsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
  pagination: PaginationInput;
  options?: InputMaybe<QueryChatHistoriesInput>;
}>;

export type GetCopilotDocSessionsQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'UserType';
    copilot: {
      __typename?: 'Copilot';
      chats: {
        __typename?: 'PaginatedCopilotHistoriesType';
        pageInfo: {
          __typename?: 'PageInfo';
          hasNextPage: boolean;
          hasPreviousPage: boolean;
          startCursor: string | null;
          endCursor: string | null;
        };
        edges: Array<{
          __typename?: 'CopilotHistoriesTypeEdge';
          cursor: string;
          node: {
            __typename?: 'CopilotHistories';
            sessionId: string;
            agentStatus: CopilotAgentStatus;
            workspaceId: string;
            docId: string | null;
            parentSessionId: string | null;
            promptName: string;
            model: string;
            reasoningMode: string;
            optionalModels: Array<string>;
            action: string | null;
            pinned: boolean;
            title: string | null;
            tokens: number;
            createdAt: string;
            updatedAt: string;
            messages: Array<{
              __typename?: 'ChatMessage';
              id: string | null;
              role: string;
              content: string;
              attachments: Array<string> | null;
              createdAt: string;
              messageType: MessageType | null;
              streamObjects: Array<{
                __typename?: 'StreamObject';
                type: string;
                textDelta: string | null;
                toolCallId: string | null;
                toolName: string | null;
                args: Record<string, string> | null;
                result: Record<string, string> | null;
                durationMs: number | null;
              }> | null;
              context: {
                __typename?: 'MessageContextType';
                docId: string | null;
                searchMode: SearchMode | null;
                items: Array<{
                  __typename?: 'MessageContextItemType';
                  id: string;
                  kind: MessageContextItemKind;
                  label: string;
                  subtitle: string | null;
                  source: ContextSource;
                  priority: ContextPriority;
                  refs: any;
                  payload: any | null;
                  display: {
                    __typename?: 'MessageContextDisplayType';
                    title: string;
                    subtitle: string | null;
                    icon: string | null;
                    preview: string | null;
                    unavailable: boolean | null;
                    unavailableReason: string | null;
                  };
                }>;
              } | null;
              sources: {
                __typename?: 'AssistantSourceManifestType';
                items: Array<{
                  __typename?: 'AssistantSourceItemType';
                  id: string;
                  kind: string;
                  label: string;
                  refs: any;
                  payload: any | null;
                  display: {
                    __typename?: 'MessageContextDisplayType';
                    title: string;
                    subtitle: string | null;
                    icon: string | null;
                    preview: string | null;
                    unavailable: boolean | null;
                    unavailableReason: string | null;
                  };
                }>;
              } | null;
              toolData: {
                __typename?: 'ToolMessageData';
                approvalId: string | null;
                description: string | null;
                confirmationCopy: Record<string, string> | null;
                approved: boolean | null;
                reason: string | null;
                includesAgentMode: boolean | null;
                includesTargetMode: boolean | null;
                toolCallId: string | null;
                toolName: string | null;
                success: boolean | null;
                result: Record<string, string> | null;
                error: string | null;
                toolCall: {
                  __typename?: 'ToolCallInfo';
                  name: string;
                  arguments: Record<string, string> | null;
                } | null;
                goalTurn: {
                  __typename?: 'ChatGoalTurnMessage';
                  goalId: string;
                  kind: string;
                  stepLabel: string | null;
                } | null;
                toolResults: Array<{
                  __typename?: 'ToolResultSummary';
                  toolCallId: string;
                  toolName: string;
                  displayName: string | null;
                  success: boolean;
                  result: Record<string, string> | null;
                  durationMs: number | null;
                }> | null;
              } | null;
            }>;
          };
        }>;
      };
    };
  } | null;
};

export type GetCopilotPinnedSessionsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  docId?: InputMaybe<Scalars['String']['input']>;
  messageOrder?: InputMaybe<ChatHistoryOrder>;
  withPrompt?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetCopilotPinnedSessionsQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'UserType';
    copilot: {
      __typename?: 'Copilot';
      chats: {
        __typename?: 'PaginatedCopilotHistoriesType';
        pageInfo: {
          __typename?: 'PageInfo';
          hasNextPage: boolean;
          hasPreviousPage: boolean;
          startCursor: string | null;
          endCursor: string | null;
        };
        edges: Array<{
          __typename?: 'CopilotHistoriesTypeEdge';
          cursor: string;
          node: {
            __typename?: 'CopilotHistories';
            sessionId: string;
            agentStatus: CopilotAgentStatus;
            workspaceId: string;
            docId: string | null;
            parentSessionId: string | null;
            promptName: string;
            model: string;
            reasoningMode: string;
            optionalModels: Array<string>;
            action: string | null;
            pinned: boolean;
            title: string | null;
            tokens: number;
            createdAt: string;
            updatedAt: string;
            messages: Array<{
              __typename?: 'ChatMessage';
              id: string | null;
              role: string;
              content: string;
              attachments: Array<string> | null;
              createdAt: string;
              messageType: MessageType | null;
              streamObjects: Array<{
                __typename?: 'StreamObject';
                type: string;
                textDelta: string | null;
                toolCallId: string | null;
                toolName: string | null;
                args: Record<string, string> | null;
                result: Record<string, string> | null;
                durationMs: number | null;
              }> | null;
              context: {
                __typename?: 'MessageContextType';
                docId: string | null;
                searchMode: SearchMode | null;
                items: Array<{
                  __typename?: 'MessageContextItemType';
                  id: string;
                  kind: MessageContextItemKind;
                  label: string;
                  subtitle: string | null;
                  source: ContextSource;
                  priority: ContextPriority;
                  refs: any;
                  payload: any | null;
                  display: {
                    __typename?: 'MessageContextDisplayType';
                    title: string;
                    subtitle: string | null;
                    icon: string | null;
                    preview: string | null;
                    unavailable: boolean | null;
                    unavailableReason: string | null;
                  };
                }>;
              } | null;
              sources: {
                __typename?: 'AssistantSourceManifestType';
                items: Array<{
                  __typename?: 'AssistantSourceItemType';
                  id: string;
                  kind: string;
                  label: string;
                  refs: any;
                  payload: any | null;
                  display: {
                    __typename?: 'MessageContextDisplayType';
                    title: string;
                    subtitle: string | null;
                    icon: string | null;
                    preview: string | null;
                    unavailable: boolean | null;
                    unavailableReason: string | null;
                  };
                }>;
              } | null;
              toolData: {
                __typename?: 'ToolMessageData';
                approvalId: string | null;
                description: string | null;
                confirmationCopy: Record<string, string> | null;
                approved: boolean | null;
                reason: string | null;
                includesAgentMode: boolean | null;
                includesTargetMode: boolean | null;
                toolCallId: string | null;
                toolName: string | null;
                success: boolean | null;
                result: Record<string, string> | null;
                error: string | null;
                toolCall: {
                  __typename?: 'ToolCallInfo';
                  name: string;
                  arguments: Record<string, string> | null;
                } | null;
                goalTurn: {
                  __typename?: 'ChatGoalTurnMessage';
                  goalId: string;
                  kind: string;
                  stepLabel: string | null;
                } | null;
                toolResults: Array<{
                  __typename?: 'ToolResultSummary';
                  toolCallId: string;
                  toolName: string;
                  displayName: string | null;
                  success: boolean;
                  result: Record<string, string> | null;
                  durationMs: number | null;
                }> | null;
              } | null;
            }>;
          };
        }>;
      };
    };
  } | null;
};

export type GetCopilotWorkspaceSessionsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  pagination: PaginationInput;
  options?: InputMaybe<QueryChatHistoriesInput>;
}>;

export type GetCopilotWorkspaceSessionsQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'UserType';
    copilot: {
      __typename?: 'Copilot';
      chats: {
        __typename?: 'PaginatedCopilotHistoriesType';
        pageInfo: {
          __typename?: 'PageInfo';
          hasNextPage: boolean;
          hasPreviousPage: boolean;
          startCursor: string | null;
          endCursor: string | null;
        };
        edges: Array<{
          __typename?: 'CopilotHistoriesTypeEdge';
          cursor: string;
          node: {
            __typename?: 'CopilotHistories';
            sessionId: string;
            agentStatus: CopilotAgentStatus;
            workspaceId: string;
            docId: string | null;
            parentSessionId: string | null;
            promptName: string;
            model: string;
            reasoningMode: string;
            optionalModels: Array<string>;
            action: string | null;
            pinned: boolean;
            title: string | null;
            tokens: number;
            createdAt: string;
            updatedAt: string;
            messages: Array<{
              __typename?: 'ChatMessage';
              id: string | null;
              role: string;
              content: string;
              attachments: Array<string> | null;
              createdAt: string;
              messageType: MessageType | null;
              streamObjects: Array<{
                __typename?: 'StreamObject';
                type: string;
                textDelta: string | null;
                toolCallId: string | null;
                toolName: string | null;
                args: Record<string, string> | null;
                result: Record<string, string> | null;
                durationMs: number | null;
              }> | null;
              context: {
                __typename?: 'MessageContextType';
                docId: string | null;
                searchMode: SearchMode | null;
                items: Array<{
                  __typename?: 'MessageContextItemType';
                  id: string;
                  kind: MessageContextItemKind;
                  label: string;
                  subtitle: string | null;
                  source: ContextSource;
                  priority: ContextPriority;
                  refs: any;
                  payload: any | null;
                  display: {
                    __typename?: 'MessageContextDisplayType';
                    title: string;
                    subtitle: string | null;
                    icon: string | null;
                    preview: string | null;
                    unavailable: boolean | null;
                    unavailableReason: string | null;
                  };
                }>;
              } | null;
              sources: {
                __typename?: 'AssistantSourceManifestType';
                items: Array<{
                  __typename?: 'AssistantSourceItemType';
                  id: string;
                  kind: string;
                  label: string;
                  refs: any;
                  payload: any | null;
                  display: {
                    __typename?: 'MessageContextDisplayType';
                    title: string;
                    subtitle: string | null;
                    icon: string | null;
                    preview: string | null;
                    unavailable: boolean | null;
                    unavailableReason: string | null;
                  };
                }>;
              } | null;
              toolData: {
                __typename?: 'ToolMessageData';
                approvalId: string | null;
                description: string | null;
                confirmationCopy: Record<string, string> | null;
                approved: boolean | null;
                reason: string | null;
                includesAgentMode: boolean | null;
                includesTargetMode: boolean | null;
                toolCallId: string | null;
                toolName: string | null;
                success: boolean | null;
                result: Record<string, string> | null;
                error: string | null;
                toolCall: {
                  __typename?: 'ToolCallInfo';
                  name: string;
                  arguments: Record<string, string> | null;
                } | null;
                goalTurn: {
                  __typename?: 'ChatGoalTurnMessage';
                  goalId: string;
                  kind: string;
                  stepLabel: string | null;
                } | null;
                toolResults: Array<{
                  __typename?: 'ToolResultSummary';
                  toolCallId: string;
                  toolName: string;
                  displayName: string | null;
                  success: boolean;
                  result: Record<string, string> | null;
                  durationMs: number | null;
                }> | null;
              } | null;
            }>;
          };
        }>;
      };
    };
  } | null;
};

export type GetCopilotHistoriesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  pagination: PaginationInput;
  docId?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<QueryChatHistoriesInput>;
}>;

export type GetCopilotHistoriesQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'UserType';
    copilot: {
      __typename?: 'Copilot';
      chats: {
        __typename?: 'PaginatedCopilotHistoriesType';
        pageInfo: {
          __typename?: 'PageInfo';
          hasNextPage: boolean;
          hasPreviousPage: boolean;
          startCursor: string | null;
          endCursor: string | null;
        };
        edges: Array<{
          __typename?: 'CopilotHistoriesTypeEdge';
          cursor: string;
          node: {
            __typename?: 'CopilotHistories';
            sessionId: string;
            agentStatus: CopilotAgentStatus;
            workspaceId: string;
            docId: string | null;
            parentSessionId: string | null;
            promptName: string;
            model: string;
            reasoningMode: string;
            optionalModels: Array<string>;
            action: string | null;
            pinned: boolean;
            title: string | null;
            tokens: number;
            createdAt: string;
            updatedAt: string;
            messages: Array<{
              __typename?: 'ChatMessage';
              id: string | null;
              role: string;
              content: string;
              attachments: Array<string> | null;
              createdAt: string;
              messageType: MessageType | null;
              streamObjects: Array<{
                __typename?: 'StreamObject';
                type: string;
                textDelta: string | null;
                toolCallId: string | null;
                toolName: string | null;
                args: Record<string, string> | null;
                result: Record<string, string> | null;
                durationMs: number | null;
              }> | null;
              context: {
                __typename?: 'MessageContextType';
                docId: string | null;
                searchMode: SearchMode | null;
                items: Array<{
                  __typename?: 'MessageContextItemType';
                  id: string;
                  kind: MessageContextItemKind;
                  label: string;
                  subtitle: string | null;
                  source: ContextSource;
                  priority: ContextPriority;
                  refs: any;
                  payload: any | null;
                  display: {
                    __typename?: 'MessageContextDisplayType';
                    title: string;
                    subtitle: string | null;
                    icon: string | null;
                    preview: string | null;
                    unavailable: boolean | null;
                    unavailableReason: string | null;
                  };
                }>;
              } | null;
              sources: {
                __typename?: 'AssistantSourceManifestType';
                items: Array<{
                  __typename?: 'AssistantSourceItemType';
                  id: string;
                  kind: string;
                  label: string;
                  refs: any;
                  payload: any | null;
                  display: {
                    __typename?: 'MessageContextDisplayType';
                    title: string;
                    subtitle: string | null;
                    icon: string | null;
                    preview: string | null;
                    unavailable: boolean | null;
                    unavailableReason: string | null;
                  };
                }>;
              } | null;
              toolData: {
                __typename?: 'ToolMessageData';
                approvalId: string | null;
                description: string | null;
                confirmationCopy: Record<string, string> | null;
                approved: boolean | null;
                reason: string | null;
                includesAgentMode: boolean | null;
                includesTargetMode: boolean | null;
                toolCallId: string | null;
                toolName: string | null;
                success: boolean | null;
                result: Record<string, string> | null;
                error: string | null;
                toolCall: {
                  __typename?: 'ToolCallInfo';
                  name: string;
                  arguments: Record<string, string> | null;
                } | null;
                goalTurn: {
                  __typename?: 'ChatGoalTurnMessage';
                  goalId: string;
                  kind: string;
                  stepLabel: string | null;
                } | null;
                toolResults: Array<{
                  __typename?: 'ToolResultSummary';
                  toolCallId: string;
                  toolName: string;
                  displayName: string | null;
                  success: boolean;
                  result: Record<string, string> | null;
                  durationMs: number | null;
                }> | null;
              } | null;
            }>;
          };
        }>;
      };
    };
  } | null;
};

export type SubmitAudioTranscriptionMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  blobId: Scalars['String']['input'];
  blob?: InputMaybe<Scalars['Upload']['input']>;
  blobs?: InputMaybe<
    Array<Scalars['Upload']['input']> | Scalars['Upload']['input']
  >;
}>;

export type SubmitAudioTranscriptionMutation = {
  __typename?: 'Mutation';
  submitAudioTranscription: {
    __typename?: 'TranscriptionResultType';
    id: string;
    status: AiJobStatus;
  } | null;
};

export type ClaimAudioTranscriptionMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}>;

export type ClaimAudioTranscriptionMutation = {
  __typename?: 'Mutation';
  claimAudioTranscription: {
    __typename?: 'TranscriptionResultType';
    id: string;
    status: AiJobStatus;
    title: string | null;
    summary: string | null;
    actions: string | null;
    transcription: Array<{
      __typename?: 'TranscriptionItemType';
      speaker: string;
      start: string;
      end: string;
      transcription: string;
    }> | null;
  } | null;
};

export type GetAudioTranscriptionQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  jobId?: InputMaybe<Scalars['String']['input']>;
  blobId?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetAudioTranscriptionQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'UserType';
    copilot: {
      __typename?: 'Copilot';
      audioTranscription: {
        __typename?: 'TranscriptionResultType';
        id: string;
        status: AiJobStatus;
        title: string | null;
        summary: string | null;
        transcription: Array<{
          __typename?: 'TranscriptionItemType';
          speaker: string;
          start: string;
          end: string;
          transcription: string;
        }> | null;
      } | null;
    };
  } | null;
};

export type RetryAudioTranscriptionMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  jobId: Scalars['String']['input'];
}>;

export type RetryAudioTranscriptionMutation = {
  __typename?: 'Mutation';
  retryAudioTranscription: {
    __typename?: 'TranscriptionResultType';
    id: string;
    status: AiJobStatus;
  } | null;
};

export type CreateCopilotMessageMutationVariables = Exact<{
  options: CreateChatMessageInput;
}>;

export type CreateCopilotMessageMutation = {
  __typename?: 'Mutation';
  createCopilotMessage: string;
};

export type GetPromptModelsQueryVariables = Exact<{
  promptName: Scalars['String']['input'];
}>;

export type GetPromptModelsQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'UserType';
    copilot: {
      __typename?: 'Copilot';
      models: {
        __typename?: 'CopilotModelsType';
        defaultModel: string;
        optionalModels: Array<{
          __typename?: 'CopilotModelType';
          id: string;
          name: string;
          providerId: string;
          providerName: string;
          tier: string;
          costMultiplier: number;
        }>;
        proModels: Array<{
          __typename?: 'CopilotModelType';
          id: string;
          name: string;
        }>;
      };
    };
  } | null;
};

export type CopilotQuotaQueryVariables = Exact<{ [key: string]: never }>;

export type CopilotQuotaQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'UserType';
    copilot: {
      __typename?: 'Copilot';
      quota: {
        __typename?: 'CopilotQuota';
        limit: number | null;
        used: number;
      };
    };
  } | null;
};

export type CleanupCopilotSessionMutationVariables = Exact<{
  input: DeleteSessionInput;
}>;

export type CleanupCopilotSessionMutation = {
  __typename?: 'Mutation';
  cleanupCopilotSession: Array<string>;
};

export type CreateCopilotSessionMutationVariables = Exact<{
  options: CreateChatSessionInput;
}>;

export type CreateCopilotSessionMutation = {
  __typename?: 'Mutation';
  createCopilotSession: string;
};

export type ForkCopilotSessionMutationVariables = Exact<{
  options: ForkChatSessionInput;
}>;

export type ForkCopilotSessionMutation = {
  __typename?: 'Mutation';
  forkCopilotSession: string;
};

export type GetCopilotLatestDocSessionQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
}>;

export type GetCopilotLatestDocSessionQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'UserType';
    copilot: {
      __typename?: 'Copilot';
      chats: {
        __typename?: 'PaginatedCopilotHistoriesType';
        pageInfo: {
          __typename?: 'PageInfo';
          hasNextPage: boolean;
          hasPreviousPage: boolean;
          startCursor: string | null;
          endCursor: string | null;
        };
        edges: Array<{
          __typename?: 'CopilotHistoriesTypeEdge';
          cursor: string;
          node: {
            __typename?: 'CopilotHistories';
            sessionId: string;
            agentStatus: CopilotAgentStatus;
            workspaceId: string;
            docId: string | null;
            parentSessionId: string | null;
            promptName: string;
            model: string;
            reasoningMode: string;
            optionalModels: Array<string>;
            action: string | null;
            pinned: boolean;
            title: string | null;
            tokens: number;
            createdAt: string;
            updatedAt: string;
            messages: Array<{
              __typename?: 'ChatMessage';
              id: string | null;
              role: string;
              content: string;
              attachments: Array<string> | null;
              createdAt: string;
              messageType: MessageType | null;
              streamObjects: Array<{
                __typename?: 'StreamObject';
                type: string;
                textDelta: string | null;
                toolCallId: string | null;
                toolName: string | null;
                args: Record<string, string> | null;
                result: Record<string, string> | null;
                durationMs: number | null;
              }> | null;
              context: {
                __typename?: 'MessageContextType';
                docId: string | null;
                searchMode: SearchMode | null;
                items: Array<{
                  __typename?: 'MessageContextItemType';
                  id: string;
                  kind: MessageContextItemKind;
                  label: string;
                  subtitle: string | null;
                  source: ContextSource;
                  priority: ContextPriority;
                  refs: any;
                  payload: any | null;
                  display: {
                    __typename?: 'MessageContextDisplayType';
                    title: string;
                    subtitle: string | null;
                    icon: string | null;
                    preview: string | null;
                    unavailable: boolean | null;
                    unavailableReason: string | null;
                  };
                }>;
              } | null;
              sources: {
                __typename?: 'AssistantSourceManifestType';
                items: Array<{
                  __typename?: 'AssistantSourceItemType';
                  id: string;
                  kind: string;
                  label: string;
                  refs: any;
                  payload: any | null;
                  display: {
                    __typename?: 'MessageContextDisplayType';
                    title: string;
                    subtitle: string | null;
                    icon: string | null;
                    preview: string | null;
                    unavailable: boolean | null;
                    unavailableReason: string | null;
                  };
                }>;
              } | null;
              toolData: {
                __typename?: 'ToolMessageData';
                approvalId: string | null;
                description: string | null;
                confirmationCopy: Record<string, string> | null;
                approved: boolean | null;
                reason: string | null;
                includesAgentMode: boolean | null;
                includesTargetMode: boolean | null;
                toolCallId: string | null;
                toolName: string | null;
                success: boolean | null;
                result: Record<string, string> | null;
                error: string | null;
                toolCall: {
                  __typename?: 'ToolCallInfo';
                  name: string;
                  arguments: Record<string, string> | null;
                } | null;
                goalTurn: {
                  __typename?: 'ChatGoalTurnMessage';
                  goalId: string;
                  kind: string;
                  stepLabel: string | null;
                } | null;
                toolResults: Array<{
                  __typename?: 'ToolResultSummary';
                  toolCallId: string;
                  toolName: string;
                  displayName: string | null;
                  success: boolean;
                  result: Record<string, string> | null;
                  durationMs: number | null;
                }> | null;
              } | null;
            }>;
          };
        }>;
      };
    };
  } | null;
};

export type GetCopilotSessionQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
}>;

export type GetCopilotSessionQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'UserType';
    copilot: {
      __typename?: 'Copilot';
      chats: {
        __typename?: 'PaginatedCopilotHistoriesType';
        pageInfo: {
          __typename?: 'PageInfo';
          hasNextPage: boolean;
          hasPreviousPage: boolean;
          startCursor: string | null;
          endCursor: string | null;
        };
        edges: Array<{
          __typename?: 'CopilotHistoriesTypeEdge';
          cursor: string;
          node: {
            __typename?: 'CopilotHistories';
            sessionId: string;
            agentStatus: CopilotAgentStatus;
            workspaceId: string;
            docId: string | null;
            parentSessionId: string | null;
            promptName: string;
            model: string;
            reasoningMode: string;
            optionalModels: Array<string>;
            action: string | null;
            pinned: boolean;
            title: string | null;
            tokens: number;
            createdAt: string;
            updatedAt: string;
            messages: Array<{
              __typename?: 'ChatMessage';
              id: string | null;
              role: string;
              content: string;
              attachments: Array<string> | null;
              createdAt: string;
              messageType: MessageType | null;
              streamObjects: Array<{
                __typename?: 'StreamObject';
                type: string;
                textDelta: string | null;
                toolCallId: string | null;
                toolName: string | null;
                args: Record<string, string> | null;
                result: Record<string, string> | null;
                durationMs: number | null;
              }> | null;
              context: {
                __typename?: 'MessageContextType';
                docId: string | null;
                searchMode: SearchMode | null;
                items: Array<{
                  __typename?: 'MessageContextItemType';
                  id: string;
                  kind: MessageContextItemKind;
                  label: string;
                  subtitle: string | null;
                  source: ContextSource;
                  priority: ContextPriority;
                  refs: any;
                  payload: any | null;
                  display: {
                    __typename?: 'MessageContextDisplayType';
                    title: string;
                    subtitle: string | null;
                    icon: string | null;
                    preview: string | null;
                    unavailable: boolean | null;
                    unavailableReason: string | null;
                  };
                }>;
              } | null;
              sources: {
                __typename?: 'AssistantSourceManifestType';
                items: Array<{
                  __typename?: 'AssistantSourceItemType';
                  id: string;
                  kind: string;
                  label: string;
                  refs: any;
                  payload: any | null;
                  display: {
                    __typename?: 'MessageContextDisplayType';
                    title: string;
                    subtitle: string | null;
                    icon: string | null;
                    preview: string | null;
                    unavailable: boolean | null;
                    unavailableReason: string | null;
                  };
                }>;
              } | null;
              toolData: {
                __typename?: 'ToolMessageData';
                approvalId: string | null;
                description: string | null;
                confirmationCopy: Record<string, string> | null;
                approved: boolean | null;
                reason: string | null;
                includesAgentMode: boolean | null;
                includesTargetMode: boolean | null;
                toolCallId: string | null;
                toolName: string | null;
                success: boolean | null;
                result: Record<string, string> | null;
                error: string | null;
                toolCall: {
                  __typename?: 'ToolCallInfo';
                  name: string;
                  arguments: Record<string, string> | null;
                } | null;
                goalTurn: {
                  __typename?: 'ChatGoalTurnMessage';
                  goalId: string;
                  kind: string;
                  stepLabel: string | null;
                } | null;
                toolResults: Array<{
                  __typename?: 'ToolResultSummary';
                  toolCallId: string;
                  toolName: string;
                  displayName: string | null;
                  success: boolean;
                  result: Record<string, string> | null;
                  durationMs: number | null;
                }> | null;
              } | null;
            }>;
          };
        }>;
      };
    };
  } | null;
};

export type GetCopilotRecentSessionsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetCopilotRecentSessionsQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'UserType';
    copilot: {
      __typename?: 'Copilot';
      chats: {
        __typename?: 'PaginatedCopilotHistoriesType';
        pageInfo: {
          __typename?: 'PageInfo';
          hasNextPage: boolean;
          hasPreviousPage: boolean;
          startCursor: string | null;
          endCursor: string | null;
        };
        edges: Array<{
          __typename?: 'CopilotHistoriesTypeEdge';
          cursor: string;
          node: {
            __typename?: 'CopilotHistories';
            sessionId: string;
            agentStatus: CopilotAgentStatus;
            workspaceId: string;
            docId: string | null;
            parentSessionId: string | null;
            promptName: string;
            model: string;
            reasoningMode: string;
            optionalModels: Array<string>;
            action: string | null;
            pinned: boolean;
            title: string | null;
            tokens: number;
            createdAt: string;
            updatedAt: string;
            messages: Array<{
              __typename?: 'ChatMessage';
              id: string | null;
              role: string;
              content: string;
              attachments: Array<string> | null;
              createdAt: string;
              messageType: MessageType | null;
              streamObjects: Array<{
                __typename?: 'StreamObject';
                type: string;
                textDelta: string | null;
                toolCallId: string | null;
                toolName: string | null;
                args: Record<string, string> | null;
                result: Record<string, string> | null;
                durationMs: number | null;
              }> | null;
              context: {
                __typename?: 'MessageContextType';
                docId: string | null;
                searchMode: SearchMode | null;
                items: Array<{
                  __typename?: 'MessageContextItemType';
                  id: string;
                  kind: MessageContextItemKind;
                  label: string;
                  subtitle: string | null;
                  source: ContextSource;
                  priority: ContextPriority;
                  refs: any;
                  payload: any | null;
                  display: {
                    __typename?: 'MessageContextDisplayType';
                    title: string;
                    subtitle: string | null;
                    icon: string | null;
                    preview: string | null;
                    unavailable: boolean | null;
                    unavailableReason: string | null;
                  };
                }>;
              } | null;
              sources: {
                __typename?: 'AssistantSourceManifestType';
                items: Array<{
                  __typename?: 'AssistantSourceItemType';
                  id: string;
                  kind: string;
                  label: string;
                  refs: any;
                  payload: any | null;
                  display: {
                    __typename?: 'MessageContextDisplayType';
                    title: string;
                    subtitle: string | null;
                    icon: string | null;
                    preview: string | null;
                    unavailable: boolean | null;
                    unavailableReason: string | null;
                  };
                }>;
              } | null;
              toolData: {
                __typename?: 'ToolMessageData';
                approvalId: string | null;
                description: string | null;
                confirmationCopy: Record<string, string> | null;
                approved: boolean | null;
                reason: string | null;
                includesAgentMode: boolean | null;
                includesTargetMode: boolean | null;
                toolCallId: string | null;
                toolName: string | null;
                success: boolean | null;
                result: Record<string, string> | null;
                error: string | null;
                toolCall: {
                  __typename?: 'ToolCallInfo';
                  name: string;
                  arguments: Record<string, string> | null;
                } | null;
                goalTurn: {
                  __typename?: 'ChatGoalTurnMessage';
                  goalId: string;
                  kind: string;
                  stepLabel: string | null;
                } | null;
                toolResults: Array<{
                  __typename?: 'ToolResultSummary';
                  toolCallId: string;
                  toolName: string;
                  displayName: string | null;
                  success: boolean;
                  result: Record<string, string> | null;
                  durationMs: number | null;
                }> | null;
              } | null;
            }>;
          };
        }>;
      };
    };
  } | null;
};

export type UpdateCopilotSessionMutationVariables = Exact<{
  options: UpdateChatSessionInput;
}>;

export type UpdateCopilotSessionMutation = {
  __typename?: 'Mutation';
  updateCopilotSession: string;
};

export type GetCopilotSessionsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  pagination: PaginationInput;
  docId?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<QueryChatHistoriesInput>;
}>;

export type GetCopilotSessionsQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'UserType';
    copilot: {
      __typename?: 'Copilot';
      chats: {
        __typename?: 'PaginatedCopilotHistoriesType';
        pageInfo: {
          __typename?: 'PageInfo';
          hasNextPage: boolean;
          hasPreviousPage: boolean;
          startCursor: string | null;
          endCursor: string | null;
        };
        edges: Array<{
          __typename?: 'CopilotHistoriesTypeEdge';
          cursor: string;
          node: {
            __typename?: 'CopilotHistories';
            sessionId: string;
            agentStatus: CopilotAgentStatus;
            workspaceId: string;
            docId: string | null;
            parentSessionId: string | null;
            promptName: string;
            model: string;
            reasoningMode: string;
            optionalModels: Array<string>;
            action: string | null;
            pinned: boolean;
            title: string | null;
            tokens: number;
            createdAt: string;
            updatedAt: string;
            messages: Array<{
              __typename?: 'ChatMessage';
              id: string | null;
              role: string;
              content: string;
              attachments: Array<string> | null;
              createdAt: string;
              messageType: MessageType | null;
              streamObjects: Array<{
                __typename?: 'StreamObject';
                type: string;
                textDelta: string | null;
                toolCallId: string | null;
                toolName: string | null;
                args: Record<string, string> | null;
                result: Record<string, string> | null;
                durationMs: number | null;
              }> | null;
              context: {
                __typename?: 'MessageContextType';
                docId: string | null;
                searchMode: SearchMode | null;
                items: Array<{
                  __typename?: 'MessageContextItemType';
                  id: string;
                  kind: MessageContextItemKind;
                  label: string;
                  subtitle: string | null;
                  source: ContextSource;
                  priority: ContextPriority;
                  refs: any;
                  payload: any | null;
                  display: {
                    __typename?: 'MessageContextDisplayType';
                    title: string;
                    subtitle: string | null;
                    icon: string | null;
                    preview: string | null;
                    unavailable: boolean | null;
                    unavailableReason: string | null;
                  };
                }>;
              } | null;
              sources: {
                __typename?: 'AssistantSourceManifestType';
                items: Array<{
                  __typename?: 'AssistantSourceItemType';
                  id: string;
                  kind: string;
                  label: string;
                  refs: any;
                  payload: any | null;
                  display: {
                    __typename?: 'MessageContextDisplayType';
                    title: string;
                    subtitle: string | null;
                    icon: string | null;
                    preview: string | null;
                    unavailable: boolean | null;
                    unavailableReason: string | null;
                  };
                }>;
              } | null;
              toolData: {
                __typename?: 'ToolMessageData';
                approvalId: string | null;
                description: string | null;
                confirmationCopy: Record<string, string> | null;
                approved: boolean | null;
                reason: string | null;
                includesAgentMode: boolean | null;
                includesTargetMode: boolean | null;
                toolCallId: string | null;
                toolName: string | null;
                success: boolean | null;
                result: Record<string, string> | null;
                error: string | null;
                toolCall: {
                  __typename?: 'ToolCallInfo';
                  name: string;
                  arguments: Record<string, string> | null;
                } | null;
                goalTurn: {
                  __typename?: 'ChatGoalTurnMessage';
                  goalId: string;
                  kind: string;
                  stepLabel: string | null;
                } | null;
                toolResults: Array<{
                  __typename?: 'ToolResultSummary';
                  toolCallId: string;
                  toolName: string;
                  displayName: string | null;
                  success: boolean;
                  result: Record<string, string> | null;
                  durationMs: number | null;
                }> | null;
              } | null;
            }>;
          };
        }>;
      };
    };
  } | null;
};

export type AddWorkspaceEmbeddingIgnoredDocsMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  add: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type AddWorkspaceEmbeddingIgnoredDocsMutation = {
  __typename?: 'Mutation';
  updateWorkspaceEmbeddingIgnoredDocs: number;
};

export type GetAllWorkspaceEmbeddingIgnoredDocsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type GetAllWorkspaceEmbeddingIgnoredDocsQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    embedding: {
      __typename?: 'CopilotWorkspaceConfig';
      allIgnoredDocs: Array<{
        __typename?: 'CopilotWorkspaceIgnoredDoc';
        docId: string;
        createdAt: string;
      }>;
    };
  };
};

export type GetWorkspaceEmbeddingIgnoredDocsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  pagination: PaginationInput;
}>;

export type GetWorkspaceEmbeddingIgnoredDocsQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    embedding: {
      __typename?: 'CopilotWorkspaceConfig';
      ignoredDocs: {
        __typename?: 'PaginatedIgnoredDocsType';
        totalCount: number;
        pageInfo: {
          __typename?: 'PageInfo';
          endCursor: string | null;
          hasNextPage: boolean;
        };
        edges: Array<{
          __typename?: 'CopilotWorkspaceIgnoredDocTypeEdge';
          node: {
            __typename?: 'CopilotWorkspaceIgnoredDoc';
            docId: string;
            createdAt: string;
            docCreatedAt: string | null;
            docUpdatedAt: string | null;
            title: string | null;
            createdBy: string | null;
            createdByAvatar: string | null;
            updatedBy: string | null;
          };
        }>;
      };
    };
  };
};

export type RemoveWorkspaceEmbeddingIgnoredDocsMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  remove: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type RemoveWorkspaceEmbeddingIgnoredDocsMutation = {
  __typename?: 'Mutation';
  updateWorkspaceEmbeddingIgnoredDocs: number;
};

export type WorkspaceCorruptionReportsQueryVariables = Exact<{
  input: GetCorruptionReportsInput;
}>;

export type WorkspaceCorruptionReportsQuery = {
  __typename?: 'Query';
  workspaceCorruptionReports: {
    __typename?: 'PaginatedCorruptionReportsType';
    total: number;
    hasMore: boolean;
    items: Array<{
      __typename?: 'CorruptionReportType';
      id: string;
      workspaceId: string;
      docId: string;
      userId: string;
      createdAt: string;
      clientTimestamp: string;
      clientTimezone: string;
      errorType: string;
      errorMessage: string;
      operation: string;
      status: CorruptionReportStatus;
      browser: string | null;
      os: string | null;
      appVersion: string | null;
      wasOnline: boolean;
      binLength: number;
      binPreview: string | null;
      docTitleSnapshot: string | null;
    }>;
  };
};

export type WorkspaceCorruptionStatsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type WorkspaceCorruptionStatsQuery = {
  __typename?: 'Query';
  workspaceCorruptionStats: {
    __typename?: 'CorruptionReportStatsType';
    total: number;
    pending: number;
    recovered: number;
    unrecoverable: number;
    affectedUsers: number;
    affectedDocs: number;
  };
};

export type CorruptionReportForAiQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type CorruptionReportForAiQuery = {
  __typename?: 'Query';
  corruptionReportForAI: {
    __typename?: 'CorruptionReportForAIType';
    reportId: string;
    exportedAt: string;
    workspaceId: string;
    docId: string;
    docTitle: string | null;
    userId: string;
    serverTimestamp: string;
    clientTimestamp: string;
    clientTimezone: string;
    errorType: string;
    errorMessage: string;
    operation: string;
    status: CorruptionReportStatus;
    browser: string | null;
    os: string | null;
    appVersion: string | null;
    wasOnline: boolean;
    corruptedDataSize: number;
    corruptedDataPreviewHex: string | null;
    markdownPrompt: string;
  } | null;
};

export type UpdateCorruptionReportStatusMutationVariables = Exact<{
  id: Scalars['String']['input'];
  status: CorruptionReportStatus;
}>;

export type UpdateCorruptionReportStatusMutation = {
  __typename?: 'Mutation';
  updateCorruptionReportStatus: {
    __typename?: 'CorruptionReportType';
    id: string;
    workspaceId: string;
    docId: string;
    userId: string;
    createdAt: string;
    clientTimestamp: string;
    clientTimezone: string;
    errorType: string;
    errorMessage: string;
    operation: string;
    status: CorruptionReportStatus;
    browser: string | null;
    os: string | null;
    appVersion: string | null;
    wasOnline: boolean;
    binLength: number;
    binPreview: string | null;
    docTitleSnapshot: string | null;
  };
};

export type DocHistoryTimelineQueryVariables = Exact<{
  input: GetDocHistoryTimelineInput;
}>;

export type DocHistoryTimelineQuery = {
  __typename?: 'Query';
  docHistoryTimeline: {
    __typename?: 'DocHistoryTimelineType';
    docId: string;
    totalEntries: number;
    validEntries: number;
    corruptEntries: number;
    suggestedRestorePoint: string | null;
    entries: Array<{
      __typename?: 'DocHistoryEntryType';
      id: string;
      timestamp: string;
      size: number;
      editorId: string | null;
      isValid: boolean;
      validationError: string | null;
      entryType: string;
      cumulativeSize: number;
      dataFingerprint: string;
    }>;
  };
};

export type RebuildDocFromHistoryMutationVariables = Exact<{
  input: RebuildDocFromHistoryInput;
}>;

export type RebuildDocFromHistoryMutation = {
  __typename?: 'Mutation';
  rebuildDocFromHistory: {
    __typename?: 'RecoveryResultType';
    success: boolean;
    newSnapshotSize: number;
    restoredToTimestamp: string;
    validEntriesApplied: number;
    corruptEntriesSkipped: number;
    error: string | null;
  };
};

export type DocSizeInfoQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
}>;

export type DocSizeInfoQuery = {
  __typename?: 'Query';
  docSizeInfo: {
    __typename?: 'DocSizeInfoType';
    docId: string;
    snapshotSizeBytes: number;
    snapshotSizeMB: number;
    historyCount: number;
    lastModified: string | null;
    exceedsAutoThreshold: boolean;
    exceedsDocAlertThreshold: boolean;
    exceedsWsAlertThreshold: boolean;
  };
};

export type CompactDocMutationVariables = Exact<{
  input: CompactDocInput;
}>;

export type CompactDocMutation = {
  __typename?: 'Mutation';
  compactDoc: {
    __typename?: 'CompactResultType';
    success: boolean;
    originalSizeBytes: number;
    newSizeBytes: number;
    reductionPercent: number;
    error: string | null;
  };
};

export type CreateAppBaseDraftMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  appBaseId: Scalars['String']['input'];
  input: CreateAppBaseDraftInput;
}>;

export type CreateAppBaseDraftMutation = {
  __typename?: 'Mutation';
  createAppBaseDraft: {
    __typename?: 'AppBaseVersionType';
    id: string;
    version: number;
    role: AppBaseVersionRole;
    active: boolean;
    viewConfig: any;
    publishedAt: string | null;
  };
};

export type CreateAppBaseMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  input: CreateAppBaseInput;
}>;

export type CreateAppBaseMutation = {
  __typename?: 'Mutation';
  createAppBase: {
    __typename?: 'AppBaseType';
    id: string;
    workspaceId: string;
    docId: string;
    slug: string;
    title: string;
    config: any;
    isPublished: boolean;
    publishedAt: string | null;
    createdAt: string;
    updatedAt: string;
  };
};

export type CreateCheckoutSessionMutationVariables = Exact<{
  input: CreateCheckoutSessionInput;
}>;

export type CreateCheckoutSessionMutation = {
  __typename?: 'Mutation';
  createCheckoutSession: string;
};

export type CreateCreditCheckoutMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  packId: Scalars['String']['input'];
  successUrl: Scalars['String']['input'];
  cancelUrl: Scalars['String']['input'];
  withdrawalConsent: Scalars['Boolean']['input'];
}>;

export type CreateCreditCheckoutMutation = {
  __typename?: 'Mutation';
  createCreditCheckout: string;
};

export type CreateCustomerPortalMutationVariables = Exact<{
  [key: string]: never;
}>;

export type CreateCustomerPortalMutation = {
  __typename?: 'Mutation';
  createCustomerPortal: string;
};

export type CreateSelfhostCustomerPortalMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type CreateSelfhostCustomerPortalMutation = {
  __typename?: 'Mutation';
  createSelfhostWorkspaceCustomerPortal: string;
};

export type CreateTagMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  color: Scalars['String']['input'];
}>;

export type CreateTagMutation = {
  __typename?: 'Mutation';
  createTag: {
    __typename?: 'WorkspaceTagType';
    id: string;
    workspaceId: string;
    name: string;
    color: string;
    createdAt: string;
    updatedAt: string;
  };
};

export type CreateWorkspaceMutationVariables = Exact<{
  idempotencyKey: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateWorkspaceMutation = {
  __typename?: 'Mutation';
  createWorkspace: {
    __typename?: 'WorkspaceType';
    id: string;
    public: boolean;
    createdAt: string;
  };
};

export type CreditBalanceQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type CreditBalanceQuery = {
  __typename?: 'Query';
  creditBalance: {
    __typename?: 'CreditBalanceType';
    balanceMicro: string;
    displayBalance: number;
    monthlyGrantMicro: string;
    displayMonthlyGrant: number;
    monthlyUsedMicro: string;
    displayMonthlyUsed: number;
    subscriptionGrantMicro: string;
    subscriptionUsedMicro: string;
    subscriptionRemainingMicro: string;
    displaySubscriptionRemaining: number;
    purchasedRemainingMicro: string;
    periodStart: string;
    periodEnd: string;
    aiUsedMicro: string;
    displayAiUsed: number;
    workflowUsedMicro: string;
    displayWorkflowUsed: number;
    otherUsedMicro: string;
    displayOtherUsed: number;
    remainingPercent: number | null;
    lowBalance: boolean;
    lowBalancePercent: number;
  };
};

export type CreditPacksQueryVariables = Exact<{ [key: string]: never }>;

export type CreditPacksQuery = {
  __typename?: 'Query';
  creditPacks: Array<{
    __typename?: 'CreditPackType';
    id: string;
    name: string;
    credits: number;
    stripeProductId: string | null;
    packType: string;
    unitAmount: number | null;
    currency: string | null;
    interval: string | null;
  }>;
};

export type CreditTransactionsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CreditTransactionTypeEnum>;
}>;

export type CreditTransactionsQuery = {
  __typename?: 'Query';
  creditTransactions: {
    __typename?: 'CreditTransactionConnection';
    edges: Array<{
      __typename?: 'CreditTransactionEdge';
      cursor: string;
      node: {
        __typename?: 'CreditTransactionType';
        id: string;
        amountMicro: string;
        displayAmount: number;
        type: CreditTransactionTypeEnum;
        description: string;
        balanceAfterMicro: string;
        displayBalanceAfter: number;
        createdAt: string;
      };
    }>;
    pageInfo: {
      __typename?: 'CreditTransactionPageInfo';
      hasNextPage: boolean;
      endCursor: string | null;
      totalCount: number;
    };
  };
};

export type CurrentBandwidthUsageQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  appBaseId: Scalars['String']['input'];
}>;

export type CurrentBandwidthUsageQuery = {
  __typename?: 'Query';
  currentBandwidthUsage: {
    __typename?: 'BandwidthUsageStatusType';
    appBaseId: string;
    usedGB: number;
    remainingGB: number;
    creditBalanceMicro: string;
    budgetSet: boolean;
    budgetMonthlyLimitMicro: string | null;
    budgetUsedPct: number | null;
    budgetBehavior: string | null;
    currentTier: string;
    asOfDate: string;
    resetDate: string;
  };
};

export type AppBaseViewerStateQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  appBaseId: Scalars['String']['input'];
}>;

export type AppBaseViewerStateQuery = {
  __typename?: 'Query';
  appBaseViewerState: {
    __typename?: 'AppBaseViewerStateType';
    viewConfig: any;
    source: string;
    isDirty: boolean;
    publishedVersion: number | null;
    draftVersion: number | null;
    selectedVersion: number | null;
    isLive: boolean;
  };
};

export type DatabaseAddPropertyMutationVariables = Exact<{
  input: DatabaseAddPropertyInput;
}>;

export type DatabaseAddPropertyMutation = {
  __typename?: 'Mutation';
  databaseAddProperty: {
    __typename?: 'DatabaseAddPropertyResult';
    columnId: string;
  };
};

export type DatabaseAddRowMutationVariables = Exact<{
  input: DatabaseAddRowInput;
}>;

export type DatabaseAddRowMutation = {
  __typename?: 'Mutation';
  databaseAddRow: { __typename?: 'DatabaseAddRowResult'; rowId: string };
};

export type DatabaseBulkMutateMutationVariables = Exact<{
  input: DatabaseBulkMutateInput;
}>;

export type DatabaseBulkMutateMutation = {
  __typename?: 'Mutation';
  databaseBulkMutate: {
    __typename?: 'DatabaseBulkResult';
    operationId: string;
    databaseId: string;
    kind: DatabaseBulkKind;
    iteratorExhausted: boolean;
    acknowledgement: string;
    confirmedCount: number;
    skippedChanged: number;
    skippedMissing: number;
    status: DatabaseBulkStatus;
    receipt: {
      __typename?: 'DatabaseBulkReceipt';
      workspaceId: string;
      groupId: string;
      operationId: string;
      mutationId: string;
      state: DatabaseBulkReceiptState;
      receiptDigest: string | null;
      deadlineAt: string;
      sourceRowIds: Array<string>;
    } | null;
    error: {
      __typename?: 'DatabaseBulkFailure';
      code: DatabaseBulkFailureCode;
      message: string;
      retryable: boolean;
    } | null;
  };
};

export type DatabaseBulkReceiptStatusQueryVariables = Exact<{
  input: DatabaseBulkReceiptStatusInput;
}>;

export type DatabaseBulkReceiptStatusQuery = {
  __typename?: 'Query';
  databaseBulkReceiptStatus: {
    __typename?: 'DatabaseBulkReceiptStatus';
    workspaceId: string;
    groupId: string;
    operationId: string;
    state: DatabaseBulkReceiptState;
    receiptDigest: string | null;
    failureClass: string | null;
  };
};

export type DatabaseDeleteDependenciesQueryVariables = Exact<{
  input: DatabasePermanentlyDeleteInput;
}>;

export type DatabaseDeleteDependenciesQuery = {
  __typename?: 'Query';
  databaseDeleteDependencies: Array<{
    __typename?: 'DatabaseDeleteDependency';
    databaseId: string;
    docId: string;
    databaseTitle: string;
    docTitle: string;
    writable: boolean;
    columns: Array<{
      __typename?: 'DatabaseDeleteDependencyColumn';
      id: string;
      name: string;
    }>;
  }>;
};

export type DatabaseDeletePropertyMutationVariables = Exact<{
  input: DatabaseDeletePropertyInput;
}>;

export type DatabaseDeletePropertyMutation = {
  __typename?: 'Mutation';
  databaseDeleteProperty: {
    __typename?: 'DatabaseDeletePropertyResult';
    success: boolean;
    columnId: string | null;
    error: string | null;
  };
};

export type DatabaseDeleteRowMutationVariables = Exact<{
  input: DatabaseDeleteRowInput;
}>;

export type DatabaseDeleteRowMutation = {
  __typename?: 'Mutation';
  databaseDeleteRow: boolean;
};

export type DatabaseDuplicatePropertyMutationVariables = Exact<{
  input: DatabaseDuplicatePropertyInput;
}>;

export type DatabaseDuplicatePropertyMutation = {
  __typename?: 'Mutation';
  databaseDuplicateProperty: {
    __typename?: 'DatabaseDuplicatePropertyResult';
    columnId: string;
  };
};

export type DatabaseTrashMutationVariables = Exact<{
  input: DatabaseLifecycleInput;
}>;

export type DatabaseTrashMutation = {
  __typename?: 'Mutation';
  databaseTrash: {
    __typename?: 'DatabaseLifecycleReceipt';
    operationId: string;
    state: string;
  };
};

export type DatabaseRestoreMutationVariables = Exact<{
  input: DatabaseLifecycleInput;
}>;

export type DatabaseRestoreMutation = {
  __typename?: 'Mutation';
  databaseRestore: {
    __typename?: 'DatabaseLifecycleReceipt';
    operationId: string;
    state: string;
  };
};

export type DatabaseMoveRowMutationVariables = Exact<{
  input: DatabaseMoveRowInput;
}>;

export type DatabaseMoveRowMutation = {
  __typename?: 'Mutation';
  databaseMoveRow: boolean;
};

export type DatabaseMoveMutationVariables = Exact<{
  input: DatabaseMoveInput;
}>;

export type DatabaseMoveMutation = {
  __typename?: 'Mutation';
  databaseMove: {
    __typename?: 'DatabaseMoveReceipt';
    operationId: string;
    databaseId: string;
    status: DatabaseMoveStatus;
    docId: string;
    blockId: string;
    kept: {
      __typename?: 'DatabaseMoveKept';
      code: string;
      databaseId: string;
      message: string;
    } | null;
  };
};

export type DatabasePermanentlyDeleteMutationVariables = Exact<{
  input: DatabasePermanentlyDeleteInput;
}>;

export type DatabasePermanentlyDeleteMutation = {
  __typename?: 'Mutation';
  databasePermanentlyDelete: {
    __typename?: 'DatabasePermanentlyDeleteResult';
    deletedSystemDocCount: number;
    systemDocIds: Array<string>;
  };
};

export type DatabaseRenamePropertyMutationVariables = Exact<{
  input: DatabaseRenamePropertyInput;
}>;

export type DatabaseRenamePropertyMutation = {
  __typename?: 'Mutation';
  databaseRenameProperty: {
    __typename?: 'DatabaseRenamePropertyResult';
    columnId: string;
  };
};

export type DatabaseSetPropertyDataMutationVariables = Exact<{
  input: DatabaseSetPropertyDataInput;
}>;

export type DatabaseSetPropertyDataMutation = {
  __typename?: 'Mutation';
  databaseSetPropertyData: {
    __typename?: 'DatabaseSetPropertyDataResult';
    columnId: string;
  };
};

export type DatabaseSetPropertyTypeMutationVariables = Exact<{
  input: DatabaseSetPropertyTypeInput;
}>;

export type DatabaseSetPropertyTypeMutation = {
  __typename?: 'Mutation';
  databaseSetPropertyType: {
    __typename?: 'DatabaseSetPropertyTypeResult';
    columnId: string;
  };
};

export type DatabaseUpdateCellsMutationVariables = Exact<{
  input: DatabaseUpdateCellsInput;
}>;

export type DatabaseUpdateCellsMutation = {
  __typename?: 'Mutation';
  databaseUpdateCells: {
    __typename?: 'DatabaseUpdateCellsResult';
    ok: boolean;
    affectedRowIds: Array<string>;
  };
};

export type DeleteAllNotificationsMutationVariables = Exact<{
  [key: string]: never;
}>;

export type DeleteAllNotificationsMutation = {
  __typename?: 'Mutation';
  deleteAllNotifications: boolean;
};

export type DeleteAppBaseMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;

export type DeleteAppBaseMutation = {
  __typename?: 'Mutation';
  deleteAppBase: boolean;
};

export type RestoreAppBaseMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;

export type RestoreAppBaseMutation = {
  __typename?: 'Mutation';
  restoreAppBase: boolean;
};

export type PermanentlyDeleteAppBaseMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  tables: Array<AppBaseTableDispositionInput> | AppBaseTableDispositionInput;
}>;

export type PermanentlyDeleteAppBaseMutation = {
  __typename?: 'Mutation';
  permanentlyDeleteAppBase: boolean;
};

export type DeleteNotificationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type DeleteNotificationMutation = {
  __typename?: 'Mutation';
  deleteNotification: boolean;
};

export type DeleteTagMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  tagId: Scalars['String']['input'];
}>;

export type DeleteTagMutation = { __typename?: 'Mutation'; deleteTag: boolean };

export type DeleteWorkspaceMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type DeleteWorkspaceMutation = {
  __typename?: 'Mutation';
  deleteWorkspace: boolean;
};

export type DetachAppBaseDatabaseMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  input: DetachAppBaseDatabaseInput;
}>;

export type DetachAppBaseDatabaseMutation = {
  __typename?: 'Mutation';
  detachAppBaseDatabase: any;
};

export type DisableManagedAiMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type DisableManagedAiMutation = {
  __typename?: 'Mutation';
  disableManagedAI: boolean;
};

export type DiscardAppBaseDraftMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  appBaseId: Scalars['String']['input'];
}>;

export type DiscardAppBaseDraftMutation = {
  __typename?: 'Mutation';
  discardAppBaseDraft: boolean;
};

export type DiscardContentEntryChangesMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  appBaseId: Scalars['String']['input'];
  sourceKey: Scalars['String']['input'];
  rowIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type DiscardContentEntryChangesMutation = {
  __typename?: 'Mutation';
  discardContentEntryChanges: Array<{
    __typename?: 'ContentEntryResultType';
    rowId: string;
    status: ContentEntryResultStatus;
    liveVersion: number | null;
    hasOpenChanges: boolean;
  }>;
};

export type DiscoverAppBaseDatabasesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  docId?: InputMaybe<Scalars['String']['input']>;
}>;

export type DiscoverAppBaseDatabasesQuery = {
  __typename?: 'Query';
  discoverAppBaseDatabases: any;
};

export type GetDocRolePermissionsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
}>;

export type GetDocRolePermissionsQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    doc: {
      __typename?: 'DocType';
      permissions: {
        __typename?: 'DocPermissions';
        Doc_Copy: boolean;
        Doc_Delete: boolean;
        Doc_Duplicate: boolean;
        Doc_Properties_Read: boolean;
        Doc_Properties_Update: boolean;
        Doc_Publish: boolean;
        Doc_Read: boolean;
        Doc_Restore: boolean;
        Doc_TransferOwner: boolean;
        Doc_Trash: boolean;
        Doc_Update: boolean;
        Doc_Users_Manage: boolean;
        Doc_Users_Read: boolean;
        Doc_Comments_Create: boolean;
        Doc_Comments_Delete: boolean;
        Doc_Comments_Read: boolean;
        Doc_Comments_Resolve: boolean;
      };
    } | null;
  };
};

export type DocTagIdsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type DocTagIdsQuery = {
  __typename?: 'Query';
  docTagIds: Array<{
    __typename?: 'DocTagIdsType';
    docId: string;
    tagIds: Array<string>;
  }>;
};

export type EnableManagedAiMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type EnableManagedAiMutation = {
  __typename?: 'Mutation';
  enableManagedAI: {
    __typename?: 'ManagedAIStatusType';
    enabled: boolean;
    consentGiven: boolean;
    consentAt: string | null;
    suspended: boolean;
    suspendReason: string | null;
    maxRequestsPerMinute: number;
  };
};

export type EnsureAppBaseDataSourcesMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  input: EnsureAppBaseDataSourcesInput;
}>;

export type EnsureAppBaseDataSourcesMutation = {
  __typename?: 'Mutation';
  ensureAppBaseDataSources: any;
};

export type FinalizeCheckoutSessionMutationVariables = Exact<{
  sessionId: Scalars['String']['input'];
}>;

export type FinalizeCheckoutSessionMutation = {
  __typename?: 'Mutation';
  finalizeCheckoutSession: string;
};

export type AddDocToFolderMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  folderId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
}>;

export type AddDocToFolderMutation = {
  __typename?: 'Mutation';
  addDocToFolder: boolean;
};

export type CheckDeletedFolderIdsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  folderIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type CheckDeletedFolderIdsQuery = {
  __typename?: 'Query';
  workspace: { __typename?: 'WorkspaceType'; deletedFolderIds: Array<string> };
};

export type CreateFolderMutationVariables = Exact<{
  input: CreateFolderInput;
}>;

export type CreateFolderMutation = {
  __typename?: 'Mutation';
  createFolder: {
    __typename?: 'FolderType';
    id: string;
    workspaceId: string;
    parentId: string | null;
    name: string;
    visibility: string;
    inheritPermissions: boolean;
    createdAt: string;
    updatedAt: string;
    docCount: number;
  };
};

export type GetFolderUsersQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  folderId: Scalars['String']['input'];
  pagination: PaginationInput;
}>;

export type GetFolderUsersQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    folder: {
      __typename?: 'FolderType';
      id: string;
      name: string;
      grantedUsers: {
        __typename?: 'PaginatedGrantedFolderUserType';
        totalCount: number;
        items: Array<{
          __typename?: 'GrantedFolderUserType';
          role: FolderRole;
          workspaceRole: Permission;
          membershipKind: WorkspaceMembershipKind | null;
          isAreaBlocked: boolean;
          areaBoundaryKind: string | null;
          areaBoundaryRootFolderId: string | null;
          areaBoundaryRootName: string | null;
          user: {
            __typename?: 'UserType';
            id: string;
            name: string;
            email: string;
            avatarUrl: string | null;
          };
        }>;
      };
    } | null;
  };
};

export type GetFolderQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  folderId: Scalars['String']['input'];
}>;

export type GetFolderQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    folder: {
      __typename?: 'FolderType';
      id: string;
      workspaceId: string;
      parentId: string | null;
      name: string;
      visibility: string;
      inheritPermissions: boolean;
      createdAt: string;
      updatedAt: string;
      docCount: number;
      permissionGraphVersion: number;
      effectiveAccess: Array<{
        __typename?: 'FolderEffectiveAccessEntryType';
        principalType: string;
        principalId: string;
        displayName: string;
        email: string | null;
        avatarUrl: string | null;
        effectiveRole: FolderRole;
        workspaceRole: Permission | null;
        membershipKind: WorkspaceMembershipKind | null;
        sourceType: string;
        sourceId: string | null;
        sourceName: string | null;
        isDirectOverride: boolean;
        isInherited: boolean;
        isInheritanceBlocked: boolean;
        isAreaBlocked: boolean;
        areaBoundaryKind: string | null;
        areaBoundaryRootFolderId: string | null;
        areaBoundaryRootName: string | null;
        permissionGraphVersion: number;
      }>;
      children: Array<{
        __typename?: 'FolderType';
        id: string;
        workspaceId: string;
        parentId: string | null;
        name: string;
        visibility: string;
        inheritPermissions: boolean;
        createdAt: string;
        updatedAt: string;
        docCount: number;
      }>;
      permissions: {
        __typename?: 'FolderPermissions';
        Folder_Read: boolean;
        Folder_Update: boolean;
        Folder_Delete: boolean;
        Folder_Trash: boolean;
        Folder_Restore: boolean;
        Folder_Move: boolean;
        Folder_AddDoc: boolean;
        Folder_RemoveDoc: boolean;
        Folder_CreateSubfolder: boolean;
        Folder_Users_Manage: boolean;
        Folder_Users_Read: boolean;
      };
    } | null;
  };
};

export type GetFoldersWithOwnersQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetFoldersWithOwnersQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    folders: Array<{
      __typename?: 'FolderType';
      id: string;
      workspaceId: string;
      parentId: string | null;
      name: string;
      visibility: string;
      inheritPermissions: boolean;
      createdAt: string;
      updatedAt: string;
      docCount: number;
      owner: {
        __typename?: 'FolderOwnerType';
        id: string;
        name: string;
        email: string;
        avatarUrl: string | null;
      } | null;
    }>;
  };
};

export type GetFoldersQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetFoldersQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    folders: Array<{
      __typename?: 'FolderType';
      id: string;
      workspaceId: string;
      parentId: string | null;
      name: string;
      visibility: string;
      inheritPermissions: boolean;
      createdAt: string;
      updatedAt: string;
      docCount: number;
    }>;
  };
};

export type GetTrashedFoldersQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type GetTrashedFoldersQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    trashedFolders: Array<{
      __typename?: 'FolderType';
      id: string;
      workspaceId: string;
      parentId: string | null;
      name: string;
      systemKind: string | null;
      trashed: boolean;
      trashedAt: string | null;
      trashedBy: string | null;
      createdAt: string;
      updatedAt: string;
      docIds: Array<string>;
      permissions: {
        __typename?: 'FolderPermissions';
        Folder_Read: boolean;
        Folder_Update: boolean;
        Folder_Delete: boolean;
        Folder_Trash: boolean;
        Folder_Restore: boolean;
        Folder_Move: boolean;
        Folder_AddDoc: boolean;
        Folder_RemoveDoc: boolean;
        Folder_CreateSubfolder: boolean;
        Folder_Users_Read: boolean;
        Folder_Users_Manage: boolean;
      };
      owner: {
        __typename?: 'FolderOwnerType';
        id: string;
        name: string;
        email: string;
        avatarUrl: string | null;
      } | null;
    }>;
  };
};

export type GrantFolderRoleMutationVariables = Exact<{
  input: GrantFolderRoleInput;
}>;

export type GrantFolderRoleMutation = {
  __typename?: 'Mutation';
  grantFolderRole: boolean;
};

export type MoveFolderMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  folderId: Scalars['String']['input'];
  newParentId?: InputMaybe<Scalars['String']['input']>;
}>;

export type MoveFolderMutation = {
  __typename?: 'Mutation';
  moveFolder: {
    __typename?: 'FolderType';
    id: string;
    workspaceId: string;
    parentId: string | null;
    name: string;
    visibility: string;
    inheritPermissions: boolean;
    createdAt: string;
    updatedAt: string;
    docCount: number;
  };
};

export type MyAccessibleFoldersQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type MyAccessibleFoldersQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    myAccessibleFolders: Array<{
      __typename?: 'FolderType';
      id: string;
      name: string;
      parentId: string | null;
      ownerUserId: string | null;
      systemKind: string | null;
      visibility: string;
      inheritPermissions: boolean;
      isWorkspaceRoot: boolean;
      immutable: boolean;
      storageLimitBytes: number | null;
      storageUsedBytes: number | null;
      metadataOnly: boolean;
      docIds: Array<string>;
      permissionGraphVersion: number;
    }>;
  };
};

export type PermanentlyDeleteFolderMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  folderId: Scalars['String']['input'];
}>;

export type PermanentlyDeleteFolderMutation = {
  __typename?: 'Mutation';
  permanentlyDeleteFolder: boolean;
};

export type PreflightPermissionLifecycleQueryVariables = Exact<{
  input: PermissionLifecyclePreflightInput;
}>;

export type PreflightPermissionLifecycleQuery = {
  __typename?: 'Query';
  preflightPermissionLifecycle: {
    __typename?: 'PermissionLifecyclePreflightResult';
    allowed: boolean;
    operation: PermissionLifecycleOperation;
    totalBlockedCount: number;
    blockedTargetIds: Array<string>;
    affectedFolderIds: Array<string>;
    affectedDocIds: Array<string>;
    areaImpacts: Array<{
      __typename?: 'PermissionLifecycleAreaImpact';
      targetKind: PermissionPreflightTargetKind;
      targetId: string;
      targetName: string | null;
      principalType: string;
      principalId: string;
      role: string;
      sourceType: string;
      sourceId: string;
      sourceName: string | null;
      impact: string;
      fromAreaKind: string;
      fromAreaRootFolderId: string;
      fromAreaRootName: string;
      fromAreaBlocked: boolean;
      toAreaKind: string;
      toAreaRootFolderId: string;
      toAreaRootName: string;
      toAreaBlocked: boolean;
    }>;
    reasonCounts: Array<{
      __typename?: 'PermissionPreflightReasonCount';
      reason: PermissionDenialReason;
      count: number;
    }>;
    blockedObjects: Array<{
      __typename?: 'PermissionPreflightBlockedObject';
      kind: PermissionPreflightTargetKind;
      id: string;
      targetId: string | null;
      name: string | null;
      reason: PermissionDenialReason;
    }>;
  };
};

export type RemoveDocFromFolderMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
}>;

export type RemoveDocFromFolderMutation = {
  __typename?: 'Mutation';
  removeDocFromFolder: boolean;
};

export type RestoreFolderMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  folderId: Scalars['String']['input'];
}>;

export type RestoreFolderMutation = {
  __typename?: 'Mutation';
  restoreFolder: {
    __typename?: 'FolderType';
    id: string;
    name: string;
    trashed: boolean;
    trashedAt: string | null;
    trashedBy: string | null;
  };
};

export type RevokeFolderRoleMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  folderId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;

export type RevokeFolderRoleMutation = {
  __typename?: 'Mutation';
  revokeFolderRole: boolean;
};

export type RootFolderDocIdsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type RootFolderDocIdsQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    rootFolder: {
      __typename?: 'FolderType';
      id: string;
      docIds: Array<string>;
    } | null;
  };
};

export type TrashFolderMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  folderId: Scalars['String']['input'];
}>;

export type TrashFolderMutation = {
  __typename?: 'Mutation';
  trashFolder: {
    __typename?: 'FolderType';
    id: string;
    name: string;
    trashed: boolean;
    trashedAt: string | null;
    trashedBy: string | null;
  };
};

export type UpdateFolderMutationVariables = Exact<{
  input: UpdateFolderInput;
}>;

export type UpdateFolderMutation = {
  __typename?: 'Mutation';
  updateFolder: {
    __typename?: 'FolderType';
    id: string;
    workspaceId: string;
    parentId: string | null;
    name: string;
    visibility: string;
    inheritPermissions: boolean;
    createdAt: string;
    updatedAt: string;
    docCount: number;
  };
};

export type CopilotChatMessageFragment = {
  __typename?: 'ChatMessage';
  id: string | null;
  role: string;
  content: string;
  attachments: Array<string> | null;
  createdAt: string;
  messageType: MessageType | null;
  streamObjects: Array<{
    __typename?: 'StreamObject';
    type: string;
    textDelta: string | null;
    toolCallId: string | null;
    toolName: string | null;
    args: Record<string, string> | null;
    result: Record<string, string> | null;
    durationMs: number | null;
  }> | null;
  context: {
    __typename?: 'MessageContextType';
    docId: string | null;
    searchMode: SearchMode | null;
    items: Array<{
      __typename?: 'MessageContextItemType';
      id: string;
      kind: MessageContextItemKind;
      label: string;
      subtitle: string | null;
      source: ContextSource;
      priority: ContextPriority;
      refs: any;
      payload: any | null;
      display: {
        __typename?: 'MessageContextDisplayType';
        title: string;
        subtitle: string | null;
        icon: string | null;
        preview: string | null;
        unavailable: boolean | null;
        unavailableReason: string | null;
      };
    }>;
  } | null;
  sources: {
    __typename?: 'AssistantSourceManifestType';
    items: Array<{
      __typename?: 'AssistantSourceItemType';
      id: string;
      kind: string;
      label: string;
      refs: any;
      payload: any | null;
      display: {
        __typename?: 'MessageContextDisplayType';
        title: string;
        subtitle: string | null;
        icon: string | null;
        preview: string | null;
        unavailable: boolean | null;
        unavailableReason: string | null;
      };
    }>;
  } | null;
  toolData: {
    __typename?: 'ToolMessageData';
    approvalId: string | null;
    description: string | null;
    confirmationCopy: Record<string, string> | null;
    approved: boolean | null;
    reason: string | null;
    includesAgentMode: boolean | null;
    includesTargetMode: boolean | null;
    toolCallId: string | null;
    toolName: string | null;
    success: boolean | null;
    result: Record<string, string> | null;
    error: string | null;
    toolCall: {
      __typename?: 'ToolCallInfo';
      name: string;
      arguments: Record<string, string> | null;
    } | null;
    goalTurn: {
      __typename?: 'ChatGoalTurnMessage';
      goalId: string;
      kind: string;
      stepLabel: string | null;
    } | null;
    toolResults: Array<{
      __typename?: 'ToolResultSummary';
      toolCallId: string;
      toolName: string;
      displayName: string | null;
      success: boolean;
      result: Record<string, string> | null;
      durationMs: number | null;
    }> | null;
  } | null;
};

export type CopilotChatHistoryFragment = {
  __typename?: 'CopilotHistories';
  sessionId: string;
  agentStatus: CopilotAgentStatus;
  workspaceId: string;
  docId: string | null;
  parentSessionId: string | null;
  promptName: string;
  model: string;
  reasoningMode: string;
  optionalModels: Array<string>;
  action: string | null;
  pinned: boolean;
  title: string | null;
  tokens: number;
  createdAt: string;
  updatedAt: string;
  messages: Array<{
    __typename?: 'ChatMessage';
    id: string | null;
    role: string;
    content: string;
    attachments: Array<string> | null;
    createdAt: string;
    messageType: MessageType | null;
    streamObjects: Array<{
      __typename?: 'StreamObject';
      type: string;
      textDelta: string | null;
      toolCallId: string | null;
      toolName: string | null;
      args: Record<string, string> | null;
      result: Record<string, string> | null;
      durationMs: number | null;
    }> | null;
    context: {
      __typename?: 'MessageContextType';
      docId: string | null;
      searchMode: SearchMode | null;
      items: Array<{
        __typename?: 'MessageContextItemType';
        id: string;
        kind: MessageContextItemKind;
        label: string;
        subtitle: string | null;
        source: ContextSource;
        priority: ContextPriority;
        refs: any;
        payload: any | null;
        display: {
          __typename?: 'MessageContextDisplayType';
          title: string;
          subtitle: string | null;
          icon: string | null;
          preview: string | null;
          unavailable: boolean | null;
          unavailableReason: string | null;
        };
      }>;
    } | null;
    sources: {
      __typename?: 'AssistantSourceManifestType';
      items: Array<{
        __typename?: 'AssistantSourceItemType';
        id: string;
        kind: string;
        label: string;
        refs: any;
        payload: any | null;
        display: {
          __typename?: 'MessageContextDisplayType';
          title: string;
          subtitle: string | null;
          icon: string | null;
          preview: string | null;
          unavailable: boolean | null;
          unavailableReason: string | null;
        };
      }>;
    } | null;
    toolData: {
      __typename?: 'ToolMessageData';
      approvalId: string | null;
      description: string | null;
      confirmationCopy: Record<string, string> | null;
      approved: boolean | null;
      reason: string | null;
      includesAgentMode: boolean | null;
      includesTargetMode: boolean | null;
      toolCallId: string | null;
      toolName: string | null;
      success: boolean | null;
      result: Record<string, string> | null;
      error: string | null;
      toolCall: {
        __typename?: 'ToolCallInfo';
        name: string;
        arguments: Record<string, string> | null;
      } | null;
      goalTurn: {
        __typename?: 'ChatGoalTurnMessage';
        goalId: string;
        kind: string;
        stepLabel: string | null;
      } | null;
      toolResults: Array<{
        __typename?: 'ToolResultSummary';
        toolCallId: string;
        toolName: string;
        displayName: string | null;
        success: boolean;
        result: Record<string, string> | null;
        durationMs: number | null;
      }> | null;
    } | null;
  }>;
};

export type PaginatedCopilotChatsFragment = {
  __typename?: 'PaginatedCopilotHistoriesType';
  pageInfo: {
    __typename?: 'PageInfo';
    hasNextPage: boolean;
    hasPreviousPage: boolean;
    startCursor: string | null;
    endCursor: string | null;
  };
  edges: Array<{
    __typename?: 'CopilotHistoriesTypeEdge';
    cursor: string;
    node: {
      __typename?: 'CopilotHistories';
      sessionId: string;
      agentStatus: CopilotAgentStatus;
      workspaceId: string;
      docId: string | null;
      parentSessionId: string | null;
      promptName: string;
      model: string;
      reasoningMode: string;
      optionalModels: Array<string>;
      action: string | null;
      pinned: boolean;
      title: string | null;
      tokens: number;
      createdAt: string;
      updatedAt: string;
      messages: Array<{
        __typename?: 'ChatMessage';
        id: string | null;
        role: string;
        content: string;
        attachments: Array<string> | null;
        createdAt: string;
        messageType: MessageType | null;
        streamObjects: Array<{
          __typename?: 'StreamObject';
          type: string;
          textDelta: string | null;
          toolCallId: string | null;
          toolName: string | null;
          args: Record<string, string> | null;
          result: Record<string, string> | null;
          durationMs: number | null;
        }> | null;
        context: {
          __typename?: 'MessageContextType';
          docId: string | null;
          searchMode: SearchMode | null;
          items: Array<{
            __typename?: 'MessageContextItemType';
            id: string;
            kind: MessageContextItemKind;
            label: string;
            subtitle: string | null;
            source: ContextSource;
            priority: ContextPriority;
            refs: any;
            payload: any | null;
            display: {
              __typename?: 'MessageContextDisplayType';
              title: string;
              subtitle: string | null;
              icon: string | null;
              preview: string | null;
              unavailable: boolean | null;
              unavailableReason: string | null;
            };
          }>;
        } | null;
        sources: {
          __typename?: 'AssistantSourceManifestType';
          items: Array<{
            __typename?: 'AssistantSourceItemType';
            id: string;
            kind: string;
            label: string;
            refs: any;
            payload: any | null;
            display: {
              __typename?: 'MessageContextDisplayType';
              title: string;
              subtitle: string | null;
              icon: string | null;
              preview: string | null;
              unavailable: boolean | null;
              unavailableReason: string | null;
            };
          }>;
        } | null;
        toolData: {
          __typename?: 'ToolMessageData';
          approvalId: string | null;
          description: string | null;
          confirmationCopy: Record<string, string> | null;
          approved: boolean | null;
          reason: string | null;
          includesAgentMode: boolean | null;
          includesTargetMode: boolean | null;
          toolCallId: string | null;
          toolName: string | null;
          success: boolean | null;
          result: Record<string, string> | null;
          error: string | null;
          toolCall: {
            __typename?: 'ToolCallInfo';
            name: string;
            arguments: Record<string, string> | null;
          } | null;
          goalTurn: {
            __typename?: 'ChatGoalTurnMessage';
            goalId: string;
            kind: string;
            stepLabel: string | null;
          } | null;
          toolResults: Array<{
            __typename?: 'ToolResultSummary';
            toolCallId: string;
            toolName: string;
            displayName: string | null;
            success: boolean;
            result: Record<string, string> | null;
            durationMs: number | null;
          }> | null;
        } | null;
      }>;
    };
  }>;
};

export type CredentialsRequirementsFragment = {
  __typename?: 'CredentialsRequirementType';
  password: {
    __typename?: 'PasswordLimitsType';
    minLength: number;
    maxLength: number;
  };
};

export type PasswordLimitsFragment = {
  __typename?: 'PasswordLimitsType';
  minLength: number;
  maxLength: number;
};

export type PermissionGraphConnectionFieldsFragment = {
  __typename?: 'PermissionGraphConnectionType';
  rightsEpoch: number;
  edges: Array<{
    __typename?: 'PermissionGraphEdgeType';
    cursor: string;
    sortKey: string;
    node:
      | {
          __typename: 'PermissionGraphNodeType';
          id: string;
          kind: string;
          label: string;
          workspaceId: string;
          metadata: Record<string, string> | null;
        }
      | {
          __typename: 'PermissionGraphRelationshipType';
          id: string;
          relationshipType: string;
          sourceType: string;
          sourceId: string;
          targetType: string;
          targetId: string;
          role: string | null;
          updatedAt: string | null;
          provenance: {
            __typename?: 'PermissionGraphProvenanceType';
            sourceType: string;
            sourceId: string;
            viaGroupId: string | null;
            viaFolderId: string | null;
            inherited: boolean;
            effective: boolean;
          };
        };
  }>;
  pageInfo: {
    __typename?: 'PermissionGraphPageInfoType';
    hasNextPage: boolean;
    endCursor: string | null;
    token: string | null;
    resetRequired: string | null;
  };
  diagnostics: {
    __typename?: 'PermissionGraphDiagnosticsType';
    bounded: boolean;
    maxPageSize: number;
    maxSubtreeDepth: number;
    projectionStatus: string;
    resetReason: string | null;
  };
};

export type GetCurrentUserFeaturesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetCurrentUserFeaturesQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'UserType';
    id: string;
    name: string;
    email: string;
    emailVerified: boolean;
    avatarUrl: string | null;
    features: Array<FeatureType>;
  } | null;
};

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never }>;

export type GetCurrentUserQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'UserType';
    id: string;
    name: string;
    email: string;
    emailVerified: boolean;
    avatarUrl: string | null;
    token: { __typename?: 'tokenType'; sessionToken: string | null };
  } | null;
};

export type GetDocCreatedByUpdatedByListQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  pagination: PaginationInput;
}>;

export type GetDocCreatedByUpdatedByListQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    docs: {
      __typename?: 'PaginatedDocType';
      totalCount: number;
      pageInfo: {
        __typename?: 'PageInfo';
        endCursor: string | null;
        hasNextPage: boolean;
      };
      edges: Array<{
        __typename?: 'DocTypeEdge';
        node: {
          __typename?: 'DocType';
          id: string;
          creatorId: string | null;
          lastUpdaterId: string | null;
        };
      }>;
    };
  };
};

export type GetDocDefaultRoleQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
}>;

export type GetDocDefaultRoleQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    doc: { __typename?: 'DocType'; defaultRole: DocRole } | null;
  };
};

export type GetDocInheritedAccessQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
  pagination: PaginationInput;
}>;

export type GetDocInheritedAccessQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    doc: {
      __typename?: 'DocType';
      inheritedAccess: {
        __typename?: 'PaginatedDocInheritedAccessType';
        totalCount: number;
        edges: Array<{
          __typename?: 'DocInheritedAccessEdge';
          cursor: string;
          node: {
            __typename?: 'DocEffectiveAccessEntryType';
            principalType: string;
            principalId: string;
            displayName: string;
            email: string | null;
            avatarUrl: string | null;
            effectiveRole: DocRole;
            sourceType: string;
            sourceId: string | null;
            sourceName: string | null;
            memberCount: number | null;
            isDirectOverride: boolean;
            isInherited: boolean;
            isInheritanceBlocked: boolean;
            isAreaBlocked: boolean;
            areaBoundaryKind: string | null;
            areaBoundaryRootFolderId: string | null;
            areaBoundaryRootName: string | null;
            permissionGraphVersion: number;
          };
        }>;
        pageInfo: {
          __typename?: 'PageInfo';
          hasNextPage: boolean;
          hasPreviousPage: boolean;
          startCursor: string | null;
          endCursor: string | null;
        };
      };
    } | null;
  };
};

export type GetDocSummaryQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
}>;

export type GetDocSummaryQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    doc: { __typename?: 'DocType'; summary: string | null } | null;
  };
};

export type GetFolderGrantedUsersListQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  folderId: Scalars['String']['input'];
  pagination: PaginationInput;
}>;

export type GetFolderGrantedUsersListQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    folder: {
      __typename?: 'FolderType';
      id: string;
      grantedUsers: {
        __typename?: 'PaginatedGrantedFolderUserType';
        totalCount: number;
        items: Array<{
          __typename?: 'GrantedFolderUserType';
          role: FolderRole;
          workspaceRole: Permission;
          isAreaBlocked: boolean;
          areaBoundaryKind: string | null;
          areaBoundaryRootFolderId: string | null;
          areaBoundaryRootName: string | null;
          user: {
            __typename?: 'UserType';
            id: string;
            name: string;
            email: string;
            avatarUrl: string | null;
          };
        }>;
      };
    } | null;
  };
};

export type GetInviteInfoQueryVariables = Exact<{
  inviteId: Scalars['String']['input'];
}>;

export type GetInviteInfoQuery = {
  __typename?: 'Query';
  getInviteInfo: {
    __typename?: 'InvitationType';
    status: WorkspaceMemberStatus | null;
    workspace: {
      __typename?: 'InvitationWorkspaceType';
      id: string;
      name: string;
      avatar: string;
    };
    user: {
      __typename?: 'WorkspaceUserType';
      id: string;
      name: string;
      avatarUrl: string | null;
    };
    invitee: {
      __typename?: 'WorkspaceUserType';
      id: string;
      name: string;
      email: string;
      avatarUrl: string | null;
    };
  };
};

export type GetMemberCountByWorkspaceIdQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type GetMemberCountByWorkspaceIdQuery = {
  __typename?: 'Query';
  workspace: { __typename?: 'WorkspaceType'; memberCount: number };
};

export type GetMembersByWorkspaceIdQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetMembersByWorkspaceIdQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    memberCount: number;
    guestCount: number;
    members: Array<{
      __typename?: 'InviteUserType';
      id: string;
      name: string | null;
      email: string | null;
      avatarUrl: string | null;
      permission: Permission;
      inviteId: string;
      emailVerified: boolean | null;
      status: WorkspaceMemberStatus;
      membershipKind: WorkspaceMembershipKind;
      houseGuestExpiresAt: string | null;
    }>;
  };
};

export type OauthProvidersQueryVariables = Exact<{ [key: string]: never }>;

export type OauthProvidersQuery = {
  __typename?: 'Query';
  serverConfig: {
    __typename?: 'ServerConfigType';
    oauthProviders: Array<OAuthProviderType>;
  };
};

export type GetPageGrantedUsersListQueryVariables = Exact<{
  pagination: PaginationInput;
  docId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  includeCandidates?: InputMaybe<Scalars['Boolean']['input']>;
  guestsOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetPageGrantedUsersListQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    doc: {
      __typename?: 'DocType';
      grantedUsersList: {
        __typename?: 'PaginatedGrantedDocUserType';
        totalCount: number;
        pageInfo: {
          __typename?: 'PageInfo';
          endCursor: string | null;
          hasNextPage: boolean;
        };
        edges: Array<{
          __typename?: 'GrantedDocUserTypeEdge';
          node: {
            __typename?: 'GrantedDocUserType';
            hasDirectGrant: boolean | null;
            role: DocRole;
            workspaceRole: Permission;
            membershipKind: WorkspaceMembershipKind | null;
            houseGuestExpiresAt: string | null;
            isAreaBlocked: boolean;
            areaBoundaryKind: string | null;
            areaBoundaryRootFolderId: string | null;
            areaBoundaryRootName: string | null;
            user: {
              __typename?: 'WorkspaceUserType';
              id: string;
              name: string;
              email: string;
              avatarUrl: string | null;
            };
          };
        }>;
      };
    } | null;
  };
};

export type GetPendingDecisionCountQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type GetPendingDecisionCountQuery = {
  __typename?: 'Query';
  workspace: { __typename?: 'WorkspaceType'; pendingDecisionCount: number };
};

export type GetPendingDecisionsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type GetPendingDecisionsQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    pendingDecisions: Array<{
      __typename?: 'PendingDecisionType';
      id: string;
      configId: string;
      sourceRowId: string;
      targetColumn: string;
      searchValue: string;
      matchCount: number;
      status: PendingDecisionStatus;
      createdAt: string;
      candidates: Array<{
        __typename?: 'RelationCandidateType';
        id: string;
        title: string;
        context: Record<string, string> | null;
      }>;
    }>;
  };
};

export type GetPublicUserByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetPublicUserByIdQuery = {
  __typename?: 'Query';
  publicUserById: {
    __typename?: 'PublicUserType';
    id: string;
    avatarUrl: string | null;
    name: string;
  } | null;
};

export type GetRecentlyUpdatedDocsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  pagination: PaginationInput;
}>;

export type GetRecentlyUpdatedDocsQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    recentlyUpdatedDocs: {
      __typename?: 'PaginatedDocType';
      totalCount: number;
      pageInfo: {
        __typename?: 'PageInfo';
        endCursor: string | null;
        hasNextPage: boolean;
      };
      edges: Array<{
        __typename?: 'DocTypeEdge';
        node: {
          __typename?: 'DocType';
          id: string;
          title: string | null;
          createdAt: string | null;
          updatedAt: string | null;
          creatorId: string | null;
          lastUpdaterId: string | null;
        };
      }>;
    };
  };
};

export type GetScheduledWorkspacesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetScheduledWorkspacesQuery = {
  __typename?: 'Query';
  workspaceDeletionGraceDays: number;
  scheduledWorkspaces: Array<{
    __typename?: 'WorkspaceType';
    id: string;
    name: string;
    deletionScheduledAt: string | null;
  }>;
};

export type GetUserDocGrantsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;

export type GetUserDocGrantsQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    userDocGrants: Array<{
      __typename?: 'UserDocGrantType';
      docId: string;
      role: DocRole;
      isAreaBlocked: boolean;
      areaBoundaryKind: string | null;
      areaBoundaryRootFolderId: string | null;
      areaBoundaryRootName: string | null;
    }>;
  };
};

export type GetUserFeaturesQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserFeaturesQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'UserType';
    id: string;
    features: Array<FeatureType>;
  } | null;
};

export type GetUserFolderGrantsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;

export type GetUserFolderGrantsQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    userFolderGrants: Array<{
      __typename?: 'UserFolderGrantType';
      folderId: string;
      role: FolderRole;
      isAreaBlocked: boolean;
      areaBoundaryKind: string | null;
      areaBoundaryRootFolderId: string | null;
      areaBoundaryRootName: string | null;
    }>;
  };
};

export type GetUserSettingsQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserSettingsQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'UserType';
    settings: {
      __typename?: 'UserSettingsType';
      receiveInvitationEmail: boolean;
      receiveMentionEmail: boolean;
      receiveCommentEmail: boolean;
      aiRelationMatchingEnabled: boolean;
      pdfSearchCoverageCoachmarkDismissed: boolean;
      timeZone: string | null;
    };
  } | null;
};

export type GetUserQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;

export type GetUserQuery = {
  __typename?: 'Query';
  user:
    | {
        __typename: 'LimitedUserType';
        email: string;
        hasPassword: boolean | null;
      }
    | {
        __typename: 'UserType';
        id: string;
        name: string;
        avatarUrl: string | null;
        email: string;
        hasPassword: boolean | null;
      }
    | null;
};

export type GetWorkspaceBillingStateQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type GetWorkspaceBillingStateQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    billingState: {
      __typename?: 'WorkspaceBillingStateType';
      effectivePlan: string;
      fallbackPlanAfterOverride: string;
      adminOverride: {
        __typename?: 'WorkspacePlanOverrideType';
        plan: string;
        expiresAt: string | null;
      } | null;
      billingSubscription: {
        __typename?: 'SubscriptionType';
        id: string | null;
        status: SubscriptionStatus;
        plan: string;
        isBasePlan: boolean;
        recurring: SubscriptionRecurring;
        start: string;
        end: string | null;
        trialStart: string | null;
        trialEnd: string | null;
        nextBillAt: string | null;
        canceledAt: string | null;
        variant: SubscriptionVariant | null;
        provider: string | null;
        canWithdraw: boolean | null;
        withdrawalEligibleUntil: string | null;
        withdrawalUnavailableReason: string | null;
      } | null;
    };
  };
};

export type GetWorkspaceDocsWithOwnersQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  pagination: PaginationInput;
}>;

export type GetWorkspaceDocsWithOwnersQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    docs: {
      __typename?: 'PaginatedDocType';
      edges: Array<{
        __typename?: 'DocTypeEdge';
        node: {
          __typename?: 'DocType';
          id: string;
          title: string | null;
          createdAt: string | null;
          updatedAt: string | null;
          createdBy: {
            __typename?: 'PublicUserType';
            id: string;
            name: string;
            avatarUrl: string | null;
          } | null;
        };
      }>;
    };
  };
};

export type GetWorkspaceInfoQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type GetWorkspaceInfoQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    name: string;
    avatarUrl: string | null;
    role: Permission;
    team: boolean;
    membershipKind: WorkspaceMembershipKind;
    recoveryVersion: number;
  };
};

export type GetWorkspacePageByIdQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
}>;

export type GetWorkspacePageByIdQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    doc: {
      __typename?: 'DocType';
      id: string;
      mode: PublicDocMode;
      defaultRole: DocRole;
      defaultRoleDirect: boolean;
      public: boolean;
      title: string | null;
      summary: string | null;
      permissionGraphVersion: number;
      publicSharing: {
        __typename?: 'DocPublicSharingType';
        public: boolean;
        manual: boolean;
        otherSourcesCount: number;
        canEnable: boolean;
        canRevoke: boolean;
      } | null;
    } | null;
  };
};

export type GetWorkspacePageMetaByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
}>;

export type GetWorkspacePageMetaByIdQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    pageMeta: {
      __typename?: 'WorkspaceDocMeta';
      createdAt: string;
      updatedAt: string;
      createdBy: {
        __typename?: 'EditorType';
        name: string;
        avatarUrl: string | null;
      } | null;
      updatedBy: {
        __typename?: 'EditorType';
        name: string;
        avatarUrl: string | null;
      } | null;
    };
  };
};

export type GetWorkspacePublicByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetWorkspacePublicByIdQuery = {
  __typename?: 'Query';
  workspace: { __typename?: 'WorkspaceType'; public: boolean };
};

export type GetWorkspacePublicPagesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type GetWorkspacePublicPagesQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    publicDocs: Array<{
      __typename?: 'DocType';
      id: string;
      mode: PublicDocMode;
    }>;
  };
};

export type GetWorkspaceSubscriptionQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type GetWorkspaceSubscriptionQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    subscription: {
      __typename?: 'SubscriptionType';
      id: string | null;
      status: SubscriptionStatus;
      plan: string;
      isBasePlan: boolean;
      recurring: SubscriptionRecurring;
      start: string;
      end: string | null;
      trialStart: string | null;
      trialEnd: string | null;
      nextBillAt: string | null;
      canceledAt: string | null;
      variant: SubscriptionVariant | null;
      provider: string | null;
      canWithdraw: boolean | null;
      withdrawalEligibleUntil: string | null;
      withdrawalUnavailableReason: string | null;
    } | null;
  };
};

export type GetWorkspaceQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetWorkspaceQuery = {
  __typename?: 'Query';
  workspace: { __typename?: 'WorkspaceType'; id: string };
};

export type GetWorkspacesQueryVariables = Exact<{ [key: string]: never }>;

export type GetWorkspacesQuery = {
  __typename?: 'Query';
  workspaces: Array<{
    __typename?: 'WorkspaceType';
    id: string;
    initialized: boolean;
    role: Permission;
    deletionScheduledAt: string | null;
    team: boolean;
    owner: { __typename?: 'UserType'; id: string };
  }>;
};

export type GrantDocUserRolesMutationVariables = Exact<{
  input: GrantDocUserRolesInput;
}>;

export type GrantDocUserRolesMutation = {
  __typename?: 'Mutation';
  grantDocUserRoles: boolean;
};

export type AddGroupMemberMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;

export type AddGroupMemberMutation = {
  __typename?: 'Mutation';
  addGroupMember: {
    __typename?: 'UserGroupMemberType';
    id: string;
    groupId: string;
    userId: string;
  };
};

export type CreateGroupMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateGroupMutation = {
  __typename?: 'Mutation';
  createGroup: {
    __typename?: 'UserGroupType';
    id: string;
    workspaceId: string;
    name: string;
    description: string | null;
    isAutoSync: boolean;
    createdAt: string;
  };
};

export type DeleteGroupMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
}>;

export type DeleteGroupMutation = {
  __typename?: 'Mutation';
  deleteGroup: boolean;
};

export type GetDocGroupRolesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
}>;

export type GetDocGroupRolesQuery = {
  __typename?: 'Query';
  docGroupRoles: Array<{
    __typename?: 'DocGroupRoleType';
    id: string;
    docId: string;
    groupId: string;
    role: DocRole;
    createdAt: string;
    isAreaBlocked: boolean;
    areaBoundaryKind: string | null;
    areaBoundaryRootFolderId: string | null;
    areaBoundaryRootName: string | null;
  }>;
};

export type GetFolderGroupRolesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  folderId: Scalars['String']['input'];
}>;

export type GetFolderGroupRolesQuery = {
  __typename?: 'Query';
  folderGroupRoles: Array<{
    __typename?: 'FolderGroupRoleType';
    id: string;
    folderId: string;
    groupId: string;
    role: FolderRole;
    createdAt: string;
    isAreaBlocked: boolean;
    areaBoundaryKind: string | null;
    areaBoundaryRootFolderId: string | null;
    areaBoundaryRootName: string | null;
  }>;
};

export type GetGroupDocRolesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
}>;

export type GetGroupDocRolesQuery = {
  __typename?: 'Query';
  groupDocRoles: Array<{
    __typename?: 'DocGroupRoleType';
    id: string;
    docId: string;
    groupId: string;
    role: DocRole;
    createdAt: string;
    isAreaBlocked: boolean;
    areaBoundaryKind: string | null;
    areaBoundaryRootFolderId: string | null;
    areaBoundaryRootName: string | null;
  }>;
};

export type GetGroupFolderRolesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
}>;

export type GetGroupFolderRolesQuery = {
  __typename?: 'Query';
  groupFolderRoles: Array<{
    __typename?: 'FolderGroupRoleType';
    id: string;
    folderId: string;
    groupId: string;
    role: FolderRole;
    createdAt: string;
    isAreaBlocked: boolean;
    areaBoundaryKind: string | null;
    areaBoundaryRootFolderId: string | null;
    areaBoundaryRootName: string | null;
  }>;
};

export type GetGroupMembersQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
}>;

export type GetGroupMembersQuery = {
  __typename?: 'Query';
  groupMembers: Array<{
    __typename?: 'UserGroupMemberType';
    id: string;
    groupId: string;
    userId: string;
  }>;
};

export type GetGroupQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
}>;

export type GetGroupQuery = {
  __typename?: 'Query';
  group: {
    __typename?: 'UserGroupType';
    id: string;
    workspaceId: string;
    name: string;
    description: string | null;
    isAutoSync: boolean;
    createdAt: string;
  } | null;
};

export type GetGroupsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type GetGroupsQuery = {
  __typename?: 'Query';
  groups: Array<{
    __typename?: 'UserGroupType';
    id: string;
    workspaceId: string;
    name: string;
    description: string | null;
    isAutoSync: boolean;
    createdAt: string;
    memberWorkspaceRoles: Array<Permission>;
  }>;
};

export type GrantDocGroupRoleMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
  role: DocRole;
}>;

export type GrantDocGroupRoleMutation = {
  __typename?: 'Mutation';
  grantDocGroupRole: {
    __typename?: 'DocGroupRoleType';
    id: string;
    docId: string;
    groupId: string;
    role: DocRole;
    createdAt: string;
    isAreaBlocked: boolean;
    areaBoundaryKind: string | null;
    areaBoundaryRootFolderId: string | null;
    areaBoundaryRootName: string | null;
  };
};

export type GrantFolderGroupRoleMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  folderId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
  role: FolderRole;
}>;

export type GrantFolderGroupRoleMutation = {
  __typename?: 'Mutation';
  grantFolderGroupRole: {
    __typename?: 'FolderGroupRoleType';
    id: string;
    folderId: string;
    groupId: string;
    role: FolderRole;
    isAreaBlocked: boolean;
    areaBoundaryKind: string | null;
    areaBoundaryRootFolderId: string | null;
    areaBoundaryRootName: string | null;
    createdAt: string;
  };
};

export type RemoveGroupMemberMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;

export type RemoveGroupMemberMutation = {
  __typename?: 'Mutation';
  removeGroupMember: boolean;
};

export type RevokeDocGroupRoleMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
}>;

export type RevokeDocGroupRoleMutation = {
  __typename?: 'Mutation';
  revokeDocGroupRole: boolean;
};

export type RevokeFolderGroupRoleMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  folderId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
}>;

export type RevokeFolderGroupRoleMutation = {
  __typename?: 'Mutation';
  revokeFolderGroupRole: boolean;
};

export type UpdateGroupMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateGroupMutation = {
  __typename?: 'Mutation';
  updateGroup: {
    __typename?: 'UserGroupType';
    id: string;
    workspaceId: string;
    name: string;
    description: string | null;
    isAutoSync: boolean;
    createdAt: string;
  };
};

export type ListHistoryQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  pageDocId: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
}>;

export type ListHistoryQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    histories: Array<{
      __typename?: 'DocHistoryType';
      id: string;
      timestamp: string;
      editor: {
        __typename?: 'EditorType';
        name: string;
        avatarUrl: string | null;
      } | null;
    }>;
  };
};

export type IndexerAggregateQueryVariables = Exact<{
  id: Scalars['String']['input'];
  input: AggregateInput;
}>;

export type IndexerAggregateQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    aggregate: {
      __typename?: 'AggregateResultObjectType';
      buckets: Array<{
        __typename?: 'AggregateBucketObjectType';
        key: string;
        count: number;
        hits: {
          __typename?: 'AggregateBucketHitsObjectType';
          nodes: Array<{
            __typename?: 'SearchNodeObjectType';
            fields: any;
            highlights: any | null;
          }>;
        };
      }>;
      pagination: {
        __typename?: 'SearchResultPagination';
        count: number;
        hasMore: boolean;
        nextCursor: string | null;
      };
    };
  };
};

export type IndexerSearchDocsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  input: SearchDocsInput;
}>;

export type IndexerSearchDocsQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    searchDocs: Array<{
      __typename?: 'SearchDocObjectType';
      docId: string;
      title: string;
      blockId: string | null;
      blobId: string | null;
      flavour: string | null;
      sourceType: string | null;
      highlight: string | null;
      databaseId: string | null;
      rowId: string | null;
      rowShardDocId: string | null;
      rowShardVersion: string | null;
      columnId: string | null;
      databaseTitle: string | null;
      rowLabel: string | null;
      columnName: string | null;
      visibility: WorkspaceSearchResultVisibility | null;
      technicalSourceKind: WorkspaceSearchTechnicalSourceKind | null;
      createdAt: string | null;
      updatedAt: string | null;
      createdByUser: {
        __typename?: 'PublicUserType';
        id: string;
        name: string;
        avatarUrl: string | null;
      } | null;
      updatedByUser: {
        __typename?: 'PublicUserType';
        id: string;
        name: string;
        avatarUrl: string | null;
      } | null;
    }>;
  };
};

export type IndexerSearchQueryVariables = Exact<{
  id: Scalars['String']['input'];
  input: SearchInput;
}>;

export type IndexerSearchQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    search: {
      __typename?: 'SearchResultObjectType';
      nodes: Array<{
        __typename?: 'SearchNodeObjectType';
        fields: any;
        highlights: any | null;
      }>;
      pagination: {
        __typename?: 'SearchResultPagination';
        count: number;
        hasMore: boolean;
        nextCursor: string | null;
      };
    };
  };
};

export type InstalledTemplatesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type InstalledTemplatesQuery = {
  __typename?: 'Query';
  installedTemplates: Array<{
    __typename?: 'MarketplaceInstallGql';
    installId: string;
    templateId: string;
    templateTitle: string;
    templateType: string;
    stepInsertType: string | null;
    versionNumber: number;
    latestVersion: number;
    installedDocIds: Array<string>;
    workflowId: string | null;
    installedAt: string;
    isLegacyInstall: boolean;
  }>;
};

export type IsWorkspaceTwoFactorCompliantQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type IsWorkspaceTwoFactorCompliantQuery = {
  __typename?: 'Query';
  isWorkspaceTwoFactorCompliant: boolean;
};

export type KnownAiCrawlerBotsQueryVariables = Exact<{ [key: string]: never }>;

export type KnownAiCrawlerBotsQuery = {
  __typename?: 'Query';
  knownAICrawlerBots: Array<{
    __typename?: 'AICrawlerBotType';
    id: string;
    userAgent: string;
    label: string;
  }>;
};

export type LeaveWorkspaceMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  sendLeaveMail?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type LeaveWorkspaceMutation = {
  __typename?: 'Mutation';
  leaveWorkspace: boolean;
};

export type ListCustomDomainsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type ListCustomDomainsQuery = {
  __typename?: 'Query';
  customDomains: Array<{
    __typename?: 'CustomDomainType';
    id: string;
    domain: string;
    url: string;
    type: CustomDomainKind;
    status: CustomDomainStatus;
    verificationToken: string | null;
    verifiedAt: string | null;
    sslStatus: CustomDomainSslStatus;
    appBaseId: string;
    createdAt: string;
  }>;
};

export type ListNotificationsQueryVariables = Exact<{
  pagination: PaginationInput;
}>;

export type ListNotificationsQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'UserType';
    notifications: {
      __typename?: 'PaginatedNotificationObjectType';
      totalCount: number;
      edges: Array<{
        __typename?: 'NotificationObjectTypeEdge';
        cursor: string;
        node: {
          __typename?: 'NotificationObjectType';
          id: string;
          type: NotificationType;
          level: NotificationLevel;
          read: boolean;
          createdAt: string;
          updatedAt: string;
          body: any;
        };
      }>;
      pageInfo: {
        __typename?: 'PageInfo';
        startCursor: string | null;
        endCursor: string | null;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
      };
    };
  } | null;
};

export type LocaleSettingsQueryVariables = Exact<{ [key: string]: never }>;

export type LocaleSettingsQuery = {
  __typename?: 'Query';
  localeSettings: {
    __typename?: 'LocaleSettingsType';
    availableLocales: Array<string>;
    defaultLocale: string;
  };
};

export type MailAccountsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type MailAccountsQuery = {
  __typename?: 'Query';
  mailAccounts: Array<{
    __typename?: 'MailAccount';
    id: string;
    workspaceId: string;
    userId: string;
    accessDocId: string;
    resourceId: string;
    lifecycleState: string;
    trashedAt: string | null;
    deletedAt: string | null;
    effectiveDocRole: DocRole | null;
    capabilities: any;
    area: any;
    scope: string;
    showInWorkspace: boolean;
    mailboxRootId: string | null;
    credentialId: string;
    providerKind: MailProviderKind;
    emailAddress: string;
    displayName: string | null;
    status: MailAccountStatus;
    syncEnabled: boolean;
    syncMode: string;
    syncAuthorityUserId: string;
    activationStatus: string;
    providerProfileId: string;
    mailboxGroupId: string | null;
    lastSyncedAt: string | null;
    lastErrorAt: string | null;
    lastError: string | null;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type MailboxRootDocIdsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type MailboxRootDocIdsQuery = {
  __typename?: 'Query';
  mailboxRootDocIds: Array<string>;
};

export type MailboxRootQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type MailboxRootQuery = {
  __typename?: 'Query';
  mailboxRoot: {
    __typename?: 'MailMailboxRoot';
    id: string;
    workspaceId: string;
    userId: string;
    docId: string;
    messagesDatabaseId: string;
    inboxDatabaseId: string;
    sentDatabaseId: string;
    draftsDatabaseId: string;
    archiveDatabaseId: string;
    trashDatabaseId: string;
    attachmentsDatabaseId: string;
    foldersDatabaseId: string | null;
    rulesDatabaseId: string | null;
    accountStatusDatabaseId: string | null;
    createdAt: string;
    updatedAt: string;
  };
};

export type MailCredentialShareProposalsQueryVariables = Exact<{
  input: MailCredentialShareProposalInput;
}>;

export type MailCredentialShareProposalsQuery = {
  __typename?: 'Query';
  mailCredentialShareProposals: Array<{
    __typename?: 'MailCredentialShareProposal';
    credentialId: string;
    currentRole: string | null;
    managedRole: string | null;
    proposedRole: string;
    targetId: string;
    targetType: string;
  }>;
};

export type MailMessagesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  accountId: Scalars['String']['input'];
  folder?: InputMaybe<MailFolder>;
  folderId?: InputMaybe<Scalars['String']['input']>;
  virtualFolder?: InputMaybe<MailVirtualFolder>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;

export type MailMessagesQuery = {
  __typename?: 'Query';
  mailMessages: Array<{
    __typename?: 'MailMessage';
    id: string;
    workspaceId: string;
    accountId: string;
    userId: string;
    mailboxRootId: string | null;
    folderId: string | null;
    folder: MailFolder;
    direction: MailDirection;
    providerUid: string | null;
    messageId: string | null;
    threadId: string | null;
    compositionKind: MailComposeKind | null;
    sourceMessageId: string | null;
    inReplyToHeader: string | null;
    referencesHeader: string | null;
    rowId: string | null;
    subject: string | null;
    fromAddress: string | null;
    fromName: string | null;
    toAddresses: Array<string>;
    ccAddresses: Array<string>;
    bccAddresses: Array<string>;
    sentAt: string | null;
    receivedAt: string | null;
    internalDate: string | null;
    snippet: string | null;
    bodyStatus: string;
    bodyHydratedAt: string | null;
    bodyLastAccessedAt: string | null;
    cachePinned: boolean;
    isRead: boolean;
    isFlagged: boolean;
    isStarred: boolean;
    hasAttachments: boolean;
    sizeBytes: string;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type MailMessagesLegacyQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  accountId: Scalars['String']['input'];
  folder?: InputMaybe<MailFolder>;
  folderId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;

export type MailMessagesLegacyQuery = {
  __typename?: 'Query';
  mailMessages: Array<{
    __typename?: 'MailMessage';
    id: string;
    workspaceId: string;
    accountId: string;
    userId: string;
    mailboxRootId: string | null;
    folderId: string | null;
    folder: MailFolder;
    direction: MailDirection;
    providerUid: string | null;
    messageId: string | null;
    threadId: string | null;
    rowId: string | null;
    subject: string | null;
    fromAddress: string | null;
    fromName: string | null;
    toAddresses: Array<string>;
    ccAddresses: Array<string>;
    bccAddresses: Array<string>;
    sentAt: string | null;
    receivedAt: string | null;
    internalDate: string | null;
    snippet: string | null;
    bodyStatus: string;
    bodyHydratedAt: string | null;
    bodyLastAccessedAt: string | null;
    cachePinned: boolean;
    isRead: boolean;
    isFlagged: boolean;
    isStarred: boolean;
    hasAttachments: boolean;
    sizeBytes: string;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type MailVirtualFoldersQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  accountId: Scalars['String']['input'];
}>;

export type MailVirtualFoldersQuery = {
  __typename?: 'Query';
  mailVirtualFolders: Array<{
    __typename?: 'MailVirtualFolderSummary';
    id: MailVirtualFolder;
    accountId: string;
    displayName: string;
    messageCount: number;
    unreadCount: number;
  }>;
};

export type MailFoldersQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  accountId?: InputMaybe<Scalars['String']['input']>;
}>;

export type MailFoldersQuery = {
  __typename?: 'Query';
  mailFolders: Array<{
    __typename?: 'MailMailboxFolder';
    id: string;
    workspaceId: string;
    accountId: string;
    userId: string;
    rowId: string | null;
    providerFolderId: string | null;
    path: string;
    displayName: string;
    role: string;
    isSystem: boolean;
    delimiter: string | null;
    selectable: boolean;
    canCreateChild: boolean;
    canRename: boolean;
    canDelete: boolean;
    canMoveMessages: boolean;
    messageCount: number;
    unreadCount: number;
    sortOrder: number;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type MailSyncStatesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  accountId?: InputMaybe<Scalars['String']['input']>;
}>;

export type MailSyncStatesQuery = {
  __typename?: 'Query';
  mailSyncStates: Array<{
    __typename?: 'MailSyncState';
    accountId: string;
    lastUid: string | null;
    lastModSeq: string | null;
    lockedAt: string | null;
    lockedBy: string | null;
    phase: string | null;
    syncReason: string | null;
    currentFolderPath: string | null;
    currentFolderIndex: number;
    folderTotal: number;
    fetchedCount: number;
    persistedCount: number;
    duplicateCount: number;
    startedAt: string | null;
    finishedAt: string | null;
    lastSuccessfulSyncAt: string | null;
    lastErrorAt: string | null;
    lastError: string | null;
    updatedAt: string;
  }>;
};

export type MailTrustedSendersQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type MailTrustedSendersQuery = {
  __typename?: 'Query';
  mailTrustedSenders: Array<{
    __typename?: 'MailTrustedSender';
    workspaceId: string;
    userId: string;
    senderAddress: string;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type MailSignaturesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type MailSignaturesQuery = {
  __typename?: 'Query';
  mailSignatures: Array<{
    __typename?: 'MailSignature';
    id: string;
    workspaceId: string;
    userId: string;
    name: string;
    bodyHtml: string | null;
    bodyText: string | null;
    isEnabled: boolean;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type MailSignatureAssignmentsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  accountId?: InputMaybe<Scalars['String']['input']>;
}>;

export type MailSignatureAssignmentsQuery = {
  __typename?: 'Query';
  mailSignatureAssignments: Array<{
    __typename?: 'MailSignatureAssignment';
    id: string;
    workspaceId: string;
    userId: string;
    accountId: string | null;
    signatureId: string | null;
    scope: MailSignatureScope;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type MailAutorespondersQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  accountId?: InputMaybe<Scalars['String']['input']>;
}>;

export type MailAutorespondersQuery = {
  __typename?: 'Query';
  mailAutoresponders: Array<{
    __typename?: 'MailAutoresponder';
    id: string;
    workspaceId: string;
    userId: string;
    accountId: string | null;
    signatureId: string | null;
    enabled: boolean;
    startsAt: string | null;
    endsAt: string | null;
    subject: string | null;
    bodyText: string | null;
    bodyHtml: string | null;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type PrepareMailCompositionQueryVariables = Exact<{
  input: PrepareMailCompositionInput;
}>;

export type PrepareMailCompositionQuery = {
  __typename?: 'Query';
  prepareMailComposition: {
    __typename?: 'PreparedMailComposition';
    accountId: string;
    composeKind: MailComposeKind;
    sourceMessageId: string;
    inReplyToHeader: string | null;
    referencesHeader: string | null;
    to: Array<string>;
    cc: Array<string>;
    bcc: Array<string>;
    subject: string;
    quoteText: string;
    quoteHtml: string | null;
    attachments: Array<{
      __typename?: 'PreparedMailAttachment';
      blobKey: string;
      filename: string;
      mimeType: string | null;
    }>;
  };
};

export type MailComposeSignatureQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  accountId: Scalars['String']['input'];
  composeKind: MailComposeKind;
}>;

export type MailComposeSignatureQuery = {
  __typename?: 'Query';
  mailComposeSignature: {
    __typename?: 'MailSignature';
    id: string;
    bodyHtml: string | null;
    bodyText: string | null;
  } | null;
};

export type MailRulesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  accountId?: InputMaybe<Scalars['String']['input']>;
}>;

export type MailRulesQuery = {
  __typename?: 'Query';
  mailRules: Array<{
    __typename?: 'MailRule';
    id: string;
    workspaceId: string;
    accountId: string | null;
    userId: string;
    rowId: string | null;
    name: string;
    requestedEnabled: boolean;
    effectiveEnabled: boolean;
    validationStatus: string;
    validationError: string | null;
    priority: number;
    conditions: any;
    actions: any;
    lastRunAt: string | null;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type MailMessageBodyQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  messageId: Scalars['String']['input'];
}>;

export type MailMessageBodyQuery = {
  __typename?: 'Query';
  mailMessageBody: {
    __typename?: 'MailMessageBody';
    id: string;
    workspaceId: string;
    accountId: string;
    userId: string;
    subject: string | null;
    bodyText: string | null;
    bodyHtml: string | null;
    bodyStatus: string;
    bodyHydratedAt: string | null;
    bodyLastAccessedAt: string | null;
    bodyEvictedAt: string | null;
    cachePinned: boolean;
    sizeBytes: string;
    attachments: Array<{
      __typename?: 'MailAttachment';
      id: string;
      workspaceId: string;
      accountId: string;
      messageId: string;
      userId: string;
      blobKey: string;
      filename: string;
      mimeType: string;
      sizeBytes: string;
      contentId: string | null;
      disposition: string | null;
      createdAt: string;
    }>;
  };
};

export type MailAdminOverviewQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type MailAdminOverviewQuery = {
  __typename?: 'Query';
  mailAdminOverview: {
    __typename?: 'MailAdminOverview';
    workspaceId: string;
    policy: {
      __typename?: 'MailPolicy';
      workspaceId: string;
      mailWindowDays: number;
      availableMailWindowDays: Array<number>;
      effectiveMailWindowDays: number;
      retentionMode: MailRetentionMode;
      retentionDays: number | null;
      searchIndexEnabled: boolean;
      searchIndexAttachmentsEnabled: boolean;
    };
    accounts: Array<{
      __typename?: 'MailAdminAccountMetadata';
      id: string;
      userId: string;
      userEmail: string;
      userName: string | null;
      providerKind: MailProviderKind;
      emailAddress: string;
      status: MailAccountStatus;
      syncEnabled: boolean;
      syncMode: string;
      syncAuthorityUserId: string;
      activationStatus: string;
      providerProfileId: string;
      mailboxGroupId: string | null;
      lastSyncedAt: string | null;
      lastErrorAt: string | null;
      lastError: string | null;
      createdAt: string;
    }>;
    usage: {
      __typename?: 'MailUsageStats';
      accountCount: number;
      messageCount: number;
      attachmentCount: number;
      searchIndexBytes: string;
      bodyCacheBytes: string;
      attachmentCacheBytes: string;
      searchIndexedMessageCount: number;
      searchPendingMessageCount: number;
      searchFailedMessageCount: number;
      searchSkippedMessageCount: number;
      calculatedAt: string;
    };
    searchIndexStatus: {
      __typename?: 'MailSearchIndexAdminStatus';
      status: string;
      backfillStatus: string;
      backfillRunId: string | null;
      backfillJobId: string | null;
      backfillScannedCount: number;
      backfillQueuedCount: number;
      backfillIndexedCount: number;
      backfillSkippedCount: number;
      backfillFailedCount: number;
      backfillPurgedCount: number;
      backfillPageCount: number;
      backfillPageSize: number | null;
      backfillCursorDate: string | null;
      backfillStartedAt: string | null;
      backfillPausedAt: string | null;
      backfillCompletedAt: string | null;
      backfillCancelledAt: string | null;
      backfillLastError: string | null;
      eligibleMessageCount: number;
      unindexedMessageCount: number;
      coveragePercent: number;
      avgIndexedBytesPerMessage: string;
      oldestEligibleMessageAt: string | null;
      newestEligibleMessageAt: string | null;
      oldestUnindexedMessageAt: string | null;
      newestUnindexedMessageAt: string | null;
      degradedReasons: Array<string>;
    };
    quotaUsers: Array<{
      __typename?: 'MailUserQuotaUsage';
      userId: string;
      userName: string | null;
      userEmail: string;
      mailWindowDays: number;
      worstFactorKind: MailQuotaFactorKind;
      worstPercent: number;
      factors: Array<{
        __typename?: 'MailQuotaFactor';
        kind: MailQuotaFactorKind;
        usedBytes: string | null;
        limitBytes: string | null;
        usedCount: number | null;
        limitCount: number | null;
        percent: number;
        status: MailQuotaStatus;
        label: string;
        detail: string;
        action: string | null;
        limitSources: Array<{
          __typename?: 'MailQuotaLimitSource';
          kind: MailQuotaLimitSourceKind;
          label: string;
          limitBytes: string | null;
          limitCount: number | null;
        }>;
      }>;
      accounts: Array<{
        __typename?: 'MailAccountQuotaUsage';
        accountId: string;
        emailAddress: string;
        providerKind: MailProviderKind;
        worstFactorKind: MailQuotaFactorKind;
        worstPercent: number;
        factors: Array<{
          __typename?: 'MailQuotaFactor';
          kind: MailQuotaFactorKind;
          usedBytes: string | null;
          limitBytes: string | null;
          usedCount: number | null;
          limitCount: number | null;
          percent: number;
          status: MailQuotaStatus;
          label: string;
          detail: string;
          action: string | null;
          limitSources: Array<{
            __typename?: 'MailQuotaLimitSource';
            kind: MailQuotaLimitSourceKind;
            label: string;
            limitBytes: string | null;
            limitCount: number | null;
          }>;
        }>;
      }>;
    }>;
  };
};

export type MailCurrentUserQuotaQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type MailCurrentUserQuotaQuery = {
  __typename?: 'Query';
  mailCurrentUserQuota: {
    __typename?: 'MailUserQuotaUsage';
    userId: string;
    userName: string | null;
    userEmail: string;
    mailWindowDays: number;
    worstFactorKind: MailQuotaFactorKind;
    worstPercent: number;
    factors: Array<{
      __typename?: 'MailQuotaFactor';
      kind: MailQuotaFactorKind;
      usedBytes: string | null;
      limitBytes: string | null;
      usedCount: number | null;
      limitCount: number | null;
      percent: number;
      status: MailQuotaStatus;
      label: string;
      detail: string;
      action: string | null;
      limitSources: Array<{
        __typename?: 'MailQuotaLimitSource';
        kind: MailQuotaLimitSourceKind;
        label: string;
        limitBytes: string | null;
        limitCount: number | null;
      }>;
    }>;
    accounts: Array<{
      __typename?: 'MailAccountQuotaUsage';
      accountId: string;
      emailAddress: string;
      providerKind: MailProviderKind;
      worstFactorKind: MailQuotaFactorKind;
      worstPercent: number;
      factors: Array<{
        __typename?: 'MailQuotaFactor';
        kind: MailQuotaFactorKind;
        usedBytes: string | null;
        limitBytes: string | null;
        usedCount: number | null;
        limitCount: number | null;
        percent: number;
        status: MailQuotaStatus;
        label: string;
        detail: string;
        action: string | null;
        limitSources: Array<{
          __typename?: 'MailQuotaLimitSource';
          kind: MailQuotaLimitSourceKind;
          label: string;
          limitBytes: string | null;
          limitCount: number | null;
        }>;
      }>;
    }>;
  };
};

export type ConnectMailAccountMutationVariables = Exact<{
  input: ConnectMailAccountInput;
}>;

export type ConnectMailAccountMutation = {
  __typename?: 'Mutation';
  connectMailAccount: {
    __typename?: 'MailAccount';
    id: string;
    workspaceId: string;
    userId: string;
    accessDocId: string;
    resourceId: string;
    lifecycleState: string;
    trashedAt: string | null;
    deletedAt: string | null;
    effectiveDocRole: DocRole | null;
    capabilities: any;
    area: any;
    scope: string;
    showInWorkspace: boolean;
    mailboxRootId: string | null;
    credentialId: string;
    providerKind: MailProviderKind;
    emailAddress: string;
    displayName: string | null;
    status: MailAccountStatus;
    syncEnabled: boolean;
    syncMode: string;
    syncAuthorityUserId: string;
    activationStatus: string;
    providerProfileId: string;
    mailboxGroupId: string | null;
    lastSyncedAt: string | null;
    lastErrorAt: string | null;
    lastError: string | null;
    createdAt: string;
    updatedAt: string;
  };
};

export type UpdateMailAccountMutationVariables = Exact<{
  input: UpdateMailAccountInput;
}>;

export type UpdateMailAccountMutation = {
  __typename?: 'Mutation';
  updateMailAccount: {
    __typename?: 'MailAccount';
    id: string;
    workspaceId: string;
    userId: string;
    accessDocId: string;
    resourceId: string;
    lifecycleState: string;
    trashedAt: string | null;
    deletedAt: string | null;
    effectiveDocRole: DocRole | null;
    capabilities: any;
    area: any;
    scope: string;
    showInWorkspace: boolean;
    mailboxRootId: string | null;
    credentialId: string;
    providerKind: MailProviderKind;
    emailAddress: string;
    displayName: string | null;
    status: MailAccountStatus;
    syncEnabled: boolean;
    syncMode: string;
    syncAuthorityUserId: string;
    activationStatus: string;
    providerProfileId: string;
    mailboxGroupId: string | null;
    lastSyncedAt: string | null;
    lastErrorAt: string | null;
    lastError: string | null;
    createdAt: string;
    updatedAt: string;
  };
};

export type DeleteMailAccountMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  accountId: Scalars['String']['input'];
}>;

export type DeleteMailAccountMutation = {
  __typename?: 'Mutation';
  deleteMailAccount: boolean;
};

export type SyncMailAccountMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  accountId: Scalars['String']['input'];
}>;

export type SyncMailAccountMutation = {
  __typename?: 'Mutation';
  syncMailAccount: string;
};

export type SetMailWatchInterestMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  accountId: Scalars['String']['input'];
  interest: MailWatchInterest;
}>;

export type SetMailWatchInterestMutation = {
  __typename?: 'Mutation';
  setMailWatchInterest: boolean;
};

export type SendMailMutationVariables = Exact<{
  input: SendMailInput;
}>;

export type SendMailMutation = {
  __typename?: 'Mutation';
  sendMail: {
    __typename?: 'SendMailResult';
    providerMessageId: string | null;
    persistedMessageId: string;
    rowId: string;
    accepted: Array<string>;
    rejected: Array<string>;
  };
};

export type SaveMailDraftMutationVariables = Exact<{
  input: SaveMailDraftInput;
}>;

export type SaveMailDraftMutation = {
  __typename?: 'Mutation';
  saveMailDraft: {
    __typename?: 'SaveMailDraftResult';
    accountId: string;
    draftMessageId: string;
    rowId: string;
    providerDraftUid: string | null;
    savedAt: string;
  };
};

export type SendSavedMailDraftMutationVariables = Exact<{
  input: SendSavedMailDraftInput;
  files?: InputMaybe<
    Array<Scalars['Upload']['input']> | Scalars['Upload']['input']
  >;
}>;

export type SendSavedMailDraftMutation = {
  __typename?: 'Mutation';
  sendSavedMailDraft: {
    __typename?: 'SendMailResult';
    providerMessageId: string | null;
    persistedMessageId: string;
    rowId: string;
    accepted: Array<string>;
    rejected: Array<string>;
  };
};

export type UpsertMailSignatureMutationVariables = Exact<{
  input: UpsertMailSignatureInput;
}>;

export type UpsertMailSignatureMutation = {
  __typename?: 'Mutation';
  upsertMailSignature: {
    __typename?: 'MailSignature';
    id: string;
    workspaceId: string;
    userId: string;
    name: string;
    bodyHtml: string | null;
    bodyText: string | null;
    isEnabled: boolean;
    createdAt: string;
    updatedAt: string;
  };
};

export type DeleteMailSignatureMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  signatureId: Scalars['String']['input'];
}>;

export type DeleteMailSignatureMutation = {
  __typename?: 'Mutation';
  deleteMailSignature: boolean;
};

export type AssignMailSignatureMutationVariables = Exact<{
  input: AssignMailSignatureInput;
}>;

export type AssignMailSignatureMutation = {
  __typename?: 'Mutation';
  assignMailSignature: {
    __typename?: 'MailSignatureAssignment';
    id: string;
    workspaceId: string;
    userId: string;
    accountId: string | null;
    signatureId: string | null;
    scope: MailSignatureScope;
    createdAt: string;
    updatedAt: string;
  };
};

export type DeleteMailSignatureAssignmentMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  accountId: Scalars['String']['input'];
  scope: MailSignatureScope;
}>;

export type DeleteMailSignatureAssignmentMutation = {
  __typename?: 'Mutation';
  deleteMailSignatureAssignment: boolean;
};

export type UpsertMailAutoresponderMutationVariables = Exact<{
  input: UpsertMailAutoresponderInput;
}>;

export type UpsertMailAutoresponderMutation = {
  __typename?: 'Mutation';
  upsertMailAutoresponder: {
    __typename?: 'MailAutoresponder';
    id: string;
    workspaceId: string;
    userId: string;
    accountId: string | null;
    signatureId: string | null;
    enabled: boolean;
    startsAt: string | null;
    endsAt: string | null;
    subject: string | null;
    bodyText: string | null;
    bodyHtml: string | null;
    createdAt: string;
    updatedAt: string;
  };
};

export type CreateMailFolderMutationVariables = Exact<{
  input: CreateMailFolderInput;
}>;

export type CreateMailFolderMutation = {
  __typename?: 'Mutation';
  createMailFolder: {
    __typename?: 'MailMailboxFolder';
    id: string;
    accountId: string;
    path: string;
    displayName: string;
    role: string;
    isSystem: boolean;
    canRename: boolean;
    canDelete: boolean;
    messageCount: number;
    unreadCount: number;
  };
};

export type UpdateMailFolderMutationVariables = Exact<{
  input: UpdateMailFolderInput;
}>;

export type UpdateMailFolderMutation = {
  __typename?: 'Mutation';
  updateMailFolder: {
    __typename?: 'MailMailboxFolder';
    id: string;
    accountId: string;
    path: string;
    displayName: string;
    role: string;
    isSystem: boolean;
    canRename: boolean;
    canDelete: boolean;
    messageCount: number;
    unreadCount: number;
  };
};

export type DeleteMailFolderMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  folderId: Scalars['String']['input'];
}>;

export type DeleteMailFolderMutation = {
  __typename?: 'Mutation';
  deleteMailFolder: boolean;
};

export type UpdateMailMessageStateMutationVariables = Exact<{
  input: UpdateMailMessageStateInput;
}>;

export type UpdateMailMessageStateMutation = {
  __typename?: 'Mutation';
  updateMailMessageState: {
    __typename?: 'MailMessage';
    id: string;
    folderId: string | null;
    folder: MailFolder;
    isRead: boolean;
    isFlagged: boolean;
    isStarred: boolean;
    updatedAt: string;
  };
};

export type MoveMailMessageMutationVariables = Exact<{
  input: MoveMailMessageInput;
}>;

export type MoveMailMessageMutation = {
  __typename?: 'Mutation';
  moveMailMessage: {
    __typename?: 'MailMessage';
    id: string;
    folderId: string | null;
    folder: MailFolder;
    isRead: boolean;
    isFlagged: boolean;
    isStarred: boolean;
    updatedAt: string;
  };
};

export type DeleteMailAutoresponderOverrideMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  accountId: Scalars['String']['input'];
}>;

export type DeleteMailAutoresponderOverrideMutation = {
  __typename?: 'Mutation';
  deleteMailAutoresponderOverride: boolean;
};

export type UpsertMailRuleMutationVariables = Exact<{
  input: UpsertMailRuleInput;
}>;

export type UpsertMailRuleMutation = {
  __typename?: 'Mutation';
  upsertMailRule: {
    __typename?: 'MailRule';
    id: string;
    accountId: string | null;
    name: string;
    requestedEnabled: boolean;
    effectiveEnabled: boolean;
    validationStatus: string;
    validationError: string | null;
    priority: number;
    conditions: any;
    actions: any;
    updatedAt: string;
  };
};

export type DeleteMailRuleMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  ruleId: Scalars['String']['input'];
}>;

export type DeleteMailRuleMutation = {
  __typename?: 'Mutation';
  deleteMailRule: boolean;
};

export type UpdateMailPolicyMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  input: UpdateMailPolicyInput;
}>;

export type UpdateMailPolicyMutation = {
  __typename?: 'Mutation';
  updateMailPolicy: {
    __typename?: 'MailPolicy';
    workspaceId: string;
    mailWindowDays: number;
    availableMailWindowDays: Array<number>;
    effectiveMailWindowDays: number;
    retentionMode: MailRetentionMode;
    retentionDays: number | null;
    searchIndexEnabled: boolean;
    searchIndexAttachmentsEnabled: boolean;
  };
};

export type RebuildMailSearchIndexMutationVariables = Exact<{
  input: RebuildMailSearchIndexInput;
}>;

export type RebuildMailSearchIndexMutation = {
  __typename?: 'Mutation';
  rebuildMailSearchIndex: {
    __typename?: 'RebuildMailSearchIndexResult';
    jobId: string;
    status: string;
    queuedMessages: number;
    skippedMessages: number;
  };
};

export type TrustMailSenderMutationVariables = Exact<{
  input: TrustMailSenderInput;
}>;

export type TrustMailSenderMutation = {
  __typename?: 'Mutation';
  trustMailSender: {
    __typename?: 'MailTrustedSender';
    workspaceId: string;
    userId: string;
    senderAddress: string;
    createdAt: string;
    updatedAt: string;
  };
};

export type ManagedAiStatusQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type ManagedAiStatusQuery = {
  __typename?: 'Query';
  managedAIStatus: {
    __typename?: 'ManagedAIStatusType';
    enabled: boolean;
    consentGiven: boolean;
    consentAt: string | null;
    suspended: boolean;
    suspendReason: string | null;
    maxRequestsPerMinute: number;
  };
};

export type AddGroupMateMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
  mateId: Scalars['String']['input'];
}>;

export type AddGroupMateMutation = {
  __typename?: 'Mutation';
  addGroupMate: boolean;
};

export type CreateSkillMutationVariables = Exact<{
  input: CreateSkillInput;
}>;

export type CreateSkillMutation = {
  __typename?: 'Mutation';
  createSkill: { __typename?: 'SkillGql'; id: string };
};

export type CreateWorkspaceMateMutationVariables = Exact<{
  input: CreateWorkspaceMateInput;
}>;

export type CreateWorkspaceMateMutation = {
  __typename?: 'Mutation';
  createWorkspaceMate: { __typename?: 'MateGql'; id: string };
};

export type DeleteMateMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  mateId: Scalars['String']['input'];
}>;

export type DeleteMateMutation = {
  __typename?: 'Mutation';
  deleteMate: boolean;
};

export type DeleteSkillMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  skillId: Scalars['String']['input'];
}>;

export type DeleteSkillMutation = {
  __typename?: 'Mutation';
  deleteSkill: boolean;
};

export type GetCanManageWorkspaceMatesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type GetCanManageWorkspaceMatesQuery = {
  __typename?: 'Query';
  canManageWorkspaceMates: boolean;
};

export type GetDocMateRolesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
}>;

export type GetDocMateRolesQuery = {
  __typename?: 'Query';
  docMateRoles: Array<{
    __typename?: 'DocMateRoleType';
    mateId: string;
    name: string;
    role: DocRole;
  }>;
};

export type GetFolderMateRolesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  folderId: Scalars['String']['input'];
}>;

export type GetFolderMateRolesQuery = {
  __typename?: 'Query';
  folderMateRoles: Array<{
    __typename?: 'FolderMateRoleType';
    mateId: string;
    name: string;
    role: FolderRole;
  }>;
};

export type GetGroupMatesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
}>;

export type GetGroupMatesQuery = {
  __typename?: 'Query';
  groupMates: Array<{
    __typename?: 'NamedMateType';
    mateId: string;
    name: string;
  }>;
};

export type GetMateGrantTargetsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type GetMateGrantTargetsQuery = {
  __typename?: 'Query';
  mateGrantTargets: Array<{
    __typename?: 'NamedMateType';
    mateId: string;
    name: string;
  }>;
};

export type GetMateInviteFoldersQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type GetMateInviteFoldersQuery = {
  __typename?: 'Query';
  mateInviteFolders: Array<{
    __typename?: 'MateInvitedFolderGql';
    folderId: string;
    name: string;
  }>;
};

export type GetMateRulesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type GetMateRulesQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    matePersonalReadMode: MateRuleMode;
    mateWorkspaceReadMode: MateRuleMode;
    mateMemoryEnabled: boolean;
  };
};

export type GetMateShareEffectQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  mateId: Scalars['String']['input'];
  principalKind: MateSharePrincipalKind;
  principalId: Scalars['String']['input'];
}>;

export type GetMateShareEffectQuery = {
  __typename?: 'Query';
  mateShareEffect: Array<{
    __typename?: 'MateShareFolderEffectGql';
    folderId: string;
    name: string;
    mateRole: FolderRole;
    rights: {
      __typename?: 'MateShareRightsGql';
      read: MateReadScope;
      create: boolean;
      update: MateChangeScope;
      delete: MateChangeScope;
    };
    read: {
      __typename?: 'MateRightEffectGql';
      allowed: boolean;
      ask: boolean;
      limitedBy: MateEffectLimit | null;
    };
    create: {
      __typename?: 'MateRightEffectGql';
      allowed: boolean;
      ask: boolean;
      limitedBy: MateEffectLimit | null;
    };
    update: {
      __typename?: 'MateRightEffectGql';
      allowed: boolean;
      ask: boolean;
      limitedBy: MateEffectLimit | null;
    };
    delete: {
      __typename?: 'MateRightEffectGql';
      allowed: boolean;
      ask: boolean;
      limitedBy: MateEffectLimit | null;
    };
  }>;
};

export type GetMateSharesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  mateId: Scalars['String']['input'];
}>;

export type GetMateSharesQuery = {
  __typename?: 'Query';
  mateShares: Array<{
    __typename?: 'MateShareGql';
    principalKind: MateSharePrincipalKind;
    principalId: string;
    principalName: string;
    mode: MateShareMode;
    shareMemory: boolean;
  }>;
};

export type GetMateSkillsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  mateId: Scalars['String']['input'];
}>;

export type GetMateSkillsQuery = {
  __typename?: 'Query';
  mateSkills: Array<string>;
};

export type GetSkillToolCatalogQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type GetSkillToolCatalogQuery = {
  __typename?: 'Query';
  skillToolCatalog: Array<{
    __typename?: 'SkillToolGroupGql';
    category: string;
    tools: Array<{
      __typename?: 'SkillToolGql';
      name: string;
      description: string;
      source: string;
    }>;
  }>;
};

export type GetUsableMatesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type GetUsableMatesQuery = {
  __typename?: 'Query';
  usableMates: Array<{
    __typename?: 'UsableMateGql';
    id: string;
    kind: string;
    name: string;
    description: string;
    memoryEnabled: boolean;
    instructions: string | null;
  }>;
};

export type GetWorkspaceMatesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type GetWorkspaceMatesQuery = {
  __typename?: 'Query';
  workspaceMates: Array<{
    __typename?: 'MateGql';
    id: string;
    name: string;
    description: string;
    instructions: string;
    memoryEnabled: boolean;
  }>;
};

export type GetWorkspaceSkillsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type GetWorkspaceSkillsQuery = {
  __typename?: 'Query';
  workspaceSkills: Array<{
    __typename?: 'SkillGql';
    id: string;
    name: string;
    description: string;
    instructions: string;
    toolNames: Array<string>;
  }>;
};

export type GrantDocMateRoleMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
  mateId: Scalars['String']['input'];
  role: DocRole;
}>;

export type GrantDocMateRoleMutation = {
  __typename?: 'Mutation';
  grantDocMateRole: boolean;
};

export type GrantFolderMateRoleMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  folderId: Scalars['String']['input'];
  mateId: Scalars['String']['input'];
  role: FolderRole;
}>;

export type GrantFolderMateRoleMutation = {
  __typename?: 'Mutation';
  grantFolderMateRole: boolean;
};

export type RemoveGroupMateMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
  mateId: Scalars['String']['input'];
}>;

export type RemoveGroupMateMutation = {
  __typename?: 'Mutation';
  removeGroupMate: boolean;
};

export type RevokeDocMateRoleMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
  mateId: Scalars['String']['input'];
}>;

export type RevokeDocMateRoleMutation = {
  __typename?: 'Mutation';
  revokeDocMateRole: boolean;
};

export type RevokeFolderMateRoleMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  folderId: Scalars['String']['input'];
  mateId: Scalars['String']['input'];
}>;

export type RevokeFolderMateRoleMutation = {
  __typename?: 'Mutation';
  revokeFolderMateRole: boolean;
};

export type SetMateSkillsMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  mateId: Scalars['String']['input'];
  skillIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type SetMateSkillsMutation = {
  __typename?: 'Mutation';
  setMateSkills: Array<string>;
};

export type ShareMateMutationVariables = Exact<{
  input: ShareMateInput;
}>;

export type ShareMateMutation = {
  __typename?: 'Mutation';
  shareMate: { __typename?: 'MateShareGql'; principalId: string };
};

export type UnshareMateMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  mateId: Scalars['String']['input'];
  principalKind: MateSharePrincipalKind;
  principalId: Scalars['String']['input'];
}>;

export type UnshareMateMutation = {
  __typename?: 'Mutation';
  unshareMate: boolean;
};

export type UpdateMateRulesMutationVariables = Exact<{
  input: UpdateWorkspaceInput;
}>;

export type UpdateMateRulesMutation = {
  __typename?: 'Mutation';
  updateWorkspace: { __typename?: 'WorkspaceType'; id: string };
};

export type UpdateMateMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  mateId: Scalars['String']['input'];
  input: UpdateMateInput;
}>;

export type UpdateMateMutation = {
  __typename?: 'Mutation';
  updateMate: { __typename?: 'MateGql'; id: string };
};

export type UpdateSkillMutationVariables = Exact<{
  input: UpdateSkillInput;
}>;

export type UpdateSkillMutation = {
  __typename?: 'Mutation';
  updateSkill: { __typename?: 'SkillGql'; id: string };
};

export type GenerateWorkspaceMcpTokenMutationVariables = Exact<{
  input: GenerateWorkspaceMcpTokenInput;
}>;

export type GenerateWorkspaceMcpTokenMutation = {
  __typename?: 'Mutation';
  generateWorkspaceMcpToken: {
    __typename?: 'WorkspaceMcpTokenWithConfig';
    config: string;
    token: {
      __typename?: 'WorkspaceMcpToken';
      id: string;
      userId: string;
      userName: string | null;
      userEmail: string | null;
      userRole: string | null;
      workspaceId: string;
      createdBy: string;
      createdByName: string | null;
      createdAt: string;
      expiresAt: string | null;
      maskedToken: string;
      connectedApp: string | null;
      toolPolicy: {
        __typename?: 'WorkspaceMcpToolPolicy';
        disabledCategories: Array<string>;
        disabledTools: Array<string>;
      };
    };
  };
};

export type GrantWorkspaceMcpAccessToGroupMutationVariables = Exact<{
  input: GrantWorkspaceMcpGroupInput;
}>;

export type GrantWorkspaceMcpAccessToGroupMutation = {
  __typename?: 'Mutation';
  grantWorkspaceMcpAccessToGroup: {
    __typename?: 'WorkspaceMcpGroupGrantResult';
    granted: number;
    skipped: number;
    failed: number;
  };
};

export type ListWorkspaceMcpTokensQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type ListWorkspaceMcpTokensQuery = {
  __typename?: 'Query';
  workspaceMcpTokens: Array<{
    __typename?: 'WorkspaceMcpToken';
    id: string;
    userId: string;
    userName: string | null;
    userEmail: string | null;
    userRole: string | null;
    workspaceId: string;
    createdBy: string;
    createdByName: string | null;
    createdAt: string;
    expiresAt: string | null;
    maskedToken: string;
    connectedApp: string | null;
    toolPolicy: {
      __typename?: 'WorkspaceMcpToolPolicy';
      disabledCategories: Array<string>;
      disabledTools: Array<string>;
    };
  }>;
};

export type MyWorkspaceMcpTokensQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type MyWorkspaceMcpTokensQuery = {
  __typename?: 'Query';
  myWorkspaceMcpTokens: Array<{
    __typename?: 'WorkspaceMcpToken';
    id: string;
    userId: string;
    userName: string | null;
    userEmail: string | null;
    userRole: string | null;
    workspaceId: string;
    createdBy: string;
    createdByName: string | null;
    createdAt: string;
    expiresAt: string | null;
    maskedToken: string;
    connectedApp: string | null;
    toolPolicy: {
      __typename?: 'WorkspaceMcpToolPolicy';
      disabledCategories: Array<string>;
      disabledTools: Array<string>;
    };
  }>;
};

export type RequestWorkspaceMcpAccessMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type RequestWorkspaceMcpAccessMutation = {
  __typename?: 'Mutation';
  requestWorkspaceMcpAccess: boolean;
};

export type RevealWorkspaceMcpGrantMutationVariables = Exact<{
  input: RevealWorkspaceMcpGrantInput;
}>;

export type RevealWorkspaceMcpGrantMutation = {
  __typename?: 'Mutation';
  revealWorkspaceMcpGrant: {
    __typename?: 'WorkspaceMcpGrantReveal';
    tokenId: string;
    workspaceId: string;
    config: string;
    expiresAt: string | null;
    createdAt: string;
  };
};

export type RevokeWorkspaceMcpTokenMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  tokenId: Scalars['String']['input'];
}>;

export type RevokeWorkspaceMcpTokenMutation = {
  __typename?: 'Mutation';
  revokeWorkspaceMcpToken: boolean;
};

export type MemberQuotaInfoQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;

export type MemberQuotaInfoQuery = {
  __typename?: 'Query';
  memberQuotaInfo: {
    __typename?: 'MemberQuotaInfoType';
    baseLimit: number;
    extraSeats: number;
    maxExtraSeats: number;
    effectiveLimit: number;
    currentUsage: number;
    canInvite: boolean;
    seatTiers: string | null;
    storagePerSeat: string;
  };
};

export type MentionUserMutationVariables = Exact<{
  input: MentionInput;
}>;

export type MentionUserMutation = {
  __typename?: 'Mutation';
  mentionUser: string;
};

export type MineCopyQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  sourceKind: MineCopySourceKind;
  sourceId: Scalars['String']['input'];
}>;

export type MineCopyQuery = {
  __typename?: 'Query';
  mineCopy: {
    __typename?: 'MineCopyLookup';
    sourceExists: boolean;
    copy: {
      __typename?: 'MineCopy';
      templateId: string;
      versionNumber: number;
      updatedAt: string;
    } | null;
  };
};

export type MoveAppBaseDatabaseMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  input: MoveAppBaseDatabaseInput;
}>;

export type MoveAppBaseDatabaseMutation = {
  __typename?: 'Mutation';
  moveAppBaseDatabase: any;
};

export type MoveAppBaseMountMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  mountId: Scalars['String']['input'];
  mountPoint: Scalars['String']['input'];
  swap?: InputMaybe<Scalars['Boolean']['input']>;
  change?: InputMaybe<AppBaseDraftChangeInput>;
}>;

export type MoveAppBaseMountMutation = {
  __typename?: 'Mutation';
  moveAppBaseMount: any;
};

export type MyAccessibleDocsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  docIds?: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >;
}>;

export type MyAccessibleDocsQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    docs: {
      __typename?: 'PaginatedDocType';
      totalCount: number;
      edges: Array<{
        __typename?: 'DocTypeEdge';
        node: {
          __typename?: 'DocType';
          id: string;
          title: string | null;
          trashed: boolean;
          createdAt: string | null;
          updatedAt: string | null;
          permissionGraphVersion: number;
          permissions: {
            __typename?: 'DocPermissions';
            Doc_Copy: boolean;
            Doc_Delete: boolean;
            Doc_Duplicate: boolean;
            Doc_Properties_Read: boolean;
            Doc_Properties_Update: boolean;
            Doc_Publish: boolean;
            Doc_Read: boolean;
            Doc_Restore: boolean;
            Doc_TransferOwner: boolean;
            Doc_Trash: boolean;
            Doc_Update: boolean;
            Doc_Users_Manage: boolean;
            Doc_Users_Read: boolean;
            Doc_Comments_Create: boolean;
            Doc_Comments_Delete: boolean;
            Doc_Comments_Read: boolean;
            Doc_Comments_Resolve: boolean;
          };
        };
      }>;
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean };
    };
  };
};

export type MyNotificationPreferencesInWorkspaceQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type MyNotificationPreferencesInWorkspaceQuery = {
  __typename?: 'Query';
  myNotificationPreferencesInWorkspace: Array<{
    __typename?: 'UserNotificationPreferenceType';
    triggerType: string;
    category: string;
    i18nKey: string;
    descriptionI18nKey: string;
    requiredRole: string;
    enabled: boolean;
    channelMail: boolean;
    channelInApp: boolean;
    channelWebPush: boolean;
    supportsMail: boolean;
    supportsInApp: boolean;
    supportsWebPush: boolean;
    accountId: string;
    folderKey: string;
    quietHours: any | null;
    thresholds: Array<number>;
    defaultThresholds: Array<number>;
    stored: boolean;
  }>;
};

export type MyTenantsQueryVariables = Exact<{ [key: string]: never }>;

export type MyTenantsQuery = {
  __typename?: 'Query';
  myTenants: Array<{
    __typename?: 'TenantType';
    id: string;
    name: string;
    slug: string;
    billingEmail: string;
    stripeCustomerId: string | null;
    createdAt: string;
    updatedAt: string;
    members: Array<{
      __typename?: 'TenantMemberType';
      id: string;
      userId: string;
      role: TenantRoleEnum;
      createdAt: string;
    }>;
  }>;
};

export type NotificationCountQueryVariables = Exact<{ [key: string]: never }>;

export type NotificationCountQuery = {
  __typename?: 'Query';
  currentUser: { __typename?: 'UserType'; notificationCount: number } | null;
};

export type OnboardingStatusQueryVariables = Exact<{ [key: string]: never }>;

export type OnboardingStatusQuery = {
  __typename?: 'Query';
  onboardingStatus: {
    __typename?: 'OnboardingStatusType';
    needsOnboarding: boolean;
    reason: OnboardingReason;
    invitedWorkspaceId: string | null;
    inviteId: string | null;
    revokedWorkspaceName: string | null;
    revocationNotificationId: string | null;
  };
};

export type PdfPageSearchQueryVariables = Exact<{
  id: Scalars['String']['input'];
  input: PdfPageSearchInput;
}>;

export type PdfPageSearchQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    pdfSearch: Array<{
      __typename?: 'PdfSearchHitObjectType';
      docId: string;
      attachmentBlockId: string;
      pageIndex: number;
      source: string | null;
      coverageStatus: string | null;
      visibility: WorkspaceSearchResultVisibility | null;
      technicalSourceKind: WorkspaceSearchTechnicalSourceKind | null;
      snippet: string;
      score: number;
      rects: Array<{
        __typename?: 'PdfSearchRectObjectType';
        x: number;
        y: number;
        width: number;
        height: number;
      }>;
    }>;
  };
};

export type PendingIntervalChangesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type PendingIntervalChangesQuery = {
  __typename?: 'Query';
  pendingIntervalChanges: Array<{
    __typename?: 'PendingIntervalChangeType';
    type: string;
    newInterval: string;
    effectiveDate: string;
    creditPackId: string | null;
  }>;
};

export type PermanentlyDeleteAppMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  appId: Scalars['String']['input'];
  tables: Array<AppBaseTableDispositionInput> | AppBaseTableDispositionInput;
}>;

export type PermanentlyDeleteAppMutation = {
  __typename?: 'Mutation';
  permanentlyDeleteApp: boolean;
};

export type PermanentlyDeleteDocMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
}>;

export type PermanentlyDeleteDocMutation = {
  __typename?: 'Mutation';
  permanentlyDeleteDoc: boolean;
};

export type PlanAppBaseDevelopmentMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  input: Scalars['JSONObject']['input'];
}>;

export type PlanAppBaseDevelopmentMutation = {
  __typename?: 'Mutation';
  planAppBaseDevelopment: any;
};

export type PlanChangePriceQueryVariables = Exact<{
  plan: Scalars['String']['input'];
  recurring: SubscriptionRecurring;
  targetPlan?: InputMaybe<Scalars['String']['input']>;
}>;

export type PlanChangePriceQuery = {
  __typename?: 'Query';
  planChangePrice: {
    __typename?: 'PlanChangePriceType';
    priceId: string;
    amount: number;
    currency: string;
    interval: string;
    kind: string;
  };
};

export type PlanRolesQueryVariables = Exact<{ [key: string]: never }>;

export type PlanRolesQuery = {
  __typename?: 'Query';
  planRoles: {
    __typename?: 'PlanRolesType';
    basePlan: string;
    demoPlan: string | null;
  };
};

export type PreflightDocCreateQueryVariables = Exact<{
  input: DocCreatePreflightInput;
}>;

export type PreflightDocCreateQuery = {
  __typename?: 'Query';
  preflightDocCreate: {
    __typename?: 'DocCreatePreflightResult';
    allowed: boolean;
    reason: DocCreatePreflightReason;
    targetFolderId: string | null;
  };
};

export type PrepareDocStripQueryVariables = Exact<{
  input: StripDocHistoryInput;
}>;

export type PrepareDocStripQuery = {
  __typename?: 'Query';
  prepareDocStrip: {
    __typename?: 'PrepareDocStripResultType';
    snapshotSizeBytes: number;
    historySizeBytes: number;
    historyCount: number;
    mergedSizeBytes: number;
    reductionPercent: number;
  };
};

export type PricesQueryVariables = Exact<{ [key: string]: never }>;

export type PricesQuery = {
  __typename?: 'Query';
  prices: Array<{
    __typename?: 'SubscriptionPrice';
    type: string;
    plan: string;
    currency: string;
    amount: number | null;
    yearlyAmount: number | null;
    lifetimeAmount: number | null;
    launchAmount: number | null;
    launchYearlyAmount: number | null;
  }>;
};

export type PricingPlansQueryVariables = Exact<{
  language?: InputMaybe<Scalars['String']['input']>;
}>;

export type PricingPlansQuery = {
  __typename?: 'Query';
  pricingPlans: Array<{
    __typename?: 'PricingPlanType';
    productName: string;
    isFreePlan: boolean;
    isBasePlan: boolean;
    trialDays: number;
    description: string | null;
    features: Array<string>;
    ctaType: string;
    badge: string | null;
    featured: boolean;
    displayOrder: number;
    prices: Array<{
      __typename?: 'PricingPlanPriceType';
      priceId: string;
      interval: string;
      amount: number;
      currency: string;
      kind: string;
    }>;
    launchOffer: {
      __typename?: 'PricingLaunchOfferType';
      endsAt: string;
      paidMonths: number;
      seatTiers: string | null;
    } | null;
    quotas: {
      __typename?: 'PricingPlanQuotasType';
      storage: string;
      storagePerMember: string;
      storagePerSeat: string;
      blobLimit: string;
      memberLimit: number;
      guestLimit: number;
      externalAccessPerDocLimit: number;
      historyDays: number;
      auditTrailRetentionDays: number | null;
      monthlyCreditGrant: number | null;
      maxExtraSeats: number;
      seatTiers: string | null;
    };
  }>;
};

export type PublishPageMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
  mode?: InputMaybe<PublicDocMode>;
}>;

export type PublishPageMutation = {
  __typename?: 'Mutation';
  publishDoc: { __typename?: 'DocType'; id: string; mode: PublicDocMode };
};

export type PublishAppBaseDraftMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  appBaseId: Scalars['String']['input'];
  version: Scalars['Int']['input'];
}>;

export type PublishAppBaseDraftMutation = {
  __typename?: 'Mutation';
  publishAppBaseDraft: {
    __typename?: 'AppBaseVersionType';
    id: string;
    version: number;
    role: AppBaseVersionRole;
    active: boolean;
    publishedAt: string | null;
  };
};

export type PublishAppContainerToMineMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  appBaseId: Scalars['String']['input'];
  fromTrash?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type PublishAppContainerToMineMutation = {
  __typename?: 'Mutation';
  publishAppContainerToMine: {
    __typename?: 'AppContainerPublishResult';
    templateId: string;
    versionNumber: number;
  };
};

export type PublishAutomationToMineMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  automationBlockId: Scalars['String']['input'];
}>;

export type PublishAutomationToMineMutation = {
  __typename?: 'Mutation';
  publishAutomationToMine: {
    __typename?: 'AppContainerPublishResult';
    templateId: string;
    versionNumber: number;
  };
};

export type PublishContentEntriesMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  appBaseId: Scalars['String']['input'];
  sourceKey: Scalars['String']['input'];
  rowIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type PublishContentEntriesMutation = {
  __typename?: 'Mutation';
  publishContentEntries: Array<{
    __typename?: 'ContentEntryResultType';
    rowId: string;
    status: ContentEntryResultStatus;
    liveVersion: number | null;
    hasOpenChanges: boolean;
  }>;
};

export type PublishTrashedAppToMineMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  appId: Scalars['String']['input'];
}>;

export type PublishTrashedAppToMineMutation = {
  __typename?: 'Mutation';
  publishTrashedAppToMine: {
    __typename?: 'AppContainerPublishResult';
    templateId: string;
    versionNumber: number;
  };
};

export type PublishWorkflowToMineMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  workflowId: Scalars['String']['input'];
}>;

export type PublishWorkflowToMineMutation = {
  __typename?: 'Mutation';
  publishWorkflowToMine: {
    __typename?: 'AppContainerPublishResult';
    templateId: string;
    versionNumber: number;
  };
};

export type PurchaseExtraSeatsMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  withdrawalConsent: Scalars['Boolean']['input'];
}>;

export type PurchaseExtraSeatsMutation = {
  __typename?: 'Mutation';
  purchaseExtraSeats: {
    __typename?: 'SeatAddonResultType';
    success: boolean;
    addon: {
      __typename?: 'WorkspaceSeatAddonType';
      quantity: number;
      status: SeatAddonStatus;
      pricingTiersMonthly: string | null;
      pricingTiersYearly: string | null;
      totalMonthly: number | null;
    } | null;
  };
};

export type QuotaQueryVariables = Exact<{ [key: string]: never }>;

export type QuotaQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'UserType';
    id: string;
    quota: {
      __typename?: 'UserQuotaType';
      name: string;
      blobLimit: number;
      storageQuota: number;
      historyPeriod: number;
      memberLimit: number;
      humanReadable: {
        __typename?: 'UserQuotaHumanReadableType';
        name: string;
        blobLimit: string;
        storageQuota: string;
        historyPeriod: string;
        memberLimit: string;
      };
    };
    quotaUsage: { __typename?: 'UserQuotaUsageType'; storageQuota: number };
  } | null;
};

export type ReactivateWorkspaceMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type ReactivateWorkspaceMutation = {
  __typename?: 'Mutation';
  reactivateWorkspace: { __typename?: 'WorkspaceType'; id: string };
};

export type ReadAllNotificationsMutationVariables = Exact<{
  [key: string]: never;
}>;

export type ReadAllNotificationsMutation = {
  __typename?: 'Mutation';
  readAllNotifications: boolean;
};

export type ReadNotificationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type ReadNotificationMutation = {
  __typename?: 'Mutation';
  readNotification: boolean;
};

export type ReassignAppBaseRowOwnersMutationVariables = Exact<{
  input: ReassignAppBaseRowOwnersInput;
}>;

export type ReassignAppBaseRowOwnersMutation = {
  __typename?: 'Mutation';
  reassignAppBaseRowOwners: {
    __typename?: 'AppBaseRowOwnerReassignResultType';
    reassignedRows: number;
    remainingRows: number;
  };
};

export type RebindAppBaseDatabaseMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  input: RebindAppBaseDatabaseInput;
}>;

export type RebindAppBaseDatabaseMutation = {
  __typename?: 'Mutation';
  rebindAppBaseDatabase: any;
};

export type RecoverDocMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
  timestamp: Scalars['DateTime']['input'];
}>;

export type RecoverDocMutation = {
  __typename?: 'Mutation';
  recoverDoc: string;
};

export type RefreshAppBasePublishedContentMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  appBaseId: Scalars['String']['input'];
}>;

export type RefreshAppBasePublishedContentMutation = {
  __typename?: 'Mutation';
  refreshAppBasePublishedContent: boolean;
};

export type RegisterCustomDomainMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  domain: Scalars['String']['input'];
  appBaseId: Scalars['String']['input'];
}>;

export type RegisterCustomDomainMutation = {
  __typename?: 'Mutation';
  registerCustomDomain: {
    __typename?: 'CustomDomainType';
    id: string;
    domain: string;
    type: CustomDomainKind;
    status: CustomDomainStatus;
    verificationToken: string | null;
    verifiedAt: string | null;
    sslStatus: CustomDomainSslStatus;
    appBaseId: string;
    createdAt: string;
  };
};

export type RegisterSubdomainMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  subdomain: Scalars['String']['input'];
  appBaseId: Scalars['String']['input'];
}>;

export type RegisterSubdomainMutation = {
  __typename?: 'Mutation';
  registerSubdomain: {
    __typename?: 'CustomDomainType';
    id: string;
    domain: string;
    type: CustomDomainKind;
    status: CustomDomainStatus;
    sslStatus: CustomDomainSslStatus;
    appBaseId: string;
    createdAt: string;
  };
};

export type ReimportOnboardingDocMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
}>;

export type ReimportOnboardingDocMutation = {
  __typename?: 'Mutation';
  reimportOnboardingDoc: string;
};

export type ReindexWorkspaceEmbeddingsMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  docIds?: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >;
}>;

export type ReindexWorkspaceEmbeddingsMutation = {
  __typename?: 'Mutation';
  reindexWorkspaceEmbeddings: {
    __typename?: 'ReindexWorkspaceEmbeddingsResult';
    deletedChunks: number;
    queuedDocs: number;
  };
};

export type ReleaseBrandedSubdomainMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type ReleaseBrandedSubdomainMutation = {
  __typename?: 'Mutation';
  releaseBrandedSubdomain: {
    __typename?: 'BrandedSubdomainRenameResult';
    effectiveHost: string;
  };
};

export type RemindWorkspaceTwoFactorMembersMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type RemindWorkspaceTwoFactorMembersMutation = {
  __typename?: 'Mutation';
  remindWorkspaceTwoFactorMembers: number;
};

export type RemoveAvatarMutationVariables = Exact<{ [key: string]: never }>;

export type RemoveAvatarMutation = {
  __typename?: 'Mutation';
  removeAvatar: { __typename?: 'RemoveAvatar'; success: boolean };
};

export type RemoveCustomDomainMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  domainId: Scalars['String']['input'];
}>;

export type RemoveCustomDomainMutation = {
  __typename?: 'Mutation';
  removeCustomDomain: boolean;
};

export type RemoveSeatAddonMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;

export type RemoveSeatAddonMutation = {
  __typename?: 'Mutation';
  removeSeatAddon: boolean;
};

export type RemoveTenantMemberMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  userId: Scalars['String']['input'];
}>;

export type RemoveTenantMemberMutation = {
  __typename?: 'Mutation';
  removeTenantMember: boolean;
};

export type RenameBrandedSubdomainMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  newLabel: Scalars['String']['input'];
}>;

export type RenameBrandedSubdomainMutation = {
  __typename?: 'Mutation';
  renameBrandedSubdomain: {
    __typename?: 'BrandedSubdomainRenameResult';
    effectiveHost: string;
  };
};

export type ReorderAppBaseMountsMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  mountIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  change?: InputMaybe<AppBaseDraftChangeInput>;
}>;

export type ReorderAppBaseMountsMutation = {
  __typename?: 'Mutation';
  reorderAppBaseMounts: any;
};

export type ReportCorruptionMutationVariables = Exact<{
  input: ReportCorruptionInput;
}>;

export type ReportCorruptionMutation = {
  __typename?: 'Mutation';
  reportCorruption: {
    __typename?: 'CorruptionReportType';
    id: string;
    workspaceId: string;
    docId: string;
    status: CorruptionReportStatus;
    createdAt: string;
  };
};

export type ResolvePendingDecisionMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  resolvedWith: Scalars['String']['input'];
}>;

export type ResolvePendingDecisionMutation = {
  __typename?: 'Mutation';
  resolvePendingDecision: {
    __typename?: 'PendingDecisionType';
    id: string;
    configId: string;
    sourceRowId: string;
    targetColumn: string;
    searchValue: string;
    matchCount: number;
    status: PendingDecisionStatus;
    createdAt: string;
    candidates: Array<{
      __typename?: 'RelationCandidateType';
      id: string;
      title: string;
      context: Record<string, string> | null;
    }>;
  };
};

export type RestoreAppBaseModuleMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  appBaseId: Scalars['String']['input'];
  version: Scalars['Int']['input'];
  mountId: Scalars['String']['input'];
}>;

export type RestoreAppBaseModuleMutation = {
  __typename?: 'Mutation';
  restoreAppBaseModule: {
    __typename?: 'AppBaseVersionType';
    id: string;
    version: number;
    role: AppBaseVersionRole;
    active: boolean;
    viewConfig: any;
  };
};

export type RestoreAppBaseVersionMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  appBaseId: Scalars['String']['input'];
  version: Scalars['Int']['input'];
}>;

export type RestoreAppBaseVersionMutation = {
  __typename?: 'Mutation';
  restoreAppBaseVersion: {
    __typename?: 'AppBaseVersionType';
    id: string;
    version: number;
    role: AppBaseVersionRole;
    active: boolean;
    viewConfig: any;
  };
};

export type RestoreAppMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  appId: Scalars['String']['input'];
  change?: InputMaybe<AppBaseDraftChangeInput>;
}>;

export type RestoreAppMutation = { __typename?: 'Mutation'; restoreApp: any };

export type RestoreContentEntryVersionMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  appBaseId: Scalars['String']['input'];
  sourceKey: Scalars['String']['input'];
  rowId: Scalars['String']['input'];
  version: Scalars['Int']['input'];
}>;

export type RestoreContentEntryVersionMutation = {
  __typename?: 'Mutation';
  restoreContentEntryVersion: {
    __typename?: 'ContentEntryResultType';
    rowId: string;
    status: ContentEntryResultStatus;
    liveVersion: number | null;
    hasOpenChanges: boolean;
  };
};

export type RestoreDocMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
}>;

export type RestoreDocMutation = {
  __typename?: 'Mutation';
  restoreDoc: { __typename?: 'DocType'; id: string; trashed: boolean };
};

export type ResumeSubscriptionMutationVariables = Exact<{
  plan: Scalars['String']['input'];
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}>;

export type ResumeSubscriptionMutation = {
  __typename?: 'Mutation';
  resumeSubscription: {
    __typename?: 'SubscriptionType';
    id: string | null;
    status: SubscriptionStatus;
    nextBillAt: string | null;
    start: string;
    end: string | null;
  };
};

export type RevokeDocUserRolesMutationVariables = Exact<{
  input: RevokeDocUserRoleInput;
}>;

export type RevokeDocUserRolesMutation = {
  __typename?: 'Mutation';
  revokeDocUserRoles: boolean;
};

export type RevokeMemberPermissionMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;

export type RevokeMemberPermissionMutation = {
  __typename?: 'Mutation';
  revokeMember: boolean;
};

export type RevokePublicPageMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
}>;

export type RevokePublicPageMutation = {
  __typename?: 'Mutation';
  revokePublicDoc: {
    __typename?: 'DocType';
    id: string;
    mode: PublicDocMode;
    public: boolean;
  };
};

export type ScheduleAccountDeletionMutationVariables = Exact<{
  reason?: InputMaybe<Scalars['String']['input']>;
}>;

export type ScheduleAccountDeletionMutation = {
  __typename?: 'Mutation';
  scheduleAccountDeletion: {
    __typename?: 'AccountDeletionStatus';
    scheduled: boolean;
    scheduledAt: string | null;
    finalizesAt: string | null;
    reactivatable: boolean;
    gracePeriodDays: number;
  };
};

export type SendBlockInviteMutationVariables = Exact<{
  input: BlockInviteInput;
}>;

export type SendBlockInviteMutation = {
  __typename?: 'Mutation';
  sendBlockInvite: {
    __typename?: 'SendBlockInviteResultType';
    createdCount: number;
    skippedCount: number;
    userIds: Array<string>;
    ineligible: Array<{
      __typename?: 'BlockInviteIneligibleTargetType';
      id: string;
      type: BlockInviteTargetType;
      reason: BlockInviteIneligibleReason;
      detail: string | null;
    }>;
  };
};

export type SendChangeEmailMutationVariables = Exact<{
  callbackUrl: Scalars['String']['input'];
}>;

export type SendChangeEmailMutation = {
  __typename?: 'Mutation';
  sendChangeEmail: boolean;
};

export type SendChangePasswordEmailMutationVariables = Exact<{
  callbackUrl: Scalars['String']['input'];
}>;

export type SendChangePasswordEmailMutation = {
  __typename?: 'Mutation';
  sendChangePasswordEmail: boolean;
};

export type SendSetPasswordEmailMutationVariables = Exact<{
  callbackUrl: Scalars['String']['input'];
}>;

export type SendSetPasswordEmailMutation = {
  __typename?: 'Mutation';
  sendSetPasswordEmail: boolean;
};

export type SendVerifyChangeEmailMutationVariables = Exact<{
  token: Scalars['String']['input'];
  email: Scalars['String']['input'];
  callbackUrl: Scalars['String']['input'];
}>;

export type SendVerifyChangeEmailMutation = {
  __typename?: 'Mutation';
  sendVerifyChangeEmail: boolean;
};

export type SendVerifyEmailMutationVariables = Exact<{
  callbackUrl: Scalars['String']['input'];
}>;

export type SendVerifyEmailMutation = {
  __typename?: 'Mutation';
  sendVerifyEmail: boolean;
};

export type ServerConfigQueryVariables = Exact<{ [key: string]: never }>;

export type ServerConfigQuery = {
  __typename?: 'Query';
  serverConfig: {
    __typename?: 'ServerConfigType';
    version: string;
    baseUrl: string;
    name: string;
    features: Array<ServerFeature>;
    type: ServerDeploymentType;
    initialized: boolean;
    syncUrl: string | null;
    credentialsRequirement: {
      __typename?: 'CredentialsRequirementType';
      password: {
        __typename?: 'PasswordLimitsType';
        minLength: number;
        maxLength: number;
      };
    };
  };
};

export type SetAppBaseAccessMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  edit: Scalars['JSONObject']['input'];
  change?: InputMaybe<AppBaseDraftChangeInput>;
}>;

export type SetAppBaseAccessMutation = {
  __typename?: 'Mutation';
  setAppBaseAccess: any;
};

export type SetAppBaseBandwidthBudgetMutationVariables = Exact<{
  input: SetAppBaseBandwidthBudgetInput;
}>;

export type SetAppBaseBandwidthBudgetMutation = {
  __typename?: 'Mutation';
  setAppBaseBandwidthBudget: {
    __typename?: 'AppBaseBandwidthBudgetType';
    id: string;
    workspaceId: string;
    appBaseId: string;
    monthlyLimitMicro: string;
    monthToDateUsedMicro: string;
    alertThresholds: Array<number>;
    behavior: string;
    createdAt: string;
    updatedAt: string;
  };
};

export type SetAppBaseFrameMountMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  mountId?: InputMaybe<Scalars['String']['input']>;
  change?: InputMaybe<AppBaseDraftChangeInput>;
}>;

export type SetAppBaseFrameMountMutation = {
  __typename?: 'Mutation';
  setAppBaseFrameMount: any;
};

export type SetAppBaseMountNavigationMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  mountId: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  placement: Scalars['String']['input'];
  design?: InputMaybe<Scalars['String']['input']>;
  change?: InputMaybe<AppBaseDraftChangeInput>;
}>;

export type SetAppBaseMountNavigationMutation = {
  __typename?: 'Mutation';
  setAppBaseMountNavigation: any;
};

export type SetInitialPasswordMutationVariables = Exact<{
  password: Scalars['String']['input'];
}>;

export type SetInitialPasswordMutation = {
  __typename?: 'Mutation';
  setInitialPassword: boolean;
};

export type SetMyNotificationPreferenceMutationVariables = Exact<{
  input: SetMyNotificationPreferenceInput;
}>;

export type SetMyNotificationPreferenceMutation = {
  __typename?: 'Mutation';
  setMyNotificationPreference: {
    __typename?: 'UserNotificationPreferenceType';
    triggerType: string;
    category: string;
    i18nKey: string;
    descriptionI18nKey: string;
    requiredRole: string;
    enabled: boolean;
    channelMail: boolean;
    channelInApp: boolean;
    channelWebPush: boolean;
    supportsMail: boolean;
    supportsInApp: boolean;
    supportsWebPush: boolean;
    accountId: string;
    folderKey: string;
    quietHours: any | null;
    thresholds: Array<number>;
    defaultThresholds: Array<number>;
    stored: boolean;
  };
};

export type SetWorkspacePublicByIdMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  public: Scalars['Boolean']['input'];
}>;

export type SetWorkspacePublicByIdMutation = {
  __typename?: 'Mutation';
  updateWorkspace: { __typename?: 'WorkspaceType'; id: string };
};

export type SkipPendingDecisionMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;

export type SkipPendingDecisionMutation = {
  __typename?: 'Mutation';
  skipPendingDecision: {
    __typename?: 'PendingDecisionType';
    id: string;
    configId: string;
    sourceRowId: string;
    targetColumn: string;
    searchValue: string;
    matchCount: number;
    status: PendingDecisionStatus;
    createdAt: string;
    candidates: Array<{
      __typename?: 'RelationCandidateType';
      id: string;
      title: string;
      context: Record<string, string> | null;
    }>;
  };
};

export type StepAppBaseVersionMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  appBaseId: Scalars['String']['input'];
  step: AppBaseVersionStep;
}>;

export type StepAppBaseVersionMutation = {
  __typename?: 'Mutation';
  stepAppBaseVersion: {
    __typename?: 'AppBaseVersionType';
    id: string;
    version: number;
    role: AppBaseVersionRole;
    active: boolean;
  };
};

export type StripDocHistoryMutationVariables = Exact<{
  input: StripDocHistoryInput;
}>;

export type StripDocHistoryMutation = {
  __typename?: 'Mutation';
  stripDocHistory: {
    __typename?: 'StripDocHistoryResultType';
    success: boolean;
    originalTotalBytes: number;
    newSizeBytes: number;
    historiesDeleted: number;
    reductionPercent: number;
    error: string | null;
  };
};

export type StripeUserSubscriptionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type StripeUserSubscriptionsQuery = {
  __typename?: 'Query';
  stripeUserSubscriptions: Array<{
    __typename?: 'StripeUserSubscriptionType';
    subscriptionId: string;
    productName: string;
    status: string;
    interval: string;
    unitAmount: number;
    currency: string;
    currentPeriodStart: string;
    currentPeriodEnd: string;
    cancelAtPeriodEnd: boolean | null;
  }>;
};

export type RefreshSubscriptionMutationVariables = Exact<{
  [key: string]: never;
}>;

export type RefreshSubscriptionMutation = {
  __typename?: 'Mutation';
  refreshUserSubscriptions: Array<{
    __typename?: 'SubscriptionType';
    id: string | null;
    status: SubscriptionStatus;
    plan: string;
    recurring: SubscriptionRecurring;
    start: string;
    end: string | null;
    nextBillAt: string | null;
    canceledAt: string | null;
    variant: SubscriptionVariant | null;
  }>;
};

export type SubscriptionQueryVariables = Exact<{ [key: string]: never }>;

export type SubscriptionQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'UserType';
    id: string;
    subscriptions: Array<{
      __typename?: 'SubscriptionType';
      id: string | null;
      status: SubscriptionStatus;
      plan: string;
      isBasePlan: boolean;
      recurring: SubscriptionRecurring;
      start: string;
      end: string | null;
      trialStart: string | null;
      trialEnd: string | null;
      nextBillAt: string | null;
      canceledAt: string | null;
      variant: SubscriptionVariant | null;
      canWithdraw: boolean | null;
      withdrawalEligibleUntil: string | null;
      withdrawalUnavailableReason: string | null;
    }>;
  } | null;
};

export type SwitchPlanIntervalMutationVariables = Exact<{
  plan: Scalars['String']['input'];
  recurring: SubscriptionRecurring;
  targetPlan?: InputMaybe<Scalars['String']['input']>;
  withdrawalConsent?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type SwitchPlanIntervalMutation = {
  __typename?: 'Mutation';
  switchPlanInterval: {
    __typename?: 'SubscriptionType';
    id: string | null;
    status: SubscriptionStatus;
    plan: string;
    recurring: SubscriptionRecurring;
    start: string;
    end: string | null;
    nextBillAt: string | null;
  };
};

export type TagDocMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
  tagId: Scalars['String']['input'];
}>;

export type TagDocMutation = { __typename?: 'Mutation'; tagDoc: boolean };

export type TenantQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type TenantQuery = {
  __typename?: 'Query';
  tenant: {
    __typename?: 'TenantType';
    id: string;
    name: string;
    slug: string;
    billingEmail: string;
    stripeCustomerId: string | null;
    createdAt: string;
    updatedAt: string;
    members: Array<{
      __typename?: 'TenantMemberType';
      id: string;
      userId: string;
      role: TenantRoleEnum;
      createdAt: string;
    }>;
  };
};

export type AdminDisableTotpMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;

export type AdminDisableTotpMutation = {
  __typename?: 'Mutation';
  adminDisableTOTP: boolean;
};

export type DisableTotpMutationVariables = Exact<{
  password: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;

export type DisableTotpMutation = {
  __typename?: 'Mutation';
  disableTOTP: boolean;
};

export type EnableTotpMutationVariables = Exact<{
  password?: InputMaybe<Scalars['String']['input']>;
}>;

export type EnableTotpMutation = {
  __typename?: 'Mutation';
  enableTOTP: {
    __typename?: 'TOTPSetupResponse';
    qrCodeDataUrl: string;
    secretKey: string;
    otpauthUri: string;
  };
};

export type RegenerateBackupCodesMutationVariables = Exact<{
  password: Scalars['String']['input'];
}>;

export type RegenerateBackupCodesMutation = {
  __typename?: 'Mutation';
  regenerateBackupCodes: Array<string>;
};

export type RevokeAllDeviceTrustsMutationVariables = Exact<{
  [key: string]: never;
}>;

export type RevokeAllDeviceTrustsMutation = {
  __typename?: 'Mutation';
  revokeAllDeviceTrusts: number;
};

export type RevokeDeviceTrustMutationVariables = Exact<{
  trustId: Scalars['String']['input'];
}>;

export type RevokeDeviceTrustMutation = {
  __typename?: 'Mutation';
  revokeDeviceTrust: boolean;
};

export type SendEmailOtpMutationVariables = Exact<{ [key: string]: never }>;

export type SendEmailOtpMutation = {
  __typename?: 'Mutation';
  sendEmailOTP: boolean;
};

export type SetPreferredTwoFactorMethodMutationVariables = Exact<{
  method: Scalars['String']['input'];
}>;

export type SetPreferredTwoFactorMethodMutation = {
  __typename?: 'Mutation';
  setPreferredTwoFactorMethod: boolean;
};

export type TotpStatusQueryVariables = Exact<{ [key: string]: never }>;

export type TotpStatusQuery = {
  __typename?: 'Query';
  totpStatus: {
    __typename?: 'TOTPStatusResponse';
    enabled: boolean;
    preferredMethod: string;
    verifiedAt: string | null;
    hasBackupCodes: boolean;
    backupCodesCount: number;
  };
};

export type TrustedDevicesQueryVariables = Exact<{ [key: string]: never }>;

export type TrustedDevicesQuery = {
  __typename?: 'Query';
  trustedDevices: Array<{
    __typename?: 'DeviceTrustType';
    id: string;
    label: string | null;
    createdAt: string;
    expiresAt: string;
  }>;
};

export type VerifyBackupCodeLoginMutationVariables = Exact<{
  code: Scalars['String']['input'];
  trustDevice?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type VerifyBackupCodeLoginMutation = {
  __typename?: 'Mutation';
  verifyBackupCodeLogin: {
    __typename?: 'TwoFactorVerifyResult';
    success: boolean;
    localDataLoginProof: string | null;
    localDataAccountId: string | null;
    backupCodesRemaining: number | null;
  };
};

export type VerifyEmailOtpLoginMutationVariables = Exact<{
  code: Scalars['String']['input'];
  trustDevice?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type VerifyEmailOtpLoginMutation = {
  __typename?: 'Mutation';
  verifyEmailOTPLogin: {
    __typename?: 'TwoFactorVerifyResult';
    success: boolean;
    localDataLoginProof: string | null;
    localDataAccountId: string | null;
    backupCodesRemaining: number | null;
  };
};

export type VerifyTotpLoginMutationVariables = Exact<{
  code: Scalars['String']['input'];
  trustDevice?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type VerifyTotpLoginMutation = {
  __typename?: 'Mutation';
  verifyTOTPLogin: {
    __typename?: 'TwoFactorVerifyResult';
    success: boolean;
    localDataLoginProof: string | null;
    localDataAccountId: string | null;
    backupCodesRemaining: number | null;
  };
};

export type VerifyTotpSetupMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;

export type VerifyTotpSetupMutation = {
  __typename?: 'Mutation';
  verifyTOTPSetup: Array<string>;
};

export type TranslateAppBaseMetadataMutationVariables = Exact<{
  input: TranslateAppBaseMetadataInput;
}>;

export type TranslateAppBaseMetadataMutation = {
  __typename?: 'Mutation';
  translateAppBaseMetadata: {
    __typename?: 'TranslateAppBaseMetadataResult';
    appBaseId: string;
    workspaceId: string;
    translatedLocales: Array<string>;
    skippedLocales: Array<string>;
    jobId: string;
    microCreditsCharged: string;
  };
};

export type TrashDocMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
}>;

export type TrashDocMutation = {
  __typename?: 'Mutation';
  trashDoc: { __typename?: 'DocType'; id: string; trashed: boolean };
};

export type TrashedAppsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type TrashedAppsQuery = {
  __typename?: 'Query';
  trashedApps: Array<{
    __typename?: 'TrashedAppType';
    appBaseId: string;
    appId: string;
    title: string;
    trashedAt: string;
    mountPoint: string;
  }>;
};

export type TrialEligibleQueryVariables = Exact<{ [key: string]: never }>;

export type TrialEligibleQuery = {
  __typename?: 'Query';
  trialEligible: boolean;
};

export type UnmountAppMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  mountId: Scalars['String']['input'];
  change?: InputMaybe<AppBaseDraftChangeInput>;
}>;

export type UnmountAppMutation = { __typename?: 'Mutation'; unmountApp: any };

export type UnpublishAppBaseMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  appBaseId: Scalars['String']['input'];
}>;

export type UnpublishAppBaseMutation = {
  __typename?: 'Mutation';
  unpublishAppBase: {
    __typename?: 'AppBaseVersionType';
    id: string;
    version: number;
    role: AppBaseVersionRole;
    active: boolean;
    publishedAt: string | null;
  };
};

export type UntagDocMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  docId: Scalars['String']['input'];
  tagId: Scalars['String']['input'];
}>;

export type UntagDocMutation = { __typename?: 'Mutation'; untagDoc: boolean };

export type UpdateAiConsentMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  consent: Scalars['Boolean']['input'];
}>;

export type UpdateAiConsentMutation = {
  __typename?: 'Mutation';
  updateAIConsent: {
    __typename?: 'ManagedAIStatusType';
    enabled: boolean;
    consentGiven: boolean;
    consentAt: string | null;
    suspended: boolean;
    suspendReason: string | null;
    maxRequestsPerMinute: number;
  };
};

export type UpdateAppBaseAieoMutationVariables = Exact<{
  input: UpdateAppBaseAieoInput;
}>;

export type UpdateAppBaseAieoMutation = {
  __typename?: 'Mutation';
  updateAppBaseAIEO: {
    __typename?: 'AppBaseAIEOSettingsType';
    appBaseId: string;
    workspaceId: string;
    crawlerPolicy: string | null;
    crawlerPolicyDetails: any | null;
    declaration: string | null;
    trainingDataConsent: boolean | null;
    attributionUrl: string | null;
    llmsTextOverride: string | null;
    updatedAt: string;
  };
};

export type UpdateAppBaseBriefMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  input: UpdateAppBaseBriefInput;
}>;

export type UpdateAppBaseBriefMutation = {
  __typename?: 'Mutation';
  updateAppBaseBrief: any;
};

export type UpdateAppBaseSeoMutationVariables = Exact<{
  input: UpdateAppBaseSeoInput;
}>;

export type UpdateAppBaseSeoMutation = {
  __typename?: 'Mutation';
  updateAppBaseSEO: {
    __typename?: 'AppBaseSEOSettingsType';
    appBaseId: string;
    workspaceId: string;
    titlesI18n: any | null;
    descriptionsI18n: any | null;
    slugsI18n: any | null;
    ogImagesI18n: any | null;
    indexing: boolean | null;
    canonicalUrlOverride: string | null;
    jsonLdType: string | null;
    twitterCardType: string | null;
    robotsDirectives: Array<string>;
    structuredData: any | null;
    updatedAt: string;
  };
};

export type UpdateAppBaseMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  input: UpdateAppBaseInput;
}>;

export type UpdateAppBaseMutation = {
  __typename?: 'Mutation';
  updateAppBase: {
    __typename?: 'AppBaseType';
    id: string;
    slug: string;
    title: string;
    config: any;
    isPublished: boolean;
    updatedAt: string;
  };
};

export type UpdateDocDefaultRoleMutationVariables = Exact<{
  input: UpdateDocDefaultRoleInput;
}>;

export type UpdateDocDefaultRoleMutation = {
  __typename?: 'Mutation';
  updateDocDefaultRole: boolean;
};

export type UpdateDocTitleMutationVariables = Exact<{
  input: UpdateDocTitleInput;
}>;

export type UpdateDocTitleMutation = {
  __typename?: 'Mutation';
  updateDocTitle: {
    __typename?: 'DocType';
    id: string;
    workspaceId: string;
    title: string | null;
    updatedAt: string | null;
  };
};

export type UpdateDocUserRoleMutationVariables = Exact<{
  input: UpdateDocUserRoleInput;
}>;

export type UpdateDocUserRoleMutation = {
  __typename?: 'Mutation';
  updateDocUserRole: boolean;
};

export type UpdateLocaleSettingsMutationVariables = Exact<{
  input: UpdateLocaleSettingsInput;
}>;

export type UpdateLocaleSettingsMutation = {
  __typename?: 'Mutation';
  updateLocaleSettings: {
    __typename?: 'LocaleSettingsType';
    availableLocales: Array<string>;
    defaultLocale: string;
  };
};

export type UpdateSeatCountMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  withdrawalConsent: Scalars['Boolean']['input'];
}>;

export type UpdateSeatCountMutation = {
  __typename?: 'Mutation';
  updateSeatCount: {
    __typename?: 'SeatAddonResultType';
    success: boolean;
    addon: {
      __typename?: 'WorkspaceSeatAddonType';
      quantity: number;
      status: SeatAddonStatus;
      pricingTiersMonthly: string | null;
      pricingTiersYearly: string | null;
      totalMonthly: number | null;
    } | null;
  };
};

export type UpdateTagMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  tagId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateTagMutation = {
  __typename?: 'Mutation';
  updateTag: {
    __typename?: 'WorkspaceTagType';
    id: string;
    workspaceId: string;
    name: string;
    color: string;
    createdAt: string;
    updatedAt: string;
  };
};

export type UpdateTenantMemberRoleMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  userId: Scalars['String']['input'];
  role: TenantRoleEnum;
}>;

export type UpdateTenantMemberRoleMutation = {
  __typename?: 'Mutation';
  updateTenantMemberRole: {
    __typename?: 'TenantMemberType';
    id: string;
    tenantId: string;
    userId: string;
    role: TenantRoleEnum;
    createdAt: string;
  };
};

export type UpdateTenantMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateTenantInput;
}>;

export type UpdateTenantMutation = {
  __typename?: 'Mutation';
  updateTenant: {
    __typename?: 'TenantType';
    id: string;
    name: string;
    slug: string;
    billingEmail: string;
    updatedAt: string;
  };
};

export type UpdateUserProfileMutationVariables = Exact<{
  input: UpdateUserInput;
}>;

export type UpdateUserProfileMutation = {
  __typename?: 'Mutation';
  updateProfile: { __typename?: 'UserType'; id: string; name: string };
};

export type UpdateUserSettingsMutationVariables = Exact<{
  input: UpdateUserSettingsInput;
}>;

export type UpdateUserSettingsMutation = {
  __typename?: 'Mutation';
  updateSettings: boolean;
};

export type UpdateWorkspacePolicyMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  input: UpdateWorkspacePolicyInput;
}>;

export type UpdateWorkspacePolicyMutation = {
  __typename?: 'Mutation';
  updateWorkspacePolicy: {
    __typename?: 'WorkspacePolicyType';
    requireTOTP: boolean;
    allowEmailOTP: boolean;
    enforcedAt: string | null;
    gracePeriodDays: number;
    gracePeriodActive: boolean;
    gracePeriodRemainingDays: number | null;
    offlineAccessTtlHours: number;
  };
};

export type UploadAvatarMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  avatar: Scalars['Upload']['input'];
}>;

export type UploadAvatarMutation = {
  __typename?: 'Mutation';
  uploadAvatar: {
    __typename?: 'UserType';
    id: string;
    name: string;
    avatarUrl: string | null;
    email: string;
  };
};

export type VerifyEmailMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;

export type VerifyEmailMutation = {
  __typename?: 'Mutation';
  verifyEmail: boolean;
};

export type WorkspaceBlobQuotaQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type WorkspaceBlobQuotaQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    quota: {
      __typename?: 'WorkspaceQuotaType';
      blobLimit: number;
      tusUploadEnabled: boolean;
      tusUploadPath: string | null;
      humanReadable: {
        __typename?: 'WorkspaceQuotaHumanReadableType';
        blobLimit: string;
      };
    };
  };
};

export type GetWorkspaceConfigQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetWorkspaceConfigQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    enableAi: boolean;
    enableUrlPreview: boolean;
    enableDocEmbedding: boolean;
    appBasesEnabled: boolean;
    presenceDiscoveryEnabled: boolean;
  };
};

export type WorkspaceCreationQuotaQueryVariables = Exact<{
  [key: string]: never;
}>;

export type WorkspaceCreationQuotaQuery = {
  __typename?: 'Query';
  workspaceCreationQuota: {
    __typename?: 'WorkspaceCreationQuotaType';
    canCreate: boolean;
    ownedCount: number;
    limit: number;
    plan: string;
    upgradeAvailable: boolean;
  };
};

export type WorkspaceCreditSubscriptionsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type WorkspaceCreditSubscriptionsQuery = {
  __typename?: 'Query';
  workspaceCreditSubscriptions: Array<{
    __typename?: 'WorkspaceCreditSubscriptionType';
    id: string;
    creditPackId: string;
    creditPackName: string;
    credits: number;
    status: CreditSubscriptionStatus;
    cancelAtPeriodEnd: boolean;
    currentPeriodEnd: string;
    billingInterval: string | null;
  }>;
};

export type SetEnableAiMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  enableAi: Scalars['Boolean']['input'];
}>;

export type SetEnableAiMutation = {
  __typename?: 'Mutation';
  updateWorkspace: { __typename?: 'WorkspaceType'; id: string };
};

export type SetAppBasesEnabledMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  appBasesEnabled: Scalars['Boolean']['input'];
}>;

export type SetAppBasesEnabledMutation = {
  __typename?: 'Mutation';
  updateWorkspace: { __typename?: 'WorkspaceType'; id: string };
};

export type SetEnableDocEmbeddingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  enableDocEmbedding: Scalars['Boolean']['input'];
}>;

export type SetEnableDocEmbeddingMutation = {
  __typename?: 'Mutation';
  updateWorkspace: { __typename?: 'WorkspaceType'; id: string };
};

export type SetEnableUrlPreviewMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  enableUrlPreview: Scalars['Boolean']['input'];
}>;

export type SetEnableUrlPreviewMutation = {
  __typename?: 'Mutation';
  updateWorkspace: { __typename?: 'WorkspaceType'; id: string };
};

export type InviteByEmailsMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  emails: Array<Scalars['String']['input']> | Scalars['String']['input'];
  permission?: InputMaybe<Permission>;
}>;

export type InviteByEmailsMutation = {
  __typename?: 'Mutation';
  inviteMembers: Array<{
    __typename?: 'InviteResult';
    email: string;
    inviteId: string | null;
    sentSuccess: boolean;
    error: any | null;
  }>;
};

export type AcceptInviteByInviteIdMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  inviteId: Scalars['String']['input'];
}>;

export type AcceptInviteByInviteIdMutation = {
  __typename?: 'Mutation';
  acceptInviteById: boolean;
};

export type GetWorkspaceInviteLinkQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetWorkspaceInviteLinkQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    inviteLink: {
      __typename?: 'InviteLink';
      link: string;
      expireTime: string;
    } | null;
  };
};

export type CreateInviteLinkMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  expireTime: WorkspaceInviteLinkExpireTime;
}>;

export type CreateInviteLinkMutation = {
  __typename?: 'Mutation';
  createInviteLink: {
    __typename?: 'InviteLink';
    link: string;
    expireTime: string;
  };
};

export type RevokeInviteLinkMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type RevokeInviteLinkMutation = {
  __typename?: 'Mutation';
  revokeInviteLink: boolean;
};

export type WorkspaceInvoicesQueryVariables = Exact<{
  take: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
  workspaceId: Scalars['String']['input'];
}>;

export type WorkspaceInvoicesQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    invoiceCount: number;
    invoices: Array<{
      __typename?: 'InvoiceType';
      id: string;
      status: InvoiceStatus;
      currency: string;
      amount: number;
      reason: string;
      lastPaymentError: string | null;
      link: string | null;
      pdfUrl: string | null;
      createdAt: string;
    }>;
  };
};

export type WorkspaceMemberComplianceQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type WorkspaceMemberComplianceQuery = {
  __typename?: 'Query';
  workspaceMemberCompliance: Array<{
    __typename?: 'MemberTwoFactorStatusType';
    userId: string;
    email: string;
    name: string | null;
    avatarUrl: string | null;
    hasTOTP: boolean;
    hasEmailOTP: boolean;
    role: Permission;
  }>;
};

export type WorkspacePolicyQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type WorkspacePolicyQuery = {
  __typename?: 'Query';
  workspacePolicy: {
    __typename?: 'WorkspacePolicyType';
    requireTOTP: boolean;
    allowEmailOTP: boolean;
    enforcedAt: string | null;
    gracePeriodDays: number;
    gracePeriodActive: boolean;
    gracePeriodRemainingDays: number | null;
    offlineAccessTtlHours: number;
  };
};

export type SetPresenceDiscoveryEnabledMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
}>;

export type SetPresenceDiscoveryEnabledMutation = {
  __typename?: 'Mutation';
  updateWorkspace: {
    __typename?: 'WorkspaceType';
    id: string;
    presenceDiscoveryEnabled: boolean;
  };
};

export type GetWorkspacePresenceQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type GetWorkspacePresenceQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    presence: Array<{
      __typename?: 'PresenceDocEntry';
      docId: string;
      userIds: Array<string>;
    }>;
  };
};

export type WorkspacePublicHostQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type WorkspacePublicHostQuery = {
  __typename?: 'Query';
  workspacePublicHost: {
    __typename?: 'WorkspacePublicHostType';
    defaultHost: string;
    brandedHost: string | null;
    customDomain: string | null;
    effectiveHost: string;
    defaultUrl: string;
    brandedUrl: string | null;
    customDomainUrl: string | null;
    effectiveUrl: string;
  } | null;
};

export type WorkspaceQuotaQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type WorkspaceQuotaQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    quota: {
      __typename?: 'WorkspaceQuotaType';
      name: string;
      blobLimit: number;
      storageQuota: number;
      usedStorageQuota: number;
      historyPeriod: number;
      memberLimit: number;
      memberCount: number;
      overcapacityMemberCount: number;
      automationCount: number;
      guestLimit: number;
      externalAccessPerDocLimit: number;
      guestCount: number;
      guestMinTtlHours: number;
      guestMaxTtlHours: number;
      guestDefaultTtlHours: number;
      sttBatch: {
        __typename?: 'WorkspaceSttBatchQuotaType';
        maxMib: number;
        maxMinutes: number;
        upgradePlan: string | null;
        upgradeMaxMib: number | null;
      };
      humanReadable: {
        __typename?: 'WorkspaceQuotaHumanReadableType';
        name: string;
        blobLimit: string;
        storageQuota: string;
        historyPeriod: string;
        memberLimit: string;
        memberCount: string;
        overcapacityMemberCount: string;
        automationCount: string;
      };
    };
  };
};

export type GetWorkspaceRolePermissionsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetWorkspaceRolePermissionsQuery = {
  __typename?: 'Query';
  workspaceRolePermissions: {
    __typename?: 'WorkspaceRolePermissions';
    permissions: {
      __typename?: 'WorkspacePermissions';
      Workspace_Automation: boolean;
      Workspace_Automation_Create: boolean;
      Workspace_Automation_Delete: boolean;
      Workspace_Automation_Edit: boolean;
      Workspace_Automation_Execute: boolean;
      Workspace_Automation_View: boolean;
      Workspace_Administrators_Manage: boolean;
      Workspace_Blobs_List: boolean;
      Workspace_Blobs_Read: boolean;
      Workspace_Blobs_Write: boolean;
      Workspace_Copilot: boolean;
      Workspace_CreateDoc: boolean;
      Workspace_Delete: boolean;
      Workspace_ExpertBots: boolean;
      Workspace_KnowledgeGraph: boolean;
      Workspace_Organize_Read: boolean;
      Workspace_Payment_Manage: boolean;
      Workspace_PersonalMemory: boolean;
      Workspace_Properties_Create: boolean;
      Workspace_Properties_Delete: boolean;
      Workspace_Properties_Read: boolean;
      Workspace_Properties_Update: boolean;
      Workspace_Read: boolean;
      Workspace_Settings_Read: boolean;
      Workspace_Settings_Update: boolean;
      Workspace_AppBases_Create: boolean;
      Workspace_AppBases_Delete: boolean;
      Workspace_AppBases_Edit: boolean;
      Workspace_AppBases_Import: boolean;
      Workspace_AppBases_Publish: boolean;
      Workspace_AppBases_View: boolean;
      Workspace_Sync: boolean;
      Workspace_TransferOwner: boolean;
      Workspace_Users_Manage: boolean;
      Workspace_Users_Read: boolean;
      Workspace_Workflow_Manage: boolean;
    };
  };
};

export type WorkspaceRunningOperationsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type WorkspaceRunningOperationsQuery = {
  __typename?: 'Query';
  workspaceRunningOperations: Array<{
    __typename?: 'WorkspaceRunningOperationType';
    suspendedExecutionId: string;
    workflowExecutionId: string;
    executionLogId: string;
    automationConfigId: string;
    automationTitle: string | null;
    docId: string;
    docTitle: string | null;
    blockId: string;
    kind: TranscriptionJobKind;
    status: TranscriptionJobStatus;
    jobId: string;
    submittedAt: string;
    expiresAt: string;
  }>;
};

export type WorkspaceSearchQueryVariables = Exact<{
  id: Scalars['String']['input'];
  input: WorkspaceSearchInput;
}>;

export type WorkspaceSearchQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    workspaceSearch: Array<{
      __typename?: 'WorkspaceSearchResult';
      id: string;
      kind: WorkspaceSearchSourceKind;
      visibility: WorkspaceSearchResultVisibility;
      title: string;
      subtitle: string | null;
      snippet: string | null;
      score: number;
      createdAt: string | null;
      updatedAt: string | null;
      receivedAt: string | null;
      mailMessageId: string | null;
      mailAccountId: string | null;
      mailFolderId: string | null;
      mailFrom: string | null;
      mailTo: Array<string>;
      mailSubject: string | null;
      attachmentHits: Array<{
        __typename?: 'WorkspaceSearchMailAttachmentHit';
        filename: string;
        mimeType: string;
        source: WorkspaceSearchMailAttachmentHitSource;
        snippet: string | null;
        pageIndex: number | null;
        coverageStatus: string | null;
      }>;
      openTarget: {
        __typename?: 'WorkspaceSearchOpenTarget';
        kind: WorkspaceSearchOpenTargetKind;
        workspaceId: string;
        route: string;
        mailMessageId: string | null;
        mailAccountId: string | null;
        mailFolderId: string | null;
      };
    }>;
  };
};

export type MailSearchDiagnosticsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  input?: InputMaybe<MailSearchDiagnosticsInput>;
}>;

export type MailSearchDiagnosticsQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'WorkspaceType';
    mailSearchDiagnostics: {
      __typename?: 'MailSearchDiagnostics';
      scopeStatus: MailSearchIndexStatus;
      missingPermissionTargets: number;
      totalMessages: number;
      messagesMissingBody: number;
      totalAttachments: number;
      totalPdfAttachments: number;
      pdfAttachmentsIndexed: number;
      pdfAttachmentsMissingOcr: number;
      pdfAttachmentsStale: number;
      pdfAttachmentsFailed: number;
      pdfAttachmentsRepairable: number;
      messages: Array<{
        __typename?: 'MailSearchMessageDiagnostic';
        messageId: string;
        accountId: string;
        folderId: string | null;
        folder: string | null;
        receivedAt: string | null;
        bodyStatus: MailSearchIndexStatus;
        attachmentStatus: MailSearchIndexStatus;
        ocrStatus: MailSearchIndexStatus;
        attachmentCount: number;
        pdfAttachmentCount: number;
        indexedPdfPageCount: number;
        missingOcrAttachmentCount: number;
        stalePdfAttachmentCount: number;
        failedPdfAttachmentCount: number;
      }>;
    };
  };
};

export type ReindexMailSearchMutationVariables = Exact<{
  input: MailSearchReindexInput;
}>;

export type ReindexMailSearchMutation = {
  __typename?: 'Mutation';
  reindexMailSearch: {
    __typename?: 'MailSearchReindexResult';
    processedMessages: number;
    processedAttachments: number;
    processedTargets: number;
    indexedPages: number;
    failedTargets: number;
    missingPermissionTargets: number;
    fallbackDocReindexCount: number;
    errors: Array<{
      __typename?: 'MailSearchReindexError';
      messageId: string | null;
      attachmentId: string | null;
      blobKey: string | null;
      status: MailSearchIndexStatus;
      message: string;
    }>;
  };
};

export type WorkspaceSeatAddonQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;

export type WorkspaceSeatAddonQuery = {
  __typename?: 'Query';
  workspaceSeatAddon: {
    __typename?: 'WorkspaceSeatAddonType';
    quantity: number;
    status: SeatAddonStatus;
    pricingTiersMonthly: string | null;
    pricingTiersYearly: string | null;
    totalMonthly: number | null;
    totalYearly: number | null;
    nextBillingDate: string | null;
    recurring: string | null;
  } | null;
};

export type WorkspaceTagsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;

export type WorkspaceTagsQuery = {
  __typename?: 'Query';
  workspaceTags: Array<{
    __typename?: 'WorkspaceTagType';
    id: string;
    workspaceId: string;
    name: string;
    color: string;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type ApproveWorkspaceTeamMemberMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;

export type ApproveWorkspaceTeamMemberMutation = {
  __typename?: 'Mutation';
  approveMember: boolean;
};

export type GrantWorkspaceTeamMemberMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  permission: Permission;
}>;

export type GrantWorkspaceTeamMemberMutation = {
  __typename?: 'Mutation';
  grantMember: boolean;
};

export type TransferWorkspaceOwnershipMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;

export type TransferWorkspaceOwnershipMutation = {
  __typename?: 'Mutation';
  transferWorkspaceOwnership: boolean;
};

export type Queries =
  | {
      name: 'listUserAccessTokensQuery';
      variables: ListUserAccessTokensQueryVariables;
      response: ListUserAccessTokensQuery;
    }
  | {
      name: 'accountDeletionPreviewQuery';
      variables: AccountDeletionPreviewQueryVariables;
      response: AccountDeletionPreviewQuery;
    }
  | {
      name: 'accountDeletionStatusQuery';
      variables: AccountDeletionStatusQueryVariables;
      response: AccountDeletionStatusQuery;
    }
  | {
      name: 'adminWorkspaceStatsQuery';
      variables: AdminWorkspaceStatsQueryVariables;
      response: AdminWorkspaceStatsQuery;
    }
  | {
      name: 'adminAiProfitabilityQuery';
      variables: AdminAiProfitabilityQueryVariables;
      response: AdminAiProfitabilityQuery;
    }
  | {
      name: 'adminAuditLogFacetsQuery';
      variables: AdminAuditLogFacetsQueryVariables;
      response: AdminAuditLogFacetsQuery;
    }
  | {
      name: 'adminAuditLogsQuery';
      variables: AdminAuditLogsQueryVariables;
      response: AdminAuditLogsQuery;
    }
  | {
      name: 'adminBillingStatsQuery';
      variables: AdminBillingStatsQueryVariables;
      response: AdminBillingStatsQuery;
    }
  | {
      name: 'adminTenantCachePerformanceQuery';
      variables: AdminTenantCachePerformanceQueryVariables;
      response: AdminTenantCachePerformanceQuery;
    }
  | {
      name: 'adminSystemCachePerformanceQuery';
      variables: AdminSystemCachePerformanceQueryVariables;
      response: AdminSystemCachePerformanceQuery;
    }
  | {
      name: 'adminGetUserSubscriptionsQuery';
      variables: AdminGetUserSubscriptionsQueryVariables;
      response: AdminGetUserSubscriptionsQuery;
    }
  | {
      name: 'adminListSubscriptionsQuery';
      variables: AdminListSubscriptionsQueryVariables;
      response: AdminListSubscriptionsQuery;
    }
  | {
      name: 'adminPermissionGraphDiagnosticsQuery';
      variables: AdminPermissionGraphDiagnosticsQueryVariables;
      response: AdminPermissionGraphDiagnosticsQuery;
    }
  | {
      name: 'adminPermissionGraphQuery';
      variables: AdminPermissionGraphQueryVariables;
      response: AdminPermissionGraphQuery;
    }
  | {
      name: 'adminPlanDistributionQuery';
      variables: AdminPlanDistributionQueryVariables;
      response: AdminPlanDistributionQuery;
    }
  | {
      name: 'recoveryLogQuery';
      variables: RecoveryLogQueryVariables;
      response: RecoveryLogQuery;
    }
  | {
      name: 'recoveryHistoryQuery';
      variables: RecoveryHistoryQueryVariables;
      response: RecoveryHistoryQuery;
    }
  | {
      name: 'recoveryTimeRangeQuery';
      variables: RecoveryTimeRangeQueryVariables;
      response: RecoveryTimeRangeQuery;
    }
  | {
      name: 'adminServerConfigQuery';
      variables: AdminServerConfigQueryVariables;
      response: AdminServerConfigQuery;
    }
  | {
      name: 'adminSignupTrendQuery';
      variables: AdminSignupTrendQueryVariables;
      response: AdminSignupTrendQuery;
    }
  | {
      name: 'adminStripeProductsQuery';
      variables: AdminStripeProductsQueryVariables;
      response: AdminStripeProductsQuery;
    }
  | {
      name: 'adminTenantDetailQuery';
      variables: AdminTenantDetailQueryVariables;
      response: AdminTenantDetailQuery;
    }
  | {
      name: 'adminTenantsCountQuery';
      variables: AdminTenantsCountQueryVariables;
      response: AdminTenantsCountQuery;
    }
  | {
      name: 'adminTenantsQuery';
      variables: AdminTenantsQueryVariables;
      response: AdminTenantsQuery;
    }
  | {
      name: 'adminTopWorkspacesByActivityQuery';
      variables: AdminTopWorkspacesByActivityQueryVariables;
      response: AdminTopWorkspacesByActivityQuery;
    }
  | {
      name: 'adminTopWorkspacesQuery';
      variables: AdminTopWorkspacesQueryVariables;
      response: AdminTopWorkspacesQuery;
    }
  | {
      name: 'adminUserStatsQuery';
      variables: AdminUserStatsQueryVariables;
      response: AdminUserStatsQuery;
    }
  | {
      name: 'adminWebhookHealthQuery';
      variables: AdminWebhookHealthQueryVariables;
      response: AdminWebhookHealthQuery;
    }
  | {
      name: 'adminWorkerJobPlacesQuery';
      variables: AdminWorkerJobPlacesQueryVariables;
      response: AdminWorkerJobPlacesQuery;
    }
  | {
      name: 'adminWorkspaceActivityCountersQuery';
      variables: AdminWorkspaceActivityCountersQueryVariables;
      response: AdminWorkspaceActivityCountersQuery;
    }
  | {
      name: 'adminWorkspaceActivityQuery';
      variables: AdminWorkspaceActivityQueryVariables;
      response: AdminWorkspaceActivityQuery;
    }
  | {
      name: 'adminWorkspaceDetailQuery';
      variables: AdminWorkspaceDetailQueryVariables;
      response: AdminWorkspaceDetailQuery;
    }
  | {
      name: 'adminWorkspacesQuery';
      variables: AdminWorkspacesQueryVariables;
      response: AdminWorkspacesQuery;
    }
  | {
      name: 'appConfigQuery';
      variables: AppConfigQueryVariables;
      response: AppConfigQuery;
    }
  | {
      name: 'getPromptsQuery';
      variables: GetPromptsQueryVariables;
      response: GetPromptsQuery;
    }
  | {
      name: 'listUsersQuery';
      variables: ListUsersQueryVariables;
      response: ListUsersQuery;
    }
  | {
      name: 'appBaseAieoQuery';
      variables: AppBaseAieoQueryVariables;
      response: AppBaseAieoQuery;
    }
  | {
      name: 'appBaseBandwidthBudgetQuery';
      variables: AppBaseBandwidthBudgetQueryVariables;
      response: AppBaseBandwidthBudgetQuery;
    }
  | {
      name: 'appBaseDatabaseBindingHealthQuery';
      variables: AppBaseDatabaseBindingHealthQueryVariables;
      response: AppBaseDatabaseBindingHealthQuery;
    }
  | {
      name: 'appBaseDatabaseBindingsQuery';
      variables: AppBaseDatabaseBindingsQueryVariables;
      response: AppBaseDatabaseBindingsQuery;
    }
  | {
      name: 'appBaseDevelopmentInspectQuery';
      variables: AppBaseDevelopmentInspectQueryVariables;
      response: AppBaseDevelopmentInspectQuery;
    }
  | {
      name: 'appBaseInvocationStatusQuery';
      variables: AppBaseInvocationStatusQueryVariables;
      response: AppBaseInvocationStatusQuery;
    }
  | {
      name: 'appBaseOwnRowIdsQuery';
      variables: AppBaseOwnRowIdsQueryVariables;
      response: AppBaseOwnRowIdsQuery;
    }
  | {
      name: 'appBasePortalInvitationsQuery';
      variables: AppBasePortalInvitationsQueryVariables;
      response: AppBasePortalInvitationsQuery;
    }
  | {
      name: 'appBasePortalMembersQuery';
      variables: AppBasePortalMembersQueryVariables;
      response: AppBasePortalMembersQuery;
    }
  | {
      name: 'appBaseProductQuotaQuery';
      variables: AppBaseProductQuotaQueryVariables;
      response: AppBaseProductQuotaQuery;
    }
  | {
      name: 'appBasePublicViewerStateQuery';
      variables: AppBasePublicViewerStateQueryVariables;
      response: AppBasePublicViewerStateQuery;
    }
  | {
      name: 'appBaseRowOwnershipSummaryQuery';
      variables: AppBaseRowOwnershipSummaryQueryVariables;
      response: AppBaseRowOwnershipSummaryQuery;
    }
  | {
      name: 'appBaseSeoCheckQuery';
      variables: AppBaseSeoCheckQueryVariables;
      response: AppBaseSeoCheckQuery;
    }
  | {
      name: 'appBaseSeoQuery';
      variables: AppBaseSeoQueryVariables;
      response: AppBaseSeoQuery;
    }
  | {
      name: 'appBaseStateQuery';
      variables: AppBaseStateQueryVariables;
      response: AppBaseStateQuery;
    }
  | {
      name: 'appBaseVersionHistoryQuery';
      variables: AppBaseVersionHistoryQueryVariables;
      response: AppBaseVersionHistoryQuery;
    }
  | {
      name: 'appBaseVersionModulesQuery';
      variables: AppBaseVersionModulesQueryVariables;
      response: AppBaseVersionModulesQuery;
    }
  | {
      name: 'appBasesByDocIdQuery';
      variables: AppBasesByDocIdQueryVariables;
      response: AppBasesByDocIdQuery;
    }
  | {
      name: 'appBasesQuery';
      variables: AppBasesQueryVariables;
      response: AppBasesQuery;
    }
  | {
      name: 'appBaseAppsQuery';
      variables: AppBaseAppsQueryVariables;
      response: AppBaseAppsQuery;
    }
  | {
      name: 'appBaseAppAccessQuery';
      variables: AppBaseAppAccessQueryVariables;
      response: AppBaseAppAccessQuery;
    }
  | {
      name: 'appBaseAppPermissionMatrixQuery';
      variables: AppBaseAppPermissionMatrixQueryVariables;
      response: AppBaseAppPermissionMatrixQuery;
    }
  | {
      name: 'appContainerPlanOverviewQuery';
      variables: AppContainerPlanOverviewQueryVariables;
      response: AppContainerPlanOverviewQuery;
    }
  | {
      name: 'appContainerPublishedPlanUsageQuery';
      variables: AppContainerPublishedPlanUsageQueryVariables;
      response: AppContainerPublishedPlanUsageQuery;
    }
  | {
      name: 'appContainersForDeletionQuery';
      variables: AppContainersForDeletionQueryVariables;
      response: AppContainersForDeletionQuery;
    }
  | {
      name: 'appTableChoicesQuery';
      variables: AppTableChoicesQueryVariables;
      response: AppTableChoicesQuery;
    }
  | {
      name: 'listBlobsQuery';
      variables: ListBlobsQueryVariables;
      response: ListBlobsQuery;
    }
  | {
      name: 'blockInviteEligibleRecipientsQuery';
      variables: BlockInviteEligibleRecipientsQueryVariables;
      response: BlockInviteEligibleRecipientsQuery;
    }
  | {
      name: 'brandedSubdomainRenameAvailabilityQuery';
      variables: BrandedSubdomainRenameAvailabilityQueryVariables;
      response: BrandedSubdomainRenameAvailabilityQuery;
    }
  | {
      name: 'listCommentChangesQuery';
      variables: ListCommentChangesQueryVariables;
      response: ListCommentChangesQuery;
    }
  | {
      name: 'listCommentsQuery';
      variables: ListCommentsQueryVariables;
      response: ListCommentsQuery;
    }
  | {
      name: 'contentEntryOpenChangesQuery';
      variables: ContentEntryOpenChangesQueryVariables;
      response: ContentEntryOpenChangesQuery;
    }
  | {
      name: 'contentEntryVersionsQuery';
      variables: ContentEntryVersionsQueryVariables;
      response: ContentEntryVersionsQuery;
    }
  | {
      name: 'listContextObjectQuery';
      variables: ListContextObjectQueryVariables;
      response: ListContextObjectQuery;
    }
  | {
      name: 'listContextQuery';
      variables: ListContextQueryVariables;
      response: ListContextQuery;
    }
  | {
      name: 'matchContextQuery';
      variables: MatchContextQueryVariables;
      response: MatchContextQuery;
    }
  | {
      name: 'matchWorkspaceDocsQuery';
      variables: MatchWorkspaceDocsQueryVariables;
      response: MatchWorkspaceDocsQuery;
    }
  | {
      name: 'matchFilesQuery';
      variables: MatchFilesQueryVariables;
      response: MatchFilesQuery;
    }
  | {
      name: 'getWorkspaceEmbeddingStatusQuery';
      variables: GetWorkspaceEmbeddingStatusQueryVariables;
      response: GetWorkspaceEmbeddingStatusQuery;
    }
  | {
      name: 'getCopilotHistoryIdsQuery';
      variables: GetCopilotHistoryIdsQueryVariables;
      response: GetCopilotHistoryIdsQuery;
    }
  | {
      name: 'getCopilotDocSessionsQuery';
      variables: GetCopilotDocSessionsQueryVariables;
      response: GetCopilotDocSessionsQuery;
    }
  | {
      name: 'getCopilotPinnedSessionsQuery';
      variables: GetCopilotPinnedSessionsQueryVariables;
      response: GetCopilotPinnedSessionsQuery;
    }
  | {
      name: 'getCopilotWorkspaceSessionsQuery';
      variables: GetCopilotWorkspaceSessionsQueryVariables;
      response: GetCopilotWorkspaceSessionsQuery;
    }
  | {
      name: 'getCopilotHistoriesQuery';
      variables: GetCopilotHistoriesQueryVariables;
      response: GetCopilotHistoriesQuery;
    }
  | {
      name: 'getAudioTranscriptionQuery';
      variables: GetAudioTranscriptionQueryVariables;
      response: GetAudioTranscriptionQuery;
    }
  | {
      name: 'getPromptModelsQuery';
      variables: GetPromptModelsQueryVariables;
      response: GetPromptModelsQuery;
    }
  | {
      name: 'copilotQuotaQuery';
      variables: CopilotQuotaQueryVariables;
      response: CopilotQuotaQuery;
    }
  | {
      name: 'getCopilotLatestDocSessionQuery';
      variables: GetCopilotLatestDocSessionQueryVariables;
      response: GetCopilotLatestDocSessionQuery;
    }
  | {
      name: 'getCopilotSessionQuery';
      variables: GetCopilotSessionQueryVariables;
      response: GetCopilotSessionQuery;
    }
  | {
      name: 'getCopilotRecentSessionsQuery';
      variables: GetCopilotRecentSessionsQueryVariables;
      response: GetCopilotRecentSessionsQuery;
    }
  | {
      name: 'getCopilotSessionsQuery';
      variables: GetCopilotSessionsQueryVariables;
      response: GetCopilotSessionsQuery;
    }
  | {
      name: 'getAllWorkspaceEmbeddingIgnoredDocsQuery';
      variables: GetAllWorkspaceEmbeddingIgnoredDocsQueryVariables;
      response: GetAllWorkspaceEmbeddingIgnoredDocsQuery;
    }
  | {
      name: 'getWorkspaceEmbeddingIgnoredDocsQuery';
      variables: GetWorkspaceEmbeddingIgnoredDocsQueryVariables;
      response: GetWorkspaceEmbeddingIgnoredDocsQuery;
    }
  | {
      name: 'workspaceCorruptionReportsQuery';
      variables: WorkspaceCorruptionReportsQueryVariables;
      response: WorkspaceCorruptionReportsQuery;
    }
  | {
      name: 'workspaceCorruptionStatsQuery';
      variables: WorkspaceCorruptionStatsQueryVariables;
      response: WorkspaceCorruptionStatsQuery;
    }
  | {
      name: 'corruptionReportForAiQuery';
      variables: CorruptionReportForAiQueryVariables;
      response: CorruptionReportForAiQuery;
    }
  | {
      name: 'docHistoryTimelineQuery';
      variables: DocHistoryTimelineQueryVariables;
      response: DocHistoryTimelineQuery;
    }
  | {
      name: 'docSizeInfoQuery';
      variables: DocSizeInfoQueryVariables;
      response: DocSizeInfoQuery;
    }
  | {
      name: 'creditBalanceQuery';
      variables: CreditBalanceQueryVariables;
      response: CreditBalanceQuery;
    }
  | {
      name: 'creditPacksQuery';
      variables: CreditPacksQueryVariables;
      response: CreditPacksQuery;
    }
  | {
      name: 'creditTransactionsQuery';
      variables: CreditTransactionsQueryVariables;
      response: CreditTransactionsQuery;
    }
  | {
      name: 'currentBandwidthUsageQuery';
      variables: CurrentBandwidthUsageQueryVariables;
      response: CurrentBandwidthUsageQuery;
    }
  | {
      name: 'appBaseViewerStateQuery';
      variables: AppBaseViewerStateQueryVariables;
      response: AppBaseViewerStateQuery;
    }
  | {
      name: 'databaseBulkReceiptStatusQuery';
      variables: DatabaseBulkReceiptStatusQueryVariables;
      response: DatabaseBulkReceiptStatusQuery;
    }
  | {
      name: 'databaseDeleteDependenciesQuery';
      variables: DatabaseDeleteDependenciesQueryVariables;
      response: DatabaseDeleteDependenciesQuery;
    }
  | {
      name: 'discoverAppBaseDatabasesQuery';
      variables: DiscoverAppBaseDatabasesQueryVariables;
      response: DiscoverAppBaseDatabasesQuery;
    }
  | {
      name: 'getDocRolePermissionsQuery';
      variables: GetDocRolePermissionsQueryVariables;
      response: GetDocRolePermissionsQuery;
    }
  | {
      name: 'docTagIdsQuery';
      variables: DocTagIdsQueryVariables;
      response: DocTagIdsQuery;
    }
  | {
      name: 'checkDeletedFolderIdsQuery';
      variables: CheckDeletedFolderIdsQueryVariables;
      response: CheckDeletedFolderIdsQuery;
    }
  | {
      name: 'getFolderUsersQuery';
      variables: GetFolderUsersQueryVariables;
      response: GetFolderUsersQuery;
    }
  | {
      name: 'getFolderQuery';
      variables: GetFolderQueryVariables;
      response: GetFolderQuery;
    }
  | {
      name: 'getFoldersWithOwnersQuery';
      variables: GetFoldersWithOwnersQueryVariables;
      response: GetFoldersWithOwnersQuery;
    }
  | {
      name: 'getFoldersQuery';
      variables: GetFoldersQueryVariables;
      response: GetFoldersQuery;
    }
  | {
      name: 'getTrashedFoldersQuery';
      variables: GetTrashedFoldersQueryVariables;
      response: GetTrashedFoldersQuery;
    }
  | {
      name: 'myAccessibleFoldersQuery';
      variables: MyAccessibleFoldersQueryVariables;
      response: MyAccessibleFoldersQuery;
    }
  | {
      name: 'preflightPermissionLifecycleQuery';
      variables: PreflightPermissionLifecycleQueryVariables;
      response: PreflightPermissionLifecycleQuery;
    }
  | {
      name: 'rootFolderDocIdsQuery';
      variables: RootFolderDocIdsQueryVariables;
      response: RootFolderDocIdsQuery;
    }
  | {
      name: 'getCurrentUserFeaturesQuery';
      variables: GetCurrentUserFeaturesQueryVariables;
      response: GetCurrentUserFeaturesQuery;
    }
  | {
      name: 'getCurrentUserQuery';
      variables: GetCurrentUserQueryVariables;
      response: GetCurrentUserQuery;
    }
  | {
      name: 'getDocCreatedByUpdatedByListQuery';
      variables: GetDocCreatedByUpdatedByListQueryVariables;
      response: GetDocCreatedByUpdatedByListQuery;
    }
  | {
      name: 'getDocDefaultRoleQuery';
      variables: GetDocDefaultRoleQueryVariables;
      response: GetDocDefaultRoleQuery;
    }
  | {
      name: 'getDocInheritedAccessQuery';
      variables: GetDocInheritedAccessQueryVariables;
      response: GetDocInheritedAccessQuery;
    }
  | {
      name: 'getDocSummaryQuery';
      variables: GetDocSummaryQueryVariables;
      response: GetDocSummaryQuery;
    }
  | {
      name: 'getFolderGrantedUsersListQuery';
      variables: GetFolderGrantedUsersListQueryVariables;
      response: GetFolderGrantedUsersListQuery;
    }
  | {
      name: 'getInviteInfoQuery';
      variables: GetInviteInfoQueryVariables;
      response: GetInviteInfoQuery;
    }
  | {
      name: 'getMemberCountByWorkspaceIdQuery';
      variables: GetMemberCountByWorkspaceIdQueryVariables;
      response: GetMemberCountByWorkspaceIdQuery;
    }
  | {
      name: 'getMembersByWorkspaceIdQuery';
      variables: GetMembersByWorkspaceIdQueryVariables;
      response: GetMembersByWorkspaceIdQuery;
    }
  | {
      name: 'oauthProvidersQuery';
      variables: OauthProvidersQueryVariables;
      response: OauthProvidersQuery;
    }
  | {
      name: 'getPageGrantedUsersListQuery';
      variables: GetPageGrantedUsersListQueryVariables;
      response: GetPageGrantedUsersListQuery;
    }
  | {
      name: 'getPendingDecisionCountQuery';
      variables: GetPendingDecisionCountQueryVariables;
      response: GetPendingDecisionCountQuery;
    }
  | {
      name: 'getPendingDecisionsQuery';
      variables: GetPendingDecisionsQueryVariables;
      response: GetPendingDecisionsQuery;
    }
  | {
      name: 'getPublicUserByIdQuery';
      variables: GetPublicUserByIdQueryVariables;
      response: GetPublicUserByIdQuery;
    }
  | {
      name: 'getRecentlyUpdatedDocsQuery';
      variables: GetRecentlyUpdatedDocsQueryVariables;
      response: GetRecentlyUpdatedDocsQuery;
    }
  | {
      name: 'getScheduledWorkspacesQuery';
      variables: GetScheduledWorkspacesQueryVariables;
      response: GetScheduledWorkspacesQuery;
    }
  | {
      name: 'getUserDocGrantsQuery';
      variables: GetUserDocGrantsQueryVariables;
      response: GetUserDocGrantsQuery;
    }
  | {
      name: 'getUserFeaturesQuery';
      variables: GetUserFeaturesQueryVariables;
      response: GetUserFeaturesQuery;
    }
  | {
      name: 'getUserFolderGrantsQuery';
      variables: GetUserFolderGrantsQueryVariables;
      response: GetUserFolderGrantsQuery;
    }
  | {
      name: 'getUserSettingsQuery';
      variables: GetUserSettingsQueryVariables;
      response: GetUserSettingsQuery;
    }
  | {
      name: 'getUserQuery';
      variables: GetUserQueryVariables;
      response: GetUserQuery;
    }
  | {
      name: 'getWorkspaceBillingStateQuery';
      variables: GetWorkspaceBillingStateQueryVariables;
      response: GetWorkspaceBillingStateQuery;
    }
  | {
      name: 'getWorkspaceDocsWithOwnersQuery';
      variables: GetWorkspaceDocsWithOwnersQueryVariables;
      response: GetWorkspaceDocsWithOwnersQuery;
    }
  | {
      name: 'getWorkspaceInfoQuery';
      variables: GetWorkspaceInfoQueryVariables;
      response: GetWorkspaceInfoQuery;
    }
  | {
      name: 'getWorkspacePageByIdQuery';
      variables: GetWorkspacePageByIdQueryVariables;
      response: GetWorkspacePageByIdQuery;
    }
  | {
      name: 'getWorkspacePageMetaByIdQuery';
      variables: GetWorkspacePageMetaByIdQueryVariables;
      response: GetWorkspacePageMetaByIdQuery;
    }
  | {
      name: 'getWorkspacePublicByIdQuery';
      variables: GetWorkspacePublicByIdQueryVariables;
      response: GetWorkspacePublicByIdQuery;
    }
  | {
      name: 'getWorkspacePublicPagesQuery';
      variables: GetWorkspacePublicPagesQueryVariables;
      response: GetWorkspacePublicPagesQuery;
    }
  | {
      name: 'getWorkspaceSubscriptionQuery';
      variables: GetWorkspaceSubscriptionQueryVariables;
      response: GetWorkspaceSubscriptionQuery;
    }
  | {
      name: 'getWorkspaceQuery';
      variables: GetWorkspaceQueryVariables;
      response: GetWorkspaceQuery;
    }
  | {
      name: 'getWorkspacesQuery';
      variables: GetWorkspacesQueryVariables;
      response: GetWorkspacesQuery;
    }
  | {
      name: 'getDocGroupRolesQuery';
      variables: GetDocGroupRolesQueryVariables;
      response: GetDocGroupRolesQuery;
    }
  | {
      name: 'getFolderGroupRolesQuery';
      variables: GetFolderGroupRolesQueryVariables;
      response: GetFolderGroupRolesQuery;
    }
  | {
      name: 'getGroupDocRolesQuery';
      variables: GetGroupDocRolesQueryVariables;
      response: GetGroupDocRolesQuery;
    }
  | {
      name: 'getGroupFolderRolesQuery';
      variables: GetGroupFolderRolesQueryVariables;
      response: GetGroupFolderRolesQuery;
    }
  | {
      name: 'getGroupMembersQuery';
      variables: GetGroupMembersQueryVariables;
      response: GetGroupMembersQuery;
    }
  | {
      name: 'getGroupQuery';
      variables: GetGroupQueryVariables;
      response: GetGroupQuery;
    }
  | {
      name: 'getGroupsQuery';
      variables: GetGroupsQueryVariables;
      response: GetGroupsQuery;
    }
  | {
      name: 'listHistoryQuery';
      variables: ListHistoryQueryVariables;
      response: ListHistoryQuery;
    }
  | {
      name: 'indexerAggregateQuery';
      variables: IndexerAggregateQueryVariables;
      response: IndexerAggregateQuery;
    }
  | {
      name: 'indexerSearchDocsQuery';
      variables: IndexerSearchDocsQueryVariables;
      response: IndexerSearchDocsQuery;
    }
  | {
      name: 'indexerSearchQuery';
      variables: IndexerSearchQueryVariables;
      response: IndexerSearchQuery;
    }
  | {
      name: 'installedTemplatesQuery';
      variables: InstalledTemplatesQueryVariables;
      response: InstalledTemplatesQuery;
    }
  | {
      name: 'isWorkspaceTwoFactorCompliantQuery';
      variables: IsWorkspaceTwoFactorCompliantQueryVariables;
      response: IsWorkspaceTwoFactorCompliantQuery;
    }
  | {
      name: 'knownAiCrawlerBotsQuery';
      variables: KnownAiCrawlerBotsQueryVariables;
      response: KnownAiCrawlerBotsQuery;
    }
  | {
      name: 'listCustomDomainsQuery';
      variables: ListCustomDomainsQueryVariables;
      response: ListCustomDomainsQuery;
    }
  | {
      name: 'listNotificationsQuery';
      variables: ListNotificationsQueryVariables;
      response: ListNotificationsQuery;
    }
  | {
      name: 'localeSettingsQuery';
      variables: LocaleSettingsQueryVariables;
      response: LocaleSettingsQuery;
    }
  | {
      name: 'mailAccountsQuery';
      variables: MailAccountsQueryVariables;
      response: MailAccountsQuery;
    }
  | {
      name: 'mailboxRootDocIdsQuery';
      variables: MailboxRootDocIdsQueryVariables;
      response: MailboxRootDocIdsQuery;
    }
  | {
      name: 'mailboxRootQuery';
      variables: MailboxRootQueryVariables;
      response: MailboxRootQuery;
    }
  | {
      name: 'mailCredentialShareProposalsQuery';
      variables: MailCredentialShareProposalsQueryVariables;
      response: MailCredentialShareProposalsQuery;
    }
  | {
      name: 'mailMessagesQuery';
      variables: MailMessagesQueryVariables;
      response: MailMessagesQuery;
    }
  | {
      name: 'mailMessagesLegacyQuery';
      variables: MailMessagesLegacyQueryVariables;
      response: MailMessagesLegacyQuery;
    }
  | {
      name: 'mailVirtualFoldersQuery';
      variables: MailVirtualFoldersQueryVariables;
      response: MailVirtualFoldersQuery;
    }
  | {
      name: 'mailFoldersQuery';
      variables: MailFoldersQueryVariables;
      response: MailFoldersQuery;
    }
  | {
      name: 'mailSyncStatesQuery';
      variables: MailSyncStatesQueryVariables;
      response: MailSyncStatesQuery;
    }
  | {
      name: 'mailTrustedSendersQuery';
      variables: MailTrustedSendersQueryVariables;
      response: MailTrustedSendersQuery;
    }
  | {
      name: 'mailSignaturesQuery';
      variables: MailSignaturesQueryVariables;
      response: MailSignaturesQuery;
    }
  | {
      name: 'mailSignatureAssignmentsQuery';
      variables: MailSignatureAssignmentsQueryVariables;
      response: MailSignatureAssignmentsQuery;
    }
  | {
      name: 'mailAutorespondersQuery';
      variables: MailAutorespondersQueryVariables;
      response: MailAutorespondersQuery;
    }
  | {
      name: 'prepareMailCompositionQuery';
      variables: PrepareMailCompositionQueryVariables;
      response: PrepareMailCompositionQuery;
    }
  | {
      name: 'mailComposeSignatureQuery';
      variables: MailComposeSignatureQueryVariables;
      response: MailComposeSignatureQuery;
    }
  | {
      name: 'mailRulesQuery';
      variables: MailRulesQueryVariables;
      response: MailRulesQuery;
    }
  | {
      name: 'mailMessageBodyQuery';
      variables: MailMessageBodyQueryVariables;
      response: MailMessageBodyQuery;
    }
  | {
      name: 'mailAdminOverviewQuery';
      variables: MailAdminOverviewQueryVariables;
      response: MailAdminOverviewQuery;
    }
  | {
      name: 'mailCurrentUserQuotaQuery';
      variables: MailCurrentUserQuotaQueryVariables;
      response: MailCurrentUserQuotaQuery;
    }
  | {
      name: 'managedAiStatusQuery';
      variables: ManagedAiStatusQueryVariables;
      response: ManagedAiStatusQuery;
    }
  | {
      name: 'getCanManageWorkspaceMatesQuery';
      variables: GetCanManageWorkspaceMatesQueryVariables;
      response: GetCanManageWorkspaceMatesQuery;
    }
  | {
      name: 'getDocMateRolesQuery';
      variables: GetDocMateRolesQueryVariables;
      response: GetDocMateRolesQuery;
    }
  | {
      name: 'getFolderMateRolesQuery';
      variables: GetFolderMateRolesQueryVariables;
      response: GetFolderMateRolesQuery;
    }
  | {
      name: 'getGroupMatesQuery';
      variables: GetGroupMatesQueryVariables;
      response: GetGroupMatesQuery;
    }
  | {
      name: 'getMateGrantTargetsQuery';
      variables: GetMateGrantTargetsQueryVariables;
      response: GetMateGrantTargetsQuery;
    }
  | {
      name: 'getMateInviteFoldersQuery';
      variables: GetMateInviteFoldersQueryVariables;
      response: GetMateInviteFoldersQuery;
    }
  | {
      name: 'getMateRulesQuery';
      variables: GetMateRulesQueryVariables;
      response: GetMateRulesQuery;
    }
  | {
      name: 'getMateShareEffectQuery';
      variables: GetMateShareEffectQueryVariables;
      response: GetMateShareEffectQuery;
    }
  | {
      name: 'getMateSharesQuery';
      variables: GetMateSharesQueryVariables;
      response: GetMateSharesQuery;
    }
  | {
      name: 'getMateSkillsQuery';
      variables: GetMateSkillsQueryVariables;
      response: GetMateSkillsQuery;
    }
  | {
      name: 'getSkillToolCatalogQuery';
      variables: GetSkillToolCatalogQueryVariables;
      response: GetSkillToolCatalogQuery;
    }
  | {
      name: 'getUsableMatesQuery';
      variables: GetUsableMatesQueryVariables;
      response: GetUsableMatesQuery;
    }
  | {
      name: 'getWorkspaceMatesQuery';
      variables: GetWorkspaceMatesQueryVariables;
      response: GetWorkspaceMatesQuery;
    }
  | {
      name: 'getWorkspaceSkillsQuery';
      variables: GetWorkspaceSkillsQueryVariables;
      response: GetWorkspaceSkillsQuery;
    }
  | {
      name: 'listWorkspaceMcpTokensQuery';
      variables: ListWorkspaceMcpTokensQueryVariables;
      response: ListWorkspaceMcpTokensQuery;
    }
  | {
      name: 'myWorkspaceMcpTokensQuery';
      variables: MyWorkspaceMcpTokensQueryVariables;
      response: MyWorkspaceMcpTokensQuery;
    }
  | {
      name: 'memberQuotaInfoQuery';
      variables: MemberQuotaInfoQueryVariables;
      response: MemberQuotaInfoQuery;
    }
  | {
      name: 'mineCopyQuery';
      variables: MineCopyQueryVariables;
      response: MineCopyQuery;
    }
  | {
      name: 'myAccessibleDocsQuery';
      variables: MyAccessibleDocsQueryVariables;
      response: MyAccessibleDocsQuery;
    }
  | {
      name: 'myNotificationPreferencesInWorkspaceQuery';
      variables: MyNotificationPreferencesInWorkspaceQueryVariables;
      response: MyNotificationPreferencesInWorkspaceQuery;
    }
  | {
      name: 'myTenantsQuery';
      variables: MyTenantsQueryVariables;
      response: MyTenantsQuery;
    }
  | {
      name: 'notificationCountQuery';
      variables: NotificationCountQueryVariables;
      response: NotificationCountQuery;
    }
  | {
      name: 'onboardingStatusQuery';
      variables: OnboardingStatusQueryVariables;
      response: OnboardingStatusQuery;
    }
  | {
      name: 'pdfPageSearchQuery';
      variables: PdfPageSearchQueryVariables;
      response: PdfPageSearchQuery;
    }
  | {
      name: 'pendingIntervalChangesQuery';
      variables: PendingIntervalChangesQueryVariables;
      response: PendingIntervalChangesQuery;
    }
  | {
      name: 'planChangePriceQuery';
      variables: PlanChangePriceQueryVariables;
      response: PlanChangePriceQuery;
    }
  | {
      name: 'planRolesQuery';
      variables: PlanRolesQueryVariables;
      response: PlanRolesQuery;
    }
  | {
      name: 'preflightDocCreateQuery';
      variables: PreflightDocCreateQueryVariables;
      response: PreflightDocCreateQuery;
    }
  | {
      name: 'prepareDocStripQuery';
      variables: PrepareDocStripQueryVariables;
      response: PrepareDocStripQuery;
    }
  | {
      name: 'pricesQuery';
      variables: PricesQueryVariables;
      response: PricesQuery;
    }
  | {
      name: 'pricingPlansQuery';
      variables: PricingPlansQueryVariables;
      response: PricingPlansQuery;
    }
  | {
      name: 'quotaQuery';
      variables: QuotaQueryVariables;
      response: QuotaQuery;
    }
  | {
      name: 'serverConfigQuery';
      variables: ServerConfigQueryVariables;
      response: ServerConfigQuery;
    }
  | {
      name: 'stripeUserSubscriptionsQuery';
      variables: StripeUserSubscriptionsQueryVariables;
      response: StripeUserSubscriptionsQuery;
    }
  | {
      name: 'subscriptionQuery';
      variables: SubscriptionQueryVariables;
      response: SubscriptionQuery;
    }
  | {
      name: 'tenantQuery';
      variables: TenantQueryVariables;
      response: TenantQuery;
    }
  | {
      name: 'totpStatusQuery';
      variables: TotpStatusQueryVariables;
      response: TotpStatusQuery;
    }
  | {
      name: 'trustedDevicesQuery';
      variables: TrustedDevicesQueryVariables;
      response: TrustedDevicesQuery;
    }
  | {
      name: 'trashedAppsQuery';
      variables: TrashedAppsQueryVariables;
      response: TrashedAppsQuery;
    }
  | {
      name: 'trialEligibleQuery';
      variables: TrialEligibleQueryVariables;
      response: TrialEligibleQuery;
    }
  | {
      name: 'workspaceBlobQuotaQuery';
      variables: WorkspaceBlobQuotaQueryVariables;
      response: WorkspaceBlobQuotaQuery;
    }
  | {
      name: 'getWorkspaceConfigQuery';
      variables: GetWorkspaceConfigQueryVariables;
      response: GetWorkspaceConfigQuery;
    }
  | {
      name: 'workspaceCreationQuotaQuery';
      variables: WorkspaceCreationQuotaQueryVariables;
      response: WorkspaceCreationQuotaQuery;
    }
  | {
      name: 'workspaceCreditSubscriptionsQuery';
      variables: WorkspaceCreditSubscriptionsQueryVariables;
      response: WorkspaceCreditSubscriptionsQuery;
    }
  | {
      name: 'getWorkspaceInviteLinkQuery';
      variables: GetWorkspaceInviteLinkQueryVariables;
      response: GetWorkspaceInviteLinkQuery;
    }
  | {
      name: 'workspaceInvoicesQuery';
      variables: WorkspaceInvoicesQueryVariables;
      response: WorkspaceInvoicesQuery;
    }
  | {
      name: 'workspaceMemberComplianceQuery';
      variables: WorkspaceMemberComplianceQueryVariables;
      response: WorkspaceMemberComplianceQuery;
    }
  | {
      name: 'workspacePolicyQuery';
      variables: WorkspacePolicyQueryVariables;
      response: WorkspacePolicyQuery;
    }
  | {
      name: 'getWorkspacePresenceQuery';
      variables: GetWorkspacePresenceQueryVariables;
      response: GetWorkspacePresenceQuery;
    }
  | {
      name: 'workspacePublicHostQuery';
      variables: WorkspacePublicHostQueryVariables;
      response: WorkspacePublicHostQuery;
    }
  | {
      name: 'workspaceQuotaQuery';
      variables: WorkspaceQuotaQueryVariables;
      response: WorkspaceQuotaQuery;
    }
  | {
      name: 'getWorkspaceRolePermissionsQuery';
      variables: GetWorkspaceRolePermissionsQueryVariables;
      response: GetWorkspaceRolePermissionsQuery;
    }
  | {
      name: 'workspaceRunningOperationsQuery';
      variables: WorkspaceRunningOperationsQueryVariables;
      response: WorkspaceRunningOperationsQuery;
    }
  | {
      name: 'workspaceSearchQuery';
      variables: WorkspaceSearchQueryVariables;
      response: WorkspaceSearchQuery;
    }
  | {
      name: 'mailSearchDiagnosticsQuery';
      variables: MailSearchDiagnosticsQueryVariables;
      response: MailSearchDiagnosticsQuery;
    }
  | {
      name: 'workspaceSeatAddonQuery';
      variables: WorkspaceSeatAddonQueryVariables;
      response: WorkspaceSeatAddonQuery;
    }
  | {
      name: 'workspaceTagsQuery';
      variables: WorkspaceTagsQueryVariables;
      response: WorkspaceTagsQuery;
    };

export type Mutations =
  | {
      name: 'generateUserAccessTokenMutation';
      variables: GenerateUserAccessTokenMutationVariables;
      response: GenerateUserAccessTokenMutation;
    }
  | {
      name: 'revokeUserAccessTokenMutation';
      variables: RevokeUserAccessTokenMutationVariables;
      response: RevokeUserAccessTokenMutation;
    }
  | {
      name: 'addTenantMemberMutation';
      variables: AddTenantMemberMutationVariables;
      response: AddTenantMemberMutation;
    }
  | {
      name: 'adminAssignPlanMutation';
      variables: AdminAssignPlanMutationVariables;
      response: AdminAssignPlanMutation;
    }
  | {
      name: 'restoreWorkspaceMutation';
      variables: RestoreWorkspaceMutationVariables;
      response: RestoreWorkspaceMutation;
    }
  | {
      name: 'createChangePasswordUrlMutation';
      variables: CreateChangePasswordUrlMutationVariables;
      response: CreateChangePasswordUrlMutation;
    }
  | {
      name: 'updatePromptMutation';
      variables: UpdatePromptMutationVariables;
      response: UpdatePromptMutation;
    }
  | {
      name: 'createUserMutation';
      variables: CreateUserMutationVariables;
      response: CreateUserMutation;
    }
  | {
      name: 'deleteUserMutation';
      variables: DeleteUserMutationVariables;
      response: DeleteUserMutation;
    }
  | {
      name: 'disableUserMutation';
      variables: DisableUserMutationVariables;
      response: DisableUserMutation;
    }
  | {
      name: 'enableUserMutation';
      variables: EnableUserMutationVariables;
      response: EnableUserMutation;
    }
  | {
      name: 'importUsersMutation';
      variables: ImportUsersMutationVariables;
      response: ImportUsersMutation;
    }
  | {
      name: 'sendTestEmailMutation';
      variables: SendTestEmailMutationVariables;
      response: SendTestEmailMutation;
    }
  | {
      name: 'updateAccountFeaturesMutation';
      variables: UpdateAccountFeaturesMutationVariables;
      response: UpdateAccountFeaturesMutation;
    }
  | {
      name: 'updateAccountMutation';
      variables: UpdateAccountMutationVariables;
      response: UpdateAccountMutation;
    }
  | {
      name: 'updateAppConfigMutation';
      variables: UpdateAppConfigMutationVariables;
      response: UpdateAppConfigMutation;
    }
  | {
      name: 'validateConfigMutation';
      variables: ValidateConfigMutationVariables;
      response: ValidateConfigMutation;
    }
  | {
      name: 'createAppBasePortalInvitationMutation';
      variables: CreateAppBasePortalInvitationMutationVariables;
      response: CreateAppBasePortalInvitationMutation;
    }
  | {
      name: 'revokeAppBasePortalInvitationMutation';
      variables: RevokeAppBasePortalInvitationMutationVariables;
      response: RevokeAppBasePortalInvitationMutation;
    }
  | {
      name: 'applyAppBaseDevelopmentMutation';
      variables: ApplyAppBaseDevelopmentMutationVariables;
      response: ApplyAppBaseDevelopmentMutation;
    }
  | {
      name: 'attachExistingAppBaseDatabaseMutation';
      variables: AttachExistingAppBaseDatabaseMutationVariables;
      response: AttachExistingAppBaseDatabaseMutation;
    }
  | {
      name: 'automationTrashMutation';
      variables: AutomationTrashMutationVariables;
      response: AutomationTrashMutation;
    }
  | {
      name: 'automationRestoreMutation';
      variables: AutomationRestoreMutationVariables;
      response: AutomationRestoreMutation;
    }
  | {
      name: 'automationDeleteMutation';
      variables: AutomationDeleteMutationVariables;
      response: AutomationDeleteMutation;
    }
  | {
      name: 'beginContentEntryChangeMutation';
      variables: BeginContentEntryChangeMutationVariables;
      response: BeginContentEntryChangeMutation;
    }
  | {
      name: 'deleteBlobMutation';
      variables: DeleteBlobMutationVariables;
      response: DeleteBlobMutation;
    }
  | {
      name: 'releaseDeletedBlobsMutation';
      variables: ReleaseDeletedBlobsMutationVariables;
      response: ReleaseDeletedBlobsMutation;
    }
  | {
      name: 'setBlobMutation';
      variables: SetBlobMutationVariables;
      response: SetBlobMutation;
    }
  | {
      name: 'cancelAccountDeletionMutation';
      variables: CancelAccountDeletionMutationVariables;
      response: CancelAccountDeletionMutation;
    }
  | {
      name: 'cancelCreditSubscriptionMutation';
      variables: CancelCreditSubscriptionMutationVariables;
      response: CancelCreditSubscriptionMutation;
    }
  | {
      name: 'cancelPendingIntervalChangeMutation';
      variables: CancelPendingIntervalChangeMutationVariables;
      response: CancelPendingIntervalChangeMutation;
    }
  | {
      name: 'cancelSubscriptionMutation';
      variables: CancelSubscriptionMutationVariables;
      response: CancelSubscriptionMutation;
    }
  | {
      name: 'changeEmailMutation';
      variables: ChangeEmailMutationVariables;
      response: ChangeEmailMutation;
    }
  | {
      name: 'changePasswordMutation';
      variables: ChangePasswordMutationVariables;
      response: ChangePasswordMutation;
    }
  | {
      name: 'clearAppBaseBandwidthBudgetMutation';
      variables: ClearAppBaseBandwidthBudgetMutationVariables;
      response: ClearAppBaseBandwidthBudgetMutation;
    }
  | {
      name: 'createCommentMutation';
      variables: CreateCommentMutationVariables;
      response: CreateCommentMutation;
    }
  | {
      name: 'deleteCommentMutation';
      variables: DeleteCommentMutationVariables;
      response: DeleteCommentMutation;
    }
  | {
      name: 'createReplyMutation';
      variables: CreateReplyMutationVariables;
      response: CreateReplyMutation;
    }
  | {
      name: 'deleteReplyMutation';
      variables: DeleteReplyMutationVariables;
      response: DeleteReplyMutation;
    }
  | {
      name: 'updateReplyMutation';
      variables: UpdateReplyMutationVariables;
      response: UpdateReplyMutation;
    }
  | {
      name: 'resolveCommentMutation';
      variables: ResolveCommentMutationVariables;
      response: ResolveCommentMutation;
    }
  | {
      name: 'updateCommentMutation';
      variables: UpdateCommentMutationVariables;
      response: UpdateCommentMutation;
    }
  | {
      name: 'uploadCommentAttachmentMutation';
      variables: UploadCommentAttachmentMutationVariables;
      response: UploadCommentAttachmentMutation;
    }
  | {
      name: 'addContextBlobMutation';
      variables: AddContextBlobMutationVariables;
      response: AddContextBlobMutation;
    }
  | {
      name: 'removeContextBlobMutation';
      variables: RemoveContextBlobMutationVariables;
      response: RemoveContextBlobMutation;
    }
  | {
      name: 'addContextCategoryMutation';
      variables: AddContextCategoryMutationVariables;
      response: AddContextCategoryMutation;
    }
  | {
      name: 'removeContextCategoryMutation';
      variables: RemoveContextCategoryMutationVariables;
      response: RemoveContextCategoryMutation;
    }
  | {
      name: 'createCopilotContextMutation';
      variables: CreateCopilotContextMutationVariables;
      response: CreateCopilotContextMutation;
    }
  | {
      name: 'addContextDocMutation';
      variables: AddContextDocMutationVariables;
      response: AddContextDocMutation;
    }
  | {
      name: 'removeContextDocMutation';
      variables: RemoveContextDocMutationVariables;
      response: RemoveContextDocMutation;
    }
  | {
      name: 'addContextFileMutation';
      variables: AddContextFileMutationVariables;
      response: AddContextFileMutation;
    }
  | {
      name: 'removeContextFileMutation';
      variables: RemoveContextFileMutationVariables;
      response: RemoveContextFileMutation;
    }
  | {
      name: 'queueWorkspaceEmbeddingMutation';
      variables: QueueWorkspaceEmbeddingMutationVariables;
      response: QueueWorkspaceEmbeddingMutation;
    }
  | {
      name: 'submitAudioTranscriptionMutation';
      variables: SubmitAudioTranscriptionMutationVariables;
      response: SubmitAudioTranscriptionMutation;
    }
  | {
      name: 'claimAudioTranscriptionMutation';
      variables: ClaimAudioTranscriptionMutationVariables;
      response: ClaimAudioTranscriptionMutation;
    }
  | {
      name: 'retryAudioTranscriptionMutation';
      variables: RetryAudioTranscriptionMutationVariables;
      response: RetryAudioTranscriptionMutation;
    }
  | {
      name: 'createCopilotMessageMutation';
      variables: CreateCopilotMessageMutationVariables;
      response: CreateCopilotMessageMutation;
    }
  | {
      name: 'cleanupCopilotSessionMutation';
      variables: CleanupCopilotSessionMutationVariables;
      response: CleanupCopilotSessionMutation;
    }
  | {
      name: 'createCopilotSessionMutation';
      variables: CreateCopilotSessionMutationVariables;
      response: CreateCopilotSessionMutation;
    }
  | {
      name: 'forkCopilotSessionMutation';
      variables: ForkCopilotSessionMutationVariables;
      response: ForkCopilotSessionMutation;
    }
  | {
      name: 'updateCopilotSessionMutation';
      variables: UpdateCopilotSessionMutationVariables;
      response: UpdateCopilotSessionMutation;
    }
  | {
      name: 'addWorkspaceEmbeddingIgnoredDocsMutation';
      variables: AddWorkspaceEmbeddingIgnoredDocsMutationVariables;
      response: AddWorkspaceEmbeddingIgnoredDocsMutation;
    }
  | {
      name: 'removeWorkspaceEmbeddingIgnoredDocsMutation';
      variables: RemoveWorkspaceEmbeddingIgnoredDocsMutationVariables;
      response: RemoveWorkspaceEmbeddingIgnoredDocsMutation;
    }
  | {
      name: 'updateCorruptionReportStatusMutation';
      variables: UpdateCorruptionReportStatusMutationVariables;
      response: UpdateCorruptionReportStatusMutation;
    }
  | {
      name: 'rebuildDocFromHistoryMutation';
      variables: RebuildDocFromHistoryMutationVariables;
      response: RebuildDocFromHistoryMutation;
    }
  | {
      name: 'compactDocMutation';
      variables: CompactDocMutationVariables;
      response: CompactDocMutation;
    }
  | {
      name: 'createAppBaseDraftMutation';
      variables: CreateAppBaseDraftMutationVariables;
      response: CreateAppBaseDraftMutation;
    }
  | {
      name: 'createAppBaseMutation';
      variables: CreateAppBaseMutationVariables;
      response: CreateAppBaseMutation;
    }
  | {
      name: 'createCheckoutSessionMutation';
      variables: CreateCheckoutSessionMutationVariables;
      response: CreateCheckoutSessionMutation;
    }
  | {
      name: 'createCreditCheckoutMutation';
      variables: CreateCreditCheckoutMutationVariables;
      response: CreateCreditCheckoutMutation;
    }
  | {
      name: 'createCustomerPortalMutation';
      variables: CreateCustomerPortalMutationVariables;
      response: CreateCustomerPortalMutation;
    }
  | {
      name: 'createSelfhostCustomerPortalMutation';
      variables: CreateSelfhostCustomerPortalMutationVariables;
      response: CreateSelfhostCustomerPortalMutation;
    }
  | {
      name: 'createTagMutation';
      variables: CreateTagMutationVariables;
      response: CreateTagMutation;
    }
  | {
      name: 'createWorkspaceMutation';
      variables: CreateWorkspaceMutationVariables;
      response: CreateWorkspaceMutation;
    }
  | {
      name: 'databaseAddPropertyMutation';
      variables: DatabaseAddPropertyMutationVariables;
      response: DatabaseAddPropertyMutation;
    }
  | {
      name: 'databaseAddRowMutation';
      variables: DatabaseAddRowMutationVariables;
      response: DatabaseAddRowMutation;
    }
  | {
      name: 'databaseBulkMutateMutation';
      variables: DatabaseBulkMutateMutationVariables;
      response: DatabaseBulkMutateMutation;
    }
  | {
      name: 'databaseDeletePropertyMutation';
      variables: DatabaseDeletePropertyMutationVariables;
      response: DatabaseDeletePropertyMutation;
    }
  | {
      name: 'databaseDeleteRowMutation';
      variables: DatabaseDeleteRowMutationVariables;
      response: DatabaseDeleteRowMutation;
    }
  | {
      name: 'databaseDuplicatePropertyMutation';
      variables: DatabaseDuplicatePropertyMutationVariables;
      response: DatabaseDuplicatePropertyMutation;
    }
  | {
      name: 'databaseTrashMutation';
      variables: DatabaseTrashMutationVariables;
      response: DatabaseTrashMutation;
    }
  | {
      name: 'databaseRestoreMutation';
      variables: DatabaseRestoreMutationVariables;
      response: DatabaseRestoreMutation;
    }
  | {
      name: 'databaseMoveRowMutation';
      variables: DatabaseMoveRowMutationVariables;
      response: DatabaseMoveRowMutation;
    }
  | {
      name: 'databaseMoveMutation';
      variables: DatabaseMoveMutationVariables;
      response: DatabaseMoveMutation;
    }
  | {
      name: 'databasePermanentlyDeleteMutation';
      variables: DatabasePermanentlyDeleteMutationVariables;
      response: DatabasePermanentlyDeleteMutation;
    }
  | {
      name: 'databaseRenamePropertyMutation';
      variables: DatabaseRenamePropertyMutationVariables;
      response: DatabaseRenamePropertyMutation;
    }
  | {
      name: 'databaseSetPropertyDataMutation';
      variables: DatabaseSetPropertyDataMutationVariables;
      response: DatabaseSetPropertyDataMutation;
    }
  | {
      name: 'databaseSetPropertyTypeMutation';
      variables: DatabaseSetPropertyTypeMutationVariables;
      response: DatabaseSetPropertyTypeMutation;
    }
  | {
      name: 'databaseUpdateCellsMutation';
      variables: DatabaseUpdateCellsMutationVariables;
      response: DatabaseUpdateCellsMutation;
    }
  | {
      name: 'deleteAllNotificationsMutation';
      variables: DeleteAllNotificationsMutationVariables;
      response: DeleteAllNotificationsMutation;
    }
  | {
      name: 'deleteAppBaseMutation';
      variables: DeleteAppBaseMutationVariables;
      response: DeleteAppBaseMutation;
    }
  | {
      name: 'restoreAppBaseMutation';
      variables: RestoreAppBaseMutationVariables;
      response: RestoreAppBaseMutation;
    }
  | {
      name: 'permanentlyDeleteAppBaseMutation';
      variables: PermanentlyDeleteAppBaseMutationVariables;
      response: PermanentlyDeleteAppBaseMutation;
    }
  | {
      name: 'deleteNotificationMutation';
      variables: DeleteNotificationMutationVariables;
      response: DeleteNotificationMutation;
    }
  | {
      name: 'deleteTagMutation';
      variables: DeleteTagMutationVariables;
      response: DeleteTagMutation;
    }
  | {
      name: 'deleteWorkspaceMutation';
      variables: DeleteWorkspaceMutationVariables;
      response: DeleteWorkspaceMutation;
    }
  | {
      name: 'detachAppBaseDatabaseMutation';
      variables: DetachAppBaseDatabaseMutationVariables;
      response: DetachAppBaseDatabaseMutation;
    }
  | {
      name: 'disableManagedAiMutation';
      variables: DisableManagedAiMutationVariables;
      response: DisableManagedAiMutation;
    }
  | {
      name: 'discardAppBaseDraftMutation';
      variables: DiscardAppBaseDraftMutationVariables;
      response: DiscardAppBaseDraftMutation;
    }
  | {
      name: 'discardContentEntryChangesMutation';
      variables: DiscardContentEntryChangesMutationVariables;
      response: DiscardContentEntryChangesMutation;
    }
  | {
      name: 'enableManagedAiMutation';
      variables: EnableManagedAiMutationVariables;
      response: EnableManagedAiMutation;
    }
  | {
      name: 'ensureAppBaseDataSourcesMutation';
      variables: EnsureAppBaseDataSourcesMutationVariables;
      response: EnsureAppBaseDataSourcesMutation;
    }
  | {
      name: 'finalizeCheckoutSessionMutation';
      variables: FinalizeCheckoutSessionMutationVariables;
      response: FinalizeCheckoutSessionMutation;
    }
  | {
      name: 'addDocToFolderMutation';
      variables: AddDocToFolderMutationVariables;
      response: AddDocToFolderMutation;
    }
  | {
      name: 'createFolderMutation';
      variables: CreateFolderMutationVariables;
      response: CreateFolderMutation;
    }
  | {
      name: 'grantFolderRoleMutation';
      variables: GrantFolderRoleMutationVariables;
      response: GrantFolderRoleMutation;
    }
  | {
      name: 'moveFolderMutation';
      variables: MoveFolderMutationVariables;
      response: MoveFolderMutation;
    }
  | {
      name: 'permanentlyDeleteFolderMutation';
      variables: PermanentlyDeleteFolderMutationVariables;
      response: PermanentlyDeleteFolderMutation;
    }
  | {
      name: 'removeDocFromFolderMutation';
      variables: RemoveDocFromFolderMutationVariables;
      response: RemoveDocFromFolderMutation;
    }
  | {
      name: 'restoreFolderMutation';
      variables: RestoreFolderMutationVariables;
      response: RestoreFolderMutation;
    }
  | {
      name: 'revokeFolderRoleMutation';
      variables: RevokeFolderRoleMutationVariables;
      response: RevokeFolderRoleMutation;
    }
  | {
      name: 'trashFolderMutation';
      variables: TrashFolderMutationVariables;
      response: TrashFolderMutation;
    }
  | {
      name: 'updateFolderMutation';
      variables: UpdateFolderMutationVariables;
      response: UpdateFolderMutation;
    }
  | {
      name: 'grantDocUserRolesMutation';
      variables: GrantDocUserRolesMutationVariables;
      response: GrantDocUserRolesMutation;
    }
  | {
      name: 'addGroupMemberMutation';
      variables: AddGroupMemberMutationVariables;
      response: AddGroupMemberMutation;
    }
  | {
      name: 'createGroupMutation';
      variables: CreateGroupMutationVariables;
      response: CreateGroupMutation;
    }
  | {
      name: 'deleteGroupMutation';
      variables: DeleteGroupMutationVariables;
      response: DeleteGroupMutation;
    }
  | {
      name: 'grantDocGroupRoleMutation';
      variables: GrantDocGroupRoleMutationVariables;
      response: GrantDocGroupRoleMutation;
    }
  | {
      name: 'grantFolderGroupRoleMutation';
      variables: GrantFolderGroupRoleMutationVariables;
      response: GrantFolderGroupRoleMutation;
    }
  | {
      name: 'removeGroupMemberMutation';
      variables: RemoveGroupMemberMutationVariables;
      response: RemoveGroupMemberMutation;
    }
  | {
      name: 'revokeDocGroupRoleMutation';
      variables: RevokeDocGroupRoleMutationVariables;
      response: RevokeDocGroupRoleMutation;
    }
  | {
      name: 'revokeFolderGroupRoleMutation';
      variables: RevokeFolderGroupRoleMutationVariables;
      response: RevokeFolderGroupRoleMutation;
    }
  | {
      name: 'updateGroupMutation';
      variables: UpdateGroupMutationVariables;
      response: UpdateGroupMutation;
    }
  | {
      name: 'leaveWorkspaceMutation';
      variables: LeaveWorkspaceMutationVariables;
      response: LeaveWorkspaceMutation;
    }
  | {
      name: 'connectMailAccountMutation';
      variables: ConnectMailAccountMutationVariables;
      response: ConnectMailAccountMutation;
    }
  | {
      name: 'updateMailAccountMutation';
      variables: UpdateMailAccountMutationVariables;
      response: UpdateMailAccountMutation;
    }
  | {
      name: 'deleteMailAccountMutation';
      variables: DeleteMailAccountMutationVariables;
      response: DeleteMailAccountMutation;
    }
  | {
      name: 'syncMailAccountMutation';
      variables: SyncMailAccountMutationVariables;
      response: SyncMailAccountMutation;
    }
  | {
      name: 'setMailWatchInterestMutation';
      variables: SetMailWatchInterestMutationVariables;
      response: SetMailWatchInterestMutation;
    }
  | {
      name: 'sendMailMutation';
      variables: SendMailMutationVariables;
      response: SendMailMutation;
    }
  | {
      name: 'saveMailDraftMutation';
      variables: SaveMailDraftMutationVariables;
      response: SaveMailDraftMutation;
    }
  | {
      name: 'sendSavedMailDraftMutation';
      variables: SendSavedMailDraftMutationVariables;
      response: SendSavedMailDraftMutation;
    }
  | {
      name: 'upsertMailSignatureMutation';
      variables: UpsertMailSignatureMutationVariables;
      response: UpsertMailSignatureMutation;
    }
  | {
      name: 'deleteMailSignatureMutation';
      variables: DeleteMailSignatureMutationVariables;
      response: DeleteMailSignatureMutation;
    }
  | {
      name: 'assignMailSignatureMutation';
      variables: AssignMailSignatureMutationVariables;
      response: AssignMailSignatureMutation;
    }
  | {
      name: 'deleteMailSignatureAssignmentMutation';
      variables: DeleteMailSignatureAssignmentMutationVariables;
      response: DeleteMailSignatureAssignmentMutation;
    }
  | {
      name: 'upsertMailAutoresponderMutation';
      variables: UpsertMailAutoresponderMutationVariables;
      response: UpsertMailAutoresponderMutation;
    }
  | {
      name: 'createMailFolderMutation';
      variables: CreateMailFolderMutationVariables;
      response: CreateMailFolderMutation;
    }
  | {
      name: 'updateMailFolderMutation';
      variables: UpdateMailFolderMutationVariables;
      response: UpdateMailFolderMutation;
    }
  | {
      name: 'deleteMailFolderMutation';
      variables: DeleteMailFolderMutationVariables;
      response: DeleteMailFolderMutation;
    }
  | {
      name: 'updateMailMessageStateMutation';
      variables: UpdateMailMessageStateMutationVariables;
      response: UpdateMailMessageStateMutation;
    }
  | {
      name: 'moveMailMessageMutation';
      variables: MoveMailMessageMutationVariables;
      response: MoveMailMessageMutation;
    }
  | {
      name: 'deleteMailAutoresponderOverrideMutation';
      variables: DeleteMailAutoresponderOverrideMutationVariables;
      response: DeleteMailAutoresponderOverrideMutation;
    }
  | {
      name: 'upsertMailRuleMutation';
      variables: UpsertMailRuleMutationVariables;
      response: UpsertMailRuleMutation;
    }
  | {
      name: 'deleteMailRuleMutation';
      variables: DeleteMailRuleMutationVariables;
      response: DeleteMailRuleMutation;
    }
  | {
      name: 'updateMailPolicyMutation';
      variables: UpdateMailPolicyMutationVariables;
      response: UpdateMailPolicyMutation;
    }
  | {
      name: 'rebuildMailSearchIndexMutation';
      variables: RebuildMailSearchIndexMutationVariables;
      response: RebuildMailSearchIndexMutation;
    }
  | {
      name: 'trustMailSenderMutation';
      variables: TrustMailSenderMutationVariables;
      response: TrustMailSenderMutation;
    }
  | {
      name: 'addGroupMateMutation';
      variables: AddGroupMateMutationVariables;
      response: AddGroupMateMutation;
    }
  | {
      name: 'createSkillMutation';
      variables: CreateSkillMutationVariables;
      response: CreateSkillMutation;
    }
  | {
      name: 'createWorkspaceMateMutation';
      variables: CreateWorkspaceMateMutationVariables;
      response: CreateWorkspaceMateMutation;
    }
  | {
      name: 'deleteMateMutation';
      variables: DeleteMateMutationVariables;
      response: DeleteMateMutation;
    }
  | {
      name: 'deleteSkillMutation';
      variables: DeleteSkillMutationVariables;
      response: DeleteSkillMutation;
    }
  | {
      name: 'grantDocMateRoleMutation';
      variables: GrantDocMateRoleMutationVariables;
      response: GrantDocMateRoleMutation;
    }
  | {
      name: 'grantFolderMateRoleMutation';
      variables: GrantFolderMateRoleMutationVariables;
      response: GrantFolderMateRoleMutation;
    }
  | {
      name: 'removeGroupMateMutation';
      variables: RemoveGroupMateMutationVariables;
      response: RemoveGroupMateMutation;
    }
  | {
      name: 'revokeDocMateRoleMutation';
      variables: RevokeDocMateRoleMutationVariables;
      response: RevokeDocMateRoleMutation;
    }
  | {
      name: 'revokeFolderMateRoleMutation';
      variables: RevokeFolderMateRoleMutationVariables;
      response: RevokeFolderMateRoleMutation;
    }
  | {
      name: 'setMateSkillsMutation';
      variables: SetMateSkillsMutationVariables;
      response: SetMateSkillsMutation;
    }
  | {
      name: 'shareMateMutation';
      variables: ShareMateMutationVariables;
      response: ShareMateMutation;
    }
  | {
      name: 'unshareMateMutation';
      variables: UnshareMateMutationVariables;
      response: UnshareMateMutation;
    }
  | {
      name: 'updateMateRulesMutation';
      variables: UpdateMateRulesMutationVariables;
      response: UpdateMateRulesMutation;
    }
  | {
      name: 'updateMateMutation';
      variables: UpdateMateMutationVariables;
      response: UpdateMateMutation;
    }
  | {
      name: 'updateSkillMutation';
      variables: UpdateSkillMutationVariables;
      response: UpdateSkillMutation;
    }
  | {
      name: 'generateWorkspaceMcpTokenMutation';
      variables: GenerateWorkspaceMcpTokenMutationVariables;
      response: GenerateWorkspaceMcpTokenMutation;
    }
  | {
      name: 'grantWorkspaceMcpAccessToGroupMutation';
      variables: GrantWorkspaceMcpAccessToGroupMutationVariables;
      response: GrantWorkspaceMcpAccessToGroupMutation;
    }
  | {
      name: 'requestWorkspaceMcpAccessMutation';
      variables: RequestWorkspaceMcpAccessMutationVariables;
      response: RequestWorkspaceMcpAccessMutation;
    }
  | {
      name: 'revealWorkspaceMcpGrantMutation';
      variables: RevealWorkspaceMcpGrantMutationVariables;
      response: RevealWorkspaceMcpGrantMutation;
    }
  | {
      name: 'revokeWorkspaceMcpTokenMutation';
      variables: RevokeWorkspaceMcpTokenMutationVariables;
      response: RevokeWorkspaceMcpTokenMutation;
    }
  | {
      name: 'mentionUserMutation';
      variables: MentionUserMutationVariables;
      response: MentionUserMutation;
    }
  | {
      name: 'moveAppBaseDatabaseMutation';
      variables: MoveAppBaseDatabaseMutationVariables;
      response: MoveAppBaseDatabaseMutation;
    }
  | {
      name: 'moveAppBaseMountMutation';
      variables: MoveAppBaseMountMutationVariables;
      response: MoveAppBaseMountMutation;
    }
  | {
      name: 'permanentlyDeleteAppMutation';
      variables: PermanentlyDeleteAppMutationVariables;
      response: PermanentlyDeleteAppMutation;
    }
  | {
      name: 'permanentlyDeleteDocMutation';
      variables: PermanentlyDeleteDocMutationVariables;
      response: PermanentlyDeleteDocMutation;
    }
  | {
      name: 'planAppBaseDevelopmentMutation';
      variables: PlanAppBaseDevelopmentMutationVariables;
      response: PlanAppBaseDevelopmentMutation;
    }
  | {
      name: 'publishPageMutation';
      variables: PublishPageMutationVariables;
      response: PublishPageMutation;
    }
  | {
      name: 'publishAppBaseDraftMutation';
      variables: PublishAppBaseDraftMutationVariables;
      response: PublishAppBaseDraftMutation;
    }
  | {
      name: 'publishAppContainerToMineMutation';
      variables: PublishAppContainerToMineMutationVariables;
      response: PublishAppContainerToMineMutation;
    }
  | {
      name: 'publishAutomationToMineMutation';
      variables: PublishAutomationToMineMutationVariables;
      response: PublishAutomationToMineMutation;
    }
  | {
      name: 'publishContentEntriesMutation';
      variables: PublishContentEntriesMutationVariables;
      response: PublishContentEntriesMutation;
    }
  | {
      name: 'publishTrashedAppToMineMutation';
      variables: PublishTrashedAppToMineMutationVariables;
      response: PublishTrashedAppToMineMutation;
    }
  | {
      name: 'publishWorkflowToMineMutation';
      variables: PublishWorkflowToMineMutationVariables;
      response: PublishWorkflowToMineMutation;
    }
  | {
      name: 'purchaseExtraSeatsMutation';
      variables: PurchaseExtraSeatsMutationVariables;
      response: PurchaseExtraSeatsMutation;
    }
  | {
      name: 'reactivateWorkspaceMutation';
      variables: ReactivateWorkspaceMutationVariables;
      response: ReactivateWorkspaceMutation;
    }
  | {
      name: 'readAllNotificationsMutation';
      variables: ReadAllNotificationsMutationVariables;
      response: ReadAllNotificationsMutation;
    }
  | {
      name: 'readNotificationMutation';
      variables: ReadNotificationMutationVariables;
      response: ReadNotificationMutation;
    }
  | {
      name: 'reassignAppBaseRowOwnersMutation';
      variables: ReassignAppBaseRowOwnersMutationVariables;
      response: ReassignAppBaseRowOwnersMutation;
    }
  | {
      name: 'rebindAppBaseDatabaseMutation';
      variables: RebindAppBaseDatabaseMutationVariables;
      response: RebindAppBaseDatabaseMutation;
    }
  | {
      name: 'recoverDocMutation';
      variables: RecoverDocMutationVariables;
      response: RecoverDocMutation;
    }
  | {
      name: 'refreshAppBasePublishedContentMutation';
      variables: RefreshAppBasePublishedContentMutationVariables;
      response: RefreshAppBasePublishedContentMutation;
    }
  | {
      name: 'registerCustomDomainMutation';
      variables: RegisterCustomDomainMutationVariables;
      response: RegisterCustomDomainMutation;
    }
  | {
      name: 'registerSubdomainMutation';
      variables: RegisterSubdomainMutationVariables;
      response: RegisterSubdomainMutation;
    }
  | {
      name: 'reimportOnboardingDocMutation';
      variables: ReimportOnboardingDocMutationVariables;
      response: ReimportOnboardingDocMutation;
    }
  | {
      name: 'reindexWorkspaceEmbeddingsMutation';
      variables: ReindexWorkspaceEmbeddingsMutationVariables;
      response: ReindexWorkspaceEmbeddingsMutation;
    }
  | {
      name: 'releaseBrandedSubdomainMutation';
      variables: ReleaseBrandedSubdomainMutationVariables;
      response: ReleaseBrandedSubdomainMutation;
    }
  | {
      name: 'remindWorkspaceTwoFactorMembersMutation';
      variables: RemindWorkspaceTwoFactorMembersMutationVariables;
      response: RemindWorkspaceTwoFactorMembersMutation;
    }
  | {
      name: 'removeAvatarMutation';
      variables: RemoveAvatarMutationVariables;
      response: RemoveAvatarMutation;
    }
  | {
      name: 'removeCustomDomainMutation';
      variables: RemoveCustomDomainMutationVariables;
      response: RemoveCustomDomainMutation;
    }
  | {
      name: 'removeSeatAddonMutation';
      variables: RemoveSeatAddonMutationVariables;
      response: RemoveSeatAddonMutation;
    }
  | {
      name: 'removeTenantMemberMutation';
      variables: RemoveTenantMemberMutationVariables;
      response: RemoveTenantMemberMutation;
    }
  | {
      name: 'renameBrandedSubdomainMutation';
      variables: RenameBrandedSubdomainMutationVariables;
      response: RenameBrandedSubdomainMutation;
    }
  | {
      name: 'reorderAppBaseMountsMutation';
      variables: ReorderAppBaseMountsMutationVariables;
      response: ReorderAppBaseMountsMutation;
    }
  | {
      name: 'reportCorruptionMutation';
      variables: ReportCorruptionMutationVariables;
      response: ReportCorruptionMutation;
    }
  | {
      name: 'resolvePendingDecisionMutation';
      variables: ResolvePendingDecisionMutationVariables;
      response: ResolvePendingDecisionMutation;
    }
  | {
      name: 'restoreAppBaseModuleMutation';
      variables: RestoreAppBaseModuleMutationVariables;
      response: RestoreAppBaseModuleMutation;
    }
  | {
      name: 'restoreAppBaseVersionMutation';
      variables: RestoreAppBaseVersionMutationVariables;
      response: RestoreAppBaseVersionMutation;
    }
  | {
      name: 'restoreAppMutation';
      variables: RestoreAppMutationVariables;
      response: RestoreAppMutation;
    }
  | {
      name: 'restoreContentEntryVersionMutation';
      variables: RestoreContentEntryVersionMutationVariables;
      response: RestoreContentEntryVersionMutation;
    }
  | {
      name: 'restoreDocMutation';
      variables: RestoreDocMutationVariables;
      response: RestoreDocMutation;
    }
  | {
      name: 'resumeSubscriptionMutation';
      variables: ResumeSubscriptionMutationVariables;
      response: ResumeSubscriptionMutation;
    }
  | {
      name: 'revokeDocUserRolesMutation';
      variables: RevokeDocUserRolesMutationVariables;
      response: RevokeDocUserRolesMutation;
    }
  | {
      name: 'revokeMemberPermissionMutation';
      variables: RevokeMemberPermissionMutationVariables;
      response: RevokeMemberPermissionMutation;
    }
  | {
      name: 'revokePublicPageMutation';
      variables: RevokePublicPageMutationVariables;
      response: RevokePublicPageMutation;
    }
  | {
      name: 'scheduleAccountDeletionMutation';
      variables: ScheduleAccountDeletionMutationVariables;
      response: ScheduleAccountDeletionMutation;
    }
  | {
      name: 'sendBlockInviteMutation';
      variables: SendBlockInviteMutationVariables;
      response: SendBlockInviteMutation;
    }
  | {
      name: 'sendChangeEmailMutation';
      variables: SendChangeEmailMutationVariables;
      response: SendChangeEmailMutation;
    }
  | {
      name: 'sendChangePasswordEmailMutation';
      variables: SendChangePasswordEmailMutationVariables;
      response: SendChangePasswordEmailMutation;
    }
  | {
      name: 'sendSetPasswordEmailMutation';
      variables: SendSetPasswordEmailMutationVariables;
      response: SendSetPasswordEmailMutation;
    }
  | {
      name: 'sendVerifyChangeEmailMutation';
      variables: SendVerifyChangeEmailMutationVariables;
      response: SendVerifyChangeEmailMutation;
    }
  | {
      name: 'sendVerifyEmailMutation';
      variables: SendVerifyEmailMutationVariables;
      response: SendVerifyEmailMutation;
    }
  | {
      name: 'setAppBaseAccessMutation';
      variables: SetAppBaseAccessMutationVariables;
      response: SetAppBaseAccessMutation;
    }
  | {
      name: 'setAppBaseBandwidthBudgetMutation';
      variables: SetAppBaseBandwidthBudgetMutationVariables;
      response: SetAppBaseBandwidthBudgetMutation;
    }
  | {
      name: 'setAppBaseFrameMountMutation';
      variables: SetAppBaseFrameMountMutationVariables;
      response: SetAppBaseFrameMountMutation;
    }
  | {
      name: 'setAppBaseMountNavigationMutation';
      variables: SetAppBaseMountNavigationMutationVariables;
      response: SetAppBaseMountNavigationMutation;
    }
  | {
      name: 'setInitialPasswordMutation';
      variables: SetInitialPasswordMutationVariables;
      response: SetInitialPasswordMutation;
    }
  | {
      name: 'setMyNotificationPreferenceMutation';
      variables: SetMyNotificationPreferenceMutationVariables;
      response: SetMyNotificationPreferenceMutation;
    }
  | {
      name: 'setWorkspacePublicByIdMutation';
      variables: SetWorkspacePublicByIdMutationVariables;
      response: SetWorkspacePublicByIdMutation;
    }
  | {
      name: 'skipPendingDecisionMutation';
      variables: SkipPendingDecisionMutationVariables;
      response: SkipPendingDecisionMutation;
    }
  | {
      name: 'stepAppBaseVersionMutation';
      variables: StepAppBaseVersionMutationVariables;
      response: StepAppBaseVersionMutation;
    }
  | {
      name: 'stripDocHistoryMutation';
      variables: StripDocHistoryMutationVariables;
      response: StripDocHistoryMutation;
    }
  | {
      name: 'refreshSubscriptionMutation';
      variables: RefreshSubscriptionMutationVariables;
      response: RefreshSubscriptionMutation;
    }
  | {
      name: 'switchPlanIntervalMutation';
      variables: SwitchPlanIntervalMutationVariables;
      response: SwitchPlanIntervalMutation;
    }
  | {
      name: 'tagDocMutation';
      variables: TagDocMutationVariables;
      response: TagDocMutation;
    }
  | {
      name: 'adminDisableTotpMutation';
      variables: AdminDisableTotpMutationVariables;
      response: AdminDisableTotpMutation;
    }
  | {
      name: 'disableTotpMutation';
      variables: DisableTotpMutationVariables;
      response: DisableTotpMutation;
    }
  | {
      name: 'enableTotpMutation';
      variables: EnableTotpMutationVariables;
      response: EnableTotpMutation;
    }
  | {
      name: 'regenerateBackupCodesMutation';
      variables: RegenerateBackupCodesMutationVariables;
      response: RegenerateBackupCodesMutation;
    }
  | {
      name: 'revokeAllDeviceTrustsMutation';
      variables: RevokeAllDeviceTrustsMutationVariables;
      response: RevokeAllDeviceTrustsMutation;
    }
  | {
      name: 'revokeDeviceTrustMutation';
      variables: RevokeDeviceTrustMutationVariables;
      response: RevokeDeviceTrustMutation;
    }
  | {
      name: 'sendEmailOtpMutation';
      variables: SendEmailOtpMutationVariables;
      response: SendEmailOtpMutation;
    }
  | {
      name: 'setPreferredTwoFactorMethodMutation';
      variables: SetPreferredTwoFactorMethodMutationVariables;
      response: SetPreferredTwoFactorMethodMutation;
    }
  | {
      name: 'verifyBackupCodeLoginMutation';
      variables: VerifyBackupCodeLoginMutationVariables;
      response: VerifyBackupCodeLoginMutation;
    }
  | {
      name: 'verifyEmailOtpLoginMutation';
      variables: VerifyEmailOtpLoginMutationVariables;
      response: VerifyEmailOtpLoginMutation;
    }
  | {
      name: 'verifyTotpLoginMutation';
      variables: VerifyTotpLoginMutationVariables;
      response: VerifyTotpLoginMutation;
    }
  | {
      name: 'verifyTotpSetupMutation';
      variables: VerifyTotpSetupMutationVariables;
      response: VerifyTotpSetupMutation;
    }
  | {
      name: 'translateAppBaseMetadataMutation';
      variables: TranslateAppBaseMetadataMutationVariables;
      response: TranslateAppBaseMetadataMutation;
    }
  | {
      name: 'trashDocMutation';
      variables: TrashDocMutationVariables;
      response: TrashDocMutation;
    }
  | {
      name: 'unmountAppMutation';
      variables: UnmountAppMutationVariables;
      response: UnmountAppMutation;
    }
  | {
      name: 'unpublishAppBaseMutation';
      variables: UnpublishAppBaseMutationVariables;
      response: UnpublishAppBaseMutation;
    }
  | {
      name: 'untagDocMutation';
      variables: UntagDocMutationVariables;
      response: UntagDocMutation;
    }
  | {
      name: 'updateAiConsentMutation';
      variables: UpdateAiConsentMutationVariables;
      response: UpdateAiConsentMutation;
    }
  | {
      name: 'updateAppBaseAieoMutation';
      variables: UpdateAppBaseAieoMutationVariables;
      response: UpdateAppBaseAieoMutation;
    }
  | {
      name: 'updateAppBaseBriefMutation';
      variables: UpdateAppBaseBriefMutationVariables;
      response: UpdateAppBaseBriefMutation;
    }
  | {
      name: 'updateAppBaseSeoMutation';
      variables: UpdateAppBaseSeoMutationVariables;
      response: UpdateAppBaseSeoMutation;
    }
  | {
      name: 'updateAppBaseMutation';
      variables: UpdateAppBaseMutationVariables;
      response: UpdateAppBaseMutation;
    }
  | {
      name: 'updateDocDefaultRoleMutation';
      variables: UpdateDocDefaultRoleMutationVariables;
      response: UpdateDocDefaultRoleMutation;
    }
  | {
      name: 'updateDocTitleMutation';
      variables: UpdateDocTitleMutationVariables;
      response: UpdateDocTitleMutation;
    }
  | {
      name: 'updateDocUserRoleMutation';
      variables: UpdateDocUserRoleMutationVariables;
      response: UpdateDocUserRoleMutation;
    }
  | {
      name: 'updateLocaleSettingsMutation';
      variables: UpdateLocaleSettingsMutationVariables;
      response: UpdateLocaleSettingsMutation;
    }
  | {
      name: 'updateSeatCountMutation';
      variables: UpdateSeatCountMutationVariables;
      response: UpdateSeatCountMutation;
    }
  | {
      name: 'updateTagMutation';
      variables: UpdateTagMutationVariables;
      response: UpdateTagMutation;
    }
  | {
      name: 'updateTenantMemberRoleMutation';
      variables: UpdateTenantMemberRoleMutationVariables;
      response: UpdateTenantMemberRoleMutation;
    }
  | {
      name: 'updateTenantMutation';
      variables: UpdateTenantMutationVariables;
      response: UpdateTenantMutation;
    }
  | {
      name: 'updateUserProfileMutation';
      variables: UpdateUserProfileMutationVariables;
      response: UpdateUserProfileMutation;
    }
  | {
      name: 'updateUserSettingsMutation';
      variables: UpdateUserSettingsMutationVariables;
      response: UpdateUserSettingsMutation;
    }
  | {
      name: 'updateWorkspacePolicyMutation';
      variables: UpdateWorkspacePolicyMutationVariables;
      response: UpdateWorkspacePolicyMutation;
    }
  | {
      name: 'uploadAvatarMutation';
      variables: UploadAvatarMutationVariables;
      response: UploadAvatarMutation;
    }
  | {
      name: 'verifyEmailMutation';
      variables: VerifyEmailMutationVariables;
      response: VerifyEmailMutation;
    }
  | {
      name: 'setEnableAiMutation';
      variables: SetEnableAiMutationVariables;
      response: SetEnableAiMutation;
    }
  | {
      name: 'setAppBasesEnabledMutation';
      variables: SetAppBasesEnabledMutationVariables;
      response: SetAppBasesEnabledMutation;
    }
  | {
      name: 'setEnableDocEmbeddingMutation';
      variables: SetEnableDocEmbeddingMutationVariables;
      response: SetEnableDocEmbeddingMutation;
    }
  | {
      name: 'setEnableUrlPreviewMutation';
      variables: SetEnableUrlPreviewMutationVariables;
      response: SetEnableUrlPreviewMutation;
    }
  | {
      name: 'inviteByEmailsMutation';
      variables: InviteByEmailsMutationVariables;
      response: InviteByEmailsMutation;
    }
  | {
      name: 'acceptInviteByInviteIdMutation';
      variables: AcceptInviteByInviteIdMutationVariables;
      response: AcceptInviteByInviteIdMutation;
    }
  | {
      name: 'createInviteLinkMutation';
      variables: CreateInviteLinkMutationVariables;
      response: CreateInviteLinkMutation;
    }
  | {
      name: 'revokeInviteLinkMutation';
      variables: RevokeInviteLinkMutationVariables;
      response: RevokeInviteLinkMutation;
    }
  | {
      name: 'setPresenceDiscoveryEnabledMutation';
      variables: SetPresenceDiscoveryEnabledMutationVariables;
      response: SetPresenceDiscoveryEnabledMutation;
    }
  | {
      name: 'reindexMailSearchMutation';
      variables: ReindexMailSearchMutationVariables;
      response: ReindexMailSearchMutation;
    }
  | {
      name: 'approveWorkspaceTeamMemberMutation';
      variables: ApproveWorkspaceTeamMemberMutationVariables;
      response: ApproveWorkspaceTeamMemberMutation;
    }
  | {
      name: 'grantWorkspaceTeamMemberMutation';
      variables: GrantWorkspaceTeamMemberMutationVariables;
      response: GrantWorkspaceTeamMemberMutation;
    }
  | {
      name: 'transferWorkspaceOwnershipMutation';
      variables: TransferWorkspaceOwnershipMutationVariables;
      response: TransferWorkspaceOwnershipMutation;
    };
